(function () {
  'use strict';
  angular
    .module('frontendapp',
      ['ui.bootstrap',
        'ngAnimate',
        'ngCookies',
        'ngTouch',
        'ngSanitize',
        'ngMessages',
        'ngAria',
        'ngResource',
        'ui.router',
        'toastr',
        'LocalStorageModule',
        'satellizer',
        'sap.imageloader',
        'ngMap',
        'fox.scrollReveal',
        'angularSmoothscroll',
        'angular-loading-bar',
        'textAngular',
        //'color.picker',
        //'angularUtils.directives.uiBreadcrumbs',
        'ngFileUpload'

      ]);

})();

/**
 * Created by DELL on 1/12/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uireport', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uireport/uireport.html',
      //templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        level: '=',
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uireportController($uibModal, $scope, $rootScope, toastr,
        $state, $auth, $location, $log, $timeout,
        UserService, localStorageService,
        TablesService, $window, $modal) {

        console.log('$rootScope.uireportController');

        $rootScope.fileId = '';
        $scope.data = '';
        $scope.excel = '';
        $rootScope.backupTickets = '';
        $rootScope.loadBatch = function (id) {
          console.log('$rootScope.movieticketbash', $rootScope.movieticketbash);
          // $rootScope.movieticketbash.storeRow();
          TablesService.filtrar('movie', { per_page: 100000 })
            .success(function (res) {
              console.log('res loadded', res);
              $rootScope.backupTickets = res;
              $scope.filters = {
                report: false,
                filters: {
                  description: {
                    items: res.result.data,
                    key: 'name',
                    type: 'selectlist'
                  },
                  created_at: {
                    operator: 'between'
                  }
                }
              }
            });
        };

        $rootScope.loadBatch();

        $scope.search = function () {
          console.log('search', $scope.filters);
          TablesService.moviereport($scope.filters)
            .success(function (res) {
              console.log('res loadded', res);
              $scope.data = res;
            });
        }

        $scope.download = function () {
          $scope.filters.report = true;
          $scope.search();
        }

        $scope.pick = function (key, item) {
          console.log(key, item);
          $scope.filters.filters.description.value = 'Ticket online ' + item.name;
          $scope.search();
        }


      }
    }
  });

/**
 * Created by DELL on 1/12/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uiticket', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiticket/uiticket.html',
      //templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        level: '=',
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uicomboController($uibModal, $scope, $rootScope, toastr,
        $state, $auth, $location, $log, $timeout,
        UserService, localStorageService,
        TablesService, $window, $modal) {

        $scope.formData = {

          //load_type: 1,
          batch_size: 1,

          promo: '',
          ticket: '',
          percentaje: 0,
          maxuses: 1,
          // movie_id: 0,
          refered_to: 0,
          //  refered_id: 0,
          date_start: '',
          date_end: '',
          // product_id:0,
        };



        $rootScope.mpromo.properties.selected = {};
        console.log('$rootScope.mpromo', $rootScope.mpromo)
        $rootScope.mpromo.properties.ticket.hide = true;
        $rootScope.mpromo.properties.batch_size.hide = false;
        //$rootScope.mpromo.selected.load_type;

        $scope.storepromo = function () {
          $rootScope.mpromo.selected.load_type = 1;
          console.log('mpromo', $rootScope.mpromo.selected);
          TablesService.storepromo($rootScope.mpromo.selected)
            .success(function (res) {
              console.log('Salida almacenar mpromo', res);
              if (res.status) {
                toastr.success('Registros almacenados', 'Exito');
                location.reload();
              }
              else {
                toastr.warning('Registros no almacenados', 'Error');
              }
            })
            .error(function (res) {
              console.log('ERROR salida almacenar', res);
              toastr.warning('Registros no almacenados', 'Error');
            });
        }
        /* $rootScope.fileId = '';
        $rootScope.backupTickets = '';
        $rootScope.loadBatch = function (id) {
          console.log('$rootScope.movieticketbash', $rootScope.movieticketbash);
          // $rootScope.movieticketbash.storeRow();
          TablesService.loadtickets({ id: id })
            .success(function (res) {
              console.log('res loadded', res);
              $rootScope.backupTickets = res;
            })

        }


        $scope.uploadExcel = function () {
          console.log('UPDATE REGISTER', $rootScope[$scope.modelName])
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              $rootScope[$scope.modelName].storeRow();
            });
        };

        $scope.saveTickets = function () {
          console.log('saveTickets', $rootScope[$scope.modelName]);

          TablesService.storetickets({ id: $rootScope.fileIdB })
            .success(function (res) {
              console.log('res loadded', res);
              location.reload();
            })
        }; */

      }
    }
  });

/**
 * Created by DELL on 2/12/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uireadvoucher', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uireadvoucher/uireadvoucher.html',
      restrict: 'E',
      replace: true,
      scope: {
        level: '=',
        modelName: '@',
        modelParent: '@',
        operationType: '@',
      },
      rootScope: $rootScope,
      controller: function uireadvoucherformController($uibModal, $scope, $rootScope, toastr,
                                                         $state, $auth, $location, $log, Upload,
                                                         UserService, localStorageService,
                                                         TablesService, $window, $modal) {

        $scope.firstTime = true;
        console.log('uireadvoucher', $scope.level, $scope.modelName);

        $rootScope.paymentTitle = 'Entrega de productos';
        $rootScope.newCreditIndex = 'unsigned';
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();

        $scope.bussinessRules = function (){
          switch ($rootScope.currentModule) {
            case 'purchases':
              $rootScope.paymentDetail = [
                {label: 'Proveedor', value: $rootScope.voucher.selected.partner.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Almacen', value: 'Almacen central'}
              ];
              break;
            case 'sales':
              $rootScope.paymentTypes = [
                {type:'cash'},
                {type:'card'},
                {type:'note'},
                {type:'transaction'}
              ];
              if(!$rootScope.voucher.selected.partner.partnercategory){
                $rootScope.voucher.selected.partner.partnercategory = {
                  name:'SN',
                  topcredit : 0
                }
              }
              if($rootScope.voucher.selected.partner.partnercategory){
                $scope.oldTopCredit = angular.copy( $rootScope.voucher.selected.partner.partnercategory.topcredit );
              }
              $rootScope.paymentDetail = [
                {label: 'Cliente', value: $rootScope.voucher.selected.partner.name},
                {label: 'Categoría', value: $rootScope.voucher.selected.partner.partnercategory.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                {label: 'Saldo de crédito',
                  success: function (){return $rootScope.newCreditIndex != 'unsigned'},
                  value: $rootScope.voucher.selected.partner.partnercategory.topcredit},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Punto de venta', value: 'Sucursal Miraflores'}
              ];
              $rootScope[$scope.modelName].selected.vouchertransaction = [
                {
                  payment_type: 'cash',
                  payment_label: 'efectivo',
                  currency: 'Bs.',
                  amount :0
                },
                {
                  payment_type: 'card',
                  payment_label: 'tarjeta',
                  currency: 'Bs.',
                  amount :0
                },
                {
                  payment_type: 'note',
                  payment_label: 'cheque',
                  verification:true,
                  attachment : '',
                  currency: 'Bs.',
                  amount :0,
                  code: ''
                },
                {
                  payment_type: 'transaction',
                  payment_label: 'transfer.',
                  verification:true,
                  currency: 'Bs.',
                  amount : 0,
                  attachment : '',
                  code: ''
                },
              ];
              break;
            case 'inventory':
              $rootScope.paymentDetail = [
                {label: 'Encargado', value: $rootScope.currentUser.partner[0].name},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Almacen', value: 'Almacen central'}
              ];
              break;
          }
        };
        $scope.bussinessRules();

        //PRODUCTS PICKER
        $scope.batchPicker = false;
        $scope.loadProducts = function (field, value) {
          /*var filter = {
           filters: {
           /!*stock: {
           operator: 'has',
           /!*field:'current_stock',
           value:'bigger'*!/
           },*!/
           code :{
           //operator: 'like',
           operator: 'orwhere',
           other: ['code_secondary', 'description'],
           value: value
           }
           },
           per_page: '10'
           };*/
          var filters = {
            per_page: '50',
            page: '1',
            filters: {
              code :{
                //operator: 'like',
                operator: 'stockavaible',
                other: ['code','code_secondary'],
                value: value
              }
            },
          };
          if (value != '') {
            //console.log('solicitado', field, filters);
            TablesService.filtrar('product', filters)
              .success(function (res) {
                if (res.status) {
                  //console.log('productos extraidos',  res.result.data);
                  $scope.products = res.result.data;
                }
                //console.log('filtros actualizados', $rootScope.memVoucher)
              });
          }
          else {
            $scope.products = [];
          }

        };
        $scope.addProduct = function (item, stock) {
          if (!$rootScope.memVoucher.voucherline) {
            $rootScope.memVoucher.voucherline = [];
          }
          console.log('inertando', item, stock)
          /*if(item.stock.length >0){item.stock[0].quantity = 1;}*/
          var newProd = {
            product_id: item.id,
            product: item,
            value: 0,
            quantity: 1,
            quantity_expected: 1,
            quantity_issued: 1,
            stock: 0,
            status: 0,
            newitem: true,
            stockadjustment : []
          };
          $rootScope.addToList($rootScope.memVoucher.voucherline, newProd, 'product_id');
          $scope.setNewStockadjustment(item.id, (stock)?stock:item.stock[0]);
          $scope.products = [];
          $rootScope.searchCode = '';
          $scope.searchCode2 = '';
          $scope.batchPicker = false;
        };
        $scope.setNewStockadjustment = function(targetId, item){
          angular.forEach($rootScope.memVoucher.voucherline, function (value) {
            if(value.product_id == targetId){
              var temp = item;
              temp.product_id =  item.product_id;
              temp.stock_id =  item.id;
              temp.quantity =  1;
              temp.quantity_expected =  1;
              temp.quantity_issued =  1;
              temp.active =  true;
              $rootScope.addToList(value.stockadjustment, temp, 'stock_id');
            }
          })
        };

        $scope.pairingVoucherStock2 = function () {
          $scope.lastOrder = 0;
          angular.forEach($rootScope.memVoucher.voucherline, function (value, key) {
            value.stockadjustment = $scope.retriveStockAdjustments(value.product_id, $scope.lastOrder );
          })
        };
        $scope.retriveStockAdjustments = function (productId, orderId){
          var stockadjustments = [];
          if($rootScope.memVoucher.stockorder.length>0){
            angular.forEach($rootScope.memVoucher.stockorder[orderId].stockadjustment,
              function (item) {
                console.log('retriveStockAdjustments', item);
                if(item.product_id == productId){
                  item.active =  true;
                  stockadjustments.push(item);
                }
              });
          }

          return stockadjustments;
        };



        //selected product to show in contextual menu


        //CALCULATES TOTAL AMOUNTH
        /*$scope.globalTotal = 0;
        $scope.othersTotal = 0;
        $scope.calculateTotal3 = function (quantity, price, discount) {
          $scope.globalTotal = 0;
          angular.forEach($rootScope.memVoucher.voucherline, function (value, key) {
            //console.log('calculateTotal3',value, value[quantity], value[price])
            var sum = 0;
            var discount = 0;
            value[quantity] = Math.round(value[quantity]);
            if (value[quantity] > 0 && parseFloat(value[price])  > 0) {
              if(value.discount){
                discount =  (parseFloat(value[price]) * value.discount/100);
                //console.log('descuento calculado', discount)
              }
              value.sub =  value[quantity] * (parseFloat(value[price]) - discount);
              sum = value[quantity] * (parseFloat(value[price]) - discount) ;
            }
            if(value.stockadjustment.length == 1){
              value.stockadjustment[0].quantity = value[quantity];
            }
            angular.forEach(value.stockadjustment, function (item, itemkey) {
              //console.log(item, itemkey);
              item.quantity_issued = item.quantity;
              item.quantity_expected = item.quantity - item.quantity_issued ;
            });

            $scope.globalTotal += sum;
          });
          $rootScope.memVoucher.total = $scope.globalTotal + $scope.othersTotal;

        };
        $scope.calculateSubTotal3 = function (target, source) {
          var sub = 0;
          console.log('calculateSubTotal3',target, source);
          angular.forEach(target.stockadjustment, function (value, key) {
            if(!value.quantity){
              value.quantity = 0;
            }
            sub += value.quantity;
          });
          target.quantity = sub;
          $scope.calculateTotal3('quantity','value');
          return sub;
        };*/

        //STORES TRANSACTION
        $scope.updateRegister = function () {
          $rootScope.memVoucher = angular.copy($rootScope.memVoucher);
          console.log('UPDATE REGISTER', $rootScope[$scope.modelName])
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              console.log('simplificado', $rootScope.memVoucher, $rootScope[$scope.modelName].actionType);
              switch ($rootScope[$scope.modelName].actionType) {
                case 'store':
                  $rootScope[$scope.modelName].storeRow();
                  break;
                case 'update':
                  $rootScope[$scope.modelName].updateRow();
                  break;
                case 'delete':
                  $rootScope[$scope.modelName].deleteRow();
                  break;
              }
            });
        };
        $rootScope.saveVoucher = function (){
          switch($rootScope.nextStep){
            case 'uipayment':
              $rootScope.uiConf.switchView('next', {actionType:'store',component:'uipayment', model:'voucher'}, false);
              break;
            case 'uiinventorycheck':
              $rootScope.uiConf.switchView('next', {actionType:'store',component:'uiinventorycheck', model:'voucher'}, false);
              break;
            case 'uicombo':
              $rootScope.uiConf.switchView('next', {actionType:'store',component:'uicombo', model:'voucher'}, false);
              break;
            default:
              $scope.updateRegister();
              break;
          }
        };

        //STOCK MOVEMENT DEFINITION

        $rootScope.memVoucher ={};
        $rootScope.loadTempVoucher = function (voucher){
          console.log('cargado', voucher)
          $rootScope.memVoucher = angular.copy(voucher);
          $scope.pairingVoucherStock2();
          if(voucher.stockorder.length>0){
            $rootScope.memVoucher.warehouse_id = voucher.stockorder[0].warehouse_id;
            $rootScope.memVoucher.warehouse = voucher.stockorder[0].warehouse;
          }
          console.log('LOADED memVoucher', $rootScope.memVoucher);
        };
        //CONTROL
        console.log($rootScope.tempVoucher);
        $rootScope.loadTempVoucher($rootScope.tempVoucher);
        $rootScope.$watch('tempVoucher', function () {
          console.log($rootScope.tempVoucher);
          $rootScope.loadTempVoucher($rootScope.tempVoucher);
        }, true);
        $scope.closeAndBack = function (){
          $rootScope.uiConf.switchView('prev')
        };


      }
    }
  })
;

'use strict';
angular.module('frontendapp')
  .directive('uipiker', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uipiker/uipiker.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        modelParent: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
        level: '='
      },
      rootScope: $rootScope,

      controller: function uipikerController($uibModal, $scope, $rootScope, toastr,
                                             $state, $auth, $location, $log,
                                             UserService, localStorageService,
                                             TablesService, $window, $modal) {

        console.log('PIKERFORM');

        console.log('PIKERFORM', $rootScope[$scope.modelName]);

        $scope.itemsList = [];
        $scope.saveSelection = function () {
          console.log('child', $rootScope[$scope.modelName].childModel)
          if ($rootScope[$scope.modelName].childModel) {
            angular.forEach($scope.itemsList, function (value) {
              value.productcombogroup_id = $rootScope.productcombogroup.selected.id;
              value['product_id'] = value.id;
            });
            console.log('storemany',
              $rootScope[$scope.modelName].parentModel,
              $rootScope[$scope.modelName].childModel,
              $scope.itemsList);
            var params = {
              items: angular.copy($scope.itemsList)
            };
            console.log('enviado', $rootScope[$scope.modelName].childModel, params);
            TablesService.storemany($rootScope[$scope.modelName].childModel, params)
              .success(function (res) {
                console.log('Salida almacenar', res);
                if (res.status) {
                  toastr.success('Registro almacenado', 'Exito');
                  $rootScope.uiConf.switchView('prev', {}, false);
                }
                else {
                  toastr.warning('Registro no almacenado', 'Error');
                }
              })
              .error(function (res) {
                console.log('ERROR salida almacenar', res);
                toastr.warning('Registro no almacenado', 'Error');
              });
          }
          else {
            $rootScope[$scope.modelName].itemsList = angular.copy($scope.itemsList);
            $rootScope.productsPiked = angular.copy($scope.itemsList);
            $rootScope.uiConf.switchView('prev');
            $rootScope[$scope.modelName].resetRegister()
          }
        };

        $scope.filters = {
          per_page: "10",
          page: 1
        };

        //paginacion
        $scope.changePage = function (value) {
          switch (value) {
            case 'increase':
              $scope.filters.page++;
              break;
            case 'decrease':
              $scope.filters.page--;
              break;
            default:
              $scope.filters.page = value;
              break;
          }
          $rootScope[$scope.modelName].filters.page = angular.copy($scope.filters.page);
          $rootScope[$scope.modelName].loadModel();
        };
        $scope.changePerPage = function () {
          console.log('changePerPage', $scope.filters);
          $rootScope[$scope.modelName].filters.page = 1;
          $rootScope[$scope.modelName].filters.per_page = parseInt(angular.copy($scope.filters.per_page));
          $rootScope[$scope.modelName].loadModel();
        };
        //ordenamiento de columnas
        $scope.sortCount = 0;
        $scope.propertyName = '';
        $scope.sortBy = function (propertyName) {
          $scope.propertyName = propertyName;
          $scope.sortCount++;
          $scope.dir = '';
          switch ($scope.sortCount) {
            case 1:
              $scope.dir = 'desc';
              $rootScope[$scope.modelName].filters.orderBy = {field: $scope.propertyName, direction: $scope.dir};
              break;
            case 2:
              $scope.dir = 'asc';
              $rootScope[$scope.modelName].filters.orderBy = {field: $scope.propertyName, direction: $scope.dir};
              break;
            default:
              $scope.sortCount = 0;
              $scope.propertyName = '';
              delete $rootScope[$scope.modelName].filters.orderBy;
              break;
          }
          console.log('orderby!!!!!!!!!', $rootScope[$scope.modelName].filters);
          $rootScope[$scope.modelName].loadModel();
        };

        $rootScope.calculateStock = function (items) {
          var total = 0;
          if (items) {
            angular.forEach(items, function (item) {
              if (item.current_stock) {
                total += item.current_stock;
              }
            });
          }

          return total;
        }
      }
    }
  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uipayment', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
        level: '=',
      },
      rootScope: $rootScope,

      controller: function uipaymentController($uibModal, $scope, $rootScope, toastr,
                                               $state, $auth, $location, $log,
                                               UserService, localStorageService,
                                               TablesService, $window, $modal) {
        $rootScope.paymentTitle = 'Forma de pago';
        $rootScope.newCreditIndex = 'unsigned';
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        $scope.getWName = function(){
          var exit = '';
          angular.forEach($rootScope.voucher.properties.warehouse_id.items, function(w){
            if($rootScope.voucher.selected.warehouse_id == w.id){
              exit = w.name;
            }
          })
          return exit;
        };
        $scope.bussinessRules = function (){
          switch ($rootScope.currentModule) {
            case 'purchases':
              $rootScope.paymentTypes = [
                {type:'account'},
                {type:'transaction'},
              ];
              if(!$rootScope.voucher.selected.partner.partnercategory){
                $rootScope.voucher.selected.partner.partnercategory = {
                  name:'SN',
                  topcredit : 0
                }
              }
              if($rootScope.voucher.selected.partner.partnercategory){
                $scope.oldTopCredit = angular.copy( $rootScope.voucher.selected.partner.partnercategory.topcredit );
              }
              $rootScope.paymentDetail = [
                {label: 'Cliente', value: $rootScope.voucher.selected.partner.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Almacen',
                  value: 'Almacen central'
                }
              ];
              $rootScope[$scope.modelName].selected.vouchertransaction = [];
              break;
            case 'sales':
                $rootScope.paymentTypes = [
                {type:'cash'},
                {type:'card'},
                {type:'note'},
                {type:'transaction'}
              ];
              if(!$rootScope.voucher.selected.partner.partnercategory){
                $rootScope.voucher.selected.partner.partnercategory = {
                  name:'SN',
                  topcredit : 0
                }
              }
              if($rootScope.voucher.selected.partner.partnercategory){
                $scope.oldTopCredit = angular.copy( $rootScope.voucher.selected.partner.partnercategory.topcredit );
              }
              $rootScope.paymentDetail = [
                {label: 'Cliente', value: $rootScope.voucher.selected.partner.name},
                {label: 'Categoría', value: $rootScope.voucher.selected.partner.partnercategory.name},
                {label: 'NIT/CI', value: $rootScope.voucher.selected.partner.docid},
                {label: 'Saldo de crédito',
                  success: function (){return $rootScope.newCreditIndex != 'unsigned'},
                  value: $rootScope.voucher.selected.partner.partnercategory.topcredit},
                {label: 'Fecha / Hora', value: $rootScope.dateNow+' / '+$rootScope.timeNow},
                {label: 'Punto de venta',
                  value: $scope.getWName()
                }
              ];
              $rootScope[$scope.modelName].selected.vouchertransaction = [];
              /*$rootScope[$scope.modelName].selected.vouchertransaction = [
                {
                  payment_type: 'cash',
                  payment_label: 'efectivo',
                  currency: 'Bs.',
                  amount :0
                },
                {
                  payment_type: 'card',
                  payment_label: 'tarjeta',
                  currency: 'Bs.',
                  amount :0
                },
                {
                  payment_type: 'note',
                  payment_label: 'cheque',
                  verification:true,
                  attachment : '',
                  currency: 'Bs.',
                  amount :0,
                  code: ''
                },
                {
                  payment_type: 'transaction',
                  payment_label: 'transfer.',
                  verification:true,
                  currency: 'Bs.',
                  amount : 0,
                  attachment : '',
                  code: ''
                },
              ];
             */
              break;
            case 'inventory':

              break;
          }
        };
        $scope.bussinessRules();

        $rootScope.newPay = function (value, currency, verification, label) {
          $scope.emptyPay = {
            voucher_id: $rootScope.voucher.selected.id,
            partner_id: $rootScope.voucher.selected.partner_id,
            type: '',
            payment_type: value,
            payment_label: label,
            currency:currency?currency:'Bs.',
            verification: '',
            comment: '',
            amount: 0,
            balance: 0,
            debit: 0,
          };
          if(verification === true){
            $scope.emptyPay.verification=true;
            $scope.emptyPay.attachment=true;
          }
          var temp = angular.copy($scope.emptyPay);
          $rootScope.voucher.selected.vouchertransaction.push(temp);
          if(value == 'credit'){
            $rootScope.newCreditIndex = $rootScope.voucher.selected.vouchertransaction.length - 1;
            $rootScope.voucher.selected.vouchertransaction[$rootScope.newCreditIndex].amount =  angular.copy($rootScope.voucher.selected.balance);
          }
        };
        $rootScope.changePay = function(tr){
          switch(tr.customize){
            case "Bs.":
              tr.currency = 'Bs.';
                  break;
            case "USD.":
              tr.currency = 'USD.';
              //$rootScope.newPay(tr.payment_type, 'USD.', (tr.payment_type !='cash' && tr.payment_type!='card') );
                  break;
          }
        };
        $rootScope.$watch( 'newCreditIndex' , function () {
          if($rootScope.newCreditIndex != 'unsigned'){
            $rootScope.voucher.selected.partner.partnercategory.topcredit =
              $rootScope.voucher.selected.partner.partnercategory.topcredit  -
              $rootScope.voucher.selected.vouchertransaction[$rootScope.newCreditIndex].amount;
          }
          else{
            $rootScope.voucher.selected.partner.partnercategory.topcredit =  angular.copy($scope.oldTopCredit);
          }
          angular.forEach( $rootScope.paymentDetail, function (value){
            if(value.label == 'Saldo de crédito'){
              value.value =  $rootScope.voucher.selected.partner.partnercategory.topcredit;
            }
          });

        }, true);
        $rootScope.exchange = function (target, value){
          target.amount = value * $rootScope.globalParams.TcUSD;
        };
        $rootScope.calculateBalance = function (lastChanged) {
          $rootScope.blockPay=false;
          $rootScope.voucher.selected.positiveBalance = 0;
          $rootScope.voucher.selected.totalAmount = 0;
          angular.forEach($rootScope.voucher.selected.vouchertransaction, function (value) {
            if (value.amount){
              $rootScope.voucher.selected.totalAmount += value.amount;
            }
          });
          $rootScope.voucher.selected.totalDebt = $rootScope.voucher.selected.total - $rootScope.voucher.selected.totalAmount;
          if($rootScope.voucher.selected.totalDebt < 0){
            $rootScope.voucher.selected.balance = 0;
            $rootScope.voucher.selected.positiveBalance = angular.copy($rootScope.voucher.selected.totalDebt * -1);
          }
          else{
            $rootScope.voucher.selected.balance =  $rootScope.voucher.selected.totalDebt;
          }
        };
        $scope.remove = function ($index) {
          $rootScope.voucher.selected.vouchertransaction.splice($index, 1);
          $rootScope.calculateBalance();
          $rootScope.newCreditIndex = 'unsigned';
        };

        $scope.resetPay = function () {
          $scope.bussinessRules();
        };

        ///////////// MODEL ESTRUCTURE //////////////
        $rootScope.$watch($scope.modelName + '.selected', function () {
          console.log('REFRESH desde uipayment', $rootScope.voucher.selected);
          if($rootScope.voucher.selected.partner.partnercategory.topcredit < $rootScope.voucher.selected.balance ){
            if($rootScope.newCreditIndex != 'unsigned'){
              $scope.remove($rootScope.newCreditIndex);
            }
          }
          $rootScope.calculateBalance();
        }, true);

        //STORES TRANSACTION
        $scope.updateRegister = function () {
          $scope.control = false;
          if ($rootScope[$scope.modelName].selected.voucherline.length > 0 && $rootScope[$scope.modelName].selected.partner.docid != '') {
            $scope.control = true;
          }
          else {
            toastr.warning('Complete los campos', 'Error');
          }
          if ($scope.control) {
            UserService.actualizarToken()
              .success(function (tok) {
                $rootScope.asignarVarSession('token', tok);
               switch ($rootScope[$scope.modelName].actionType) {
                  case 'store':
                    $rootScope[$scope.modelName].storeRow();
                    break;
                  case 'update':
                    $rootScope[$scope.modelName].updateRow();
                    break;
                  case 'delete':
                    $rootScope[$scope.modelName].deleteRow();
                    break;
                }
              });
          }
        };


      }
    }
  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uiinvoice', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiinvoice/uiinvoice.html',
      restrict: 'E',
      replace: true,
      scope: {
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
        level: '='
      },
      rootScope: $rootScope,

      controller: function uiinvoiceController($uibModal, $scope, $rootScope, toastr,
                                               $state, $auth, $location, $log,
                                               UserService, localStorageService,
                                               TablesService) {


        $rootScope.$watch($scope.modelName + '.selected', function () {
         /*  if ($rootScope.voucher.selected.partner.partnercategory.topcredit < $rootScope.voucher.selected.balance) {
            if ($rootScope.newCreditIndex != 'unsigned') {
              $scope.remove($rootScope.newCreditIndex);
            }
          } */
          console.log('$rootScope.voucher.selected',$rootScope.voucher.selected)
        }, true);
        /* if ($rootScope.voucher.selected.partner.partnercategory) {
          $scope.oldTopCredit = angular.copy($rootScope.voucher.selected.partner.partnercategory.topcredit);
        } */

        $rootScope.printDiv = function () {
          window.print();
        };

        $scope.getWName = function () {
          var exit = '';
          angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w) {
            if ($rootScope.voucher.selected.warehouse_id == w.id) {
              exit = w.name;
            }
          });
          return exit;
        };

        $rootScope.paymentDetail = [
          {label: 'Cliente', value: $rootScope.voucher.selected.user.firstname},
          {label: 'NIT/CI', value: $rootScope.voucher.selected.user.docid},
          {label: 'Razón social', value: $rootScope.voucher.selected.user.docextend},
          {label: 'Fecha / Hora', value: $rootScope.voucher.selected.created_at},
          {label: 'Telefono', value: $rootScope.voucher.selected.user.phone},
          {label: 'Método de pago', value: $rootScope.voucher.selected.payment_type},
        ];
        TablesService.filtrar('warehouse', {selected: $rootScope.voucher.selected.warehouse_id})
          .success(function (res) {
            $rootScope.voucher.selected.warehouse = res.selected;


          });
        var d = new Date();
        $rootScope.dateNow = d.getFullYear() + '/' + parseInt(d.getMonth() + 1) + '/' + d.getDate();
        $rootScope.timeNow = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds();
        $scope.closeAndBack = function () {
          $rootScope.uiConf.switchView('prev')
        };
      }
    }
  });

/**
 * Created by DELL on 28/10/2018.
 */
 'use strict';
 angular.module('frontendapp')
   .directive('uifilters', function ($rootScope) {
     return {
       templateUrl: 'app/scripts/directives/uibuilder/components/uifilters/uifilters.html',
       restrict: 'E',
       replace: true,
       scope: {
         //configuracion basica
         modelLabel: '@',
         modelName: '@',
         customTemplate:'@',
         crudTitle: '@',
       },
       rootScope: $rootScope,

       controller: function uifiltersController($uibModal, $scope, $rootScope, toastr,
                                                       $state, $auth, $location, $log,
                                                       UserService, localStorageService,
                                                       TablesService, $window, $modal) {

         if(!$scope.customTemplate){
           $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uifilters/templates/default.html'
         }
         else{
           $scope.currentTemplate = $scope.customTemplate;
         }

         /*$rootScope[$scope.modelName].filters = angular.copy($rootScope[$scope.modelName].filters);*/
         $rootScope[$scope.modelName].filters2 = angular.copy($rootScope[$scope.modelName].filters);

         //console.log('CARGA FILTROS!!!!!', $rootScope[$scope.modelName], $rootScope[$scope.modelName].filters);

         $scope.loadAcItems = function(model, key, operator, value){
           console.log('ejecuta loadAcItems',model, key, operator, value)
           var filters = {
             per_page: '1000000',
             page: '1',
             filters : {},
             order: [{
               field: 'id',
               direction: 'asc'
             }]
           };
           filters.filters[key]= {
             operator: operator,
             value: value
           };
           if(value==''){
             $scope.search();
           }
           //var targetModel = model?model:$scope.modelName;
           //console.log('recarga datos con ',model, filters)

           TablesService.filtrar(model, filters)
             .success(function (res) {
               if (res.status) {
                 console.log('datos para carga de items',res);
                 $rootScope[$scope.modelName].filters.filters[key].items = res.result.data;
               }
             });
         };

         $scope.pickItem = function(key, value){
           console.log('recarga desde pickItem',key, value);
           $rootScope[$scope.modelName].filters.filters[key].value = value;
           $rootScope[$scope.modelName].filters.filters[key][key+'_open']=false;
           $scope.search();
         };

         $scope.search=function(){
           console.log('recarga desde search',  $rootScope[$scope.modelName].filters);
           //$rootScope[$scope.modelName].filters.filters = angular.copy($rootScope[$scope.modelName].filters.filters);
          // $rootScope[$scope.modelName].loadModel(true);
           TablesService.filtrar($scope.modelName, $rootScope[$scope.modelName].filters)
             .success(function (res) {
               console.log('ORIGINAL RESPONSE',res);
               console.log('ORIGINAL MODEL', $rootScope[res.modelName]);
               if (res.status) {
                 $rootScope[res.modelName].dataset = res.result;
                 $rootScope[res.modelName].globalStatics = res.globalStatics;
                 $rootScope[res.modelName].statics = res.statics;
                 $rootScope[$scope.modelName].filters.page=res.result.page;
                 $rootScope[$scope.modelName].filters.per_page = angular.copy(res.result.per_page) ;

               }
             });
          // $rootScope[$scope.modelName].loadModel();
         };

         $scope.resetFilters = function (){
           $rootScope.reloadUI();
           /*$rootScope[$scope.modelName].filters = $rootScope[$scope.modelName].filters2;
          // $scope.stock.filters = $scope.stBackup;
           $scope.search();*/
         }

         $scope.loadItems = function (filterTarget, model, key, operator, value, other) {
           console.log('loadItems',model, key, operator, value, other);

           switch ($rootScope.currentModule) {
             case 'purchases':
               $scope.partnerType = 3;
               break;
             case 'inventory':
               $scope.partnerType = 1;
               break;
             case 'sales':
               if(filterTarget == 'partner_id'){
                 $scope.partnerType = 2;
               }
               if(filterTarget == 'partner_related'){
                 $scope.partnerType = 1;
               }
               break;
           }
           var filters = {
             per_page: '10',
             page: '1',
             filters: {
               type: {
                 operator: 'whereIn',
                 value:  $scope.partnerType,
               },
               docid :{
                 operator: 'orwhere',
                 other: ['name'/*, 'phone'*/],
                 value: value
               }
             }
           };
           console.log('Antes de enviar',model,  filters);
           TablesService.filtrar(model, filters)
             .success(function (res) {
               if (res.status) {
                 console.log('datos para carga de items', res);
                 $rootScope[$scope.modelName].filters.filters[filterTarget].items = res.result.data;
               }
             });
         };



         $scope.loadFilterList = function (filterTarget, model, key, operator, value, page,searchIn) {
           console.log('loadList', searchIn);
           if (!page) {
             $rootScope[$scope.modelName].filters.filters[filterTarget].items = [];
           }
           var filters = {
             per_page: '25',
             page: page ? parseInt($rootScope[$scope.modelName].filters.filters[filterTarget].page) + 1 : 1,
             filters: {},
             orderBy: {
               field: key,
               direction:'asc'
             }
           };
           filters.filters[key] = {
             operator: operator,
             value: value,
             other: (operator == 'orwhere') ? ['code_secondary', 'description'] : null
           };
           console.log('Antes de enviar', model, filters);
           TablesService.filtrar(model, filters)
             .success(function (res) {
               if (res.status) {
                 console.log('datos para carga de items', res);
                 angular.forEach(res.result.data, function (value, key) {
                   $rootScope[$scope.modelName].filters.filters[filterTarget].items.push(value);
                 });
                 $rootScope[$scope.modelName].filters.filters[filterTarget].page = parseInt(res.result.current_page);
                 $rootScope[$scope.modelName].filters.filters[filterTarget].lastPage = parseInt(res.result.last_page);
               }
             });
         };
         $scope.pick = function(key, value, dato){
           console.log('recarga desde pickItem',key, value, dato);
           $rootScope[$scope.modelName].filters.filters[key].value = value.id;
           $rootScope[$scope.modelName].filters.filters[key].value2 =
             (value[dato.itemsLabel]!="")?value[dato.itemsLabel]:value[dato.itemsLabel2];
           $scope.search();
         };

         $scope.countItems = function(obj){
           if(obj){
             var exit = Object.keys(obj).length?Object.keys(obj).length:0;
             return exit;
           }

         }

         ///////////////////////////////////////

         /* $scope.stock = {
            filters: [
              {
                isopen:    false,
                search:    '',
                model:    'productfamily',
                field:    'productfamily_id',
                label:    'Familia',
                searchIn: 'name',
              },
              {
                isopen:    false,
                search:    '',
                model:    'productbrand',
                field:    'productbrand_id',
                label:    'Marca',
                searchIn: 'name',
              },
              {
                isopen:    false,
                search:    '',
                model:    'productline',
                field:    'productline_id',
                label:    'Linea',
                searchIn: 'name',
              }
            ],
            setFilter: function (sf, item) {
              console.log('setFilter', sf, item);
              /!*$rootScope.stock.filters.filters.product = {
                operator: "has",
                value: parseInt(item.id),
                field: sf.field
              };*!/
              console.log('recarga desde search',  $rootScope[$scope.modelName].filters.filters);
              $rootScope[$scope.modelName].filters.filters = angular.copy($rootScope[$scope.modelName].filters.filters);

              if(!$rootScope[$scope.modelName].filters.filters.product){
                $rootScope[$scope.modelName].filters.filters.product = {
                  operator: "hasGroup",
                  value: [],
                  field: sf.field
                };
              }
              var temp = {
                field: sf.field,
                value: item.id
              };
              var exit = true;
              angular.forEach($rootScope[$scope.modelName].filters.filters.product.value, function (v) {
                if (v.field == sf.field) {
                  v.value = item.id;
                  exit = false;
                }
              });
              if(exit ===true){
                $rootScope[$scope.modelName].filters.filters.product.value.push(temp);
              }
              sf.search = '';
              sf.label = item[sf.searchIn];

              $rootScope.stockR = angular.copy($rootScope.stock.filters.filters);
              console.log('$rootScope.stock', $rootScope.stock.filters.filters);
              $rootScope[$scope.modelName].loadModel();
            },
            loadData: function(f){
              var params = {
                per_page:10,
                filters : {
                  name:{
                    operator:'like',
                    value: f.search
                  }
                }
              };
              TablesService.filtrar(f.model, params)
                .success(function (res) {
                  if (res.status) {
                    console.log('datos para carga de items', res);
                    f.data = res.result.data;
                  }
                });
            }
          };

          $scope.stBackup = angular.copy($scope.stock.filters);
          $rootScope.stockR = angular.copy($rootScope.stock.filters.filters);
  */

         $rootScope.$watch('stockadjustment.filters', function () {
           console.log('stockadjustment desde uifilters', $rootScope[$scope.modelName].filters.filters)
         }, true);

         $scope.setFilter = function (sf, item, dato, key) {
           console.log('setFilter', sf, item, dato, key);

           if (!$rootScope[$scope.modelName].filters.filters.product) {
             $rootScope[$scope.modelName].filters.filters.product = {
               operator: "hasGroup",
               value: [],
               field: sf.field
             };
           }
           var temp = {
             field: sf.field,
             value: item.id
           };
           var exit = true;
           angular.forEach($rootScope[$scope.modelName].filters.filters.product.value, function (v) {
             if (v.field == sf.field) {
               v.value = item.id;
               exit = false;
             }
           });
           if (exit === true) {
             $rootScope[$scope.modelName].filters.filters.product.value.push(temp);
           }
           sf.search = '';
           sf.label = item[sf.searchIn];
           console.log('$rootScope.stock', $rootScope[$scope.modelName].filters.filters);
           $scope.search();
         };

         $scope.resetLoadData =  function(f){
           f.data = [];
           f.page = 0;
         }
         $scope.loadData = function(f){
           console.log('loadData',f);
           /*var params = {
             per_page:10,
             filters : {
               name:{
                 operator:'like',
                 value: f.search
               }
             }
           };*/

           if (!f.page) {
             f.data = [];
           }

           var params = {
             per_page:10,
             filters : {},
             page: f.page ? parseInt(f.page) + 1 : 1,
             orderBy: {
               field: (f.searchIn)?f.searchIn:'id',
               direction:'asc'
             }
           };
           params.filters[(f.searchIn)?f.searchIn:'name']={
             operator:(f.operator)?f.operator:'like',
             value:f.search
           };
           if (f.filters){
             var ftemp = JSON.parse(f.filters);
             angular.forEach(ftemp, function (i, k) {
               console.log('f.filters', k, i);
               params.filters[k] = i;
             })
           }
           console.log('before loadData', f.model, params);
           TablesService.filtrar(f.model, params)
             .success(function (res) {
               if (res.status) {
                 console.log('datos para carga de items', res);
                // f.data = res.result.data;
                 angular.forEach(res.result.data, function (value, key) {
                   f.data.push(value);
                 });
                 f.page = parseInt(res.result.current_page);
                 f.lastPage = parseInt(res.result.last_page);
               }
             });
         }

         $rootScope.stockReport = function () {
           //console.log('stockReport',$rootScope.stockR);
           var exit = '?';
           angular.forEach($rootScope[$scope.modelName].filters.filters, function (v, k) {
             if (k != 'current_stock') {
               if (exit != '?') {
                 exit += '&';
               }
               if (v.operator == 'hasGroup') {
                 angular.forEach(v.value, function (v2, k2) {
                   if (exit != '?') {
                     exit += '&';
                   }
                   exit += v2.field + '=' + ((v2.value) ? v2.value : 'null');
                 });
               }
               else {
                 exit += k + '=' + ((v.value) ? v.value : 'null');
               }
             }

           });
           return exit;
         }




       }
     }
   });

/**
 * Created by DELL on 1/12/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uiexcel', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uiexcel/uiexcel.html',
      //templateUrl: 'app/scripts/directives/uibuilder/components/uipayment/uipayment.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        level: '=',
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uicomboController($uibModal, $scope, $rootScope, toastr,
        $state, $auth, $location, $log, $timeout,
        UserService, localStorageService,
        TablesService, $window, $modal) {

          console.log('$rootScope.movieticketbash');

        $rootScope.fileId = '';
        $rootScope.backupTickets = '';
        $rootScope.loadBatch = function (id) {
          console.log('$rootScope.movieticketbash', $rootScope.movieticketbash);
          // $rootScope.movieticketbash.storeRow();
          TablesService.loadtickets({ id: id })
            .success(function (res) {
              console.log('res loadded', res);
              $rootScope.backupTickets = res;
            })

        }


        $scope.uploadExcel = function () {
          console.log('UPDATE REGISTER', $rootScope[$scope.modelName])
          UserService.actualizarToken()
            .success(function (tok) {
              $rootScope.asignarVarSession('token', tok);
              $rootScope[$scope.modelName].storeRow();
            });
        };

        $scope.saveTickets = function () {
          console.log('saveTickets', $rootScope[$scope.modelName]);

          TablesService.storetickets({ id: $rootScope.fileIdB })
            .success(function (res) {
              console.log('res loadded', res);
              location.reload();
            })
        };

      }
    }
  });

'use strict';
angular.module('frontendapp')
  .directive('uidefaultform', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uidefaultform/uidefaultform.html',
      restrict: 'E',
      replace: true,
      scope: {
        level: '=',
        modelName: '@',
        modelParent: '@',
      },
      rootScope: $rootScope,
      controller: function uidefaultformController($uibModal, $scope, $rootScope, toastr,
        $state, $auth, $location, $log, Upload,
        UserService, localStorageService,
        TablesService, $window, $modal) {




        //=================DB interactions===================
        $scope.updateRegister = function () {
          console.log('UPDATE REGISTER', $rootScope[$scope.modelName])
          if ($scope.checkAllValidations()) {
            switch ($rootScope[$scope.modelName].actionType) {
              case 'update':
                $rootScope[$scope.modelName].updateRow();
                break;
              case 'store':
                $rootScope[$scope.modelName].storeRow();
                break;
              case 'delete':
                $rootScope[$scope.modelName].deleteRow();
                break;
            }
            /* UserService.actualizarToken()
              .success(function (tok) {
                console.log('refreshed Token', tok);
                $rootScope.asignarVarSession('token', tok);
                $rootScope.asignarVarSession('satellizer_token', tok);
               //]] $rootScope.tk=tok;
                $rootScope.tk = tok;
                setTimeout(function(){
                  switch ($rootScope[$scope.modelName].actionType) {
                    case 'update':
                      $rootScope[$scope.modelName].updateRow();
                      break;
                    case 'store':
                      $rootScope[$scope.modelName].storeRow();
                      break;
                    case 'delete':
                      $rootScope[$scope.modelName].deleteRow();
                      break;
                  }
                },20);
              }); */
          }
        };

        //=======================VALIDATION RULES=====================


        //text-angular
        $scope.loadToolBar = function (mode) {
          var toolbarConfig = angular.copy(mode);
          console.log('loadToolBar', mode);
          switch (mode) {
            case 'reduced':
              toolbarConfig = [
                ['bold', 'italics', 'underline', 'strikeThrough'],
                ['undo', 'redo', 'clear'],
                ['html'],
                ['wordcount', 'charcount']
              ];
              break;
            case 'basics':
              toolbarConfig = [
                ['p'],
                ['bold', 'italics', 'underline', 'strikeThrough'],
                ['ul', 'ol'],
                ['undo', 'redo', 'clear'],
                ['html'],
                ['insertLink'],
                ['wordcount', 'charcount']
                /*['bold', 'italics', 'underline', 'strikeThrough'],
                 ['ul', 'ol'],
                 ['undo', 'redo', 'clear'],
                 ['html'],
                 ['wordcount', 'charcount']*/
              ];
              break;
            case 'complete':
              toolbarConfig = [
                ['insertRelation', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'pre', 'quote'],
                ['bold', 'italics', 'underline', 'strikeThrough'],
                ['ul', 'ol'],
                ['undo', 'redo', 'clear'],
                ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
                ['html'],
                ['insertImage', 'insertLink', 'insertVideo'],
                ['wordcount', 'charcount']
              ];
              break;
          }
          return toolbarConfig;
        };
        //text transformations
        $scope.dateToSpanishFormat = function (dateString) {
          var x = new Date(dateString);
          var y = x.toDateString();
          y = y.replace("Mon", "Lun");
          y = y.replace("Tue", "Mar");
          y = y.replace("Wed", "Mié");
          y = y.replace("Thu", "Jue");
          y = y.replace("Fri", "Vie");
          y = y.replace("Sat", "Sáb");
          y = y.replace("Sun", "Dom");
          y = y.replace("Jan", "Enero");
          y = y.replace("Feb", "Febrero");
          y = y.replace("Mar", "Marzo");
          y = y.replace("Apr", "Abril");
          y = y.replace("May", "Mayo");
          y = y.replace("Jun", "Junio");
          y = y.replace("Jul", "Julio");
          y = y.replace("Aug", "Agosto");
          y = y.replace("Sep", "Septiembre");
          y = y.replace("Oct", "Octubre");
          y = y.replace("Nov", "Noviembre");
          y = y.replace("Dec", "Diciembre");
          var z = y.split(" ");
          return (z[2] + ' de ' + z[1] + ' de ' + z[3]);
        };
        $scope.numberToMonth = function (dateString) {
          var y = '' + dateString;
          y = y.replace("1", "Enero");
          y = y.replace("2", "Febrero");
          y = y.replace("3", "Marzo");
          y = y.replace("4", "Abril");
          y = y.replace("5", "Mayo");
          y = y.replace("6", "Junio");
          y = y.replace("7", "Julio");
          y = y.replace("8", "Agosto");
          y = y.replace("9", "Septiembre");
          y = y.replace("10", "Octubre");
          y = y.replace("11", "Noviembre");
          y = y.replace("12", "Diciembre");
          return y;
        };

        //maps
        $scope.pos = function () {
          $scope.p = this.getPosition();
          $rootScope[$scope.modelName].selected.lat = $scope.p.lat();
          $rootScope[$scope.modelName].selected.lng = $scope.p.lng();
          console.log('drag marker: ', $scope.p.lat(), $scope.p.lng(), $rootScope[$scope.modelName].selected.lat)
        };
        //maps
        $scope.posJson = function (key) {
          $scope.p = this.getPosition();
          $rootScope[$scope.modelName].selected[key].lat = $scope.p.lat();
          $rootScope[$scope.modelName].selected[key].lon = $scope.p.lng();
        };
        //ui-switch
        $scope.uiSwitch = function (value) {
          var x = angular.copy($rootScope[$scope.modelName].selected[value])
          if (x || x == 1 || x == '1') {
            $rootScope[$scope.modelName].selected[value] = 0;
          }
          if (!x || x == 0 || x == '0') {
            $rootScope[$scope.modelName].selected[value] = 1;
          }
        };
        //passwords

        $scope.validatePassword = function (id1, id2) {
          var pass2 = document.getElementById(id1).value;
          var pass1 = document.getElementById(id2).value;
          /*if(pass1.length < 6 ){
           document.getElementById(id2).setCustomValidity("Se requieren mínimo 6 caracteres");
           }*/
          if (pass1 != pass2)
            document.getElementById(id2).setCustomValidity("Las contraseñas no coinciden");
          else
            document.getElementById(id2).setCustomValidity('');
        };
        $scope.passGeneratorReady = false;
        $scope.passGenerator = function (len) {
          var length = (len) ? (len) : (10);
          var string = "abcdefghijklmnopqrstuvwxyz"; //to upper
          var numeric = '0123456789';
          var punctuation = '!@#$%^&*()_+~`|}{[]\:;?><,./-=';
          var password = "";
          var character = "";
          var crunch = true;
          while (password.length < length) {
            var entity1 = Math.ceil(string.length * Math.random() * Math.random());
            var entity2 = Math.ceil(numeric.length * Math.random() * Math.random());
            var entity3 = Math.ceil(punctuation.length * Math.random() * Math.random());
            var hold = string.charAt(entity1);
            var hold = (entity1 % 2 == 0) ? (hold.toUpperCase()) : (hold);
            character += hold;
            character += numeric.charAt(entity2);
            character += punctuation.charAt(entity3);
            password = character;
          }

          //$rootScope[$scope.modelName].selected.password = password;
          //$scope.copyField = password;
          //$scope.passGeneratorReady = true;
          //return password;
        };
        //datepicker

        $scope.options = {
          customClass: getDayClass,
          minDate: new Date(),
          showWeeks: true
        };
        $scope.toggleMin = function () {
          $scope.options.minDate = $scope.options.minDate ? null : new Date();
        };
        $scope.toggleMin();
        $scope.setDate = function (year, month, day) {
          $scope.dt = new Date(year, month, day);
        };
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        var afterTomorrow = new Date(tomorrow);
        afterTomorrow.setDate(tomorrow.getDate() + 1);
        $scope.events = [
          {
            date: tomorrow,
            status: 'full'
          },
          {
            date: afterTomorrow,
            status: 'partially'
          }
        ];
        function getDayClass(data) {
          var date = data.date,
            mode = data.mode;
          if (mode === 'day') {
            var dayToCheck = new Date(date).setHours(0, 0, 0, 0);

            for (var i = 0; i < $scope.events.length; i++) {
              var currentDay = new Date($scope.events[i].date).setHours(0, 0, 0, 0);

              if (dayToCheck === currentDay) {
                return $scope.events[i].status;
              }
            }
          }
          return '';
        }

        //required fields
        $scope.checkAllValidations = function () {
          var exit = true;
          return true;
        };
        $scope.sortBy = function (widget, propertyName) {
          widget.reverse = (widget.propertyName === propertyName) ? !widget.reverse : false;
          widget.propertyName = propertyName;
        };
        $scope.reOrder = function (parent, model, property, item1, item2) {
          console.log('reorder', parent, model, property, item1, item2);
          var a = angular.copy(item1[(property.presentation.order) ? property.presentation.order : 'order']);
          var b = angular.copy(item2[(property.presentation.order) ? property.presentation.order : 'order']);
          TablesService.actualizar(model, item1.id, { order: b, ui_order: b })
            .success(function (res) {
              if (res.status) {
                TablesService.actualizar(model, item2.id, { order: a, ui_order: a })
                  .success(function (res) {
                    if (res.status) {
                      TablesService.filtrar(parent, { selected: $rootScope[parent].selected.id })
                        .success(function (res) {
                          console.log('Salida filtrar', res);
                          property.items = res.selected[model];
                        });
                      toastr.success('Registro actualizado', 'OK');
                    }
                    else {
                      toastr.warning('Registro no actualizado', 'Error');
                    }
                  })
                  .error(function () {
                    toastr.warning('Registro no actualizado', 'Error');
                  });
              }
              else {
                toastr.warning('Registro no actualizado', 'Error');
              }
            })
            .error(function () {
              toastr.warning('Registro no actualizado', 'Error');
            });


        };


      }
    }
  })
  ;

'use strict';
angular.module('frontendapp')
  .directive('uicrudgrid', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uicrudgrid/crudgrid.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
      },
      rootScope: $rootScope,

      controller: function uicrudgridController($uibModal, $scope, $rootScope, toastr,
                                                $state, $auth, $location, $log,
                                                UserService, localStorageService,
                                                TablesService, $window, $modal) {


        $scope.level = 0;
        $scope.modelParent = $scope.modelName;
        ///////////// MODEL ESTRUCTURE ///////////////


        $scope.filters = {
          per_page: "10",
          page: 1
        };
        //paginacion
        $scope.changePage = function (value) {
          switch (value) {
            case 'increase':
              $scope.filters.page++;
              break;
            case 'decrease':
              $scope.filters.page--;
              break;
            default:
              $scope.filters.page = value;
              break;
          }
          $rootScope[$scope.modelName].filters.page = angular.copy($scope.filters.page);
          $rootScope[$scope.modelName].loadModel();
        };
        $scope.changePerPage = function () {
          console.log('changePerPage', $scope.filters);
          $rootScope[$scope.modelName].filters.page = 1;
          $rootScope[$scope.modelName].filters.per_page = parseInt(angular.copy($scope.filters.per_page));
          $rootScope[$scope.modelName].loadModel();
        };
        //ordenamiento de columnas
        $scope.sortCount = 0;
        $scope.propertyName = '';
        $scope.sortBy = function (propertyName) {
          $scope.propertyName = propertyName;
          $scope.sortCount++;
          $scope.dir = '';
          switch ($scope.sortCount) {
            case 1:
              $scope.dir = 'desc';
              $rootScope[$scope.modelName].filters.orderBy = {field: $scope.propertyName, direction: $scope.dir};
              break;
            case 2:
              $scope.dir = 'asc';
              $rootScope[$scope.modelName].filters.orderBy = {field: $scope.propertyName, direction: $scope.dir};
              break;
            default:
              $scope.sortCount = 0;
              $scope.propertyName = '';
              delete $rootScope[$scope.modelName].filters.orderBy;
              break;
          }
          console.log('orderby!!!!!!!!!', $rootScope[$scope.modelName].filters);
          $rootScope[$scope.modelName].loadModel();
          /*$scope.sortCount++;
           $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
           $scope.propertyName = propertyName;
           if ($scope.sortCount == 3) {
           $scope.sortCount = 0;
           $scope.propertyName = '';
           delete $scope.filters.orden;
           }
           else {
           if ($scope.reverse) {
           var dir = 'desc'
           }
           else {
           var dir = 'asc'
           }
           $scope.filters.orden = [{
           campo: propertyName,
           direccion: dir
           }]
           }
           $scope.reloadData();*/
        };


       /*  setTimeout(function(){
          $rootScope.uiConf.switchView('next', {component:'uireport', model:'voucher'},false)
        }, 2000) */

      }
    }
  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uicontextualmenu', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/components/uicontextualmenu/uicontextualmenu.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        customTemplate: '@',
        crudTitle: '@',
      },
      rootScope: $rootScope,

      controller: function uicontextualmenuController($uibModal, $scope, $rootScope, toastr,
                                                      $state, $auth, $location, $log,
                                                      UserService, localStorageService,
                                                      TablesService, $window, $modal) {

        if (!$scope.customTemplate) {
          $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/default.html'
        }
        else {
          $scope.currentTemplate = $scope.customTemplate;
        }

        if ($scope.modelName == 'stocklog') {
          $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/stocklog.html';
        }
        if ($scope.modelName == 'selleragenda') {
          $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/selleragenda.html';
        }
        if ($scope.modelName == 'payrequest') {
          $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-temp.html';
        }
        if ($scope.modelName == 'voucher') {
          switch ($rootScope.currentState) {
            case 'sales-point':
            case 'transfer-point':
            case 'purchase-point':
              $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-creation.html';
              break;
            case 'sales-debts':
            case 'purchases-debts':
            case 'pend-cashregister':
              $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-transaction.html';
              break;
            //inventory
            case 'pend-purchases-incomes':
            case 'pend-transfer-incomes':
            case 'op-purchases-incomes':
            case 'op-transfer':
            case 'op-transfer-request':
            //sales
            case 'sales-delivery-point':
            case 'hist-sales':
            case 'hist-rent':
            case 'hist-consignation':
              $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-stockorder.html';
              break;
            default:
              $scope.currentTemplate = 'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-creation.html';
              break;
          }
        }


        $scope.modelParent = $scope.modelName;
        ///////////// MODEL ESTRUCTURE //////////////

        $rootScope.$watch($scope.modelName + '.selected', function () {
          //console.log('REFRESH selected desde context', $rootScope[$scope.modelName].selected);

        }, true);

        $scope.clevel = 1;
        $rootScope.tabl2 = 1;
        $rootScope.tab = 1;

        $scope.switchClevel = function (value) {
          switch (value) {
            case 'next':
              $scope.clevel++;
              break;
            case 'prev':
              $scope.clevel--;
              break;
            default:
              $scope.clevel = value;
              break;
          }
        };
        $scope.setVoucherFilter = function (item, properties) {
          $scope.voucherFilter = item.id;
          $scope.voucherLabel = item.label2;
          $scope.voucherRules = angular.copy(item);
          console.log(
            'setVoucherFilter',
            item,
            $scope.voucherFilter,
            $scope.voucherLabel,
            $scope.voucherRules
          );
          $scope.checkItems = function () {
            var exit = false;
            angular.forEach($rootScope[$scope.modelName].selected.partner.voucher, function (i) {
              //console.log(i.vouchertype_id,$scope.voucherFilter );
              if (i.vouchertype_id == $scope.voucherFilter && !exit) {
                exit = true;
              }
            });
            return exit;
          };
          console.log('vouchers loadad', $rootScope[$scope.modelName].selected.partner.voucher)
        }

      }
    }
  });

/**
 * Created by DELL on 28/10/2018.
 */
'use strict';
angular.module('frontendapp')
  .directive('uibuilder', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/uibuilder/uibuilder.html',
      restrict: 'E',
      replace: true,
      scope: {
        //configuracion basica
        modelLabel: '@',
        modelName: '@',
        crudTitle: '@',
        //filtros
        customFilter: '=',
        //customization
        collection: '=',
        /////////////////////
        uiCrudTitle: '@',
        uiFirstLevel: '='
      },
      rootScope: $rootScope,

      controller: function uibuilderController($uibModal, $scope, $rootScope, toastr,
        $state, $auth, $location, $log,
        UserService, localStorageService,
        TablesService, Upload, $window, $modal) {

        /////////// MODEL CONSTRUCTOR  //////////////
        $rootScope.modelConstruct = function (params) {
          console.log('modelConstruct', params)
          $rootScope[params.modelAs ? params.modelAs : params.model] = {
            accessDenied: false,
            refresh: (params.refresh != null) ? params.refresh : true,
            label: params.label,
            model: params.model,
            gridTitle: params.gridTitle,
            parentModel: params.parentModel,
            childModel: params.childModel,
            customComponent: params.customComponent,
            referenceField: '',
            customProperties: params.customProperties ? params.customProperties : null,
            properties: {},
            customFilters: params.customFilters ? params.customFilters : null,
            filters: { filters: {} },
            dataset: {},
            selected: {},
            operations: params.operations ? params.operations : {},
            customOperations: params.customOperations ? params.customOperations : {},
            actionType: params.actionType ? params.actionType : null,
            newSelected: function () {
              this.selected = {};
              console.log('new!!');
              for (var j in this.properties) {
                if (this.properties[j].default) {

                  if (this.properties[j].type == 'json') {
                    this.selected[j] = JSON.parse(this.properties[j].default);
                  }
                  else {
                    this.selected[j] = this.properties[j].default;

                  }
                } else {
                  this.selected[j] = '';
                }
                if (j == this.parentModel + '_id') {
                  //console.log('DETECTA DEPENDENCIA', j);
                  this.selected[j] = $rootScope[this.parentModel].selected.id;
                  this.properties[j].disabled = true;
                }
              }
              this.resolveMethodsOf();
            },
            resetRegister: function (close) {
              $rootScope[this.model + '_old'] = angular.copy(this);
              if (close) {
                $rootScope.uiConf.switchView('prev', {}, this.refresh);
              }
              else {
                this.selected = angular.copy(this.selectedBackup);
                //this.resolveMethodsOf();
              }
              console.log('ejecuta reseteo', this);
            },
            loadModel: function () {
              if (this.customFilters) {
                this.filters = this.customFilters;
                //console.log('agrega filtros personalizados')
              }
              //console.log('SOLICITA:', this.model, this.filters);
              console.log('LOADING MODEL', this);
              TablesService.filtrar(this.model, this.filters)
                .success(function (res) {
                  console.log("========CRUD CONSOLE===========");
                  console.log('ORIGINAL RESPONSE', res);
                  console.log('ORIGINAL MODEL', $rootScope[res.modelName]);
                  if (res.status) {
                    $rootScope[res.modelName].dataset = res.result;
                    $rootScope[res.modelName].reload = false;
                    $rootScope[res.modelName].operations = res.options;
                    $rootScope[res.modelName].properties = res.modelProperties;
                    $rootScope[res.modelName].selected = res.selected;
                    $rootScope[res.modelName].referenceField = res.referenceField;
                    $rootScope[res.modelName].extraConf = res.extraConf;
                    res.modellabel != '' ? $scope.uiCrudTitle = res.modellabel : '';
                    $scope.referenceField = res.referenceField;

                    if ($rootScope[res.modelName].customProperties) {
                      $rootScope.customizeProperty($rootScope[res.modelName].properties, $rootScope[res.modelName].customProperties);
                    }
                    if ($rootScope[res.modelName].selected) {
                      $rootScope[res.modelName].resolveMethodsOf();
                      $rootScope[res.modelName].selectedBackup = angular.copy($rootScope[res.modelName].selected);
                    }
                    if ($rootScope[res.modelName].customFilters) {
                      //customize or overwrite filters
                      $rootScope.customizeProperty($rootScope[res.modelName].filters.filters, res.filterSet);
                    }
                    else {
                      //creates filters set
                      $rootScope[res.modelName].filters.filters = {};
                      $rootScope[res.modelName].filters.filters = res.filterSet;
                    }
                    if ($rootScope[res.modelName].customOperations && Object.keys($rootScope[res.modelName].customOperations).length > 0) {
                      //customize or overwrite filters
                      console.log('customOperations', $rootScope[res.modelName].customOperations, ' = ', Object.keys($rootScope[res.modelName].customOperations).length);
                      $rootScope[res.modelName].operations = angular.copy($rootScope[res.modelName].customOperations);
                      /* $rootScope.customizeProperty($rootScope[res.modelName].operations);*/
                    }
                    if ($rootScope[res.modelName].actionType == 'store' && !$rootScope[res.modelName].selected) {
                      $rootScope[res.modelName].newSelected();
                    }
                    $rootScope[res.modelName].ready = true;
                  }
                  console.log('ESTRUCTURA DE CRUD', $rootScope[res.modelName]);
                });
            },
            getFilesToUpload: function () {
              var fileslist = { fields: [] };
              var properties = this.properties;
              var selected = this.selected;
              angular.forEach(properties, function (value, key) {
                if (value.type == 'file' && typeof selected[key + '_file'] == 'object') {
                  fileslist[key] = selected[key + '_file'];
                  fileslist.fields.push(key);
                }
              });
              this.fileslist = fileslist;
            },
            uploadFiles: function () {
              Upload.upload({
                url: $rootScope.api + '/api/' + this.model + '/upload/' + this.selected.id,
                data: this.fileslist
              }).then(function (response) {
                console.log('upload 1', response);
                var result = response.data;
                if (result.response) {
                  toastr.success('Registro almacenado', 'Exito');
                  if (result.modelName == 'movieticketbatch') {
                    console.log('UPLOADING XLS', result)
                    toastr.info('Cargando Archivo Excel ', 'Procesando');
                    $rootScope.loadBatch(result.id);
                    $rootScope.fileIdB = result.id;
                    /* TablesService.storemetadata({ id: result.id })
                      .success(function (res) {
                        console.log('Salida GETFILE', res);

                      }) */
                  }
                  else {
                    $rootScope[result.modelName].resetRegister(true);
                  }
                } else {
                  toastr.success('Registro almacenado', 'Exito');
                }
              }, function (response) {
                console.log('upload 2', response)
                if (response.status > 0) {
                  toastr.warning(response.status + ': ' + response.data, 'Error');
                  $scope.errorMsg = response.status + ': ' + response.data;
                }
              }, function (evt) {
                console.log('upload 3', evt)
                $scope.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
              });

            },
            storeMany: function (items) {
              TablesService.storemany(this.model, items)
                .success(function (res) {
                  console.log('Salida almacenar', res);
                  if (res.status) {
                    toastr.success('Registro almacenado', 'Exito');
                    $rootScope.uiConf.switchView('prev', {}, true);
                  }
                  else {
                    toastr.warning('Registro no almacenado', 'Error');
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida almacenar', res);
                  toastr.warning('Registro no almacenado', 'Error');
                });
            },
            storeRow: function () {
              console.log('ingresa en store');
              this.getFilesToUpload();
              TablesService.almacenar(this.model, this.selected)
                .success(function (res) {
                  console.log('Salida almacenar', res);
                  if (res.status) {
                    $rootScope[res.modelName].selected.id = res.result.id;
                    if ($rootScope[res.modelName].fileslist.fields.length > 0) {
                      $rootScope[res.modelName].uploadFiles();
                      toastr.info('Cargando archivos', 'En proceso');
                    }
                    else {
                      toastr.success('Registro almacenado', 'Exito');
                      $rootScope[res.modelName].resetRegister($rootScope[res.modelName].refresh);
                    }
                  }
                  else {
                    toastr.warning('Registro no almacenado', 'Error');
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida almacenar', res);
                  toastr.warning('Registro no almacenado', 'Error');
                });
            },
            updateRow: function () {
              this.getFilesToUpload();
              console.log('ingresa en update enviando', this.selected);
              TablesService.actualizar(this.model, this.selected.id, this.selected)
                .success(function (res) {
                  console.log('Salida actualizar', res);
                  if (res.status) {
                    if ($rootScope[res.modelName].fileslist.fields.length > 0) {
                      $rootScope[res.modelName].uploadFiles();
                      toastr.info('Cargando archivos', 'En proceso');
                    }
                    else {
                      toastr.success('Registro actualizado', 'Exito');
                      $rootScope[res.modelName].resetRegister(true);
                    }
                  }
                  else {
                    toastr.warning('Registro no actualizado', 'Error');
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida actualizar', res);
                  toastr.warning('Registro no actualizado', 'Error');
                });
            },
            deleteRow: function () {
              console.log('ingresa en delete');
              TablesService.eliminar(this.model, this.selected.id, this.selected)
                .success(function (res) {
                  console.log('Salida eliminar', res);
                  if (res.status) {
                    toastr.success('Registro eliminado', 'Exito');
                    $rootScope[res.modelName].resetRegister(true);
                  }
                  else {
                    toastr.warning('Registro no eliminado', 'Error');
                  }
                })
                .error(function (res) {
                  console.log('ERROR salida eliminar', res);
                  toastr.warning('Registro no eliminado', 'Error');
                });
            },
            resolveMethodsOf: function () {
              console.log('inicia resolve', this);
              for (var property in this.properties) {
                for (var j in this.properties[property].resolve) {
                  console.log('rresuelve', j);
                  this.properties[property][j] = this.resolve(this.properties[property].resolve[j]);
                  console.log('resolve!!!!', j);
                }
                if (this.properties[property].type == 'innerCrud' && this.selected && this.actionType != 'store') {
                  console.log('say hello!!! selected', this.selected[property]);
                  console.log('say hello!!! properties', this.properties[property]);
                  this.prepareInnerCrud(this.selected[property], this.properties[property]);
                }
              }
            },
            resolve: function (functionInjected) {
              return functionInjected(this);
            },
            //NOT COMPLETE
            prepareInnerCrud: function (source, properties) {
              properties.items = [];
              if (properties.hasLevels) {
                properties.items = source;
              }
              else {
                if (source.length > 0) {
                  properties.items.push(source);
                }
              }
              if (properties.items.length > 0) {
                angular.forEach(properties.items, function (subitem) {
                  subitem.referenceField = $rootScope.getVarFromString(subitem, properties.itemsLabel)
                });
                console.log('innercruditems', properties.items)
              }

            }
          };
          $rootScope[params.modelAs ? params.modelAs : params.model].loadModel(); // MODEL BUILDER
        };

        /////////// UI CONFIGURATION  //////////////
        $rootScope.uiConf = {
          currentLevel: 0,
          level: [],
          setNewLevel: function (params, autoload) {
            //console.log('PARAMS EVALUATED', params)
            var control = false; // if control is true doesnt create a new level
            if (this.level[this.currentLevel]) {
              control = (this.level[this.currentLevel].component == params.component && this.level[this.currentLevel].model == params.model);
            }
            if (control === false) {
              this.level.push(params);
              if (autoload) {
                $rootScope.modelConstruct(params);
              }
              this.currentLevel = this.level.lastIndexOf(params);
              console.log('NEW LEVEL UICONF', $rootScope.uiConf)
            }
            $rootScope.excelPath = '';
          },
          destroyCurrentLevel: function (autoload) {
            var index = this.level.indexOf(this.level[this.currentLevel]);
            if (index > 0) {
              if (index > -1) {
                this.level.splice(index, 1);
              }
              this.currentLevel--;
              if (autoload) {
                $rootScope[this.level[this.currentLevel].model].loadModel();
              }
            }
          },
          switchView: function (option, params, autoload) {
            console.log('UICONF OBJECT', option, params, autoload)
            switch (option) {
              case 'next':
                this.setNewLevel(params, autoload);
                break;
              case 'prev':
                this.destroyCurrentLevel(autoload);
                break;
              case 'new':
                this.setNewLevel(params, true);
                break;
              default:
                break;
            }
            console.log('UICONF OBJECT', $rootScope.uiConf)
          },
        };

        /////////// CRUD BUILDER'S TRIGGER //////////////
        $rootScope.uiConf.switchView('new', $scope.uiFirstLevel, true);

        //CUSTOMIZE MODEL PROPERTIES FROM FRONTEND
        $rootScope.customizeProperty = function (target, property) {
          console.log('CUSTOM', target, property);
          for (var j in property) {
            console.log('CUSTOM LEV 0', j)
            if (typeof property[j] == 'object') {
              if (!target[j]) {
                target[j] = {};
              }
              for (var k in property[j]) {
                //console.log('CUSTOM LEV 2',target[j],  k)
                target[j][k] = property[j][k];
              }
            }
            else {
              //console.log('CUSTOM LEV 1', j)
              target[j] = property[j];
            }
          }
        };

        $rootScope.getProp = function (property) {
          var keepGoing = true;
          angular.forEach(property, function (value, key) {
            if (keepGoing) {
              if (typeof value != 'object') {
                keepGoing = false;
                return value;
              }
            }
          });
        };

        //SET SELECTED ATRIBUTE TO CURRENT MODEL
        $rootScope.chooseRegister = function (modelName, selected, actionType, reload, component) {
          console.log('SELECCIONA', modelName, selected, actionType, reload, component);
          $rootScope[modelName].selected = selected;
          $rootScope[modelName].actionType = actionType;
          $rootScope[modelName].resolveMethodsOf();
          if (actionType == 'store') {
            $rootScope[modelName].newSelected();
            console.log('NEW SELECTED ATRIBUTE', $rootScope[modelName].selected)
          }
          if (actionType == 'read') {
            $rootScope.showInfoMenu(true);
          }
          if (actionType != 'read') {
            $rootScope[modelName].selectedBackup = angular.copy(selected);
            $rootScope[modelName].filters.selected = angular.copy(selected.id);
            var params = {
              component: component ? component : 'uidefaultform',
              model: modelName,
              actionType: $rootScope[modelName].actionType,
              filters: $rootScope[modelName].filters
            };
            //console.log('params before new level', params);
            $rootScope.uiConf.switchView('next', params, reload);
          }
          console.log('modelo actual', $rootScope[modelName])
        };

        //creates new inner crud
        $rootScope.setInnerCrud = function (modelName, selected, actionType, parentModel, properties) {
          console.log('ingresa:', modelName, selected, actionType, parentModel, properties);
          console.log('seleccionado inner crud', selected);
          var params = {
            component: 'uidefaultform',
            model: modelName,
            parentModel: parentModel,
            actionType: actionType,
            customFilters: {
              selected: (selected) ? angular.copy(selected.id) : null
            },
          };
          if (properties && properties.customProperties && properties.customProperties != null) {
            params.customProperties = properties.customProperties;
          }
          $rootScope.uiConf.switchView('new', params, true);
        };

        $rootScope.openPicker = function (model, modelAs, childModel) {
          var params = {
            component: 'uipiker',
            model: model,
            modelAs: modelAs,
            childModel: childModel,
          };
          $rootScope.uiConf.switchView('new', params, true)
          if (childModel) {
            $rootScope[modelAs].childModel = childModel;
          }

        };

        //get reference field in a relation
        $rootScope.getVarFromString = function (target, searched) {
          var exit = '';
          var levels = searched.split('.');
          switch (levels.length) {
            case 1:
              exit = target[levels[0]];
              break;
            case 2:
              exit = target[levels[0]][levels[1]];
              break;
            case 3:
              exit = target[levels[0]][levels[1]][levels[2]];
              break;
            case 4:
              exit = target[levels[0]][levels[1]][levels[2]][levels[3]];
              break;
          }
          /*console.log('BUSCANDO', target);
           console.log('searched', searched);
           console.log('levels', levels);
           console.log('MAPPEADO', exit, levels.length)*/
          return exit;
        };

        //operations to add objects in a list
        $rootScope.verifyInList = function (target, item, fieldcontrol) {
          var exit = true;
          angular.forEach(target, function (value, key) {
            if (value[fieldcontrol] == item[fieldcontrol]) {
              exit = false;
            }
          });
          return exit;
        };

        $rootScope.addToList = function (list, item, fieldcontrol, autoremove) {
          if ($rootScope.verifyInList(list, item, fieldcontrol)) {
            list.push(item);
          }
          else {

            if (autoremove) {
              var tempIndex = list.indexOf(item);
              //list.splice(tempIndex, 1);
              var control = false;
              angular.forEach(list, function (i, key) {
                if (!control && item[fieldcontrol] == i[fieldcontrol]) {
                  tempIndex = key;
                  control = true;
                  console.log('tempIndex', tempIndex)
                }
              });
              list.splice(tempIndex, 1);
            }
            else {
              toastr.warning('Registro duplicado', 'Error');
              console.log('error', list);
            }
          }
          console.log('lista actualizada', list);
        };

        //Chanve view title, when changeTitle change
        $rootScope.$watch('changeTitle', function () {
          if ($rootScope.changeTitle) {
            $scope.uiCrudTitle = $rootScope.changeTitle;
          }
        });

        //Reload UI
        $rootScope.loadItemList = function (target, model) {
          TablesService.filtrar(model, { per_page: 100000 })
            .success(function (res) {
              if (res.status) {
                console.log('lista cargada', res);
                target.items = res.result.data;
              }
            });
        };
        //Reload UI
        $rootScope.reloadUI = function () {
          location.reload();
        };

        ///////////////////////////////////////////////////
        //////////////CUSTOMIZATION GUIBDENTAL/////////////
        ///////////////////////////////////////////////////
        ////////PRODUCTS, SALES, TRANSFER, PURCHASE////////
        ///////////////////////////////////////////////////
        ///////////////// DIRECTIVES  /////////////////////
        //Trigguer multiple products picker
        $rootScope.openPicker = function (model, customSettings, warehouse) {
          console.log('openPicker', model, customSettings);
          $rootScope.uiConf.switchView('next',
            {
              actionType: $rootScope.productcombogroup.actionType,
              component: 'uipiker',
              model: model
            }, false
          );
          /*$rootScope.uiConf.switchView('new',  {
           actionType:'store',
           component:'uipiker',
           model:model
           }, true);*/
        };
        //Trigger payments directive
        $rootScope.setDebt = function () {
          $rootScope.voucher.actionType = 'update';
          $rootScope.voucher.selected.newTransaction = true;
          $rootScope.voucher.selected.voucherTotal = angular.copy($rootScope.voucher.selected.total);
          $rootScope.voucher.selected.total = $rootScope.voucher.selected.credit_amount;
        };
        $rootScope.openPayment = function () {
          $rootScope.uiConf.switchView('next', { actionType: 'store', component: 'uipayment', model: 'voucher' }, false);
        };
        //Trigguer stock order directive
        $rootScope.setStockorder = function (value) {
          $rootScope.stockOrderSelected = angular.copy(value);
        };
        $rootScope.openStockview = function () {
          $rootScope.voucher.actionType = 'update';

          $rootScope.uiConf.switchView('next', {
            actionType: 'update',
            component: 'uiinventorycheck',
            model: 'voucher'
          }, false);
        };
        //trigguer combo view directive
        $rootScope.openComboview = function () {
          $rootScope.voucher.actionType = 'update';
          $rootScope.uiConf.switchView('next', {
            actionType: 'update',
            component: 'uicombo',
            model: 'voucher'
          }, false);
        };
        ///////////////GLOBAL FUNCTIONS///////////////////
        //READ AND LOAD VOUCHERS
        $rootScope.readTempVoucher = function (voucher) {
          $rootScope.uiConf.switchView('next', {
            actionType: 'store',
            component: 'uireadvoucher',
            model: 'voucher'
          }, false);
          $rootScope.tempVoucher = angular.copy(voucher);
        };
        $rootScope.loadVoucher = function (voucher, actionType) {
          $scope.partnerB = angular.copy(voucher.partner);
          $scope.partner_idB = angular.copy(voucher.partner_id);
          $rootScope.voucher.selected = angular.copy(voucher);
          $rootScope.voucher.actionType = actionType;
          if (voucher.stockorder.length > 0) {
            $rootScope.voucher.selected.warehouse_id = voucher.stockorder[0].warehouse_id;
            $rootScope.voucher.selected.warehouse = voucher.stockorder[0].warehouse;
          }
          $rootScope.voucher.selected.partner = $scope.partnerB;
          $rootScope.voucher.selected.partner_id = $scope.partner_idB;

          $rootScope.voucher.selected.stockorder = voucher.stockorder[voucher.stockorder.length - 1];
          $rootScope.voucher.selected.stockorderhist = angular.copy(voucher.stockorder);
          $rootScope.setVoucherType($rootScope.voucher.selected.vouchertype_id);
          if (!$rootScope.voucher.selected.voucherline) {
            $rootScope.voucher.selected.voucherline = [];
          }
          if (!$rootScope.voucher.selected.stockorder) {
            $rootScope.voucher.selected.stockorder = {
              stockadjustment: [],
              status: 0
            };
          }
        };
        //PRODUCTS PICKER
        $rootScope.addLine = function (item) {
          console.log('insertando voucherline', item);
          var newLine = {
            product_id: item.id,
            product: item,
            group: (item.group) ? item.group : '',
            min: (item.min) ? item.min : '',
            max: (item.max) ? item.max : '',
            value: 0,
            quantity: 0,
            quantity_expected: 0,
            quantity_issued: 0,
            stock: 0,
            status: 0,
            stockadjustment: []
          };
          console.log('newLine', newLine);
          $rootScope.addToList($rootScope.voucher.selected.voucherline, newLine, 'product_id');
          console.log('salida voucherline', $rootScope.voucher.selected);
        };
        $rootScope.addMany = function (itemsList) {
          angular.forEach(itemsList, function (item) {
            $rootScope.addLine(item);
            var first = $rootScope.getFirstEnabled(item, $rootScope.voucher.selected.warehouse_id);
            //$rootScope.addStock(first);
            if (first.length > 0) {
              $rootScope.addStock(first[0]);
            }

          });
        };
        $rootScope.addStock = function (stock) {
          console.log('insertando stockadjustment', stock);
          stock.stock_id = stock.id;
          stock.quantity = 0;
          stock.quantity_expected = 0;
          stock.quantity_issued = 0;
          stock.active = true;
          $rootScope.addToList(
            $rootScope.voucher.selected.stockorder.stockadjustment,
            stock,
            'stock_id'
          );
          console.log('salida stockadjustment', $rootScope.voucher.selected);
        };
        $rootScope.newStockBatch = function (product) {
          console.log('insertando stockadjustment', product);
          var stock = {};
          stock.product_id = product.id;
          stock.warehouse_id = $rootScope.voucher.selected.warehouse_id2;
          stock.quantity = 0;
          stock.quantity_expected = 0;
          stock.quantity_issued = 0;
          stock.batchcode = '';
          stock.isNew = true;
          stock.active = true;
          console.log('temporal', $rootScope.voucher.selected);
          $rootScope.voucher.selected.stockorder.stockadjustment.push(stock);
        };
        $rootScope.getFirstEnabled = function (items, warehouseId) {
          var exit = [];
          angular.forEach(items.stock, function (i) {
            if (i.warehouse_id == warehouseId && i.current_stock > 0) {
              exit.push(i);
            }
          });
          return exit;
        };
        //PRODUCT PICKER TO SHOW ON UICONTEXTUAL MENU
        $rootScope.tab = 1;
        $rootScope.setPicked = function (id) {
          console.log('setPicked', id);
          //picked = product.id
          $rootScope.voucher.picked = id;
          $rootScope.infoMenu = true;
          $rootScope.tab = 3;
        };
        //CALCULATES TOTAL AMOUNTH
        $rootScope.globalTotal = 0;
        $rootScope.othersTotal = 0;
        $rootScope.calculateTotal = function (quantity, price, discount) {
          $rootScope.globalTotal = 0;
          angular.forEach($rootScope.voucher.selected.voucherline, function (value, key) {
            //console.log('calculateTotal',value, value[quantity], value[price])
            var sum = 0;
            var discount = 0;
            value.quantity = value.quantity ? value.quantity : 0;
            value[quantity] = Math.round(value[quantity]);
            if (parseFloat(value[quantity]) > 0 && parseFloat(value[price]) > 0) {
              console.log('modificando', value.discount);
              if (value.discount) {
                discount = (parseFloat(value[price]) * parseFloat(value.discount / 100));
                //console.log('descuento calculado', discount)
              }
              sum = parseFloat(value[quantity]) * (parseFloat(value[price]) - discount);
              value.sub = parseFloat(value[quantity]) * (parseFloat(value[price]) - discount);
            }
            $rootScope.globalTotal += sum;
          });
          $rootScope.voucher.selected.total = $rootScope.globalTotal + $rootScope.othersTotal;
        };
        $rootScope.calculateSubTotal = function (target) {
          var sub = 0;
          console.log('calculateSubTotal', target);
          angular.forEach($rootScope.getSubitems(target), function (value, key) {
            console.log('line', value);
            if (!value.quantity) {
              value.quantity = 0;
            }
            console.log('0', parseInt(value.quantity), parseInt(value.current_stock))
            if (parseInt(value.quantity) > parseInt(value.current_stock)) {
              value.quantity = parseInt(value.current_stock);
              value.limitHelp = parseInt(value.current_stock);
              toastr.warning('Límite excedido', 'Advertencia');
            }
            sub += value.quantity;
          });
          target.quantity = sub;
          $rootScope.calculateTotal('quantity', 'value');
          return sub;
        };
        $rootScope.calculateIssuedTotal = function (target) {
          var sub = 0;
          console.log('calculateSubTotal', target);
          angular.forEach($rootScope.getSubitems(target), function (value, key) {
            console.log('line', value);
            if (!value.quantity_issued) {
              value.quantity_issued = 0;
            }
            if (value.quantity_issued > parseInt(value.current_stock)) {
              value.quantity_issued = parseInt(value.current_stock);
              toastr.warning('Límite excedido', 'Advertencia');
            }
            sub += value.quantity_issued;
          });
          target.quantity_issued = sub;
          target.quantity = target.quantity ? target.quantity : 0;

          if (target.older_issued) {
            console.log('reajustado', target.quantity, target.quantity_issued, target.older_issued);
            target.quantity_expected = target.quantity - target.quantity_issued - target.older_issued;
          }
          else {
            target.quantity_expected = target.quantity - target.quantity_issued;
          }

          //$rootScope.calculateTotal('quantity','value');
          return sub;
        };
        $rootScope.calculateOthersTotal = function () {
          $rootScope.othersTotal = 0;
          if ($rootScope.voucher.selected.other_amount) {
            $rootScope.othersTotal += $rootScope.voucher.selected.other_amount;
          }
          if ($rootScope.voucher.selected.transport_amount) {
            $rootScope.othersTotal += $rootScope.voucher.selected.transport_amount;
          }
          $rootScope.voucher.selected.othersTotal = $rootScope.othersTotal;
          $rootScope.voucher.selected.total = $rootScope.globalTotal + $rootScope.othersTotal;
        };
        $rootScope.searchDiscount = function () {
          if ($rootScope.voucher.selected.voucherline && $rootScope.currentModule == 'sales') {
            angular.forEach($rootScope.voucher.selected.voucherline, function (value, key) {
              value.discount = 0;
              if ($rootScope.voucher.selected.partner) {
                if ($rootScope.voucher.selected.partner.clientdiscount) {
                  //console.log('partner con descuentos en ', $rootScope.voucher.selected.partner.clientdiscount);
                  angular.forEach($rootScope.voucher.selected.partner.clientdiscount, function (discount) {
                    if (value.product.id == discount.product_id) {
                      value.discount = discount.discount;
                    }
                  });
                }
              }
            });
          }
        };
        $rootScope.getCompleteStock = function (product, warehouse_id) {
          var total = 0;
          //console.log('getCompleteStock', product, warehouse_id),
          if (warehouse_id) {
            angular.forEach(product.stock, function (p) {
              if (p.warehouse_id == warehouse_id) {
                total += parseInt(p.current_stock);
              }
            });
          }
          else {
            angular.forEach(product.stock, function (p) {
              total += parseInt(p.current_stock);
            });
          }
          return total;
        };
        $rootScope.getSubitems = function (item) {
          //console.log('buscando subitems', item);
          var list = [];
          angular.forEach($rootScope.voucher.selected.stockorder.stockadjustment, function (st) {
            //console.log('st',st)
            if (st.product_id == item.product_id) {
              list.push(st)
            }
          });
          // console.log('subitems',list);
          return list;
        };
        $rootScope.getStockSum = function (items) {
          return items
            .map(function (x) {
              return x.current_stock;
            })
            .reduce(function (a, b) {
              return a + b;
            });
        };
        $rootScope.getWarehousename = function (id) {
          var control = false;
          var exit = '';
          //console.log('getWarehousename',$rootScope.voucher.properties.warehouse_id.items, id);
          if ($rootScope.voucher.properties.warehouse_id.items) {
            angular.forEach($rootScope.voucher.properties.warehouse_id.items, function (w) {
              if (w.id == id && !control) {
                control = true;
                exit = w.name;
              }
            });
          }
          return exit;
        };
        //Watchers
        $rootScope.$watch('voucher.ready', function () {
          if ($rootScope.globalPartner) {
            switch ($rootScope.currentState) {
              case 'sales-debts':
                TablesService.filtrar('voucher', {
                  filters: {
                    credit_amount: {
                      value: 1,
                      operator: '>'
                    },
                    vouchertype_id: {
                      value: 9,
                    },
                    partner_id: {
                      value: $rootScope.globalPartner.id,
                    }
                  }
                })
                  .success(function (res) {
                    if (res.status) {
                      $rootScope.voucher.dataset = res.result;
                    }
                  });
                console.log('grid global');
                break;
            }
          }
        });
        ///////////////////////////////////////////////////
        //////////////CUSTOMIZATION GUIBDENTAL/////////////
        ///////////////////////////////////////////////////


      }
    }
  });

'use strict';
/**
 * Created by FER-PC-WIN10 on 25/05/2016.
 */
angular.module('frontendapp')
  .directive('uiBreadcrumbs', ['$interpolate', '$state', '$rootScope', function ($interpolate, $state, $rootScope) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'app/scripts/directives/uiBreadcrumbs/uiBreadcrumbs.tpl.html',
      //templateUrl: 'app/views/directives/crud/crud.html',
      scope: {
        displaynameProperty: '@',
        fakeLabelParent: '=',
        abstractProxyProperty: '@?'
      },
      link: function (scope) {
        $rootScope.$watch('crudTitle', function () {
          scope.titulo = $rootScope.crudTitle;
        });
        //console.log('!!!!!!!!!',$rootScope.api)
        scope.breadcrumbs = [];
        if ($state.$current.name !== '') {
          updateBreadcrumbsArray();
        }
        scope.currentModule = $rootScope.currentModule;
        scope.$on('$stateChangeSuccess', function () {
          updateBreadcrumbsArray();
          scope.titulo = $rootScope.crudTitle;
          scope.currentModule = $rootScope.currentModule;
        });
        /**
         * Start with the current state and traverse up the path to build the
         * array of breadcrumbs that can be used in an ng-repeat in the template.
         */
        function updateBreadcrumbsArray() {
          var workingState;
          var displayName;
          var breadcrumbs = [];
          var currentState = $state.$current;
          while (currentState && currentState.name !== '') {
            workingState = getWorkingState(currentState);
            if (workingState) {
              displayName = getDisplayName(workingState);
              if (displayName !== false && !stateAlreadyInBreadcrumbs(workingState, breadcrumbs)) {
                //CUSTOM INDOMITA CONFIGURATION
                //CUSTOM INDOMITA CONFIGURATION
                //CUSTOM INDOMITA CONFIGURATION
                var size = currentState.name.split('.');
                var discard = ['select', 'password', 'view', 'review'];
                if ($state.$current.name == currentState.name && ((size.length > 1 && discard.indexOf(size[1]) >= 0))) {
                  console.log('final!!! 2', currentState.name)
                  displayName = displayName + scope.titulo;
                }
                //CUSTOM INDOMITA CONFIGURATION
                //CUSTOM INDOMITA CONFIGURATION
                //CUSTOM INDOMITA CONFIGURATION
                breadcrumbs.push({
                  displayName: displayName,
                  route: workingState.name
                });
              }
            }
            currentState = currentState.parent;
          }
          breadcrumbs.reverse();
          scope.breadcrumbs = breadcrumbs;
        }

        /**
         * Get the state to put in the breadcrumbs array, taking into account that if the current state is abstract,
         * we need to either substitute it with the state named in the `scope.abstractProxyProperty` property, or
         * set it to `false` which means this breadcrumb level will be skipped entirely.
         * @param currentState
         * @returns {*}
         */
        function getWorkingState(currentState) {
          var proxyStateName;
          var workingState = currentState;
          if (currentState.abstract === true) {
            if (typeof scope.abstractProxyProperty !== 'undefined') {
              proxyStateName = getObjectValue(scope.abstractProxyProperty, currentState);
              if (proxyStateName) {
                workingState = angular.copy($state.get(proxyStateName));
                if (workingState) {
                  workingState.locals = currentState.locals;
                }
              } else {
                workingState = false;
              }
            } else {
              workingState = false;
            }
          }
          return workingState;
        }

        /**
         * Resolve the displayName of the specified state. Take the property specified by the `displayname-property`
         * attribute and look up the corresponding property on the state's config object. The specified string can be interpolated against any resolved
         * properties on the state config object, by using the usual {{ }} syntax.
         * @param currentState
         * @returns {*}
         */
        function getDisplayName(currentState) {
          var interpolationContext;
          var propertyReference;
          var displayName;
          if (!scope.displaynameProperty) {
            // if the displayname-property attribute was not specified, default to the state's name
            return currentState.name;
          }
          propertyReference = getObjectValue(scope.displaynameProperty, currentState);
          if (propertyReference === false) {
            return false;
          } else if (typeof propertyReference === 'undefined') {
            return currentState.name;
          } else {
            // use the $interpolate service to handle any bindings in the propertyReference string.
            interpolationContext = (typeof currentState.locals !== 'undefined') ? currentState.locals.globals : currentState;
            displayName = $interpolate(propertyReference)(interpolationContext);
            return displayName;
          }
        }

        /**
         * Given a string of the type 'object.property.property', traverse the given context (eg the current $state object) and return the
         * value found at that path.
         *
         * @param objectPath
         * @param context
         * @returns {*}
         */
        function getObjectValue(objectPath, context) {
          var i;
          var propertyArray = objectPath.split('.');
          var propertyReference = context;
          for (i = 0; i < propertyArray.length; i++) {
            if (angular.isDefined(propertyReference[propertyArray[i]])) {
              propertyReference = propertyReference[propertyArray[i]];
            } else {
              // if the specified property was not found, default to the state's name
              return undefined;
            }
          }
          return propertyReference;
        }

        /**
         * Check whether the current `state` has already appeared in the current breadcrumbs array. This check is necessary
         * when using abstract states that might specify a proxy that is already there in the breadcrumbs.
         * @param state
         * @param breadcrumbs
         * @returns {boolean}
         */
        function stateAlreadyInBreadcrumbs(state, breadcrumbs) {
          var i;
          var alreadyUsed = false;
          for (i = 0; i < breadcrumbs.length; i++) {
            if (breadcrumbs[i].route === state.name) {
              alreadyUsed = true;
            }
          }
          return alreadyUsed;
        }
      }
    };
  }]);

'use strict';
angular.module('frontendapp')
  .directive('appcontextmenu', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/appcontextmenu/appcontextmenu.html',
      restrict: 'E',
      replace: true,
      scope: {
        menuItems: '=',
        menuTitle: '@',
        menuDepth: '@',
        menuClass: '@',
      },
      rootScope: $rootScope,
      controller: function ($scope, $rootScope, $state, $auth, $location,
                            $log, UserService, localStorageService,
                            TablesService, $window, $modal) {


        $scope.infoMenu = $rootScope.infoMenu;

        $scope.showInfoMenu = function () {
          $rootScope.showInfoMenu()
        };

        $scope.stateGo = function (state, params) {
          $state.go(state, params);
        };

        $scope.currentState = $rootScope.currentState;

        $rootScope.$on('$stateChangeSuccess',
          function (event, toState) {
            $scope.currentState = $rootScope.currentState;
          });

        $rootScope.$watch('currentModule', function () {
          //$scope.currentModule = $rootScope.currentModule
        });

        $rootScope.$watch('infoMenu', function () {
          $scope.infoMenu = $rootScope.infoMenu;
        });


      }

      //////END CONTROLLER ////////
    }
  });

'use strict';

/**
 * @ngdoc function
 * @name frontendApp.config:textAngular
 * @description
 * # textAngular
 * Config of the frontendApp
 */

angular.module('frontendapp')
  .config(['$provide', function ($provide) {
    $provide.decorator('taOptions', ['taRegisterTool', '$delegate', 'taSelection', '$modal', function (taRegisterTool, taOptions, taSelection, $modal) {
      taRegisterTool('insertRelation', {
        iconclass: 'fas fa-tag',
        buttontext: 'Vincular etiqueta',
        disabled: function () {
          return window.getSelection().toString().length < 1;
        },
        action: function (deferred, restoreSelection) {
          var self = this, savedSel = rangy.saveSelection();
          $modal.open({
            controller: 'GlossaryModalInstance',
            templateUrl: 'app/views/glossary/home2.html'
          }).result.then(
            function (term) {
              console.log('este es el term', term);
              rangy.restoreSelection(savedSel);
              document.execCommand("insertHTML", false, "<strong class='modal-term ng-isolate-scope' title='" + term + "' >" + document.getSelection() + "</strong>");
              console.log('este es el term', document.getSelection());
              deferred.resolve();
            },
            function () {
              deferred.resolve();
            }
          );
          //console.log('este es el term', term);
          rangy.restoreSelection(savedSel);
          //document.execCommand("insertHTML", true, "<a  href='' target='_blank'>"+ document.getSelection()+"</a>");
          //console.log('este es el term', document.getSelection());
          return false;
        }
      });
      taRegisterTool('localfiles', {
        iconclass: 'fa fa-file-image-o',
        buttontext: 'Agregar archivo',
        //disabled: function () {
        //  return window.getSelection().toString().length < 1;
        //},
        action: function (deferred, restoreSelection) {
          var self = this, savedSel = rangy.saveSelection();
          $modal.open({
            controller: 'LocalfilesModalInstanceCtrl',
            templateUrl: 'views/localfiles/modal-localfiles.html'
          }).result.then(
            function (term) {
              rangy.restoreSelection(savedSel);
              switch (term.tipo) {
                case 1:
                  document.execCommand("insertHTML", false, "<img alt='" + term.descripcion + "' src='" + term.archivo + "' target='_blank'>" + "");
                  break;
                case 2:
                  document.execCommand("insertHTML", false, "<a  href='" + term.archivo + "' target='_blank'>" + term.nombre + "</a>");
                  break;
                //case 3:
                //  document.execCommand("insertHTML", false, "<video heigth='400' controls src='"+ term.archivo +"'> </video>");

              }


              deferred.resolve();
            },
            function () {
              deferred.resolve();
            }
          );
          return false;
        }
      });
      taOptions.toolbar[1].push('localfiles');
      return taOptions;
    }]);
  }]);

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .controller('GlossaryModalInstance', ['$scope', '$rootScope', '$modal', '$modalInstance', 'UserService', 'TablesService', function ($scope, $rootScope, $modal, $modalInstance, UserService, TablesService) {


      var filters = {
        per_page: 10000,
        page: 1,
      };
      //$rootScope.tagData = 'test';
      /*  UserService.actualizarToken()
       .success(function (tok) {
       TablesService.filtrar('terminos', filters)
       .success(function (res) {
       $scope.terms = res.resultado.data;
       });
       });*/

      $scope.pickTerm = function (term) {
        $scope.termino = term;
      };
      $scope.resetTerm = function () {
        $scope.termino = null;
      };
      $scope.status = {isopen: false};
      $scope.termino = '';
      $scope.insertRelation = function () {
        $modalInstance.close($rootScope.tagData);
        //$rootScope.execTaOp($rootScope.tagData);
      };

    }
    ])
  ;
})
();

angular.module('frontendapp')
  .directive('modalTerm', function ($rootScope, $modal) {
    return {
      restrict: 'C',
      scope: {
        title: '@'
      },
      link: function (scope, elem) {
        elem.bind('click', function () {
          scope.editText();
        });
        scope.editText = function () {
          $modal.open({
            templateUrl: 'app/views/glossary/modal-glossary.html',
            controller: 'GlossaryModalInstance',
            windowClass: 'centered',
            title: scope.title,
            scope: scope,
            resolve: {
              title: function () {
                return scope.title
              }
            }
          });
        }
      },
      rootScope: $rootScope
    }
  });




'use strict';

/**
 * @ngdoc directive
 * @name izzyposWebApp.directive:adminPosHeader
 * @description
 * # adminPosHeader
 */

angular.module('frontendapp')
  .directive('mydatepicker', function () {
    return {
      templateUrl: 'app/scripts/directives/datepicker/datepicker.html',
      restrict: "E",
      scope: {
        ngModel: "=",
        ngChange: "=",
        ngRequired: "=",
        dateOptions: "=",
        opened: "=",
        format: "@"
      },
      link: function ($scope, element, attrs) {
        $scope.open = function (event) {
          event.preventDefault();
          event.stopPropagation();
          $scope.opened = true;

        };
        //console.log('datepicker',$scope.dateRequired);
        //$scope.format = 'yyyy/MM/dd';
        $scope.clear = function () {
          $scope.ngModel = null;
        };
      },

      controller: function uicomboController($uibModal, $scope, $rootScope) {
        //console.log('datepicker',$scope.dateRequired, $scope.ngModel);
      }

    }
  });

'use strict';
angular.module('frontendapp')
  .directive('appmenu', function ($rootScope) {
    return {
      templateUrl: 'app/scripts/directives/appmenu/appmenu.html',
      restrict: 'E',
      replace: true,
      scope: {
        menuItems: '=',
        menuTitle: '@',
        menuDepth: '@',
        menuClass: '@',
      },
      rootScope: $rootScope,
      controller: function ($scope, $rootScope, $state, $auth, $location,
                            $log, UserService, localStorageService,
                            TablesService, $window, $modal) {

        $scope.appMenu = false;

        $scope.showAppMenu = function (value) {
          console.log('infoMenu');
          $scope.appMenu = value ? value : !$scope.appMenu;
        };

        $scope.stateGo = function (state, params) {
          $state.go(state, params);
        };

        $scope.initAppMenu = function () {
          $scope.currentLevel = 0;
          $scope.menuLevels = [];
          for (var i = 0; i < parseInt($scope.menuDepth); i++) {
            $scope.menuLevels.push($scope.menuItems);
          }
        };

        $scope.initAppMenu();

        $scope.currentState = $rootScope.currentState;

        $rootScope.$on('$stateChangeSuccess',
          function (event, toState) {
            $scope.currentState = $rootScope.currentState;
            //$scope.showAppMenu(false);
            $scope.appMenu = false;
          });

        $rootScope.$watch('currentModule', function () {
          // console.log('deteca cambio');
          $scope.menuItems = $rootScope.appMenuItems[$rootScope.currentModule];
          $scope.initAppMenu();
        });

        $scope.selectItems = function (data, index, name) {
          console.log(index, data)
          $scope.menuLevels[index + 1] = data.items;
          $scope.currentLevel++;
        };

        $scope.showParent = function () {
          $scope.currentLevel--;
        };

        $scope.userPopover = {
          templateUrl: 'userPopover.html',
        };

        $scope.appPopover = {
          templateUrl: 'appPopover.html',
        };

        $scope.logout = function () {
          $rootScope.logout();
        };

        $scope.switchModule = function (value) {
          $rootScope.switchModule(value);
        };

      }

      //////END CONTROLLER ////////
    }
  });

/**
 * Created by FER-PC-WIN10 on 03/05/2016.
 */
(function () {
  'use strict';
  angular
    .module('frontendapp')
    .directive('renderHtml', function ($compile) {
      return function (scope, element, attrs) {
        scope.$watch(
          function (scope) {
            return scope.$eval(attrs.renderHtml);
          },
          function (value) {
            element.html(value);
            $compile(element.contents())(scope);
          }
        );
      };
    });
})();

/* -----------------------------------------------
 /* Author : Vincent Garreau  - vincentgarreau.com
 /* MIT license: http://opensource.org/licenses/MIT
 /* Demo / Generator : vincentgarreau.com/particles.js
 /* GitHub : github.com/VincentGarreau/particles.js
 /* How to use? : Check the GitHub README
 /* v2.0.0
 /* ----------------------------------------------- */
function hexToRgb(e) {
  var a = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
  e = e.replace(a, function (e, a, t, i) {
    return a + a + t + t + i + i
  });
  var t = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e);
  return t ? {r: parseInt(t[1], 16), g: parseInt(t[2], 16), b: parseInt(t[3], 16)} : null
}
function clamp(e, a, t) {
  return Math.min(Math.max(e, a), t)
}
function isInArray(e, a) {
  return a.indexOf(e) > -1
}
var pJS = function (e, a) {
  var t = document.querySelector("#" + e + " > .particles-js-canvas-el");
  this.pJS = {
    canvas: {el: t, w: t.offsetWidth, h: t.offsetHeight},
    particles: {
      number: {value: 400, density: {enable: !0, value_area: 800}},
      color: {value: "#fff"},
      shape: {
        type: "circle",
        stroke: {width: 0, color: "#ff0000"},
        polygon: {nb_sides: 5},
        image: {src: "", width: 100, height: 100}
      },
      opacity: {value: 1, random: !1, anim: {enable: !1, speed: 2, opacity_min: 0, sync: !1}},
      size: {value: 20, random: !1, anim: {enable: !1, speed: 20, size_min: 0, sync: !1}},
      line_linked: {enable: !0, distance: 100, color: "#fff", opacity: 1, width: 1},
      move: {
        enable: !0,
        speed: 2,
        direction: "none",
        random: !1,
        straight: !1,
        out_mode: "out",
        bounce: !1,
        attract: {enable: !1, rotateX: 3e3, rotateY: 3e3}
      },
      array: []
    },
    interactivity: {
      detect_on: "canvas",
      events: {onhover: {enable: !0, mode: "grab"}, onclick: {enable: !0, mode: "push"}, resize: !0},
      modes: {
        grab: {distance: 100, line_linked: {opacity: 1}},
        bubble: {distance: 200, size: 80, duration: .4},
        repulse: {distance: 200, duration: .4},
        push: {particles_nb: 4},
        remove: {particles_nb: 2}
      },
      mouse: {}
    },
    retina_detect: !1,
    fn: {interact: {}, modes: {}, vendors: {}},
    tmp: {}
  };
  var i = this.pJS;
  a && Object.deepExtend(i, a), i.tmp.obj = {
    size_value: i.particles.size.value,
    size_anim_speed: i.particles.size.anim.speed,
    move_speed: i.particles.move.speed,
    line_linked_distance: i.particles.line_linked.distance,
    line_linked_width: i.particles.line_linked.width,
    mode_grab_distance: i.interactivity.modes.grab.distance,
    mode_bubble_distance: i.interactivity.modes.bubble.distance,
    mode_bubble_size: i.interactivity.modes.bubble.size,
    mode_repulse_distance: i.interactivity.modes.repulse.distance
  }, i.fn.retinaInit = function () {
    i.retina_detect && window.devicePixelRatio > 1 ? (i.canvas.pxratio = window.devicePixelRatio, i.tmp.retina = !0) : (i.canvas.pxratio = 1, i.tmp.retina = !1), i.canvas.w = i.canvas.el.offsetWidth * i.canvas.pxratio, i.canvas.h = i.canvas.el.offsetHeight * i.canvas.pxratio, i.particles.size.value = i.tmp.obj.size_value * i.canvas.pxratio, i.particles.size.anim.speed = i.tmp.obj.size_anim_speed * i.canvas.pxratio, i.particles.move.speed = i.tmp.obj.move_speed * i.canvas.pxratio, i.particles.line_linked.distance = i.tmp.obj.line_linked_distance * i.canvas.pxratio, i.interactivity.modes.grab.distance = i.tmp.obj.mode_grab_distance * i.canvas.pxratio, i.interactivity.modes.bubble.distance = i.tmp.obj.mode_bubble_distance * i.canvas.pxratio, i.particles.line_linked.width = i.tmp.obj.line_linked_width * i.canvas.pxratio, i.interactivity.modes.bubble.size = i.tmp.obj.mode_bubble_size * i.canvas.pxratio, i.interactivity.modes.repulse.distance = i.tmp.obj.mode_repulse_distance * i.canvas.pxratio
  }, i.fn.canvasInit = function () {
    i.canvas.ctx = i.canvas.el.getContext("2d")
  }, i.fn.canvasSize = function () {
    i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i && i.interactivity.events.resize && window.addEventListener("resize", function () {
      i.canvas.w = i.canvas.el.offsetWidth, i.canvas.h = i.canvas.el.offsetHeight, i.tmp.retina && (i.canvas.w *= i.canvas.pxratio, i.canvas.h *= i.canvas.pxratio), i.canvas.el.width = i.canvas.w, i.canvas.el.height = i.canvas.h, i.particles.move.enable || (i.fn.particlesEmpty(), i.fn.particlesCreate(), i.fn.particlesDraw(), i.fn.vendors.densityAutoParticles()), i.fn.vendors.densityAutoParticles()
    })
  }, i.fn.canvasPaint = function () {
    i.canvas.ctx.fillRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.canvasClear = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h)
  }, i.fn.particle = function (e, a, t) {
    if (this.radius = (i.particles.size.random ? Math.random() : 1) * i.particles.size.value, i.particles.size.anim.enable && (this.size_status = !1, this.vs = i.particles.size.anim.speed / 100, i.particles.size.anim.sync || (this.vs = this.vs * Math.random())), this.x = t ? t.x : Math.random() * i.canvas.w, this.y = t ? t.y : Math.random() * i.canvas.h, this.x > i.canvas.w - 2 * this.radius ? this.x = this.x - this.radius : this.x < 2 * this.radius && (this.x = this.x + this.radius), this.y > i.canvas.h - 2 * this.radius ? this.y = this.y - this.radius : this.y < 2 * this.radius && (this.y = this.y + this.radius), i.particles.move.bounce && i.fn.vendors.checkOverlap(this, t), this.color = {}, "object" == typeof e.value)if (e.value instanceof Array) {
      var s = e.value[Math.floor(Math.random() * i.particles.color.value.length)];
      this.color.rgb = hexToRgb(s)
    } else void 0 != e.value.r && void 0 != e.value.g && void 0 != e.value.b && (this.color.rgb = {
      r: e.value.r,
      g: e.value.g,
      b: e.value.b
    }), void 0 != e.value.h && void 0 != e.value.s && void 0 != e.value.l && (this.color.hsl = {
      h: e.value.h,
      s: e.value.s,
      l: e.value.l
    }); else"random" == e.value ? this.color.rgb = {
      r: Math.floor(256 * Math.random()) + 0,
      g: Math.floor(256 * Math.random()) + 0,
      b: Math.floor(256 * Math.random()) + 0
    } : "string" == typeof e.value && (this.color = e, this.color.rgb = hexToRgb(this.color.value));
    this.opacity = (i.particles.opacity.random ? Math.random() : 1) * i.particles.opacity.value, i.particles.opacity.anim.enable && (this.opacity_status = !1, this.vo = i.particles.opacity.anim.speed / 100, i.particles.opacity.anim.sync || (this.vo = this.vo * Math.random()));
    var n = {};
    switch (i.particles.move.direction) {
      case"top":
        n = {x: 0, y: -1};
        break;
      case"top-right":
        n = {x: .5, y: -.5};
        break;
      case"right":
        n = {x: 1, y: -0};
        break;
      case"bottom-right":
        n = {x: .5, y: .5};
        break;
      case"bottom":
        n = {x: 0, y: 1};
        break;
      case"bottom-left":
        n = {x: -.5, y: 1};
        break;
      case"left":
        n = {x: -1, y: 0};
        break;
      case"top-left":
        n = {x: -.5, y: -.5};
        break;
      default:
        n = {x: 0, y: 0}
    }
    i.particles.move.straight ? (this.vx = n.x, this.vy = n.y, i.particles.move.random && (this.vx = this.vx * Math.random(), this.vy = this.vy * Math.random())) : (this.vx = n.x + Math.random() - .5, this.vy = n.y + Math.random() - .5), this.vx_i = this.vx, this.vy_i = this.vy;
    var r = i.particles.shape.type;
    if ("object" == typeof r) {
      if (r instanceof Array) {
        var c = r[Math.floor(Math.random() * r.length)];
        this.shape = c
      }
    } else this.shape = r;
    if ("image" == this.shape) {
      var o = i.particles.shape;
      this.img = {
        src: o.image.src,
        ratio: o.image.width / o.image.height
      }, this.img.ratio || (this.img.ratio = 1), "svg" == i.tmp.img_type && void 0 != i.tmp.source_svg && (i.fn.vendors.createSvgImg(this), i.tmp.pushing && (this.img.loaded = !1))
    }
  }, i.fn.particle.prototype.draw = function () {
    function e() {
      i.canvas.ctx.drawImage(r, a.x - t, a.y - t, 2 * t, 2 * t / a.img.ratio)
    }

    var a = this;
    if (void 0 != a.radius_bubble)var t = a.radius_bubble; else var t = a.radius;
    if (void 0 != a.opacity_bubble)var s = a.opacity_bubble; else var s = a.opacity;
    if (a.color.rgb)var n = "rgba(" + a.color.rgb.r + "," + a.color.rgb.g + "," + a.color.rgb.b + "," + s + ")"; else var n = "hsla(" + a.color.hsl.h + "," + a.color.hsl.s + "%," + a.color.hsl.l + "%," + s + ")";
    switch (i.canvas.ctx.fillStyle = n, i.canvas.ctx.beginPath(), a.shape) {
      case"circle":
        i.canvas.ctx.arc(a.x, a.y, t, 0, 2 * Math.PI, !1);
        break;
      case"edge":
        i.canvas.ctx.rect(a.x - t, a.y - t, 2 * t, 2 * t);
        break;
      case"triangle":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t, a.y + t / 1.66, 2 * t, 3, 2);
        break;
      case"polygon":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - t / (i.particles.shape.polygon.nb_sides / 3.5), a.y - t / .76, 2.66 * t / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 1);
        break;
      case"star":
        i.fn.vendors.drawShape(i.canvas.ctx, a.x - 2 * t / (i.particles.shape.polygon.nb_sides / 4), a.y - t / 1.52, 2 * t * 2.66 / (i.particles.shape.polygon.nb_sides / 3), i.particles.shape.polygon.nb_sides, 2);
        break;
      case"image":
        if ("svg" == i.tmp.img_type)var r = a.img.obj; else var r = i.tmp.img_obj;
        r && e()
    }
    i.canvas.ctx.closePath(), i.particles.shape.stroke.width > 0 && (i.canvas.ctx.strokeStyle = i.particles.shape.stroke.color, i.canvas.ctx.lineWidth = i.particles.shape.stroke.width, i.canvas.ctx.stroke()), i.canvas.ctx.fill()
  }, i.fn.particlesCreate = function () {
    for (var e = 0; e < i.particles.number.value; e++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value))
  }, i.fn.particlesUpdate = function () {
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      if (i.particles.move.enable) {
        var t = i.particles.move.speed / 2;
        a.x += a.vx * t, a.y += a.vy * t
      }
      if (i.particles.opacity.anim.enable && (1 == a.opacity_status ? (a.opacity >= i.particles.opacity.value && (a.opacity_status = !1), a.opacity += a.vo) : (a.opacity <= i.particles.opacity.anim.opacity_min && (a.opacity_status = !0), a.opacity -= a.vo), a.opacity < 0 && (a.opacity = 0)), i.particles.size.anim.enable && (1 == a.size_status ? (a.radius >= i.particles.size.value && (a.size_status = !1), a.radius += a.vs) : (a.radius <= i.particles.size.anim.size_min && (a.size_status = !0), a.radius -= a.vs), a.radius < 0 && (a.radius = 0)), "bounce" == i.particles.move.out_mode)var s = {
        x_left: a.radius,
        x_right: i.canvas.w,
        y_top: a.radius,
        y_bottom: i.canvas.h
      }; else var s = {
        x_left: -a.radius,
        x_right: i.canvas.w + a.radius,
        y_top: -a.radius,
        y_bottom: i.canvas.h + a.radius
      };
      switch (a.x - a.radius > i.canvas.w ? (a.x = s.x_left, a.y = Math.random() * i.canvas.h) : a.x + a.radius < 0 && (a.x = s.x_right, a.y = Math.random() * i.canvas.h), a.y - a.radius > i.canvas.h ? (a.y = s.y_top, a.x = Math.random() * i.canvas.w) : a.y + a.radius < 0 && (a.y = s.y_bottom, a.x = Math.random() * i.canvas.w), i.particles.move.out_mode) {
        case"bounce":
          a.x + a.radius > i.canvas.w ? a.vx = -a.vx : a.x - a.radius < 0 && (a.vx = -a.vx), a.y + a.radius > i.canvas.h ? a.vy = -a.vy : a.y - a.radius < 0 && (a.vy = -a.vy)
      }
      if (isInArray("grab", i.interactivity.events.onhover.mode) && i.fn.modes.grabParticle(a), (isInArray("bubble", i.interactivity.events.onhover.mode) || isInArray("bubble", i.interactivity.events.onclick.mode)) && i.fn.modes.bubbleParticle(a), (isInArray("repulse", i.interactivity.events.onhover.mode) || isInArray("repulse", i.interactivity.events.onclick.mode)) && i.fn.modes.repulseParticle(a), i.particles.line_linked.enable || i.particles.move.attract.enable)for (var n = e + 1; n < i.particles.array.length; n++) {
        var r = i.particles.array[n];
        i.particles.line_linked.enable && i.fn.interact.linkParticles(a, r), i.particles.move.attract.enable && i.fn.interact.attractParticles(a, r), i.particles.move.bounce && i.fn.interact.bounceParticles(a, r)
      }
    }
  }, i.fn.particlesDraw = function () {
    i.canvas.ctx.clearRect(0, 0, i.canvas.w, i.canvas.h), i.fn.particlesUpdate();
    for (var e = 0; e < i.particles.array.length; e++) {
      var a = i.particles.array[e];
      a.draw()
    }
  }, i.fn.particlesEmpty = function () {
    i.particles.array = []
  }, i.fn.particlesRefresh = function () {
    cancelRequestAnimFrame(i.fn.checkAnimFrame), cancelRequestAnimFrame(i.fn.drawAnimFrame), i.tmp.source_svg = void 0, i.tmp.img_obj = void 0, i.tmp.count_svg = 0, i.fn.particlesEmpty(), i.fn.canvasClear(), i.fn.vendors.start()
  }, i.fn.interact.linkParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = i.particles.line_linked.opacity - n / (1 / i.particles.line_linked.opacity) / i.particles.line_linked.distance;
      if (r > 0) {
        var c = i.particles.line_linked.color_rgb_line;
        i.canvas.ctx.strokeStyle = "rgba(" + c.r + "," + c.g + "," + c.b + "," + r + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(a.x, a.y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
      }
    }
  }, i.fn.interact.attractParticles = function (e, a) {
    var t = e.x - a.x, s = e.y - a.y, n = Math.sqrt(t * t + s * s);
    if (n <= i.particles.line_linked.distance) {
      var r = t / (1e3 * i.particles.move.attract.rotateX), c = s / (1e3 * i.particles.move.attract.rotateY);
      e.vx -= r, e.vy -= c, a.vx += r, a.vy += c
    }
  }, i.fn.interact.bounceParticles = function (e, a) {
    var t = e.x - a.x, i = e.y - a.y, s = Math.sqrt(t * t + i * i), n = e.radius + a.radius;
    n >= s && (e.vx = -e.vx, e.vy = -e.vy, a.vx = -a.vx, a.vy = -a.vy)
  }, i.fn.modes.pushParticles = function (e, a) {
    i.tmp.pushing = !0;
    for (var t = 0; e > t; t++)i.particles.array.push(new i.fn.particle(i.particles.color, i.particles.opacity.value, {
      x: a ? a.pos_x : Math.random() * i.canvas.w,
      y: a ? a.pos_y : Math.random() * i.canvas.h
    })), t == e - 1 && (i.particles.move.enable || i.fn.particlesDraw(), i.tmp.pushing = !1)
  }, i.fn.modes.removeParticles = function (e) {
    i.particles.array.splice(0, e), i.particles.move.enable || i.fn.particlesDraw()
  }, i.fn.modes.bubbleParticle = function (e) {
    function a() {
      e.opacity_bubble = e.opacity, e.radius_bubble = e.radius
    }

    function t(a, t, s, n, c) {
      if (a != t)if (i.tmp.bubble_duration_end) {
        if (void 0 != s) {
          var o = n - p * (n - a) / i.interactivity.modes.bubble.duration, l = a - o;
          d = a + l, "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else if (r <= i.interactivity.modes.bubble.distance) {
        if (void 0 != s)var v = s; else var v = n;
        if (v != a) {
          var d = n - p * (n - a) / i.interactivity.modes.bubble.duration;
          "size" == c && (e.radius_bubble = d), "opacity" == c && (e.opacity_bubble = d)
        }
      } else"size" == c && (e.radius_bubble = void 0), "opacity" == c && (e.opacity_bubble = void 0)
    }

    if (i.interactivity.events.onhover.enable && isInArray("bubble", i.interactivity.events.onhover.mode)) {
      var s = e.x - i.interactivity.mouse.pos_x, n = e.y - i.interactivity.mouse.pos_y, r = Math.sqrt(s * s + n * n),
        c = 1 - r / i.interactivity.modes.bubble.distance;
      if (r <= i.interactivity.modes.bubble.distance) {
        if (c >= 0 && "mousemove" == i.interactivity.status) {
          if (i.interactivity.modes.bubble.size != i.particles.size.value)if (i.interactivity.modes.bubble.size > i.particles.size.value) {
            var o = e.radius + i.interactivity.modes.bubble.size * c;
            o >= 0 && (e.radius_bubble = o)
          } else {
            var l = e.radius - i.interactivity.modes.bubble.size, o = e.radius - l * c;
            o > 0 ? e.radius_bubble = o : e.radius_bubble = 0
          }
          if (i.interactivity.modes.bubble.opacity != i.particles.opacity.value)if (i.interactivity.modes.bubble.opacity > i.particles.opacity.value) {
            var v = i.interactivity.modes.bubble.opacity * c;
            v > e.opacity && v <= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          } else {
            var v = e.opacity - (i.particles.opacity.value - i.interactivity.modes.bubble.opacity) * c;
            v < e.opacity && v >= i.interactivity.modes.bubble.opacity && (e.opacity_bubble = v)
          }
        }
      } else a();
      "mouseleave" == i.interactivity.status && a()
    } else if (i.interactivity.events.onclick.enable && isInArray("bubble", i.interactivity.events.onclick.mode)) {
      if (i.tmp.bubble_clicking) {
        var s = e.x - i.interactivity.mouse.click_pos_x, n = e.y - i.interactivity.mouse.click_pos_y,
          r = Math.sqrt(s * s + n * n), p = ((new Date).getTime() - i.interactivity.mouse.click_time) / 1e3;
        p > i.interactivity.modes.bubble.duration && (i.tmp.bubble_duration_end = !0), p > 2 * i.interactivity.modes.bubble.duration && (i.tmp.bubble_clicking = !1, i.tmp.bubble_duration_end = !1)
      }
      i.tmp.bubble_clicking && (t(i.interactivity.modes.bubble.size, i.particles.size.value, e.radius_bubble, e.radius, "size"), t(i.interactivity.modes.bubble.opacity, i.particles.opacity.value, e.opacity_bubble, e.opacity, "opacity"))
    }
  }, i.fn.modes.repulseParticle = function (e) {
    function a() {
      var a = Math.atan2(d, p);
      if (e.vx = u * Math.cos(a), e.vy = u * Math.sin(a), "bounce" == i.particles.move.out_mode) {
        var t = {x: e.x + e.vx, y: e.y + e.vy};
        t.x + e.radius > i.canvas.w ? e.vx = -e.vx : t.x - e.radius < 0 && (e.vx = -e.vx), t.y + e.radius > i.canvas.h ? e.vy = -e.vy : t.y - e.radius < 0 && (e.vy = -e.vy)
      }
    }

    if (i.interactivity.events.onhover.enable && isInArray("repulse", i.interactivity.events.onhover.mode) && "mousemove" == i.interactivity.status) {
      var t = e.x - i.interactivity.mouse.pos_x, s = e.y - i.interactivity.mouse.pos_y, n = Math.sqrt(t * t + s * s),
        r = {
          x: t / n,
          y: s / n
        }, c = i.interactivity.modes.repulse.distance, o = 100,
        l = clamp(1 / c * (-1 * Math.pow(n / c, 2) + 1) * c * o, 0, 50), v = {
          x: e.x + r.x * l,
          y: e.y + r.y * l
        };
      "bounce" == i.particles.move.out_mode ? (v.x - e.radius > 0 && v.x + e.radius < i.canvas.w && (e.x = v.x), v.y - e.radius > 0 && v.y + e.radius < i.canvas.h && (e.y = v.y)) : (e.x = v.x, e.y = v.y)
    } else if (i.interactivity.events.onclick.enable && isInArray("repulse", i.interactivity.events.onclick.mode))if (i.tmp.repulse_finish || (i.tmp.repulse_count++, i.tmp.repulse_count == i.particles.array.length && (i.tmp.repulse_finish = !0)), i.tmp.repulse_clicking) {
      var c = Math.pow(i.interactivity.modes.repulse.distance / 6, 3), p = i.interactivity.mouse.click_pos_x - e.x,
        d = i.interactivity.mouse.click_pos_y - e.y, m = p * p + d * d, u = -c / m * 1;
      c >= m && a()
    } else 0 == i.tmp.repulse_clicking && (e.vx = e.vx_i, e.vy = e.vy_i)
  }, i.fn.modes.grabParticle = function (e) {
    if (i.interactivity.events.onhover.enable && "mousemove" == i.interactivity.status) {
      var a = e.x - i.interactivity.mouse.pos_x, t = e.y - i.interactivity.mouse.pos_y, s = Math.sqrt(a * a + t * t);
      if (s <= i.interactivity.modes.grab.distance) {
        var n = i.interactivity.modes.grab.line_linked.opacity - s / (1 / i.interactivity.modes.grab.line_linked.opacity) / i.interactivity.modes.grab.distance;
        if (n > 0) {
          var r = i.particles.line_linked.color_rgb_line;
          i.canvas.ctx.strokeStyle = "rgba(" + r.r + "," + r.g + "," + r.b + "," + n + ")", i.canvas.ctx.lineWidth = i.particles.line_linked.width, i.canvas.ctx.beginPath(), i.canvas.ctx.moveTo(e.x, e.y), i.canvas.ctx.lineTo(i.interactivity.mouse.pos_x, i.interactivity.mouse.pos_y), i.canvas.ctx.stroke(), i.canvas.ctx.closePath()
        }
      }
    }
  }, i.fn.vendors.eventsListeners = function () {
    "window" == i.interactivity.detect_on ? i.interactivity.el = window : i.interactivity.el = i.canvas.el, (i.interactivity.events.onhover.enable || i.interactivity.events.onclick.enable) && (i.interactivity.el.addEventListener("mousemove", function (e) {
      if (i.interactivity.el == window)var a = e.clientX, t = e.clientY; else var a = e.offsetX || e.clientX,
        t = e.offsetY || e.clientY;
      i.interactivity.mouse.pos_x = a, i.interactivity.mouse.pos_y = t, i.tmp.retina && (i.interactivity.mouse.pos_x *= i.canvas.pxratio, i.interactivity.mouse.pos_y *= i.canvas.pxratio), i.interactivity.status = "mousemove"
    }), i.interactivity.el.addEventListener("mouseleave", function (e) {
      i.interactivity.mouse.pos_x = null, i.interactivity.mouse.pos_y = null, i.interactivity.status = "mouseleave"
    })), i.interactivity.events.onclick.enable && i.interactivity.el.addEventListener("click", function () {
      if (i.interactivity.mouse.click_pos_x = i.interactivity.mouse.pos_x, i.interactivity.mouse.click_pos_y = i.interactivity.mouse.pos_y, i.interactivity.mouse.click_time = (new Date).getTime(), i.interactivity.events.onclick.enable)switch (i.interactivity.events.onclick.mode) {
        case"push":
          i.particles.move.enable ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : 1 == i.interactivity.modes.push.particles_nb ? i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb, i.interactivity.mouse) : i.interactivity.modes.push.particles_nb > 1 && i.fn.modes.pushParticles(i.interactivity.modes.push.particles_nb);
          break;
        case"remove":
          i.fn.modes.removeParticles(i.interactivity.modes.remove.particles_nb);
          break;
        case"bubble":
          i.tmp.bubble_clicking = !0;
          break;
        case"repulse":
          i.tmp.repulse_clicking = !0, i.tmp.repulse_count = 0, i.tmp.repulse_finish = !1, setTimeout(function () {
            i.tmp.repulse_clicking = !1
          }, 1e3 * i.interactivity.modes.repulse.duration)
      }
    })
  }, i.fn.vendors.densityAutoParticles = function () {
    if (i.particles.number.density.enable) {
      var e = i.canvas.el.width * i.canvas.el.height / 1e3;
      i.tmp.retina && (e /= 2 * i.canvas.pxratio);
      var a = e * i.particles.number.value / i.particles.number.density.value_area, t = i.particles.array.length - a;
      0 > t ? i.fn.modes.pushParticles(Math.abs(t)) : i.fn.modes.removeParticles(t)
    }
  }, i.fn.vendors.checkOverlap = function (e, a) {
    for (var t = 0; t < i.particles.array.length; t++) {
      var s = i.particles.array[t], n = e.x - s.x, r = e.y - s.y, c = Math.sqrt(n * n + r * r);
      c <= e.radius + s.radius && (e.x = a ? a.x : Math.random() * i.canvas.w, e.y = a ? a.y : Math.random() * i.canvas.h, i.fn.vendors.checkOverlap(e))
    }
  }, i.fn.vendors.createSvgImg = function (e) {
    var a = i.tmp.source_svg, t = /#([0-9A-F]{3,6})/gi, s = a.replace(t, function (a, t, i, s) {
        if (e.color.rgb)var n = "rgba(" + e.color.rgb.r + "," + e.color.rgb.g + "," + e.color.rgb.b + "," + e.opacity + ")"; else var n = "hsla(" + e.color.hsl.h + "," + e.color.hsl.s + "%," + e.color.hsl.l + "%," + e.opacity + ")";
        return n
      }), n = new Blob([s], {type: "image/svg+xml;charset=utf-8"}), r = window.URL || window.webkitURL || window,
      c = r.createObjectURL(n), o = new Image;
    o.addEventListener("load", function () {
      e.img.obj = o, e.img.loaded = !0, r.revokeObjectURL(c), i.tmp.count_svg++
    }), o.src = c
  }, i.fn.vendors.destroypJS = function () {
    cancelAnimationFrame(i.fn.drawAnimFrame), t.remove(), pJSDom = null
  }, i.fn.vendors.drawShape = function (e, a, t, i, s, n) {
    var r = s * n, c = s / n, o = 180 * (c - 2) / c, l = Math.PI - Math.PI * o / 180;
    e.save(), e.beginPath(), e.translate(a, t), e.moveTo(0, 0);
    for (var v = 0; r > v; v++)e.lineTo(i, 0), e.translate(i, 0), e.rotate(l);
    e.fill(), e.restore()
  }, i.fn.vendors.exportImg = function () {
    window.open(i.canvas.el.toDataURL("image/png"), "_blank")
  }, i.fn.vendors.loadImg = function (e) {
    if (i.tmp.img_error = void 0, "" != i.particles.shape.image.src)if ("svg" == e) {
      var a = new XMLHttpRequest;
      a.open("GET", i.particles.shape.image.src), a.onreadystatechange = function (e) {
        4 == a.readyState && (200 == a.status ? (i.tmp.source_svg = e.currentTarget.response, i.fn.vendors.checkBeforeDraw()) : (console.log("Error pJS - Image not found"), i.tmp.img_error = !0))
      }, a.send()
    } else {
      var t = new Image;
      t.addEventListener("load", function () {
        i.tmp.img_obj = t, i.fn.vendors.checkBeforeDraw()
      }), t.src = i.particles.shape.image.src
    } else console.log("Error pJS - No image.src"), i.tmp.img_error = !0
  }, i.fn.vendors.draw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type ? i.tmp.count_svg >= i.particles.number.value ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : void 0 != i.tmp.img_obj ? (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame)) : i.tmp.img_error || (i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw)) : (i.fn.particlesDraw(), i.particles.move.enable ? i.fn.drawAnimFrame = requestAnimFrame(i.fn.vendors.draw) : cancelRequestAnimFrame(i.fn.drawAnimFrame))
  }, i.fn.vendors.checkBeforeDraw = function () {
    "image" == i.particles.shape.type ? "svg" == i.tmp.img_type && void 0 == i.tmp.source_svg ? i.tmp.checkAnimFrame = requestAnimFrame(check) : (cancelRequestAnimFrame(i.tmp.checkAnimFrame), i.tmp.img_error || (i.fn.vendors.init(), i.fn.vendors.draw())) : (i.fn.vendors.init(), i.fn.vendors.draw())
  }, i.fn.vendors.init = function () {
    i.fn.retinaInit(), i.fn.canvasInit(), i.fn.canvasSize(), i.fn.canvasPaint(), i.fn.particlesCreate(), i.fn.vendors.densityAutoParticles(), i.particles.line_linked.color_rgb_line = hexToRgb(i.particles.line_linked.color)
  }, i.fn.vendors.start = function () {
    isInArray("image", i.particles.shape.type) ? (i.tmp.img_type = i.particles.shape.image.src.substr(i.particles.shape.image.src.length - 3), i.fn.vendors.loadImg(i.tmp.img_type)) : i.fn.vendors.checkBeforeDraw()
  }, i.fn.vendors.eventsListeners(), i.fn.vendors.start()
};
Object.deepExtend = function (e, a) {
  for (var t in a)a[t] && a[t].constructor && a[t].constructor === Object ? (e[t] = e[t] || {}, arguments.callee(e[t], a[t])) : e[t] = a[t];
  return e
}, window.requestAnimFrame = function () {
  return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (e) {
      window.setTimeout(e, 1e3 / 60)
    }
}(), window.cancelRequestAnimFrame = function () {
  return window.cancelAnimationFrame || window.webkitCancelRequestAnimationFrame || window.mozCancelRequestAnimationFrame || window.oCancelRequestAnimationFrame || window.msCancelRequestAnimationFrame || clearTimeout
}(), window.pJSDom = [], window.particlesJS = function (e, a) {
  "string" != typeof e && (a = e, e = "particles-js"), e || (e = "particles-js");
  var t = document.getElementById(e), i = "particles-js-canvas-el", s = t.getElementsByClassName(i);
  if (s.length)for (; s.length > 0;)t.removeChild(s[0]);
  var n = document.createElement("canvas");
  n.className = i, n.style.width = "100%", n.style.height = "100%";
  var r = document.getElementById(e).appendChild(n);
  null != r && pJSDom.push(new pJS(e, a))
}, window.particlesJS.load = function (e, a, t) {
  var i = new XMLHttpRequest;
  i.open("GET", a), i.onreadystatechange = function (a) {
    if (4 == i.readyState)if (200 == i.status) {
      var s = JSON.parse(a.currentTarget.response);
      window.particlesJS(e, s), t && t()
    } else console.log("Error pJS - XMLHttpRequest status: " + i.status), console.log("Error pJS - File config not found")
  }, i.send()
};
/**
 * Created by DELL on 18/7/2018.
 */

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .directive('windowheight', function () {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {
            element.css({minHeight: $(window).height()});
            element.css({maxHeight: $(window).height()});
          }).resize();
        }
      };
    })
    .directive('contextheight', function ($timeout) {
      return {
        restrict: 'A',
        link: function (scope, element) {
          $(window).resize(function () {

            $timeout(function () {
              /*var evt = $window.document.createEvent('UIEvents');
               evt.initUIEvent('resize', true, false, $window, 0);
               $window.dispatchEvent(evt);*/
              console.log(element.parent().height());
              var parent = element.parent().height() - 130;
              element.css({height: parent});
              element.css({maxHeight: parent});
              element.css({overflowX: 'hidden'});
              element.css({overflowY: 'scroll'});
              angular.element(window).resize(function () {
                $timeout(function () {
                }, 30);
              });
            }, 1000);
          }).resize();
        }
      };
    })
    .directive('equalheight', function ($timeout) {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '=',
          classitem: '@'
        },
        link: function (scope, element) {
          $(window).resize(function () {
            $timeout(function () {
              var x = document.getElementsByClassName(scope.classitem);
              var arrayTemp = [];
              var temp = 0;
              for (var i = 0; i < x.length; i++) {
                //console.log(x[i].offsetHeight)
                if (temp < x[i].offsetHeight) {
                  temp = x[i].offsetHeight;
                }
              }
              console.log('maximo', temp);
              element.css({minHeight: temp});


            }, 1000);
          }).resize();
        }
      };
    })
    .directive('modalheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            element.css({minHeight: customHeight});
            element.css({maxHeight: customHeight});
          }).resize();
        }
      };
    })
    .directive('customheight', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            //console.log(element, scope.minus, scope.plus, scope.equal, customHeight, '!!!!!');
            element.css({minHeight: customHeight});
          }).resize();
        }
      };
    })
    .directive('uiHeigth', function () {
      return {
        restrict: 'A',
        scope: {
          minus: '=',
          plus: '=',
          equal: '='
        },
        link: function (scope, element) {
          $(window).resize(function () {
            var customHeight = $(window).height();
            if (scope.equal) {
              customHeight = scope.equal;
            }
            if (scope.minus) {
              customHeight -= scope.minus;
            }
            if (scope.plus) {
              customHeight += scope.plus;
            }
            //console.log(element, scope.minus, scope.plus, scope.equal, customHeight, '!!!!!');
            element.css({minHeight: customHeight});
            element.css({maxHeight: customHeight});
          }).resize();
        }
      };
    })
    //carga video
    .directive('myYoutube', function ($sce) {
      return {
        restrict: 'A',
        scope: {code: '='},
        replace: true,
        template: '<div style="width:100%;"><iframe style="overflow:hidden;height:100%;width:100%" width="100%" height="100%" src="{{url}}" frameborder="0" allowfullscreen></iframe></div>',
        link: function (scope) {
          //console.log('here');
          scope.$watch('code', function (newVal) {
            if (newVal) {
              scope.url = $sce.trustAsResourceUrl("https://www.youtube.com/embed/" + newVal);
            }
          });
        }
      };
    })


})();

/**
 *
 * Color picker
 * Author: Stefan Petre www.eyecon.ro
 *
 * Dual licensed under the MIT and GPL licenses
 *
 */

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .directive('colorpicker', function ($compile) {
      return {
        restrict: 'E',
        replace: true,
        templateUrl: 'app/views/directives/colorpicker.html',
        link: function (scope, element) {
          console.log('ejecuta ccolor picker')

          var
            ids = {},
            inAction,
            charMin = 65,
            visible,
            defaults = {
              eventName: 'click',
              onShow: function () {
              },
              onBeforeShow: function () {
              },
              onHide: function () {
              },
              onChange: function () {
              },
              onSubmit: function () {
              },
              color: 'ff0000',
              livePreview: true,
              flat: false
            },
            fillRGBFields = function (hsb, cal) {
              var rgb = HSBToRGB(hsb);
              $(cal).data('colorpicker').fields
                .eq(1).val(rgb.r).end()
                .eq(2).val(rgb.g).end()
                .eq(3).val(rgb.b).end();
            },
            fillHSBFields = function (hsb, cal) {
              $(cal).data('colorpicker').fields
                .eq(4).val(hsb.h).end()
                .eq(5).val(hsb.s).end()
                .eq(6).val(hsb.b).end();
            },
            fillHexFields = function (hsb, cal) {
              $(cal).data('colorpicker').fields
                .eq(0).val(HSBToHex(hsb)).end();
            },
            setSelector = function (hsb, cal) {
              $(cal).data('colorpicker').selector.css('backgroundColor', '#' + HSBToHex({h: hsb.h, s: 100, b: 100}));
              $(cal).data('colorpicker').selectorIndic.css({
                left: parseInt(150 * hsb.s / 100, 10),
                top: parseInt(150 * (100 - hsb.b) / 100, 10)
              });
            },
            setHue = function (hsb, cal) {
              $(cal).data('colorpicker').hue.css('top', parseInt(150 - 150 * hsb.h / 360, 10));
            },
            setCurrentColor = function (hsb, cal) {
              $(cal).data('colorpicker').currentColor.css('backgroundColor', '#' + HSBToHex(hsb));
            },
            setNewColor = function (hsb, cal) {
              $(cal).data('colorpicker').newColor.css('backgroundColor', '#' + HSBToHex(hsb));
            },
            keyDown = function (ev) {
              var pressedKey = ev.charCode || ev.keyCode || -1;
              if ((pressedKey > charMin && pressedKey <= 90) || pressedKey == 32) {
                return false;
              }
              var cal = $(this).parent().parent();
              if (cal.data('colorpicker').livePreview === true) {
                change.apply(this);
              }
            },
            change = function (ev) {
              var cal = $(this).parent().parent(), col;
              if (this.parentNode.className.indexOf('_hex') > 0) {
                cal.data('colorpicker').color = col = HexToHSB(fixHex(this.value));
              } else if (this.parentNode.className.indexOf('_hsb') > 0) {
                cal.data('colorpicker').color = col = fixHSB({
                  h: parseInt(cal.data('colorpicker').fields.eq(4).val(), 10),
                  s: parseInt(cal.data('colorpicker').fields.eq(5).val(), 10),
                  b: parseInt(cal.data('colorpicker').fields.eq(6).val(), 10)
                });
              } else {
                cal.data('colorpicker').color = col = RGBToHSB(fixRGB({
                  r: parseInt(cal.data('colorpicker').fields.eq(1).val(), 10),
                  g: parseInt(cal.data('colorpicker').fields.eq(2).val(), 10),
                  b: parseInt(cal.data('colorpicker').fields.eq(3).val(), 10)
                }));
              }
              if (ev) {
                fillRGBFields(col, cal.get(0));
                fillHexFields(col, cal.get(0));
                fillHSBFields(col, cal.get(0));
              }
              setSelector(col, cal.get(0));
              setHue(col, cal.get(0));
              setNewColor(col, cal.get(0));
              cal.data('colorpicker').onChange.apply(cal, [col, HSBToHex(col), HSBToRGB(col)]);
            },
            blur = function (ev) {
              var cal = $(this).parent().parent();
              cal.data('colorpicker').fields.parent().removeClass('colorpicker_focus');
            },
            focus = function () {
              charMin = this.parentNode.className.indexOf('_hex') > 0 ? 70 : 65;
              $(this).parent().parent().data('colorpicker').fields.parent().removeClass('colorpicker_focus');
              $(this).parent().addClass('colorpicker_focus');
            },
            downIncrement = function (ev) {
              var field = $(this).parent().find('input').focus();
              var current = {
                el: $(this).parent().addClass('colorpicker_slider'),
                max: this.parentNode.className.indexOf('_hsb_h') > 0 ? 360 : (this.parentNode.className.indexOf('_hsb') > 0 ? 100 : 255),
                y: ev.pageY,
                field: field,
                val: parseInt(field.val(), 10),
                preview: $(this).parent().parent().data('colorpicker').livePreview
              };
              $(document).bind('mouseup', current, upIncrement);
              $(document).bind('mousemove', current, moveIncrement);
            },
            moveIncrement = function (ev) {
              ev.data.field.val(Math.max(0, Math.min(ev.data.max, parseInt(ev.data.val + ev.pageY - ev.data.y, 10))));
              if (ev.data.preview) {
                change.apply(ev.data.field.get(0), [true]);
              }
              return false;
            },
            upIncrement = function (ev) {
              change.apply(ev.data.field.get(0), [true]);
              ev.data.el.removeClass('colorpicker_slider').find('input').focus();
              $(document).unbind('mouseup', upIncrement);
              $(document).unbind('mousemove', moveIncrement);
              return false;
            },
            downHue = function (ev) {
              var current = {
                cal: $(this).parent(),
                y: $(this).offset().top
              };
              current.preview = current.cal.data('colorpicker').livePreview;
              $(document).bind('mouseup', current, upHue);
              $(document).bind('mousemove', current, moveHue);
            },
            moveHue = function (ev) {
              change.apply(
                ev.data.cal.data('colorpicker')
                  .fields
                  .eq(4)
                  .val(parseInt(360 * (150 - Math.max(0, Math.min(150, (ev.pageY - ev.data.y)))) / 150, 10))
                  .get(0),
                [ev.data.preview]
              );
              return false;
            },
            upHue = function (ev) {
              fillRGBFields(ev.data.cal.data('colorpicker').color, ev.data.cal.get(0));
              fillHexFields(ev.data.cal.data('colorpicker').color, ev.data.cal.get(0));
              $(document).unbind('mouseup', upHue);
              $(document).unbind('mousemove', moveHue);
              return false;
            },
            downSelector = function (ev) {
              var current = {
                cal: $(this).parent(),
                pos: $(this).offset()
              };
              current.preview = current.cal.data('colorpicker').livePreview;
              $(document).bind('mouseup', current, upSelector);
              $(document).bind('mousemove', current, moveSelector);
            },
            moveSelector = function (ev) {
              change.apply(
                ev.data.cal.data('colorpicker')
                  .fields
                  .eq(6)
                  .val(parseInt(100 * (150 - Math.max(0, Math.min(150, (ev.pageY - ev.data.pos.top)))) / 150, 10))
                  .end()
                  .eq(5)
                  .val(parseInt(100 * (Math.max(0, Math.min(150, (ev.pageX - ev.data.pos.left)))) / 150, 10))
                  .get(0),
                [ev.data.preview]
              );
              return false;
            },
            upSelector = function (ev) {
              fillRGBFields(ev.data.cal.data('colorpicker').color, ev.data.cal.get(0));
              fillHexFields(ev.data.cal.data('colorpicker').color, ev.data.cal.get(0));
              $(document).unbind('mouseup', upSelector);
              $(document).unbind('mousemove', moveSelector);
              return false;
            },
            enterSubmit = function (ev) {
              $(this).addClass('colorpicker_focus');
            },
            leaveSubmit = function (ev) {
              $(this).removeClass('colorpicker_focus');
            },
            clickSubmit = function (ev) {
              var cal = $(this).parent();
              var col = cal.data('colorpicker').color;
              cal.data('colorpicker').origColor = col;
              setCurrentColor(col, cal.get(0));
              cal.data('colorpicker').onSubmit(col, HSBToHex(col), HSBToRGB(col), cal.data('colorpicker').el);
            },
            show = function (ev) {
              var cal = $('#' + $(this).data('colorpickerId'));
              cal.data('colorpicker').onBeforeShow.apply(this, [cal.get(0)]);
              var pos = $(this).offset();
              var viewPort = getViewport();
              var top = pos.top + this.offsetHeight;
              var left = pos.left;
              if (top + 176 > viewPort.t + viewPort.h) {
                top -= this.offsetHeight + 176;
              }
              if (left + 356 > viewPort.l + viewPort.w) {
                left -= 356;
              }
              cal.css({left: left + 'px', top: top + 'px'});
              if (cal.data('colorpicker').onShow.apply(this, [cal.get(0)]) != false) {
                cal.show();
              }
              $(document).bind('mousedown', {cal: cal}, hide);
              return false;
            },
            hide = function (ev) {
              if (!isChildOf(ev.data.cal.get(0), ev.target, ev.data.cal.get(0))) {
                if (ev.data.cal.data('colorpicker').onHide.apply(this, [ev.data.cal.get(0)]) != false) {
                  ev.data.cal.hide();
                }
                $(document).unbind('mousedown', hide);
              }
            },
            isChildOf = function (parentEl, el, container) {
              if (parentEl == el) {
                return true;
              }
              if (parentEl.contains) {
                return parentEl.contains(el);
              }
              if (parentEl.compareDocumentPosition) {
                return !!(parentEl.compareDocumentPosition(el) & 16);
              }
              var prEl = el.parentNode;
              while (prEl && prEl != container) {
                if (prEl == parentEl)
                  return true;
                prEl = prEl.parentNode;
              }
              return false;
            },
            getViewport = function () {
              var m = document.compatMode == 'CSS1Compat';
              return {
                l: window.pageXOffset || (m ? document.documentElement.scrollLeft : document.body.scrollLeft),
                t: window.pageYOffset || (m ? document.documentElement.scrollTop : document.body.scrollTop),
                w: window.innerWidth || (m ? document.documentElement.clientWidth : document.body.clientWidth),
                h: window.innerHeight || (m ? document.documentElement.clientHeight : document.body.clientHeight)
              };
            },
            fixHSB = function (hsb) {
              return {
                h: Math.min(360, Math.max(0, hsb.h)),
                s: Math.min(100, Math.max(0, hsb.s)),
                b: Math.min(100, Math.max(0, hsb.b))
              };
            },
            fixRGB = function (rgb) {
              return {
                r: Math.min(255, Math.max(0, rgb.r)),
                g: Math.min(255, Math.max(0, rgb.g)),
                b: Math.min(255, Math.max(0, rgb.b))
              };
            },
            fixHex = function (hex) {
              var len = 6 - hex.length;
              if (len > 0) {
                var o = [];
                for (var i = 0; i < len; i++) {
                  o.push('0');
                }
                o.push(hex);
                hex = o.join('');
              }
              return hex;
            },
            HexToRGB = function (hex) {
              var hex = parseInt(((hex.indexOf('#') > -1) ? hex.substring(1) : hex), 16);
              return {r: hex >> 16, g: (hex & 0x00FF00) >> 8, b: (hex & 0x0000FF)};
            },
            HexToHSB = function (hex) {
              return RGBToHSB(HexToRGB(hex));
            },
            RGBToHSB = function (rgb) {
              var hsb = {
                h: 0,
                s: 0,
                b: 0
              };
              var min = Math.min(rgb.r, rgb.g, rgb.b);
              var max = Math.max(rgb.r, rgb.g, rgb.b);
              var delta = max - min;
              hsb.b = max;
              if (max != 0) {

              }
              hsb.s = max != 0 ? 255 * delta / max : 0;
              if (hsb.s != 0) {
                if (rgb.r == max) {
                  hsb.h = (rgb.g - rgb.b) / delta;
                } else if (rgb.g == max) {
                  hsb.h = 2 + (rgb.b - rgb.r) / delta;
                } else {
                  hsb.h = 4 + (rgb.r - rgb.g) / delta;
                }
              } else {
                hsb.h = -1;
              }
              hsb.h *= 60;
              if (hsb.h < 0) {
                hsb.h += 360;
              }
              hsb.s *= 100 / 255;
              hsb.b *= 100 / 255;
              return hsb;
            },
            HSBToRGB = function (hsb) {
              var rgb = {};
              var h = Math.round(hsb.h);
              var s = Math.round(hsb.s * 255 / 100);
              var v = Math.round(hsb.b * 255 / 100);
              if (s == 0) {
                rgb.r = rgb.g = rgb.b = v;
              } else {
                var t1 = v;
                var t2 = (255 - s) * v / 255;
                var t3 = (t1 - t2) * (h % 60) / 60;
                if (h == 360) h = 0;
                if (h < 60) {
                  rgb.r = t1;
                  rgb.b = t2;
                  rgb.g = t2 + t3
                }
                else if (h < 120) {
                  rgb.g = t1;
                  rgb.b = t2;
                  rgb.r = t1 - t3
                }
                else if (h < 180) {
                  rgb.g = t1;
                  rgb.r = t2;
                  rgb.b = t2 + t3
                }
                else if (h < 240) {
                  rgb.b = t1;
                  rgb.r = t2;
                  rgb.g = t1 - t3
                }
                else if (h < 300) {
                  rgb.b = t1;
                  rgb.g = t2;
                  rgb.r = t2 + t3
                }
                else if (h < 360) {
                  rgb.r = t1;
                  rgb.g = t2;
                  rgb.b = t1 - t3
                }
                else {
                  rgb.r = 0;
                  rgb.g = 0;
                  rgb.b = 0
                }
              }
              return {r: Math.round(rgb.r), g: Math.round(rgb.g), b: Math.round(rgb.b)};
            },
            RGBToHex = function (rgb) {
              var hex = [
                rgb.r.toString(16),
                rgb.g.toString(16),
                rgb.b.toString(16)
              ];
              $.each(hex, function (nr, val) {
                if (val.length == 1) {
                  hex[nr] = '0' + val;
                }
              });
              return hex.join('');
            },
            HSBToHex = function (hsb) {
              return RGBToHex(HSBToRGB(hsb));
            },
            restoreOriginal = function () {
              var cal = $(this).parent();
              var col = cal.data('colorpicker').origColor;
              cal.data('colorpicker').color = col;
              fillRGBFields(col, cal.get(0));
              fillHexFields(col, cal.get(0));
              fillHSBFields(col, cal.get(0));
              setSelector(col, cal.get(0));
              setHue(col, cal.get(0));
              setNewColor(col, cal.get(0));
            };
          return {
            init: function (opt) {
              opt = $.extend({}, defaults, opt || {});
              if (typeof opt.color == 'string') {
                opt.color = HexToHSB(opt.color);
              } else if (opt.color.r != undefined && opt.color.g != undefined && opt.color.b != undefined) {
                opt.color = RGBToHSB(opt.color);
              } else if (opt.color.h != undefined && opt.color.s != undefined && opt.color.b != undefined) {
                opt.color = fixHSB(opt.color);
              } else {
                return this;
              }
              return this.each(function () {
                if (!$(this).data('colorpickerId')) {
                  var options = $.extend({}, opt);
                  options.origColor = opt.color;
                  var id = 'collorpicker_' + parseInt(Math.random() * 1000);
                  $(this).data('colorpickerId', id);
                  var cal = $(tpl).attr('id', id);
                  if (options.flat) {
                    cal.appendTo(this).show();
                  } else {
                    cal.appendTo(document.body);
                  }
                  options.fields = cal
                    .find('input')
                    .bind('keyup', keyDown)
                    .bind('change', change)
                    .bind('blur', blur)
                    .bind('focus', focus);
                  cal
                    .find('span').bind('mousedown', downIncrement).end()
                    .find('>div.colorpicker_current_color').bind('click', restoreOriginal);
                  options.selector = cal.find('div.colorpicker_color').bind('mousedown', downSelector);
                  options.selectorIndic = options.selector.find('div div');
                  options.el = this;
                  options.hue = cal.find('div.colorpicker_hue div');
                  cal.find('div.colorpicker_hue').bind('mousedown', downHue);
                  options.newColor = cal.find('div.colorpicker_new_color');
                  options.currentColor = cal.find('div.colorpicker_current_color');
                  cal.data('colorpicker', options);
                  cal.find('div.colorpicker_submit')
                    .bind('mouseenter', enterSubmit)
                    .bind('mouseleave', leaveSubmit)
                    .bind('click', clickSubmit);
                  fillRGBFields(options.color, cal.get(0));
                  fillHSBFields(options.color, cal.get(0));
                  fillHexFields(options.color, cal.get(0));
                  setHue(options.color, cal.get(0));
                  setSelector(options.color, cal.get(0));
                  setCurrentColor(options.color, cal.get(0));
                  setNewColor(options.color, cal.get(0));
                  if (options.flat) {
                    cal.css({
                      position: 'relative',
                      display: 'block'
                    });
                  } else {
                    $(this).bind(options.eventName, show);
                  }
                }
              });
            }(),
            showPicker: function () {
              return this.each(function () {
                if ($(this).data('colorpickerId')) {
                  show.apply(this);
                }
              });
            }(),
            hidePicker: function () {
              return this.each(function () {
                if ($(this).data('colorpickerId')) {
                  $('#' + $(this).data('colorpickerId')).hide();
                }
              });
            }(),
            setColor: function (col) {
              if (typeof col == 'string') {
                col = HexToHSB(col);
              } else if (col.r != undefined && col.g != undefined && col.b != undefined) {
                col = RGBToHSB(col);
              } else if (col.h != undefined && col.s != undefined && col.b != undefined) {
                col = fixHSB(col);
              } else {
                return this;
              }
              return this.each(function () {
                if ($(this).data('colorpickerId')) {
                  var cal = $('#' + $(this).data('colorpickerId'));
                  cal.data('colorpicker').color = col;
                  cal.data('colorpicker').origColor = col;
                  fillRGBFields(col, cal.get(0));
                  fillHSBFields(col, cal.get(0));
                  fillHexFields(col, cal.get(0));
                  setHue(col, cal.get(0));
                  setSelector(col, cal.get(0));
                  setCurrentColor(col, cal.get(0));
                  setNewColor(col, cal.get(0));
                }
              });
            }()
          };

        }


      }
    });
})();


'use strict';
angular
  .module('frontendapp')
  .factory('UserService', function ($http, $rootScope) {
    return {
      actualizarToken: function () {
        return $http.get($rootScope.api + '/api/authenticate/refresh?token=' + $rootScope.tk);
      },
      owneraccount: function () {
        var params = {
          'token': $rootScope.tk
        };
        return $http.post($rootScope.api + '/api/authenticate/owneraccount', params);
      },
      updateclientprofile: function (params) {
        params.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/authenticate/updateaccount', params);
      },
      usercp: function (params) {
        params.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/authenticate/newpassword', params);
      },
      forgotpassword: function (params) {
        return $http.post($rootScope.api + '/api/authenticate/forgotpassword', params);
      },
      checklink: function (params) {
        return $http.post($rootScope.api + '/api/authenticate/chekforgotlink', params);
      },
      resetforgotten: function (params) {
        return $http.post($rootScope.api + '/api/authenticate/resetpassword', params);
      }


    };
  });

'use strict';
angular
  .module('frontendapp')
  .factory('TablesService', function ($http, $rootScope) {
    return {
      listar: function (tabla) {
        var params = [];
        //params['lan'] = 'en';
        return $http.get($rootScope.api + '/api/' + tabla, params);
      },
      filtrar: function (tabla, params) {
        //params['lan'] =   $rootScope.language;
        params.currentState = $rootScope.currentState;
        console.log('GET DATA PARAMS', tabla, params)
        return $http.post($rootScope.api + '/api/' + tabla + '/getdata', params);
      },
      contactar: function (params) {
        params['lan'] = $rootScope.language != undefined ? $rootScope.language : 'en';
        return $http.post($rootScope.api + '/api/formcontacto/almacenar', params);
      },
      estructura: function (tabla) {
        return $http.get($rootScope.api + '/api/' + tabla + '/estructura');
      },
      almacenar: function (tabla, parametros) {
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/store', parametros);
      },
      storemany: function (tabla, parametros) {
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/storemany', parametros);
      },
      actualizar: function (tabla, id, parametros) {
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/update/' + id, parametros);
      },
      cargar: function (tabla, id, parametros) {
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/upload/' + id, parametros);
      },
      eliminar: function (tabla, id, parametros) {
        if (parametros == null) {
          parametros = {};
        }
        parametros['token'] = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/delete/' + id, parametros);
      },
      visualizar: function (tabla, id) {
        var params = {
          'token': $rootScope.tk,
          'lan': $rootScope.language != undefined ? $rootScope.language : 'en'
        };
        return $http.get($rootScope.api + '/api/' + tabla + '/visualizar/' + id, params);
      },

      generate: function (parametros) {
        // parametros['token'] = $rootScope.tk;
        //////console.log('PRAMETROS', parametros)
        return $http.post($rootScope.api + '/api/facts/generate', parametros);
      },
      getTable: function (parametros) {
        return $http.post($rootScope.api + '/api/core/gettable', parametros);
      },
      getTableColumns: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/core/gettablecolumns', parametros);
      },
      corebuild: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/core/build', parametros);
      },
      notifications: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/not', parametros);
      },

      statics: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/voucher/statics', {});
      },

      storemetadata: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/stocklog/storemetadata', parametros);
      },

      getmetadata: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/stocklog/getmetadata', parametros);
      },

      updatestock: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/stocklog/updatestock', parametros);
      },

      /* loadtickets: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/movieticket/loadtickets', parametros);
      }, */

      loadtickets: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/movieticketbatch/getmetadata', parametros);
      },

      storetickets: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/movieticketbatch/storemetadata', parametros);
      },

      storepromo: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/mpromo/storemetadata', parametros);
      },

      downloadexcel: function (tabla, parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/' + tabla + '/download', parametros);
      },

      moviereport: function (parametros) {
        parametros.token = $rootScope.tk;
        return $http.post($rootScope.api + '/api/voucher/moviesreport', parametros);
      },

    };
  });

'use strict';
angular
  .module('frontendapp')
  .controller('wcmsCtrl', function (ImageLoader, $window, $log, TablesService, $state, $timeout, $rootScope) {
    var vm = this;

    vm.rulesP = [
      { field: 'id', active: false, activeGrid: false, required: false },
    ];
    vm.preload = function () {
      vm.crudReady = true;
      vm.model = $state.params.model;
      vm.type = $state.params.type;

      /*********** CUSTOMIZATION DORE **********/
      vm.webrouteParam = $state.params.webroute;
      vm.webcontextParam = $state.params.webcontext;

      /** Categorias de contenido **/
      vm.webadversiting = {
        component: 'grid',
        model: 'webadversiting',
        customOperations: {
          create: true,//$rootScope.access(['gestor-de-contenido', 'super-admin']),
          delete: false,
          update: true,
          read: true
        },
      };

      /** Menu **/

      vm.webroute = {
        component: 'grid',
        model: 'webroute',
        customOperations: {
          create: true,
          delete: true,
          update: true,
          read: true
        },
        customFilters: {
          filters: {
            type: {
              value: '1',
              operator: '='
            }
          }
        },
        customProperties: {
          state: {},
          name: {
            disabled: false
          },
          type: {
            default: '1'
          },
          webcollection: {
            presentation: {
              type: 'article',
            },
            customOperations: {
              create: true,
              delete: true,
              update: true,
              read: true
            },
            customProperties: {
              websection: {
                presentation: {
                  type: 'article',
                },
                customProperties: {
                  webroute_id: {
                    default: function () {
                      var exit = 0;
                      switch (vm.webrouteParam) {
                        case 'home':
                          exit = 1;
                          break;
                      }
                      return exit;
                    }(),
                    disabled: false
                  },
                  webcontext_id: {
                    resolve: {
                      items: function (model) {
                        var exit = [];
                        angular.forEach(model.properties.webcontext_id.items, function (i) {
                          console.log('webcontextParam', i.webroutename, vm.webrouteParam);
                          if (i.webroutename == vm.webrouteParam) {
                            exit.push(i);
                            console.log('Match!!');
                          }
                        });
                        console.log('items seleccionados', exit, vm.webroute);
                        return exit;
                      }
                    }
                  },
                  websectiondata: {
                    presentation: {
                      type: 'render',
                    },
                    hide: false,
                    customProperties: {
                      name: {
                        hide: true
                      },
                      order: {
                        resolve: {
                          default: function (model) {
                            var exit = 0;
                            angular.forEach($rootScope.websection.selected.websectiondata, function (i) {
                              console.log('ORDEN EXTRAIDO', i.order);
                              if (i.order > exit) {
                                exit = i.order;
                              }
                            });
                            console.log('NEXT ID', exit + 1);
                            if (model.actionType == 'store') {
                              return exit + 1;
                            }
                            else {
                              return null;
                            }
                          },
                        },
                        disabled: false,
                        // hide:true
                      },
                      type: {
                        /*resolve: {
                         disabled: function (model) {
                         if (model.actionType == 'store') {
                         return false;
                         }
                         else {
                         return true;
                         }
                         },
                         },*/
                        ngChange: function (model) {
                          //TITLE
                          switch (model.selected.type) {
                            case 1:
                            case 5:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                              model.properties.title.hide = false;
                              break;
                            default:
                              model.properties.title.hide = true;
                              break;
                          }
                          //CONTENT
                          switch (model.selected.type) {
                            case 0:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                              model.properties.content.hide = false;
                              break;
                            default:
                              model.properties.content.hide = true;
                              break;
                          }
                          //LINK
                          switch (model.selected.type) {
                            case 2:
                            case 5:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 12:
                            case 13:
                            case 14:
                            case 15:
                            case 16:
                              model.properties.link.hide = false;
                              break;
                            default:
                              model.properties.link.hide = true;
                              break;
                          }
                          switch (model.selected.type) {
                            case 17:
                            case 18:
                              model.properties.link.type = 'file';
                              break;
                            case 16:
                              model.properties.link.type = 'textarea';
                              break;
                            default:
                              model.properties.link.type = 'text';
                              break;
                          }
                          //IMAGE
                          switch (model.selected.type) {
                            case 1:
                            case 5:
                            case 17:
                            case 18:
                            case 19:
                            case 20:
                            case 7:
                            case 8:
                            case 9:
                            case 10:
                            case 11:
                            case 13:
                            case 15:
                              model.properties.image.hide = false;
                              break;
                            default:
                              model.properties.image.hide = true;
                              break;
                          }
                          //websectiondataitem
                          switch (model.selected.type) {
                            case 3:
                            case 4:
                            case 6:
                              model.properties.websectiondataitem.hide = false;
                              break;
                            default:
                              model.properties.websectiondataitem.hide = true;
                              break;
                          }
                          /*switch (model.selected.type) {
                           case 0:
                           model.properties.content.hide = false;
                           model.properties.image.hide = true;
                           model.properties.link.hide = true;
                           model.properties.websectiondataitem.hide = true;
                           break;
                           case 1:
                           model.properties.content.hide = true;
                           model.properties.image.hide = false;
                           model.properties.link.hide = true;
                           model.properties.websectiondataitem.hide = true;
                           break;
                           case 2:
                           model.properties.content.hide = true;
                           model.properties.image.hide = true;
                           model.properties.link.hide = false;
                           model.properties.websectiondataitem.hide = true;
                           break;
                           case 3:
                           case 4:
                           console.log('caso galeria!!!');
                           model.properties.content.hide = true;
                           model.properties.image.hide = true;
                           model.properties.link.hide = true;
                           model.properties.websectiondataitem.hide = false;
                           break;
                           }*/
                        },
                      },
                      title: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            //TITLE
                            switch (model.selected.type) {
                              case 1:
                              case 5:
                              case 17:
                              case 18:
                              case 19:
                              case 20:
                              case 7:
                              case 8:
                              case 9:
                              case 10:
                              case 11:
                              case 12:
                              case 13:
                              case 14:
                              case 15:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          },
                        }
                      },
                      content: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            //CONTENT
                            switch (model.selected.type) {
                              case 0:
                              case 7:
                              case 8:
                              case 9:
                              case 10:
                              case 11:
                              case 12:
                              case 13:
                              case 14:
                              case 15:
                              case 16:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          },
                        }
                      },
                      image: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            switch (model.selected.type) {
                              case 1:
                              case 5:
                              case 17:
                              case 18:
                              case 19:
                              case 20:
                              case 7:
                              case 8:
                              case 9:
                              case 10:
                              case 11:
                              case 13:
                              case 15:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          },
                        }
                      },
                      link: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            //LINK
                            switch (model.selected.type) {
                              case 2:
                              case 5:
                              case 17:
                              case 18:
                              case 19:
                              case 20:
                              case 7:
                              case 8:
                              case 9:
                              case 10:
                              case 11:
                              case 12:
                              case 13:
                              case 14:
                              case 15:
                              case 16:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          },
                          type: function (model) {
                            var exit = true;
                            //LINK
                            switch (model.selected.type) {
                              case 17:
                              case 18:
                                exit = 'file';
                                break;
                              case 16:
                                exit = 'textarea';
                                break;
                              default:
                                exit = 'text';
                                break;
                            }
                            return exit;
                          },
                          toolbar: function (model) {
                            var exit = true;
                            //LINK
                            switch (model.selected.type) {
                              case 16:
                                exit = 'basics';
                                break;
                              default:
                                exit = 'text';
                                break;
                            }
                            return exit;
                          },
                        }
                      },
                      websectiondataitem: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            //websectiondataitem
                            switch (model.selected.type) {
                              case 3:
                              case 4:
                              case 6:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          }
                        },
                        presentation: {
                          type: 'render',
                        },
                        customProperties: {
                          order: {
                            resolve: {
                              default: function (model) {
                                var exit = 0;
                                angular.forEach($rootScope.websectiondata.selected.websectiondataitem, function (i) {
                                  console.log('ORDEN EXTRAIDO', i.order);
                                  if (i.order > exit) {
                                    exit = i.order;
                                  }
                                });
                                console.log('NEXT ID', exit + 1);
                                if (model.actionType == 'store') {
                                  return exit + 1;
                                }
                                else {
                                  return null;
                                }
                              }
                            },
                            disabled: true,
                            // hide:true
                          },
                          title: {
                            resolve: {
                              hide: function (model) {
                                var exit = true;
                                switch ($rootScope.websectiondata.selected.type) {
                                  //case 3:
                                  case 4:
                                  case 6:
                                    exit = false;
                                    break;
                                  default:
                                    exit = true;
                                    break;
                                }
                                return exit;
                              }
                            }
                          },
                          content: {
                            resolve: {
                              hide: function (model) {
                                var exit = true;
                                switch ($rootScope.websectiondata.selected.type) {
                                  //case 3:
                                  case 4:
                                    //case 6:
                                    exit = false;
                                    break;
                                  default:
                                    exit = true;
                                    break;
                                }
                                return exit;
                              }
                            }
                          },
                          image: {
                            resolve: {
                              hide: function (model) {
                                var exit = true;
                                switch ($rootScope.websectiondata.selected.type) {
                                  case 3:
                                  case 4:
                                    //case 6:
                                    exit = false;
                                    break;
                                  default:
                                    exit = true;
                                    break;
                                }
                                return exit;
                              }
                            }
                          },
                          link: {
                            resolve: {
                              hide: function (model) {
                                var exit = true;
                                switch ($rootScope.websectiondata.selected.type) {
                                  //case 3:
                                  case 4:
                                  case 6:
                                    exit = false;
                                    break;
                                  default:
                                    exit = true;
                                    break;
                                }
                                return exit;
                              }
                            }
                          }
                        }
                      }
                    }
                  },

                }
              },
              webroute_id: {
                disabled: false
              }
            }
          }
        }

      };

      /** Categorias de contenido **/

      vm.webcontext = {
        component: 'grid',
        model: 'webcontext',
        customOperations: {
          create: true,//$rootScope.access(['gestor-de-contenido', 'super-admin']),
          delete: true,
          update: true,
          read: true
        },
        customFilters: {
          filters: {
            webroute_id: {
              operator: 'belongsTo',
              field: 'name',
              model: 'webroute',
              value: vm.webrouteParam
            }
          }
        },
        customProperties: {
          image: {
            hide: (vm.webrouteParam != 'Revistas') ? true : false,
            hideGrid: (vm.webrouteParam != 'Revistas') ? true : false,
          }
        },
      };

      /** Colecciones **/

      vm.webcollection = {
        component: 'grid',
        model: 'webcollection',
        customOperations: {
          create: true,
          delete: true,
          update: true,
          read: true
        },
        customProperties: {
          websection: {
            presentation: {
              type: 'article',
            },
            customProperties: {
              webroute_id: {
                default: function () {
                  var exit = 0;
                  switch (vm.webrouteParam) {
                    case 'home':
                      exit = 1;
                      break;
                  }
                  return exit;
                }(),
                disabled: false
              },
              webcontext_id: {
                resolve: {
                  items: function (model) {
                    var exit = [];
                    angular.forEach(model.properties.webcontext_id.items, function (i) {
                      console.log('webcontextParam', i.webroutename, vm.webrouteParam);
                      if (i.webroutename == vm.webrouteParam) {
                        exit.push(i);
                        console.log('Match!!');
                      }
                    });
                    console.log('items seleccionados', exit, vm.webroute);
                    return exit;
                  }
                }
              },
              websectiondata: {
                presentation: {
                  type: 'render',
                },
                hide: false,
                customProperties: {
                  name: {
                    hide: true
                  },
                  order: {
                    resolve: {
                      default: function (model) {
                        var exit = 0;
                        angular.forEach($rootScope.websection.selected.websectiondata, function (i) {
                          console.log('ORDEN EXTRAIDO', i.order);
                          if (i.order > exit) {
                            exit = i.order;
                          }
                        });
                        console.log('NEXT ID', exit + 1);
                        if (model.actionType == 'store') {
                          return exit + 1;
                        }
                        else {
                          return null;
                        }
                      },
                    },
                    disabled: false,
                    // hide:true
                  },
                  type: {
                    /*resolve: {
                      disabled: function (model) {
                        if (model.actionType == 'store') {
                          return false;
                        }
                        else {
                          return true;
                        }
                      },
                     },*/
                    ngChange: function (model) {
                      //TITLE
                      switch (model.selected.type) {
                        case 5:
                        case 17:
                        case 18:
                        case 19:
                        case 20:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                          model.properties.title.hide = false;
                          break;
                        default:
                          model.properties.title.hide = true;
                          break;
                      }
                      //CONTENT
                      switch (model.selected.type) {
                        case 0:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                          model.properties.content.hide = false;
                          break;
                        default:
                          model.properties.content.hide = true;
                          break;
                      }
                      //LINK
                      switch (model.selected.type) {
                        case 2:
                        case 5:
                        case 17:
                        case 18:
                        case 19:
                        case 20:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 12:
                        case 13:
                        case 14:
                        case 15:
                        case 16:
                          model.properties.link.hide = false;
                          break;
                        default:
                          model.properties.link.hide = true;
                          break;
                      }
                      switch (model.selected.type) {
                        case 17:
                        case 18:
                          model.properties.link.type = 'file';
                          break;
                        case 16:
                          model.properties.link.type = 'textarea';
                          break;
                        default:
                          model.properties.link.type = 'text';
                          break;
                      }
                      //IMAGE
                      switch (model.selected.type) {
                        case 1:
                        case 5:
                        case 17:
                        case 18:
                        case 19:
                        case 20:
                        case 7:
                        case 8:
                        case 9:
                        case 10:
                        case 11:
                        case 13:
                        case 15:
                          model.properties.image.hide = false;
                          break;
                        default:
                          model.properties.image.hide = true;
                          break;
                      }
                      //websectiondataitem
                      switch (model.selected.type) {
                        case 3:
                        case 4:
                        case 6:
                          model.properties.websectiondataitem.hide = false;
                          break;
                        default:
                          model.properties.websectiondataitem.hide = true;
                          break;
                      }
                      /*switch (model.selected.type) {
                       case 0:
                       model.properties.content.hide = false;
                       model.properties.image.hide = true;
                       model.properties.link.hide = true;
                       model.properties.websectiondataitem.hide = true;
                       break;
                       case 1:
                       model.properties.content.hide = true;
                       model.properties.image.hide = false;
                       model.properties.link.hide = true;
                       model.properties.websectiondataitem.hide = true;
                       break;
                       case 2:
                       model.properties.content.hide = true;
                       model.properties.image.hide = true;
                       model.properties.link.hide = false;
                       model.properties.websectiondataitem.hide = true;
                       break;
                       case 3:
                       case 4:
                       console.log('caso galeria!!!');
                       model.properties.content.hide = true;
                       model.properties.image.hide = true;
                       model.properties.link.hide = true;
                       model.properties.websectiondataitem.hide = false;
                       break;
                       }*/
                    },
                  },
                  title: {
                    resolve: {
                      hide: function (model) {
                        var exit = true;
                        //TITLE
                        switch (model.selected.type) {
                          case 5:
                          case 17:
                          case 18:
                          case 19:
                          case 20:
                          case 7:
                          case 8:
                          case 9:
                          case 10:
                          case 11:
                          case 12:
                          case 13:
                          case 14:
                          case 15:
                            exit = false;
                            break;
                          default:
                            exit = true;
                            break;
                        }
                        return exit;
                      },
                    }
                  },
                  content: {
                    resolve: {
                      hide: function (model) {
                        var exit = true;
                        //CONTENT
                        switch (model.selected.type) {
                          case 0:
                          case 7:
                          case 8:
                          case 9:
                          case 10:
                          case 11:
                          case 12:
                          case 13:
                          case 14:
                          case 15:
                          case 16:
                            exit = false;
                            break;
                          default:
                            exit = true;
                            break;
                        }
                        return exit;
                      },
                    }
                  },
                  image: {
                    resolve: {
                      hide: function (model) {
                        var exit = true;
                        switch (model.selected.type) {
                          case 1:
                          case 5:
                          case 17:
                          case 18:
                          case 19:
                          case 20:
                          case 7:
                          case 8:
                          case 9:
                          case 10:
                          case 11:
                          case 13:
                          case 15:
                            exit = false;
                            break;
                          default:
                            exit = true;
                            break;
                        }
                        return exit;
                      },
                    }
                  },
                  link: {
                    resolve: {
                      hide: function (model) {
                        var exit = true;
                        //LINK
                        switch (model.selected.type) {
                          case 2:
                          case 5:
                          case 17:
                          case 18:
                          case 19:
                          case 20:
                          case 7:
                          case 8:
                          case 9:
                          case 10:
                          case 11:
                          case 12:
                          case 13:
                          case 14:
                          case 15:
                          case 16:
                            exit = false;
                            break;
                          default:
                            exit = true;
                            break;
                        }
                        return exit;
                      },
                      type: function (model) {
                        var exit = true;
                        //LINK
                        switch (model.selected.type) {
                          case 17:
                          case 18:
                            exit = 'file';
                            break;
                          case 16:
                            exit = 'textarea';
                            break;
                          default:
                            exit = 'text';
                            break;
                        }
                        return exit;
                      },
                      toolbar: function (model) {
                        var exit = true;
                        //LINK
                        switch (model.selected.type) {
                          case 16:
                            exit = 'basics';
                            break;
                          default:
                            exit = 'text';
                            break;
                        }
                        return exit;
                      },
                    }
                  },
                  websectiondataitem: {
                    resolve: {
                      hide: function (model) {
                        var exit = true;
                        //websectiondataitem
                        switch (model.selected.type) {
                          case 3:
                          case 4:
                          case 6:
                            exit = false;
                            break;
                          default:
                            exit = true;
                            break;
                        }
                        return exit;
                      }
                    },
                    presentation: {
                      type: 'render',
                    },
                    customProperties: {
                      order: {
                        resolve: {
                          default: function (model) {
                            var exit = 0;
                            angular.forEach($rootScope.websectiondata.selected.websectiondataitem, function (i) {
                              console.log('ORDEN EXTRAIDO', i.order);
                              if (i.order > exit) {
                                exit = i.order;
                              }
                            });
                            console.log('NEXT ID', exit + 1);
                            if (model.actionType == 'store') {
                              return exit + 1;
                            }
                            else {
                              return null;
                            }
                          }
                        },
                        disabled: true,
                        // hide:true
                      },
                      title: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            switch ($rootScope.websectiondata.selected.type) {
                              //case 3:
                              case 4:
                              case 6:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          }
                        }
                      },
                      content: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            switch ($rootScope.websectiondata.selected.type) {
                              //case 3:
                              case 4:
                                //case 6:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          }
                        }
                      },
                      image: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            switch ($rootScope.websectiondata.selected.type) {
                              case 3:
                              case 4:
                                //case 6:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          }
                        }
                      },
                      link: {
                        resolve: {
                          hide: function (model) {
                            var exit = true;
                            switch ($rootScope.websectiondata.selected.type) {
                              //case 3:
                              //case 4:
                              case 6:
                                exit = false;
                                break;
                              default:
                                exit = true;
                                break;
                            }
                            return exit;
                          }
                        }
                      }
                    }
                  }
                }
              },

            }
          },
          webroute_id: {
            disabled: false
          }
        }
      };

      /** Articulos **/
      vm.websection = {
        component: 'grid',
        model: 'websection',
        customOperations: {
          create: (vm.webrouteParam === 'terminos') ? false : true,
          delete: (vm.webrouteParam === 'terminos') ? false : true,
          update: true,
          read: true
        },
        customFilters: {
          filters: {
            webroute_id: {
              operator: 'belongsTo',
              field: 'name',
              model: 'webroute',
              value: vm.webrouteParam
            }
          }
        },
        customProperties: {
          webroute_id: {
            default: function () {
              var exit = 0;
              switch (vm.webrouteParam) {
                case 'home':
                  exit = 1;
                  break;
                case 'services':
                  exit = 2;
                  break;
                case 'about':
                  exit = 3;
                  break;
                case 'contact':
                  exit = 4;
                  break;
                case 'terms':
                  exit = 5;
                  break;
                case 'help':
                  exit = 6;
                  break;
                case 'promo':
                  exit = 8;
                  break;
              }
              return exit;
            }(),
            disabled: false
          },
          webcontext_id: {
            hide: true,
            hideGrid: true
          },

          websectiondata: {
            presentation: {
              type: 'render',
            },
            hide: false,
            customProperties: {
              name: {
                hide: true
              },
              order: {
                resolve: {
                  default: function (model) {
                    var exit = 0;
                    angular.forEach($rootScope.websection.selected.websectiondata, function (i) {
                      console.log('ORDEN EXTRAIDO', i.order);
                      if (i.order > exit) {
                        exit = i.order;
                      }
                    });
                    console.log('NEXT ID', exit + 1);
                    if (model.actionType == 'store') {
                      return exit + 1;
                    }
                    else {
                      return null;
                    }
                  },
                },
                disabled: true,
                // hide:true
              },
              type: {
                resolve: {
                  disabled: function (model) {
                    if (model.actionType == 'store') {
                      return false;
                    }
                    else {
                      return true;
                    }
                  },
                },
                ngChange: function (model) {
                  switch (model.selected.type) {
                    case 0:
                      model.properties.content.hide = false;
                      model.properties.image.hide = true;
                      model.properties.link.hide = true;
                      model.properties.websectiondataitem.hide = true;
                      break;
                    case 1:
                      model.properties.content.hide = true;
                      model.properties.image.hide = false;
                      model.properties.link.hide = false;
                      model.properties.websectiondataitem.hide = true;
                      break;
                    case 2:
                      model.properties.content.hide = true;
                      model.properties.image.hide = true;
                      model.properties.link.hide = false;
                      model.properties.websectiondataitem.hide = true;
                      break;
                    case 3:
                    case 4:
                      console.log('caso galeria!!!');
                      model.properties.content.hide = true;
                      model.properties.image.hide = true;
                      model.properties.link.hide = true;
                      model.properties.websectiondataitem.hide = false;
                      break;
                    /* case '4':
                     model.properties.content.hide = true;
                     model.properties.image.hide = true;
                     model.properties.link.hide = true;
                     model.properties.websectiondataitem.hide = true;
                     break;*/
                  }
                },
              },
              content: {
                resolve: {
                  hide: function (model) {
                    var exit = true;
                    if (model.selected.type === 0) {
                      exit = false;
                    }
                    return exit;
                  },
                }
              },
              image: {
                resolve: {
                  hide: function (model) {
                    var exit = true;
                    if (model.selected.type === 1) {
                      exit = false;
                    }
                    return exit;
                  },
                }
              },
              link: {
                resolve: {
                  hide: function (model) {
                    var exit = true;
                    if (model.selected.type === 2 || model.selected.type === 1) {
                      exit = false;
                    }
                    return exit;
                  },
                }
              },
              websectiondataitem: {
                presentation: {
                  type: 'render2',
                },
                resolve: {
                  hide: function (model) {
                    var exit = true;
                    if (model.selected.type === 3 || model.selected.type === 4) {
                      exit = false;
                    }
                    return exit;
                  },
                },
                customProperties: {
                  order: {
                    resolve: {
                      default: function (model) {
                        var exit = 0;
                        angular.forEach($rootScope.websectiondata.selected.websectiondataitem, function (i) {
                          console.log('ORDEN EXTRAIDO', i.order);
                          if (i.order > exit) {
                            exit = i.order;
                          }
                        });
                        console.log('NEXT ID', exit + 1);
                        if (model.actionType == 'store') {
                          return exit + 1;
                        }
                        else {
                          return null;
                        }
                      },
                    },
                    disabled: true,
                    // hide:true
                  },
                  title: {
                    resolve: {
                      hide: function (model) {
                        var exit = true;
                        if ($rootScope.websectiondata.selected.type === 4) {
                          exit = false;
                        }
                        return exit;
                      },
                    }
                  },
                  content: {
                    resolve: {
                      hide: function (model) {
                        var exit = true;
                        if ($rootScope.websectiondata.selected.type === 4) {
                          exit = false;
                        }
                        return exit;
                      },
                    }
                  },
                  image: {
                    resolve: {
                      hide: function (model) {
                        var exit = true;
                        if ($rootScope.websectiondata.selected.type === 3) {
                          exit = false;
                        }
                        return exit;
                      },
                    }
                  },
                }
              },
            }
          }
        }
      };
    };
    vm.preload();
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      vm.preload();
    });


    vm.usermedic = {
      component: 'grid',
      model: 'user',
      customFilters: {
        filters: {
          user_type: {
            value: 3
          }
        }
      }
    };
    vm.usermedic = {
      component: 'grid',
      model: 'user',
      customFilters: {
        filters: {
          user_type: {
            value: 3
          }
        }
      }
    };
    vm.usergovernment = {
      component: 'grid',
      model: 'user',
      customFilters: {
        filters: {
          user_type: {
            value: 4
          }
        }
      }
    };
    vm.usercitizen = {
      component: 'grid',
      model: 'user',
      customFilters: {
        filters: {
          user_type: {
            value: 2
          }
        }
      }
    };


    vm.markercategory = {
      component: 'grid',
      model: 'markercategory'
    };

    vm.marker = {
      component: 'grid',
      model: 'marker'
    };

    vm.markeruser = {
      component: 'grid',
      model: 'markeruser'
    };

    /* vm.webadversiting = {
      component: 'grid',
      model: 'webadversiting',
      customOperations: {
        create: true,//$rootScope.access(['gestor-de-contenido', 'super-admin']),
        delete: false,
        update: true,
        read: true
      },
    }; */
    vm.adversitingOnline = {
      component: 'grid',
      model: 'webadversiting',
      customOperations: {
        create: true,//$rootScope.access(['gestor-de-contenido', 'super-admin']),
        delete: true,
        update: true,
        read: true
      },
      customFilters: {
        filters: {
          webroute_id: {
            value: 7
          }
        }
      },
      customProperties: {
        webroute_id: {
          default: 7,
          disabled:true
          //hide: true,
          //hideGrid: true
        },
      }
    };

    vm.adversitingCinema = {
      component: 'grid',
      model: 'webadversiting',
      customOperations: {
        create: true,//$rootScope.access(['gestor-de-contenido', 'super-admin']),
        delete: true,
        update: true,
        read: true
      },
      customFilters: {
        /* filters: {
          webroute_id: {
            value: 7
          }
        } */
      },
      customProperties: {
        webroute_id: {
          hide: false,
          hideGrid: false
        },
      }
    };




  });

'use strict';
angular
  .module('frontendapp')
  .controller('UserController', function (UserService, ImageLoader, $window,
                                          toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    $log.debug('UserController');

    /*ContentService.sendform( {
     mailingcategory_id:1,
     fields:{}
     })
     .success(function (res) {
     $log.debug('envia!!!!!!', res)
     if(res.status){
     $log.debug('sendform', res)
     }
     });*/

    vm.saveUserData = function () {
      $log.debug('almacena informacion', vm.profile);
      UserService.updateclientprofile(vm.profile)
        .success(function (res) {
          $log.debug('salida perfil', res);
          $rootScope.asignarVarSession('currentUser', res.profile);
          $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
        });
    };

    vm.restore = function () {
      vm.profile = angular.copy($rootScope.currentUser);
    };

    vm.usercp = {fail: false};

    vm.validatePassword = function () {
      if (vm.usercp.newpass != vm.usercp.newpass2) {
        return false;
      }
      else {
        return true;
      }
    };

    vm.changePassword = function (redirect) {
      $log.debug('modifica contrasenña');
      if (vm.validatePassword()) {
        $log.debug('enviado', vm.usercp);
        UserService.usercp(vm.usercp)
          .success(function (res) {
            $log.debug('salida usercp', res);
            if (res.status) {
              toastr.success('Contraseña actualizada', 'Exito');
              $rootScope.asignarVarSession('currentUser', res.profile);
              $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
              if (redirect) {
                $state.go('home', {lan: $rootScope.language});
              }
            }
            else {
              toastr.warning('Contraseña invalida', 'Error');
            }
          });
      }
      else {
        toastr.warning('Las contraseñas no coinciden', 'Error');
      }

    }

    vm.reset = {
      email: '',
      gc: ''
    };

    function onloadCallback() {
      /*grecaptcha.ready(function() {
       grecaptcha.execute('6Lea5pcUAAAAAESSNlMhVPVx-roOJkt5emuiOeAI', {action: 'login'})
       .then(function(token) {
       $log.debug('tc');
       vm.reset.gc = token;
       });
       });*/
    }

    //recaptcha
    vm.generarSeguridad = function () {
      vm.reset.gc = '';
      onloadCallback();
      //grecaptcha.reset();
    };
    vm.generarSeguridad();
    vm.forgotPassword = function () {
      //$log.debug('ejecuta');
      UserService.forgotpassword(vm.reset)
        .success(function (res) {
          //$log.debug(res)
        })
    }


    vm.userFilterSet = {
      firstname: {
        value: '',
        operator: 'like',
        type: 'autocomplete'
      },
      lastname: {
        value: '',
        operator: 'like',
        type: 'autocomplete'
      },
      email: {
        value: '',
        operator: 'like',
        type: 'search'
      }
    };

    vm.partnerconfig = {
      component: 'grid',
      model: 'partner',
      customFilters: {
        //selected: 1,
        filters: {
          type: {
            //type : 'autocomplete',
            operator: 'like',
            value: '1'
          },
          name: {
            type: 'search',
            operator: 'like',
            value: ''
          },
        }
      },
      customProperties: {
        partnercategory_id: {
          hide: true,
          hideGrid: true
        }
      }
    };

    vm.userconfig = {
      component: 'grid',
      model: 'user',
      customProperties: {
        userrole: {
          type: 'innerCrud',
          label: 'roles',
          customProperties: {
            user_id: {
              label: 'prueba',
              resolve: {
                helpText: function (dataset, selected) {
                  return 'Segundo test'
                }
              }
            }
          }
        }
      }
      /*customFilters:{
       selected:1,
       filters: {
       email:{
       type : 'autocomplete',
       operator:'like',
       value:'gmail'
       }
       }
       }*/
    }

  });

'use strict';
angular
  .module('frontendapp')
  .controller('SaleCtrl', function (UserService, ImageLoader, $window,
                                    toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    console.log('SaleCtrl');

    vm.ready = true;
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      console.log('detecta 1')
    });
    $rootScope.$on('$stateChangeStart', function (event, toState) {
      console.log('detecta 2')
    });

    vm.globalId = $state.params.id;

    vm.productsale = {
      component: 'uiinventoryform',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        vouchertype_id: {
          label: 'Comprobante',
          type: 'select',
          default: 9,
          itemsLabel: 'label',
          items: [
            {id: 8, label: 'Cotización'},
            {id: 9, label: 'Orden de venta', component: 'uipayment', newStockorder: true, newTransaction: true},
            {id: 10, label: 'Consignación', component: 'uiinventorycheck', newTransaction: true}
          ]
        },
        status: {
          hide: true,
          hideGrid: true,
          label: 'Estado',
          type: 'select',
          default: 1,
        },
        warehouse_id: {
          disabled: true,
          default: 2,
          label: 'punto de venta',
          resolve: {
            default: function (model) {
              if (model.filters.selected) {
                return model.selected.warehouse_id = model.selected.stockorder[0].warehouse.id;
              }
              else {
                return 1;
              }
            },
          }
          //hide:true,
          //hideGrid:true,
        },
        warehouse_id2: {
          disabled: true,
          hide: true,
          hideGrid: true,
          default: 0,
        },
        partner_id: {
          label: 'Cliente',
        }
      },
      customFilters: {
        selected: $rootScope.globalId
      }
    };

    vm.vouchersale = {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        vouchertype_id: {
          hide: true,
          hideGrid: true,
          default: 2
        },
        status: {
          label: 'Estado',
          type: 'select',
          default: 1,
          itemsLabel: 'label',
          items: [
            {id: 0, label: 'Cotización'},
            {id: 1, label: 'Orden de venta'},
          ]
        },
        warehouse_id: {
          disabled: true,
          default: 2,
          label: 'punto de venta',
          resolve: {
            default: function (model) {
              if (model.filters.selected) {
                return model.selected.warehouse_id = model.selected.stockorder[0].warehouse.id;
              }
              else {
                return 1;
              }
            },
          }
          //hide:true,
          //hideGrid:true,
        },
        warehouse_id2: {
          disabled: true,
          hide: true,
          hideGrid: true,
          default: 0,
        },
        partner_id: {
          label: 'Cliente',
        }
      },
      customFilters: {
        selected: $rootScope.globalId
      }
    };

    vm.partnerconfig = {
      component: 'grid',
      model: 'partner',
      customFilters: {
        filters: {
          type: {
            //type : 'autocomplete',
            operator: 'like',
            value: '2'
          }
        }
      },
      customProperties: {
        user_id: {
          hide: true,
          hideGrid: true
        },
        type: {
          hide: true,
          hideGrid: true,
          label: 'Socio',
          disabled: true,
          default: 2,
        }
      }
    };


  });

'use strict';
angular
  .module('frontendapp')
  .controller('ResetController', function (UserService, ImageLoader, $window,
                                           toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    $log.debug('ContactController');

    vm.validatePassword = function () {
      if (vm.reset.newpass != vm.reset.newpass2) {
        return false;
      }
      else {
        return true;
      }
    };
    vm.reset = {
      ac: $state.params.ac,
      rtk: $state.params.rtk
    };
    function onloadCallback() {
      /*grecaptcha.ready(function() {
       grecaptcha.execute('6Lea5pcUAAAAAESSNlMhVPVx-roOJkt5emuiOeAI', {action: 'login'})
       .then(function(token) {
       console.log('tc');
       vm.reset.gc = token;
       });
       });*/
    }

    //recaptcha
    vm.generarSeguridad = function () {
      vm.reset.gc = '';
      onloadCallback();
      //grecaptcha.reset();
    };
    vm.generarSeguridad();

    vm.resetForgottenPassword = function () {
      //console.log('modifica contrasenña');
      if (vm.validatePassword()) {
        //console.log('enviado', vm.reset)
        UserService.resetforgotten(vm.reset)
          .success(function (res) {
            //console.log('salida reset', res)
            if (res.status) {
              toastr.success('Contraseña actualizada', 'Exito');
              $state.go('auth');
            }
            else {
              toastr.warning('Contraseña invalida', 'Error');
            }
          });
      }
      else {
        toastr.warning('Las contraseñas no coinciden', 'Error');
      }
    };

    UserService.checklink($state.params)
      .success(function (res) {
        //console.log('forgotlink',res)
        if (!res.status) {
          toastr.warning('Invalid', 'Error');
          $state.go('auth');
        }
      })

  });

'use strict';
angular
  .module('frontendapp')
  .controller('PurchaseCtrl', function (UserService, ImageLoader, $window,
                                        toastr, $log, $timeout, $rootScope, $scope, $state) {
    var vm = this;
    console.log('PurchaseCtrl');

    vm.ready = true;
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      console.log('detecta 1')
    });
    $rootScope.$on('$stateChangeStart', function (event, toState) {
      console.log('detecta 2')
    });

    vm.globalId = $state.params.id;

    vm.productpurchase = {
      component: 'uiinventoryform',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        vouchertype_id: {
          label: 'Comprobante',
          type: 'select',
          default: 3,
          itemsLabel: 'label',
          items: [
            {id: 2, label: 'Cotización'},
            {id: 3, label: 'Orden de compra', component: 'uipayment', newTransaction: true},
          ]
        },
        status: {
          hide: true,
          hideGrid: true,
          label: 'Estado',
          type: 'select',
          default: 1,
        },
        warehouse_id: {
          disabled: true,
          hide: true,
          hideGrid: true,
        },
        warehouse_id2: {
          disabled: true,
          default: 1,
          resolve: {
            default: function (model) {
              if (model.filters.selected) {
                return model.selected.warehouse_id = model.selected.stockorder[0].warehouse.id;
              }
              else {
                return 1;
              }
            },
          }
        },
        partner_id: {
          label: 'Proveedor',
        }
      },
      customFilters: {
        selected: $rootScope.globalId
      }
    };

    vm.purchasevoucher = {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        vouchertype_id: {
          hide: true,
          hideGrid: true,
          default: 2
        },
        status: {
          label: 'Estado',
          type: 'select',
          default: 1,
          itemsLabel: 'label',
          items: [
            {id: 0, label: 'Cotización'},
            {id: 1, label: 'Orden de compra'},
          ]
        },
        warehouse_id: {
          disabled: true,
          hide: true,
          hideGrid: true,
        },
        warehouse_id2: {
          disabled: true,
          default: 1,
          label: 'Almacen',
          resolve: {
            default: function (model) {
              if (model.filters.selected) {
                return model.selected.warehouse_id = model.selected.stockorder[0].warehouse.id;
              }
              else {
                return 1;
              }
            },
          }
        },
        partner_id: {
          label: 'Proveedor',
        }
      },
      customFilters: {
        selected: $rootScope.globalId
      }
    };


    vm.partnerconfig = {
      component: 'grid',
      model: 'partner',
      customFilters: {
        selected: 1,
        filters: {
          type: {
            //type : 'autocomplete',
            operator: 'like',
            value: '1'
          }
        }
      },
      customProperties: {
        user_id: {
          hide: true,
          hideGrid: true
        },
        partnercategory_id: {
          hide: true,
          hideGrid: true
        }
      }
    };


  });

'use strict';
angular
  .module('frontendapp')
  .controller('projectsCtrl', function ($uibModal, ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('projectsCtrl');

    $rootScope.showNots = false;

    $rootScope.notDisplay = 1;

    $rootScope.comments = [
      {
        id: 1,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
      ,
      {
        id: 2,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
    ]

    $rootScope.newComment = '';

    $rootScope.addComment = function (value) {

      var comment = {
        autor: 'Fernando López',
        created_at: '10 Mayo',
        active: true,
        comment: value
      };
      $rootScope.comments.push(comment);
      console.log('agrega', $rootScope.comments);
    }


    //////////////////////////////////////////

    vm.rulesP = [
      {
        field: 'servicios_id',
        itemsLabel: 'nombre_es',
        label: 'Servicio',
        order: 1,
        required: true,
      },
      {
        field: 'nombre',
        label: 'Nombre',
        order: 2,
        required: true
      },
      {
        field: 'estado',
        label: 'Estado',
        order: 3,
        required: true,
        render: true,
        renderFunction: function (value) {
          var exit = '';
          switch (value) {
            case '1':
              exit = '<p>Activo</p>';
              break;
            case '2':
              exit = '<p>Congelado</p>';
              break;
            case '3':
              exit = '<p>Culminado</p>';
              break;
          }
          return exit;
        }
      },
      {
        field: 'fecha_prog_inicio',
        label: 'Inicio programado',
        type: 'date',
        required: true,
        activeGrid: false
      },
      {
        field: 'fecha_prog_fin',
        label: 'Cierre programado',
        type: 'date',
        required: true,
        activeGrid: false
      },
      {
        field: 'fecha_real_inicio',
        label: 'Inicio',
        type: 'date',
        required: true
      },
      {
        field: 'fecha_real_fin',
        label: 'Cierre',
        type: 'date',
        required: true
      },
      {
        field: 'descripcion',
        label: 'Descripción',
        type: 'textarea',
        required: true,
        activeGrid: false
      },
    ]

    vm.customTemplate = 'app/views/projects/project/customTemplate.html';
    vm.customFilters = 'app/views/projects/project/customFilters.html';
    vm.customTitleEs = 'Proyectos';
    vm.customTitleEn = 'Projects';
  });

'use strict';
angular
  .module('frontendapp')
  .controller('productCtrl', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('productCtrl');

    vm.rulesP = [
      {
        field: 'productocategoria_id',
        itemsLabel: 'titulo_es',
        label: 'Categoría',
        order: 1,
        required: true,
      },
      {
        field: 'nombre_es',
        label: 'Nombre español',
        order: 2,
        required: true
      },
      {
        field: 'nombre_en',
        label: 'Nombre ingles',
        activeGrid: false,
        order: 2,
        required: true
      },
      {
        field: 'descripcion_es',
        label: 'Descripción español',
        type: 'textarea',
        toolbar: 'basics',
        order: 2,
        required: true
      },
      {
        field: 'descripcion_en',
        label: 'Descripción ingles',
        type: 'textarea',
        toolbar: 'basics',
        activeGrid: false,
        order: 2,
        required: true
      },
      {
        field: 'status',
        label: 'Estado',
        order: 3,
        required: true,
        activeGrid: false,
        render: true,
        renderFunction: function (value) {
          var exit = '';
          switch (value) {
            case '1':
              exit = '<p>Activo</p>';
              break;
            case '0':
              exit = '<p>Congelado</p>';
              break;
          }
          return exit;
        }
      },
      {
        field: 'imagen',
        label: 'Imagen',
        type: 'file',
        order: 2,
        required: true
      },
      {
        field: 'descuento',
        label: 'Descuento',
        type: 'textarea',
        toolbar: 'basics',
        activeGrid: false,
        order: 2,
        required: true
      },
    ]


    vm.rulesC = [
      {
        field: 'titulo_es',
        label: 'Titulo español',
        order: 1,
        required: true,
      },
      {
        field: 'titulo_en',
        label: 'Titulo ingles',
        activeGrid: false,
        order: 1,
        required: true,
      },
      {
        field: 'contenido_es',
        label: 'Contenido español',
        activeGrid: false,
        order: 1,
        required: true,
      },
      {
        field: 'contenido_en',
        label: 'Contenido ingles',
        activeGrid: false,
        order: 1,
        required: true,
      },
      {
        field: 'imagen',
        type: 'file',
        order: 1,
        required: true,
      }
    ]

  });

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .directive('particlesDrv', function ($window, $log) {
      return {
        restrict: 'A',
        template: '<div class="particleJs" id="particleJs"></div>',
        link: function (scope, element, attrs, fn) {
          $log.debug('test');
          $window.particlesJS('particleJs', {
            particles: {
              number: {
                value: 80,
                density: {
                  enable: true,
                  value_area: 800
                }
              },
              color: {
                value: '#FFFFFF'
              },
              shape: {
                type: "circle",
                polygon: {
                  nb_sides: 5
                }
              },
              opacity: {
                value: 0.5,
                random: false,
                anim: {
                  enable: false,
                  speed: 1,
                  opacity_min: 0.1,
                  sync: false
                }
              },
              size: {
                value: 5,
                random: true,
                anim: {
                  enable: false,
                  speed: 40,
                  size_min: 0.1,
                  sync: false
                }
              },
              line_linked: {
                enable: true,
                distance: 150,
                color: '#ffffff',
                opacity: 0.4,
                width: 1
              },
              move: {
                enable: true,
                speed: 2,
                direction: 'none',
                random: false,
                straight: false,
                out_mode: 'out',
                bounce: false,
                attract: {
                  enable: false,
                  rotateX: 600,
                  rotateY: 1200
                }
              }
            },
            interactivity: {
              detect_on: 'canvas',
              events: {
                onhover: {
                  enable: true,
                  mode: 'grab'
                },
                onclick: {
                  enable: true,
                  mode: 'push'
                },
                resize: true
              },
              modes: {
                grab: {
                  distance: 140,
                  line_linked: {
                    opacity: 1
                  }
                },
                bubble: {
                  distance: 400,
                  size: 40,
                  duration: 2,
                  opacity: 8,
                  speed: 3
                },
                repulse: {
                  distance: 200,
                  duration: 0.4
                },
                push: {
                  particles_nb: 4
                },
                remove: {
                  particles_nb: 2
                }
              }
            },
            retina_detect: true
          });
        }
      };
    })
})();

angular
  .module('frontendapp')
  .controller('particlesCtrl', function ($rootScope, $scope) {
    $scope.showParticles = true;
  });

'use strict';
angular
  .module('frontendapp')
  .controller('offersCtrl', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('offersCtrl');

    $rootScope.showNots = false;

    $rootScope.notDisplay = 1;

    $rootScope.comments = [
      {
        id: 1,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
      ,
      {
        id: 2,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
    ]

    $rootScope.newComment = '';

    $rootScope.addComment = function (value) {

      var comment = {
        autor: 'Fernando López',
        created_at: '10 Mayo',
        active: true,
        comment: value
      };
      $rootScope.comments.push(comment);
      console.log('agrega', $rootScope.comments);
    }


  });

'use strict';
angular
  .module('frontendapp')
  .controller('LoginCtrl', function ($rootScope, $scope, $state, $auth,
                                     $log, UserService, localStorageService,
                                     toastr, $timeout) {
    var vm = this;
    $log.debug('loginCtrl');

    if ($rootScope.currentState == 'activatelink') {
      $log.debug('activatelink');
      UserService.checklink($state.params)
        .success(function (res) {
          $log.debug('forgotlink', res);
          if (!res.status) {
            toastr.warning('Invalid', 'Error');
            $state.go('auth');
          }
          else {
            vm.email = res.email;
            vm.password = res.email;
          }
        });
    }

    //temporary values
    vm.email = '';
    vm.password = '';
    /*m.email = 'lopezfer.moscoso@gmail.com';
     vm.password = 'AKNA.test';*/

    function onloadCallback() {
      /*grecaptcha.ready(function() {
       grecaptcha.execute('6Lea5pcUAAAAAESSNlMhVPVx-roOJkt5emuiOeAI', {action: 'login'})
       .then(function(token) {
       $log.debug('tc');
       vm.gc = token;
       });
       });*/
    }

    //recaptcha
    vm.generarSeguridad = function () {
      vm.gc = '';
      onloadCallback();
      //grecaptcha.reset();
    };
    vm.generarSeguridad();
    $rootScope.loginNew = function (user, pass) {
      $log.debug('step 0', user, pass, vm.gc);
      $auth.login({
        email: user,
        password: pass,
        gc: vm.gc
      })
        .then(function (res) {
          $rootScope.tk = $auth.getToken();
          $rootScope.asignarVarSession('token', $auth.getToken());
          $log.debug('step 1', res, $rootScope.tk);
          UserService.owneraccount()
            .success(function (user) {
              $log.debug('step 2', user);
              $rootScope.asignarVarSession('currentUser', user.profile);
              $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
              $timeout(function () {
                vm.email = '';
                vm.password = '';
                vm.errorDatos = false;
                $log.debug('Bienvenido');
                toastr.success($rootScope.switchText('Bienvenido', 'Welcome'), 'Exito');
                $state.go('home', {lan: 'es'}, {reload: true});
              }, 500);
            })
            .error(function (res) {
              $log.debug('error 1', res);
              toastr.warning(res, 'Error');
            //  $rootScope.logout();
            });
        })
        .catch(function (response) {
          console.log(response)
          /* switch (response.data.error) {
            case 'invalid_credentials':
              toastr.warning('invalid credentials', 'Error');
              break;
            case 'could_not_create_token':
              toastr.warning('could not create token', 'Error');
              break;
            case 'is_robot':
              toastr.warning('verify captcha first', 'Error');
              break;
            case 'not_security_validation':
              toastr.warning('not security validation', 'Error');
              break;
          } */
         // $log.debug('error 2', response.data.error);
          vm.generarSeguridad();
        });
    };

  });

'use strict';
angular
  .module('frontendapp')
  .controller('HomeController', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('HomeController');

    vm.sendMail = function (emailId, subject, message) {
      $window.open("mailto:" + emailId + "?subject=" + subject + "&body=" + message, "_self");
    };


  });

/**
 * Created by DELL on 7/6/2018.
 */
'use strict';
angular
  .module('frontendapp')
  .controller('formsCtrl', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('formsCtrl');

    vm.switchFormView = function (value) {
      switch (value) {
        case 'back':
          vm.formView--;
          break;
        default:
          vm.formView = value;
          break;
      }
    };

    vm.forms = {
      newService: {
        views: 3,
        categoriasservicios_id: '',
        servicios_id: '',
        message: ''
      },
      newDate: {
        views: 1,
        date: '',
        hour: '',
        message: ''
      },
      newOpinion: {
        views: 1,
        type: '',
        message: ''
      },
      newClaim: {
        views: 1,
        motive: '',
        message: ''
      }
    };

    vm.loadForm = function (value) {
      vm.formView = 1;
      switch (value) {
        case ('newservice'):
          $rootScope.customModal.data = angular.copy(vm.forms.newService);
          break;
        case ('schedulemeeting'):
          $rootScope.customModal.data = angular.copy(vm.forms.newDate);
          break;
        case ('newopinion'):
          $rootScope.customModal.data = angular.copy(vm.forms.newOpinion);
          break;
        case ('newclaim'):
          $rootScope.customModal.data = angular.copy(vm.forms.newClaim);
          break;
      }
      console.log('current form', $rootScope.customModal)
    };

    $rootScope.sendForm = function (data, target) {
      console.log('envia mensaje', $rootScope.customModal.data);
      vm.switchFormView(0);
    };

    //CUSTOM CODE FOR SEBOING CRM
    //new service
    vm.loadServices = function () {
      TablesService.filtrar(
        'servicios',
        {
          lan: $rootScope.language,
          comparaciones: [
            {
              campo: 'categoriasservicios_id',
              operador: 'like',
              dato: $rootScope.customModal.data.categoriasservicios_id,
              dato2: ''
            }
          ]
        }
      )
        .success(function (res) {
          vm.services = res.resultado;
        });
    };
    vm.chooseCatServices = function (value) {
      $rootScope.customModal.data.categoriasservicios_id = value;
      $rootScope.customModal.data.servicios_id = '';
      vm.loadServices();
      vm.switchFormView(2);
    }


  });

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .controller('FixedContentsCtrl', function ($scope, $rootScope, $log, $state, $location) {
      var vm = this;

      switch ($rootScope.currentState) {
        case 'homegeneral':
          vm.paginaId = 1;
          vm.paginalabel = 'Inicio';
          break;
        case 'productgeneral':
          vm.paginaId = 2;
          vm.paginalabel = 'Productos';
          break;
        case 'paymentgeneral':
          vm.paginaId = 3;
          vm.paginalabel = 'Pagos';
          break;
        case 'bloggeneral':
          vm.paginaId = 5;
          vm.paginalabel = 'Contactos';
          break;
        case 'contactgeneral':
          vm.paginaId = 4;
          vm.paginalabel = 'Contactos';
          break;
      }


      vm.rules = [
        {
          field: 'paginas_id',
          label: 'Página',
          active: false,
          activeGrid: false,
          activeForEdit: false,
          activeForCreate: false,
        },
        {
          field: 'nombre',
          label: 'Campo',
          disabled: true,
          required: true
        },
        {
          field: 'contenido_es',
          label: 'Contenido',
          language: 'es',
          required: true,
          activeGrid: false,
          toolbar: [
            ['h5', 'h6', 'p'],
            ['bold', 'italics', 'underline', 'strikeThrough'],
            /* ['ul', 'ol'],*/
            ['undo', 'redo', 'clear'],
            //['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
            ['html'],
            ['insertLink'],
            //[, 'insertImage','insertLink', 'insertVideo'],
            ['wordcount', 'charcount']
          ],
          resolve: {
            helpText: function (dataset, selected) {
              //////console.log('seleccionado', selected.id);
              switch (selected.id) {
                default:
                  return '';
                case 23:
                  return 'Formato sugerido JPG 1440x900';
                case 36:
                  return 'Formato sugerido JPG 1440x900';
                case 37:
                  return 'Formato sugerido JPG 1440x900';
                case 39:
                  return 'Formato sugerido JPG 1440x900';
                case 26:
                  return 'Formato sugerido JPG 600x350';
                case 29:
                  return 'Formato sugerido JPG 600x350';
                case 19:
                  return 'Formato sugerido JPG 600x350';
              }
            },
            type: function (dataset, selected) {
              if (selected) {
                if (selected.html == 2) {
                  return 'file'
                }
                if (selected.html == 3) {
                  return 'pdf'
                }
                if (selected.html == 1) {
                  return 'textarea'
                }
                if (selected.html == 0) {
                  return 'text'
                }
              }
            },
          }
        },
        {
          field: 'contenido_en',
          label: 'Contenido',
          activeGrid: false,
          language: 'en',
          toolbar: [
            //[ 'h5', 'h6', 'p'],
            ['bold', 'italics', 'underline', 'strikeThrough'],
            /* ['ul', 'ol'],*/
            ['undo', 'redo', 'clear'],
            //['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', 'indent', 'outdent'],
            ['html'],
            ['insertLink'],
            //[, 'insertImage','insertLink', 'insertVideo'],
            ['wordcount', 'charcount']
          ],
          resolve: {
            active: function (dataset, selected) {
              if (selected) {
                if (selected.html == 2 || selected.html == 3) {
                  return false;
                }
                if (selected.html == 1 || selected.html == 0) {
                  return true;
                }
              }
            },
            type: function (dataset, selected) {
              if (selected) {
                if (selected.html == 2) {
                  return 'file'
                }
                if (selected.html == 3) {
                  return 'pdf'
                }
                if (selected.html == 1) {
                  return 'textarea'
                }
                if (selected.html == 0) {
                  return 'text'
                }
              }
            },
          }
        },
        {
          field: 'html',
          label: 'HTML',
          active: false,
          activeGrid: false,
          activeForEdit: false,
          activeForCreate: false,

        }
      ];

      vm.rulesForImages = [
        {
          field: 'paginas_id',
          label: 'Página',
          active: false,
          activeGrid: false,
          activeForEdit: false,
          activeForCreate: false,
        },
        {
          field: 'imagen',
          label: 'Archivo',
          required: true,
          /*activeForCreate: true,
           activeForEdit: true,*/
          resolve: {
            type: function (dataset, selected) {
              if (selected) {
                if (selected.tipo == 0) {
                  return 'file'
                }
                else {
                  return 'pdf'
                }
              }

            }
          }
        },
        {
          field: 'tipo',
          label: 'Tipo',
          activeGrid: false
        }
      ];
      vm.options = {
        create: false,
        read: false,
        update: true,
        delete: false,
        goToOwnState: false,
        relationsLinks: false
      };


    })
})();

'use strict';
angular
  .module('frontendapp')
  .controller('ecommerceCtrl', function (ImageLoader, $window, $log, TablesService, $state, $timeout, $rootScope) {
    var vm = this;
    vm.webrouteParam = $state.params.id;
    vm.rulesP = [
      { field: 'id', active: false, activeGrid: false, required: false },
    ];



    vm.preload = function () {
      vm.webrouteParam = $state.params.id;
      vm.voucherConfig = {
        component: 'grid',
        model: 'voucher'
      }
      if ($state.params.id) {
        vm.voucherConfig.customFilters = {
          filters: {
            id: { value: $state.params.id }
          }
        }
      }

      vm.partnerconfig = {
        component: 'grid',
        model: 'user',
        customFilters: {
          filters: {
            user_type: {
              value: 2
            }
          }
        },
        customProperties:{
          userrole:{
            hide:true
          }
        }
      };
    }
    vm.preload();
    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      vm.preload();
    });


    TablesService.statics({})
                .success(function (res) {
                  console.log('ESTADISTICAS', res)
                  $rootScope.statics = res;
                })

  });

'use strict';
angular
  .module('frontendapp')
  .controller('documentsCtrl', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('documentsCtrl');

    $rootScope.showNots = false;

    $rootScope.notDisplay = 1;

    $rootScope.comments = [
      {
        id: 1,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
      ,
      {
        id: 2,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
    ]

    $rootScope.newComment = '';

    $rootScope.addComment = function (value) {

      var comment = {
        autor: 'Fernando López',
        created_at: '10 Mayo',
        active: true,
        comment: value
      };
      $rootScope.comments.push(comment);
      console.log('agrega', $rootScope.comments);
    }


  });

/**
 * Created by FER-PC-WIN10 on 28/08/2017.
 */

(function () {
  'use strict';
  angular
    .module('frontendapp')
    .controller('CrudGeneratorCtrl', function (TablesService, $rootScope, $scope, $http) {

      $scope.rules = [
        {
          field: 'test_id',
          label: 'Categoria',
          itemsLabel: 'title',
          required: true,
          order: 1
        }
      ];

      $scope.crudStep = 1;

      $scope.data = {
        model: "",
        dataEstructure: [],
        permissions: {insert: '', update: '', delete: '', review: ''},
        administration: {section: '', group: ''}
      }

      $scope.addField = function () {
        $scope.data.dataEstructure.push(
          {
            "dbField": "",
            "dbType": "TEXT",
            "dbSize": "",
            "dbDefault": "",
            "dbNull": false,
            "dbIndex": "",
            "dbFkTable": "",
            "dbFkField": "",
            "dbFkCascadeDelete": false,
            "dbComment": "",
            "dbAutoTraduction": false,
            "dbLanguages": [
              'es',
              'en'/*,
               'fr',
               'pt',
               'de',
               'it'*/
            ],
            "modelLabel": "",
            "modelType": "text",
            "modelRequired": true,
            "modelDisabled": false,
            "showDB": false,
            "showMV": false,
          }
        )
      }

      $scope.deleteField = function (sourceF, index) {
        $scope.data.dataEstructure.splice(index, index + 1);
      }

      $scope.changeFormDetail = function (source, type, value) {
        source[type] = !source[type]
      }

      $scope.changeValue = function (value) {
        $scope.crudStep = value;
      }

      $scope.generateCrud = function () {
        console.log('modelo', $scope.data)
        TablesService.corebuild($scope.data)
          .success(function (res) {
            console.log(res)
            $rootScope.buildtemp = res;
          })
      }

      $scope.onFileChange = function (fileEl) {
        var files = fileEl.files;
        var file = files[0];
        var reader = new FileReader();
        reader.onloadend = function (evt) {
          if (evt.target.readyState === FileReader.DONE) {
            $scope.$apply(function () {
              $scope.something = JSON.parse(evt.target.result);
              console.log("JSON", $scope.something);
              $scope.data = $scope.something;
            });
          }
        };
        reader.readAsText(file);
      };

      $scope.modelvalid = false;

      $scope.verifyModelName = function () {
        for (var i = 0; i < $scope.migrations.length; i++) {
          if ($scope.migrations[i].table == $scope.data.model) {
            console.log('elemento repetido')
            $scope.modelvalid = false;
            break;
          }
          else {
            $scope.modelvalid = true;
            console.log('tabla valida')
          }
        }
      };

      //Services to extract list of tables and permissions
      $scope.getDataTowork = function () {
        TablesService.getTable({table: 'all'})
          .success(function (res) {
            //console.log(res)
            $scope.migrations = res.resultado;
          });
        /*TablesService.getTable( {table:'permisos'})
         .success(function (res) {
         //console.log(res)
         $scope.permissions = res.resultado;
         });*/
        /*TablesService.listar( 'vistas' )
         .success(function (res) {
         console.log(res)
         $scope.pages = res.resultado;
         });*/
      };

      $scope.getDataTowork();

      $scope.getTableColumns = function (table) {
        TablesService.getTableColumns({table: table})
          .success(function (res) {
            console.log(res);
            $scope.migrationsColunns = res.resultado;
          })
      }

      $scope.createPermission = function (data) {
        TablesService.almacenar('permisos', data)
          .success(function (res) {
            $scope.last = res.resultado;
            TablesService.getTable({table: 'permisos'})
              .success(function (res) {
                $scope.permissions = res.resultado;
                for (var i = 0; i < $scope.permissions.length; i++) {
                  if ($scope.permissions[i].id == $scope.last) {
                    $scope.data.permissions[$scope.temp] = $scope.permissions[i].id;
                    break;
                  }
                }
              });
          });
      };

      $scope.createView = function (data) {
        TablesService.almacenar('vistas', data)
          .success(function (res) {
            $scope.last = res.resultado;
            TablesService.listar('vistas')
              .success(function (res) {
                $scope.pages = res.resultado;
                for (var i = 0; i < $scope.pages.length; i++) {
                  if ($scope.pages[i].id == $scope.last) {
                    $scope.data.administration[$scope.temp] = $scope.pages[i].id;
                    break;
                  }
                }
              });
          });
      };

      $scope.setTempValue = function (temp) {
        $scope.temp = temp;
        console.log('valor temporal: ', $scope.temp)
      };

      $scope.closeModal = function (targetModal) {
        angular.element('#' + targetModal).modal('hide');
        angular.element('body').removeClass('modal-open');
        angular.element('.modal-backdrop').remove();
      };


      /// tools for develope
      $scope.print = function (target) {
        console.log(target + ': ', $scope[target])
      }


    })

})();

'use strict';
angular
  .module('frontendapp')
  .controller('calendarCtrl', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('calendarCtrl');

    $rootScope.showNots = false;

    $rootScope.notDisplay = 1;

    $rootScope.comments = [
      {
        id: 1,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
      ,
      {
        id: 2,
        autor: 'Fernando López',
        created_at: '05 Abril',
        active: true,
        comment: '  Lorem ipsum dolor sit amet,consectetur adipisicing elit. Ab,ad aliquam amet animi asperiores autdeleniti doloribus ea error fuga id,maiores minus molestiae odio quiarepudiandae vel. Dignissimos, officia?'
      }
    ]

    $rootScope.newComment = '';

    $rootScope.addComment = function (value) {

      var comment = {
        autor: 'Fernando López',
        created_at: '10 Mayo',
        active: true,
        comment: value
      };
      $rootScope.comments.push(comment);
      console.log('agrega', $rootScope.comments);
    }


  });

'use strict';
angular
  .module('frontendapp')
  .controller('AppController', function ($state, $log, TablesService, $rootScope, $scope) {
    var vm = this;
    $log.debug('AppController');

    // SYSTEM VARIABLES
    $rootScope.system = {};
    $rootScope.system.notifications = [
      /*{id:1, label:'text'},
       {id:2, label:'text'},*/
    ];
    /// MENU CONSTRUCTION
    $rootScope.redirect = function (state, params, config) {
      $state.go(
        state, params, config
      );
    };

    $rootScope.appMenuItems = {
      admin: [
        {
          label: 'Administración de usuarios',
          items: [
            {
              label: 'Administración de usuarios', // prestados, consignados, bajas existencias
              state: 'user'
            },

            {
              label: 'Administración de roles',
              state: 'userrole'
            },
          ]
        }
      ],
      wcms: [

        {
          label: 'Trabajos',
          items: [
            {
              label: 'Contenidos',
              state: 'contents',
              stateParams: { model: 'webcontent', type: 'dinamic' }
            },
            {
              label: 'Galerias',
              state: 'contents',
              stateParams: { model: 'artcollection', type: 'dinamic' }
            },
            {
              label: 'Imagenes',
              state: 'contents',
              stateParams: { model: 'artcollectionitem', type: 'dinamic' }
            },
            /* {
              label: 'Prensa',
              state: 'contents',
              stateParams: { model: 'webresource', type: 'dinamic' }
            },
            {
              label: 'webgallery',
              state: 'contents',
              stateParams: { model: 'webgallery', type: 'dinamic' }
            },
            {
              label: 'webgalleryitem',
              state: 'contents',
              stateParams: { model: 'webgalleryitem', type: 'dinamic' }
            } */
          ]

        },
        {
          label: 'Menu',
          items: [

            {
              label: 'Categorias Menu',
              state: 'contents',
              stateParams: { model: 'menu', type: 'dinamic' }
            },

            {
              label: 'Platos',
              state: 'contents',
              stateParams: { model: 'menuitem', type: 'dinamic' }
            },

            {
              label: 'Staf',
              state: 'contents',
              stateParams: { model: 'staff', type: 'dinamic' }
            },

/*
            {
              label: 'Videos',
              state: 'contents',
              stateParams: { model: 'webresource', type: 'dinamic' }
            },
            {
              label: 'Prensa',
              state: 'websection',
              stateParams: { model: 'websection', webroute: 'promo' }
            },
            {
              label: 'Contenidos Contactos',
              state: 'websection',
              stateParams: { model: 'websection', webroute: 'contact' }
            }, */
            {
              label: 'Redes sociales',
              state: 'contents',
              stateParams: { model: 'websocial', type: 'dinamic' }
            },

          ]
        },
        {
          label: 'Configuración',
          items: [
            {
              label: 'Receptores de correo',
              state: 'mailinginnerreceiver',
            },
            {
              label: 'Rutas del sistema',
              state: 'webroute',
              stateParams: { model: 'webroute', type: 'dinamic' }
            },
            {
              label: 'Configuraciones',
              state: 'webconfig',
            }
          ]
        },

        /*{
         label: 'Globales (TEMPORAL)',
         items: [
         /!*{
         label: 'webcontext',
         state: 'webcontext',
         stateParams: {model: 'webcontext', type: 'dinamic'}
         },*!/
         {
         label: 'webroute',
         state: 'webroute',
         stateParams: {model: 'webroute', type: 'dinamic'}
         },
         /!* {
         label: 'Secciones',
         state: 'websection',
         stateParams: {model: 'websection', type: 'dinamic'}
         },*!/
         ]
         },*/

      ]

    };

    $rootScope.dateToSpanishFormat = function (dateString) {
      var x = new Date(dateString);
      var y = x.toDateString();
      y = y.replace("Mon", "Lun");
      y = y.replace("Tue", "Mar");
      y = y.replace("Wed", "Mié");
      y = y.replace("Thu", "Jue");
      y = y.replace("Fri", "Vie");
      y = y.replace("Sat", "Sáb");
      y = y.replace("Sun", "Dom");
      y = y.replace("Jan", "Enero");
      y = y.replace("Feb", "Febrero");
      y = y.replace("Mar", "Marzo");
      y = y.replace("Apr", "Abril");
      y = y.replace("May", "Mayo");
      y = y.replace("Jun", "Junio");
      y = y.replace("Jul", "Julio");
      y = y.replace("Aug", "Agosto");
      y = y.replace("Sep", "Septiembre");
      y = y.replace("Oct", "Octubre");
      y = y.replace("Nov", "Noviembre");
      y = y.replace("Dec", "Diciembre");
      var z = y.split(" ");
      return (z[2] + ' de ' + z[1] + ' de ' + z[3]);
    };
    $rootScope.numberToMonth = function (dateString) {
      var y = '' + dateString;
      y = y.replace("1", "Enero");
      y = y.replace("2", "Febrero");
      y = y.replace("3", "Marzo");
      y = y.replace("4", "Abril");
      y = y.replace("5", "Mayo");
      y = y.replace("6", "Junio");
      y = y.replace("7", "Julio");
      y = y.replace("8", "Agosto");
      y = y.replace("9", "Septiembre");
      y = y.replace("10", "Octubre");
      y = y.replace("11", "Noviembre");
      y = y.replace("12", "Diciembre");
      return y;
    };
    $rootScope.exchangeAmount = function (value, currency) {
      var exchanged = value * $rootScope.globalParams[currency];
      console.log('exchange', value, currency, '=', exchanged);
      return exchanged
    };
    $rootScope.colorOptions = {
      format: 'hex',
      placeholder: '',
      inputClass: '',
      case: 'upper',
      hue: true,
      saturation: true,
      lightness: true,
      round: true,
      // show/hide
      show: {
        swatch: true,
        focus: true
      },
      hide: {
        blur: true,
        escape: true,
        click: true
      },
      // buttons
      close: {
        show: true,
        label: 'Cerrar',
        class: ''
      },
      clear: {
        show: true,
        label: 'Limpiar',
        class: ''
      },
      reset: {
        show: true,
        label: 'Resetear',
        class: ''
      },
      restrictToFormat: true
    }

    $rootScope.pickLaundry = function (target, value) {
      console.log(target, value);
      target = value;
    }

    $rootScope.sendLinkWhastapp = function (number, voucher) {
      var message = '';
      var status = '';
      (voucher.status == 0) ? status = 'esta pendiente a aprobación' : '';
      (voucher.status == 1) ? status = 'estan en preparación' : '';
      (voucher.status == 2) ? status = 'esta en camino' : '';
      (voucher.status == 3) ? status = 'ha sido entregada' : '';
      (voucher.status == 4) ? status = 'ha sido cancelada' : '';
      message += 'Hola ' + voucher.user.firstname + '! Tu orden ' + status + '\n';
      message += 'Puedes verificar el estado de tu pedido en cualquier momento ingresando a: http://burbank.bo/voucher/' + voucher.id + '\n';
      return 'https://api.whatsapp.com/send?phone=591' + number + '&text=%20' + encodeURI(message);
    };
    $rootScope.opemWhastapp = function (number) {
      var message = '';
      return 'https://api.whatsapp.com/send?phone=591' + number + '&text=' + encodeURI(message);
    };


    $rootScope.updateStock = function (id) {
      TablesService.updatestock({ id: id })
        .success(function (res) {
          console.log('STOCK ACTUALIZADO', res);
        })
      console.log('updateStock', id)
    }

    $rootScope.getmetadata = function (id, target) {
      TablesService.getmetadata({ id: id })
        .success(function (res) {
          console.log('getmetadata', res);
          target.fileRows = res.file;
          target.fileMatches = res.matches;
          target.fileRegisters = res.registers;
        })
    }
    $rootScope.retrieveNewStock = function (code) {
      var exit = '';
      //console.log('retrieveNewStock', code)
      angular.forEach($rootScope.stocklog.selected.fileRows, function (value, key) {
        if (value.codigo == code) {
          exit = value.cantidad;
        }
      });
      return exit;
    }
    $rootScope.$watch('stocklog.selected', function () {
      if ($rootScope.stocklog) {
        if ($rootScope.stocklog.selected) {
          $rootScope.getmetadata($rootScope.stocklog.selected.id, $rootScope.stocklog.selected)
        }

      }

    });

    //getmetadata
   /*  TablesService.statics({})
      .success(function (res) {
        console.log('ESTADISTICAS', res)
        $rootScope.statics = res;
      }); */

    $rootScope.downloadexcel = function (table, params) {
      console.log('downloadexcel starting');
      TablesService.downloadexcel(table, params)
        .success(function (res) {
          console.log('downloadexcel', res);
          $rootScope.excelPath = $rootScope.api + '/' + res.file;
        })
    }

    $rootScope.storeparsedata= function (params) {
     // console.log('storeVoucher', params);
      TablesService.almacenar('voucher', params)
        .success(function (res) {
          console.log('storeVoucher', res);
         // location.reload();
        })
    }

  });

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .service('webDevTec', webDevTec);

  /** @ngInject */
  function webDevTec() {
    var data = [
      {
        'title': 'AngularJS',
        'url': 'https://angularjs.org/',
        'description': 'HTML enhanced for web apps!',
        'logo': 'angular.png'
      },
      {
        'title': 'BrowserSync',
        'url': 'http://browsersync.io/',
        'description': 'Time-saving synchronised browser testing.',
        'logo': 'browsersync.png'
      },
      {
        'title': 'GulpJS',
        'url': 'http://gulpjs.com/',
        'description': 'The streaming build system.',
        'logo': 'gulp.png'
      },
      {
        'title': 'Jasmine',
        'url': 'http://jasmine.github.io/',
        'description': 'Behavior-Driven JavaScript.',
        'logo': 'jasmine.png'
      },
      {
        'title': 'Karma',
        'url': 'http://karma-runner.github.io/',
        'description': 'Spectacular Test Runner for JavaScript.',
        'logo': 'karma.png'
      },
      {
        'title': 'Protractor',
        'url': 'https://github.com/angular/protractor',
        'description': 'End to end test framework for AngularJS applications built on top of WebDriverJS.',
        'logo': 'protractor.png'
      },
      {
        'title': 'Bootstrap',
        'url': 'http://getbootstrap.com/',
        'description': 'Bootstrap is the most popular HTML, CSS, and JS framework for developing responsive, mobile first projects on the web.',
        'logo': 'bootstrap.png'
      },
      {
        'title': 'Angular UI Bootstrap',
        'url': 'http://angular-ui.github.io/bootstrap/',
        'description': 'Bootstrap components written in pure AngularJS by the AngularUI Team.',
        'logo': 'ui-bootstrap.png'
      },
      {
        'title': 'Sass (Node)',
        'url': 'https://github.com/sass/node-sass',
        'description': 'Node.js binding to libsass, the C version of the popular stylesheet preprocessor, Sass.',
        'logo': 'node-sass.png'
      }
    ];

    this.getTec = getTec;

    function getTec() {
      return data;
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .directive('acmeNavbar', acmeNavbar);

  /** @ngInject */
  function acmeNavbar() {
    var directive = {
      restrict: 'E',
      templateUrl: 'app/components/navbar/navbar.html',
      scope: {
        creationDate: '='
      },
      controller: NavbarController,
      controllerAs: 'vm',
      bindToController: true
    };

    return directive;

    /** @ngInject */
    function NavbarController(moment) {
      var vm = this;

      // "vm.creation" is avaible by directive option "bindToController: true"
      vm.relativeDate = moment(vm.creationDate).fromNow();
    }
  }

})();

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .directive('acmeMalarkey', acmeMalarkey);

  /** @ngInject */
  function acmeMalarkey(malarkey) {
    var directive = {
      restrict: 'E',
      scope: {
        extraValues: '='
      },
      template: '&nbsp;',
      link: linkFunc,
      controller: MalarkeyController,
      controllerAs: 'vm'
    };

    return directive;

    function linkFunc(scope, el, attr, vm) {
      var watcher;
      var typist = malarkey(el[0], {
        typeSpeed: 40,
        deleteSpeed: 40,
        pauseDelay: 800,
        loop: true,
        postfix: ' '
      });

      el.addClass('acme-malarkey');

      angular.forEach(scope.extraValues, function (value) {
        typist.type(value).pause().delete();
      });

      watcher = scope.$watch('vm.contributors', function () {
        angular.forEach(vm.contributors, function (contributor) {
          typist.type(contributor.login).pause().delete();
        });
      });

      scope.$on('$destroy', function () {
        watcher();
      });
    }

    /** @ngInject */
    function MalarkeyController($log, githubContributor) {
      var vm = this;

      vm.contributors = [];

      activate();

      function activate() {
        return getContributors().then(function () {
          $log.info('Activated Contributors View');
        });
      }

      function getContributors() {
        return githubContributor.getContributors(10).then(function (data) {
          vm.contributors = data;

          return vm.contributors;
        });
      }
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .factory('githubContributor', githubContributor);

  /** @ngInject */
  function githubContributor($log, $http) {
    var apiHost = 'https://api.github.com/repos/Swiip/generator-gulp-angular';

    var service = {
      apiHost: apiHost,
      getContributors: getContributors
    };

    return service;

    function getContributors(limit) {
      if (!limit) {
        limit = 30;
      }

      return $http.get(apiHost + '/contributors?per_page=' + limit)
        .then(getContributorsComplete)
        .catch(getContributorsFailed);

      function getContributorsComplete(response) {
        return response.data;
      }

      function getContributorsFailed(error) {
        $log.error('XHR Failed for getContributors.\n' + angular.toJson(error.data, true));
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($timeout, webDevTec, toastr) {
    var vm = this;

    vm.awesomeThings = [];
    vm.classAnimation = '';
    vm.creationDate = 1516719002839;
    vm.showToastr = showToastr;

    activate();

    function activate() {
      getWebDevTec();
      $timeout(function () {
        vm.classAnimation = 'rubberBand';
      }, 4000);
    }

    function showToastr() {
      toastr.info('Fork <a href="https://github.com/Swiip/generator-gulp-angular" target="_blank"><b>generator-gulp-angular</b></a>');
      vm.classAnimation = '';
    }

    function getWebDevTec() {
      vm.awesomeThings = webDevTec.getTec();

      angular.forEach(vm.awesomeThings, function (awesomeThing) {
        awesomeThing.rank = Math.random();
      });
    }
  }
})();

'use strict';
angular
  .module('frontendapp')
  .controller('inventoryCtrl', function (ImageLoader, $window, $log, TablesService, $timeout, $rootScope) {
    var vm = this;
    $log.debug('inventoryCtrl');

    vm.sendMail = function (emailId, subject, message) {
      $window.open("mailto:" + emailId + "?subject=" + subject + "&body=" + message, "_self");
    };

    vm.print = function () {
      console.log('ejecuta mensa desde inventoryCtrl')
    }

    vm.comboconfig = {
      component: 'grid',
      model: 'product',

      customFilters: {
        filters: {
          productcategory_id: {
            operator: 'like',
            value: '4'
          },
          code: {
            operator: "like",
            type: "search"
          }
        }
      },
      customProperties: {
        productcategory_id: {
          default: 4,
          disabled: true
        }
      }

    };

    vm.productconfig = {
      component: 'grid',
      model: 'product',
      customProperties: {
        productcombogroup: {
          resolve: {
            hide: function (model) {
              if (model.selected.productcategory_id != 4) {
                return true;
              }
              return false;
            },
          }
        }

      }

    };

    vm.lowerstockconfig = {

      component: 'grid',
      model: 'stock',

      customFilters: {
        filters: {
          current_stock: {
            operator: 'lower',
            value: 'stockmin'
          }
        }
      }

    };

    vm.producttransfer = {
      component: 'uiinventoryform',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        vouchertype_id: {
          label: 'Comprobante',
          type: 'select',
          itemsLabel: 'label',
          default: 6,
          items: [
            {id: 5, label: 'Solicitud de transferencia'},
            {
              id: 6, label: 'Transferencia de productos',
              component: 'uiinventorycheck', newStockorder: true
            },
          ]
        },
        status: {
          hide: true,
          hideGrid: true,
          label: 'Estado',
          type: 'select',
          default: 1,
        },
        warehouse_id: {
          //disabled:true,
          //hide:true,
          //hideGrid:true,
        },
        warehouse_id2: {
          //disabled:true,
          default: 1,
          //resolve: {
          //  default: function (model) {
          //    if(model.filters.selected){
          //      return model.selected.warehouse_id = model.selected.stockorder[0].warehouse.id;
          //    }
          //    else{
          //      return 1;
          //    }
          //  },
          //}
        },
        partner_id: {
          label: 'Encargado',
        }
      },
      customFilters: {
        selected: $rootScope.globalId
      }
    };

    vm.vouchertransfer = {
      component: 'grid',
      model: 'voucher',
      actionType: $rootScope.globalId ? 'update' : 'store',
      customProperties: {
        vouchertype_id: {
          hide: true,
          hideGrid: true,
          default: 2
        },
        status: {
          label: 'Estado',
          type: 'select',
          default: 1,
        },
        warehouse_id: {
          //disabled:true,
          //hide:true,
          //hideGrid:true,
          default: 1,
        },
        warehouse_id2: {
          //disabled:true,
          default: 1,
          //resolve: {
          //  default: function (model) {
          //    if(model.filters.selected){
          //      return model.selected.warehouse_id = model.selected.stockorder[0].warehouse.id;
          //    }
          //    else{
          //      return 1;
          //    }
          //  },
          //}
        },
        partner_id: {
          label: 'Encargado',
        }
      },
      customFilters: {
        selected: $rootScope.globalId
      }
    };


  });

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $state, localStorageService, toastr, UserService, $timeout, $window, $auth) {


    $rootScope.api = 'https://rooftophostels.com/restapi/public';
   // $rootScope.api = 'https://test.rooftophostels.com/restapi/public';
    //$rootScope.api = 'http://localhost:8000';

    //TRANSALATE
    $rootScope.transl = function (target) {
      if (target) {
        return target[$rootScope.language];
      }
      else {
        return '';
      }
    };

    $rootScope.switchText = function (value1, value2) {
      if ($rootScope.language == 'es') {
        return value1;
      }
      else {
        return value2;
      }
    };

    $rootScope.language = 'es';

    $rootScope.obtenerVarSession = function (key) {
      return localStorageService.get(key);
    };

    $rootScope.asignarVarSession = function (key, val) {
      return localStorageService.set(key, val);
    };

    $rootScope.eliminarVarSession = function () {
      return localStorageService.clearAll();
    };

    $rootScope.changeLanguage = function (value, state) {
      console.log('cambia lenguaje');
      $rootScope.language = value;
      $rootScope.asignarVarSession('language', value);
      $state.go(state, { lan: value });
    };

    $rootScope.logout = function () {
      $auth.logout().then(function () {
        if (!$rootScope.logued()) {
          $rootScope.eliminarVarSession();
          //console.log('sesion terminada')
          location.href = './auth';
        }
      });
    };
    $rootScope.logued = function () {
      //////console.log('ejecuta logued')
      //console.log('step 2')
      $rootScope.actS = $auth.isAuthenticated();
      $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
      if (!$rootScope.currentUser || !$rootScope.actS) {
        console.log('step 1', 'invalid');

        return false;
      }
      else {
        UserService.owneraccount()
          .success(function (user) {
            console.log('step 2', user);
            if (user.status) {
              $rootScope.asignarVarSession('currentUser', user.profile);
              $rootScope.currentUser = $rootScope.obtenerVarSession('currentUser');
            }
            else {
              $rootScope.logout();
            }
          })
          .error(function (res) {
            console.log('error2', res);
            $rootScope.logout();
          });
        $rootScope.tk = $auth.getToken();
        $rootScope.asignarVarSession('token', $auth.getToken());
        return true;
      }
      /*return $rootScope.actS;*/
    };

    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////

    $rootScope.infoMenu = false;
    $rootScope.alertMenu = false;

    $rootScope.showInfoMenu = function (value) {
      console.log('infoMenu');
      $rootScope.infoMenu = value ? value : !$rootScope.infoMenu;
    };
    $rootScope.showAlertMenu = function (value) {
      console.log('alertMenu');
      $rootScope.alertMenu = value ? value : !$rootScope.alertMenu;
    };

    $rootScope.appMenu = false;

    $rootScope.showAppMenu = function () {
      console.log('infoMenu');
      $rootScope.appMenu = !$rootScope.appMenu;
    };

    //$rootScope.currentModule = 'default';
    $rootScope.switchModule = function (value) {
      $rootScope.asignarVarSession('currentModule', value);
      $rootScope.currentModule = $rootScope.obtenerVarSession('currentModule');
      //console.log('nuevo modulo', $rootScope.currentModule );
    };

    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////
    /////////////////////////////////////////////////////////

    $rootScope.showNotsGlobal = false;

    $rootScope.globalParams = {
      currency: 'Bs.',
      TcUSD: 6.96
    };

    $rootScope.showNotsG = function () {
      //console.log('showNotsG');
      $rootScope.showNotsGlobal = !$rootScope.showNotsGlobal;
    };

    $rootScope.showSideBar = false;
    $rootScope.showSideBarG = function () {
      //console.log('showSideBar');
      $rootScope.showSideBar = !$rootScope.showSideBar;
    };

    $rootScope.access = function (aliasList) {
      var access = false;
      angular.forEach(aliasList, function (alias) {
        angular.forEach($rootScope.currentUser.userrole, function (u) {
          if (u.appmodulerole.alias == alias) access = true;
        });
        //console.log('MATCH ', alias, ' = ', access);
      });
      //console.log('ACCESO ',  access);
      return access;
    };

    $rootScope.uiAccess = function (state) {
      //console.log('uiAccess', state);
      if ($rootScope.logued()) {
        var target = $state.get(state);
        if (target) {
          var exit = $rootScope.access(target.data.roles);
        }
        else {
          var exit = true;
        }
      }
      return exit;
    };


    $rootScope.$on('$stateChangeSuccess', function (event, toState) {
      // auto scroll to top
      $("html, body").animate({ scrollTop: 0 }, 1000);

      // state validations
      $state.current = toState;
      $rootScope.$state = $state;
      $rootScope.currentState = $state.current.name;
      $rootScope.publicStates = [
        'auth',
        'activate',
        'activatelink',
        'forgot',
        'reset'
      ];
      if (!$rootScope.logued() && $rootScope.publicStates.indexOf($state.current.name) == -1) {
        $rootScope.logout();
      }

      //activation logic interaction
      if ($rootScope.logued()) {
        if ($rootScope.currentUser.status == 0) {
          $state.go('newpassword', { lan: $rootScope.language });

          //toastr.info($rootScope.switchText('Cree una contraseña para continuar', 'Create a new password to continue'),'Atención');
        }
        if ($rootScope.currentUser.status == 1 && $rootScope.currentState == 'newpassword') {
          $state.go('profile', { lan: $rootScope.language })
        }
        var roles = toState.data.roles;
        if (roles) {
          console.log('VALIDATING', roles);
          if (!$rootScope.access(roles)) {
            toastr.error('Acceso denegado', 'AKNA - SUITE');
            $state.go('home', { lan: $rootScope.language });
          }
        }
        //$rootScope.getNotifications();
      }

      // language configuration
      var x = $rootScope.obtenerVarSession('language');
      (x) ? $rootScope.language = x : $rootScope.language = 'es';
      //console.log('actual', $rootScope.currentState, x)

      $rootScope.infoMenu = false;

      //temporal viewTitle
      //console.log('ANCESTORS', $state.$current.includes);
      angular.forEach($state.$current.includes, function (value, key) {
        //console.log(key, value);
        switch (key) {
          case 'inventory':
          case 'purchases':
          case 'sales':
          case 'accounting':
          case 'admin':
          case 'dashboard':
          case 'crm':
          case 'wcms':
          case 'ecommerce':
            $rootScope.switchModule(key);
            break;
          default:
            break;
        }
      });

      $rootScope.currentModule = $rootScope.obtenerVarSession('currentModule');

      $rootScope.appMenu = false;

      $rootScope.getCurrentTitle();

      $rootScope.globalId = $state.params.id;
      $rootScope.ready = true;

      //console.log('globalId',$rootScope.globalId )
    });

    $rootScope.getCurrentTitle = function () {
      //console.log('modulo', $rootScope.currentModule)
      $rootScope.currentTitle = "";
      if ($rootScope.currentState == $rootScope.currentModule) {
        switch ($state.current.name) {
          case 'inventory':
            $rootScope.currentTitle = 'Inventarios';
            break;
          case 'purchases':
            $rootScope.currentTitle = 'Compras';
            break;
          case 'sales':
            $rootScope.currentTitle = 'Ventas';
            break;
          case 'accounting':
            $rootScope.currentTitle = 'Contabilidad';
            break;
          case 'admin':
            $rootScope.currentTitle = 'Administración';
            break;
          case 'dashboard':
            $rootScope.currentTitle = 'Tablero de control';
            break;
        }
      }
      else {
        angular.forEach($rootScope.appMenuItems[$rootScope.currentModule], function (value, key) {
          if (value.items) {
            $rootScope.mapLevel(value);
          }
          else {
            $rootScope.currentTitle = value.label;
          }
        });
      }
      if ($rootScope.currentState == 'home') {
        $rootScope.currentTitle = 'Inicio';
      }

      //console.log('titulo actual', $rootScope.currentTitle, $rootScope.currentState);
      return $rootScope.currentTitle;
    };

    $rootScope.mapLevel = function (target) {
      angular.forEach(target.items, function (value, key) {
        if (value.state == $rootScope.currentState) {
          //console.log('encontrado en', value);
          $rootScope.currentTitle = value.label;
        }
      });
    };

    $rootScope.backTop = function () {
      $("html, body").animate({ scrollTop: 0 }, 1000);
    };

    $rootScope.stateGoParent = function () {
      $state.go('^');
    };

    $rootScope.stateGo = function (state, params) {
      $state.go(state, params);
    };

    $log.debug('intenet explerer navigator', window.navigator.userAgent);
    if (navigator.userAgent.indexOf("MSIE") != -1) {
      $log.debug('intenet explerer navigator', window.navigator.userAgent);
    }

    $rootScope.customModal = {
      visible: false,
      ngClass: '',
      ngTemplate: '',
      target: '',
      data: {}
    };

    $rootScope.openCustomModal = function (template, target) {
      console.log('abre menu')
      $rootScope.customModal.visible = true;
      $rootScope.customModal.ngTemplate = template;
      $rootScope.customModal.target = target;
    };

    $rootScope.closeCustomModal = function () {
      console.log('cierra menu')
      $rootScope.customModal.visible = false;
    };


    $log.debug('runBlock end');
  }

})();

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $urlRouterProvider.otherwise('/');
    $stateProvider

    ///////////////////////////////////////////////
    ///////////// AUTHENTICATION //////////////////
    ///////////////////////////////////////////////
      .state('auth', {
        url: '/auth',
        templateUrl: 'app/views/auth/login.html',
        controller: 'LoginCtrl',
        controllerAs: 'auth'
      })
      .state('activate', {
        url: '/activate',
        templateUrl: 'app/views/auth/activate.html',
        controller: 'LoginCtrl',
        controllerAs: 'auth'
      })
      .state('activatelink', {
        url: '/activatelink/:ac/:rtk',
        templateUrl: 'app/views/auth/activate.html',
        controller: 'LoginCtrl',
        controllerAs: 'auth'
      })
      .state('forgot', {
        url: '/forgot',
        templateUrl: 'app/views/auth/forgot.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      .state('reset', {
        url: '/reset/:ac/:rtk',
        templateUrl: 'app/views/auth/reset.html',
        controller: 'ResetController',
        controllerAs: 'us'
      })
      .state('profile', {
        parent: 'home',
        url: '/profile',
        templateUrl: 'app/views/auth/profile.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      .state('password', {
        parent: 'home',
        url: '/password',
        templateUrl: 'app/views/auth/password.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      .state('newpassword', {
        parent: 'home',
        url: '/newpassword',
        templateUrl: 'app/views/auth/newpassword.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      ///////////////////////////////////////////////
      ///////////// AUTHENTICATION //////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ///////////// AKNA SUITE MAIN /////////////////
      ///////////////////////////////////////////////
      .state('home', {
        url: '/:lan',
        params: {
          lan: 'es'
        },
        templateUrl: 'app/views/appmain.html',
        data: {
          displayName: 'Inicio'
        }
      })
      ///////////////////////////////////////////////
      ///////////// AKNA SUITE MAIN /////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      /////////////// SYSTEM TOOLS //////////////////
      ///////////////////////////////////////////////
      .state('crudgenerator', {
        parent: 'home',
        templateUrl: 'app/views/crudgenerator/crudgenerator_home.html',
        url: '/crudgenerator',
        controller: 'CrudGeneratorCtrl',
        data: {displayName: 'Generador MVC'}
      })
      ///////////////////////////////////////////////
      /////////////// SYSTEM TOOLS //////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      /////////////////// ADMIN /////////////////////
      ///////////////////////////////////////////////
      .state('admin', {
        url: '/admin',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {
          displayName: 'Administración',
          roles: (function () {
            return ['super-admin'];
          })()
        }
      })
      .state('user', {
        url: '/user',
        parent: 'admin',
        templateUrl: 'app/admin/user.html',
        controller: 'UserController',
        controllerAs: 'us',
      })
      .state('userrole', {
        url: '/userrole',
        parent: 'admin',
        templateUrl: 'app/admin/userrole.html',
        controller: 'UserController',
        controllerAs: 'us'
      })
      ///////////////////////////////////////////////
      /////////////////// ADMIN /////////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ///////////////// PURCHASES ///////////////////
      ///////////////////////////////////////////////
      .state('purchases', {
        url: '/purchases',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {
          displayName: 'Compras',
          roles: (function () {
            return ['super-admin', 'gestor-de-compras'];
          })()
        }
      })
      ///////////////////////////////////////////////
      ///////////////// PURCHASES ///////////////////
      ///////////////////////////////////////////////


      ///////////////////////////////////////////////
      /////////////////// SALES /////////////////////
      ///////////////////////////////////////////////
      .state('sales', {
        url: '/sales',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {
          displayName: 'Ventas',
          roles: (function () {
            return [
              'super-admin',
              'vendedor-punto-de-venta',
              'vendedor-visitador',
              'mensajero'
            ];
          })()
        }
      })
      ///////////////////////////////////////////////
      /////////////////// SALES /////////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ////////////////// INVENTORY //////////////////
      ///////////////////////////////////////////////
      .state('inventory', {
        url: '/inventory',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        controller: 'inventoryCtrl',
        controllerAs: 'pro',
        data: {
          displayName: 'Inventarios',
          roles: (function () {
            return [
              'super-admin',
              'gestor-global-de-inventario',
              'gestor-local-de-inventario',
            ];
          })()
        },
      })
      ///////////////////////////////////////////////
      ////////////////// INVENTORY //////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ////////////////// ACCOUNTING /////////////////
      ///////////////////////////////////////////////
      .state('accounting', {
        url: '/accounting',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {
          displayName: 'Contabilidad',
          roles: (function () {
            return ['super-admin'];
          })()
        }

      })
      ///////////////////////////////////////////////
      ////////////////// ACCOUNTING /////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      ////////////////// DASHBOARD //////////////////
      ///////////////////////////////////////////////
      .state('dashboard', {
        url: '/dashboard',
        parent: 'home',
        templateUrl: 'app/views/default/main.html',
        data: {
          displayName: 'Tablero de control',
          roles: (function () {
            return ['super-admin'];
          })()
        }
      })
      ///////////////////////////////////////////////
      ////////////////// DASHBOARD //////////////////
      ///////////////////////////////////////////////

      ///////////////////////////////////////////////
      //////////////////// WCMS /////////////////////
      ///////////////////////////////////////////////
      .state('wcms', {
        url: '/wcms',
        parent: 'home',
        templateUrl: 'app/wcms/main.html',
        data: {
          displayName: 'Contenidos web',
          roles: (function () {
            return [
              'super-admin',
              'gestor-de-contenido',
              'gestor-de-contenido-limitado'
            ];
          })()
        }
      })
      .state('markercategory', {
        url: '/markercategory',
        parent: 'wcms',
        templateUrl: 'app/wcms/tatasapp/markercategory.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('marker', {
        url: '/marker',
        parent: 'wcms',
        templateUrl: 'app/wcms/tatasapp/marker.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('markeruser', {
        url: '/markeruser',
        parent: 'wcms',
        templateUrl: 'app/wcms/tatasapp/markeruser.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('contents', {
        url: '/contents/:model/:type',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/contents.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('webroute', {
        url: '/webroute/:model/:type',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/webroute.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('webcontext', {
        url: '/webcontext/:webroute',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/webcontext.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('websection', {
        url: '/websection/:webroute/:webcontext',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/websection.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('webcollection', {
        url: '/webcollection/:webroute',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/webcollection.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('webadversiting', {
        url: '/webadversiting/:webroute',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/webadversiting.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('webadversiting-online', {
        url: '/webadversiting-online',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/webadversiting-online.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('webadversiting-cinema', {
        url: '/webadversiting-cinema',
        parent: 'wcms',
        templateUrl: 'app/wcms/contents/webadversiting-cinema.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc'
      })
      .state('mailinginnerreceiver', {
        url: '/mailinginnerreceiver',
        parent: 'wcms',
        templateUrl: 'app/wcms/config/mailinginnerreceiver.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc',
        data: {
          roles: (function () {
            return [
              'super-admin',
              'gestor-de-contenido',
            ];
          })()
        }
      })
      .state('webconfig', {
        url: '/webconfig',
        parent: 'wcms',
        templateUrl: 'app/wcms/config/webconfig.html',
        controller: 'wcmsCtrl',
        controllerAs: 'wc',
        data: {
          roles: (function () {
            return [
              'super-admin',
              'gestor-de-contenido',
            ];
          })()
        }
      })
    ///////////////////////////////////////////////
    //////////////////// WCMS /////////////////////
    ///////////////////////////////////////////////
  /******* AKNA E-COMMERCE MODULE ******/
  .state('ecommerce', {
    url: '/ecommerce',
    parent: 'home',
    templateUrl: 'app/ecommerce/main.html',
    controller: 'ecommerceCtrl',
    data: {
      displayName: 'E-Commerce',
      roles: (function () {
        return [
          'super-admin',
          'gestor-de-contenido',
          'gestor-de-contenido-limitado'
        ];
      })()
    }
  })

  .state('pay-request-qr', {
    url: '/pay-request-qr',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/pay-request-qr.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-bank', {
    url: '/e-bank',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-bank.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })

  .state('e-location', {
    url: '/e-location',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-locations.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-stock', {
    url: '/e-stock',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-stock.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-product', {
    url: '/e-product',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-product.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productsubtype', {
    url: '/e-productsubtype',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productsubtype.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productfamily', {
    url: '/e-productfamily',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productfamily.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productcategory', {
    url: '/e-productcategory',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productcategory.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productbrand', {
    url: '/e-productbrand',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productbrand.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productline', {
    url: '/e-productline',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productline.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productgroup', {
    url: '/e-productgroup',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productgroup.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productgroupitem', {
    url: '/e-productgroupitem',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productgroupitem.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productmeasure', {
    url: '/e-productmeasure',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productmeasure.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-productcare', {
    url: '/e-productcare',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-productcare.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-stocklog', {
    url: '/e-stocklog',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-stocklog.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('e-warehouse', {
    url: '/e-warehouse',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/e-warehouse.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('hist-online-purchase', {
    url: '/hist-online-purchase/:id',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/hist-online-purchase.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'ec'
  })
  .state('online-clients', {
    url: '/online-clients',
    parent: 'ecommerce',
    templateUrl: 'app/ecommerce/online-clients.html',
    controller: 'ecommerceCtrl',
    controllerAs: 'eco'
  })

    ;

  }

})();

/* global malarkey:false, moment:false */
(function () {
  'use strict';

  angular
    .module('frontendapp')
    .constant('malarkey', malarkey)
    .constant('moment', moment);

})();

(function () {
  'use strict';

  angular
    .module('frontendapp')
    .config(config);

  /** @ngInject */
  function config($logProvider, toastrConfig, $locationProvider, $authProvider, localStorageServiceProvider) {
    /*// Set the default quality
     $colorThiefProvider.setDefaultQuality(50);

     // Set the default palette color count
     $colorThiefProvider.setDefaultColorCount(5);

     // Set wether to return arrays (ColorThief's default) or
     // objects like {r: 242, g: 124, b: 91} (false by default).
     $colorThiefProvider.setReturnObjects(true);*/

    // Login
    //$authProvider.loginUrl = 'https://multicine.aknatechnologies.com/restapi/public/api/authenticate';
    //$authProvider.loginUrl = 'https://online.multicine.com.bo/restapi/public/api/authenticate';
    //$authProvider.loginUrl = 'https://testing.multicine.com.bo/restapi2/public/api/authenticate';
    //$authProvider.loginUrl = 'http://192.168.0.7:8000/api/authenticate';
    //$authProvider.loginUrl = 'https://test.rooftophostels.com/restapi/public/api/authenticate';
    $authProvider.loginUrl = 'https://rooftophostels.com/restapi/public/api/authenticate';
    //$authProvider.loginUrl = 'http://localhost:8000/api/authenticate';

    localStorageServiceProvider
      .setPrefix('adminApp')
      .setStorageType('localStorage')
      .setNotify(true, true);

    // Enable log
    $logProvider.debugEnabled(true);
    $locationProvider.html5Mode(true).hashPrefix('#');

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 4000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = false;
    toastrConfig.progressBar = true;
    new WOW().init();
  }

})();

angular.module("frontendapp").run(["$templateCache", function($templateCache) {$templateCache.put("app/ecommerce/e-bank.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Cuentas bancarias\" ui-first-level=\"{component: \'grid\', model: \'accountbank\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-locations.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Ciudades / costo de envío\" ui-first-level=\"{component: \'grid\', model: \'location\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-product.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Tallas / items inventariables\" ui-first-level=\"{component: \'grid\', model: \'product\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productbrand.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Marcas de productos\" ui-first-level=\"{component: \'grid\', model: \'productbrand\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productcare.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Plantillas de cuidados y medidas\" ui-first-level=\"{component: \'grid\', model: \'productcare\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productcategory.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Categorias de productos\" ui-first-level=\"{component: \'grid\', model: \'productcategory\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productfamily.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Familias de productos\" ui-first-level=\"{component: \'grid\', model: \'productfamily\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productgroup.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Grupos de productos\" ui-first-level=\"{component: \'grid\', model: \'productgroup\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productgroupitem.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Presentacion de productos\" ui-first-level=\"{component: \'grid\', model: \'productgroupitem\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productline.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Lineas de productos\" ui-first-level=\"{component: \'grid\', model: \'productline\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productmeasure.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Medidas productos\" ui-first-level=\"{component: \'grid\', model: \'productmeasure\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-productsubtype.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Presentaciones / colores\" ui-first-level=\"{component: \'grid\', model: \'productsubtype\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-stock.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Existencias en linea\" ui-first-level=\"{component: \'grid\', model: \'stock\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-stocklog.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Actualización en lote\" ui-first-level=\"{component: \'grid\', model: \'stocklog\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/e-warehouse.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Almacenes\" ui-first-level=\"{component: \'grid\', model: \'warehouse\'}\"></uibuilder></div>");
$templateCache.put("app/ecommerce/hist-online-purchase.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Historial de pedidos\" ui-first-level=\"ec.voucherConfig\"></uibuilder></div>");
$templateCache.put("app/ecommerce/main.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{\'E Commerce\'}}</h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><div class=\"dash-item-box\"><div class=\"dash-item com\"><div class=\"dash-item-container\"><div class=\"dash-icon\"><a href=\"\"><i class=\"fas fa-receipt\"></i></a></div><div class=\"dash-ind\">{{$root.statics.pending}}</div><div class=\"dash-text\">Pedidos pendientes</div></div></div><div class=\"dash-item com\"><div class=\"dash-item-container\"><div class=\"dash-icon\"><a href=\"\"><i class=\"fas fa-receipt\"></i></a></div><div class=\"dash-ind\">{{$root.statics.inprocess}}</div><div class=\"dash-text\">Pedidos en proceso</div></div></div><div class=\"dash-item com\"><div class=\"dash-item-container\"><div class=\"dash-icon\"><a href=\"\"><i class=\"fas fa-users\"></i></a></div><div class=\"dash-ind\">{{$root.statics.new}}</div><div class=\"dash-text\">Clientes nuevos</div></div></div></div></div><div class=\"clear-fix\"></div><div class=\"col-xs-12 no-padding\"><ul class=\"tree-new hier\"><li class=\"root\" equalheight=\"\" classitem=\"root\" data-ng-repeat=\"level in appMenuItems[currentModule] track by $index\"><a data-ng-click=\"(level.items)?\'\':stateGo(level.state, level.stateParams)\">{{level.label}}</a><ul class=\"child\" data-ng-if=\"level.items\"><li class=\"{{subitem.level}}\" data-ng-repeat=\"subitem in level.items\"><a class=\"{{$root.currentModule}}\" data-ng-click=\"stateGo(subitem.state, subitem.stateParams)\">{{subitem.label}}<i class=\"far fa-edit\"></i></a></li></ul></li></ul></div></div></div>");
$templateCache.put("app/ecommerce/online-clients.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Clientes\" ui-first-level=\"eco.partnerconfig\"></uibuilder></div>");
$templateCache.put("app/ecommerce/pay-request-qr.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Pagos con QR\" ui-first-level=\"{component: \'grid\', model: \'payrequest\'}\"></uibuilder></div>");
$templateCache.put("app/admin/partner.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de asociados\" ui-first-level=\"us.partnerconfig\"></uibuilder></div>");
$templateCache.put("app/admin/user.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de usuarios\" ui-first-level=\"us.userconfig\"></uibuilder></div>");
$templateCache.put("app/admin/userrole.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de roles\" ui-first-level=\"{component:\'grid\',model:\'appmodulerole\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/invmain.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{currentModule}}</h1></div></div><ul class=\"tree\"><li class=\"root\" data-ng-repeat=\"level in appMenuItems[currentModule] track by $index\"><a style=\"text-transform: capitalize\" data-ng-click=\"(level.items)?\'\':stateGo(level.state, level.stateParams)\">{{level.label}}</a><ul data-ng-if=\"level.items\"><li data-ng-repeat=\"subitem in level.items\"><a style=\"text-transform: capitalize\" data-ng-click=\"stateGo(subitem.state, subitem.stateParams)\">{{subitem.label}}</a></li></ul></li></ul></div>");
$templateCache.put("app/inventory/lowerstock.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Bajas existencias\" ui-first-level=\"pro.lowerstockconfig\"></uibuilder></div>");
$templateCache.put("app/inventory/moves.html","<div class=\"container-fluid\" data-ng-if=\"$root.currentState==\'replacements\'\"><uibuilder ui-crud-title=\"Ingreso por compra\" ui-first-level=\"{component:\'grid\',model:\'purchase\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/productkardex.html","<div class=\"container-fluid\"><crudv3 state=\"productkardex\" table-name=\"productkardex\" table-label=\"Movimiento de inventario\" crud-title=\'{{$root.switchText(\"Movimientos de inventario\", \"Kardex\")}}\'></crudv3></div>");
$templateCache.put("app/inventory/productwarehouse.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Existencias\" ui-first-level=\"{component:\'grid\',model:\'productwarehouse\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/stockentry.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Punto de tranferencias\" ui-first-level=\"pro.producttransfer\"></uibuilder></div>");
$templateCache.put("app/inventory/voucher.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Historial de transferencias\" ui-first-level=\"pro.vouchertransfer\"></uibuilder></div>");
$templateCache.put("app/main/main.html","<div class=\"container\"><div><acme-navbar creation-date=\"main.creationDate\"></acme-navbar></div><div class=\"jumbotron text-center\"><h1>\'Allo, \'Allo!</h1><p class=\"lead\"><img src=\"assets/images/yeoman.png\" alt=\"I\'m Yeoman\"><br>Always a pleasure scaffolding your apps.</p><p class=\"animated infinite\" ng-class=\"main.classAnimation\"><button type=\"button\" class=\"btn btn-lg btn-success\" ng-click=\"main.showToastr()\">Splendid Toastr</button></p><p>With ♥ thanks to the contributions of<acme-malarkey extra-values=\"[\'Yeoman\', \'Gulp\', \'Angular\']\"></acme-malarkey></p></div><div class=\"row\"><div class=\"col-sm-6 col-md-4\" ng-repeat=\"awesomeThing in main.awesomeThings | orderBy:\'rank\'\"><div class=\"thumbnail\"><img class=\"pull-right\" ng-src=\"assets/images/{{ awesomeThing.logo }}\" alt=\"{{ awesomeThing.title }}\"><div class=\"caption\"><h3>{{ awesomeThing.title }}</h3><p>{{ awesomeThing.description }}</p><p><a ng-href=\"{{awesomeThing.url}}\">{{ awesomeThing.url }}</a></p></div></div></div></div></div>");
$templateCache.put("app/purchase/otherpurchases.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body></body></html>");
$templateCache.put("app/purchase/producdevolution.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Registrar compra\" ui-first-level=\"pur.productpurchase\"></uibuilder></div>");
$templateCache.put("app/purchase/productcotization.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Registrar cotizacion\" ui-first-level=\"pur.productpurchase\"></uibuilder></div>");
$templateCache.put("app/purchase/productpurchase.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Punto de compra\" ui-first-level=\"pur.productpurchase\"></uibuilder></div>");
$templateCache.put("app/purchase/supplier.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Gestión de proveedores\" ui-first-level=\"pur.partnerconfig\"></uibuilder></div>");
$templateCache.put("app/purchase/voucher.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Historial de compras\" ui-first-level=\"pur.purchasevoucher\"></uibuilder></div>");
$templateCache.put("app/sales/clients.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Clientes\" ui-first-level=\"sal.partnerconfig\"></uibuilder></div>");
$templateCache.put("app/sales/productsale.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Punto de venta\" ui-first-level=\"sal.productsale\"></uibuilder></div>");
$templateCache.put("app/sales/voucher.html","<div class=\"container-fluid\"><uibuilder data-ng-if=\"$root.ready\" ui-crud-title=\"Historial de ventas\" ui-first-level=\"sal.vouchersale\"></uibuilder></div>");
$templateCache.put("app/views/appmain.html","<div class=\"app-body {{currentModule}}\" windowheight=\"\"><appmenu menu-items=\"appMenuItems[currentModule]\" menu-title=\"{{currentModule}}\" menu-class=\"{{currentModule}}\" menu-depth=\"3\"></appmenu><div class=\"app-wrapper\" windowheight=\"\"><div data-ng-class=\"{ \'min\': infoMenu }\" class=\"app-view\" windowheight=\"\"><ui-breadcrumbs displayname-property=\"data.displayName\"></ui-breadcrumbs><div class=\"app-interface\" ui-heigth=\"\" minus=\"50\" ui-view=\"\"><ng-include src=\"\'app/views/main/home.html\'\"></ng-include></div></div></div></div>");
$templateCache.put("app/views/authView.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/180711-AKNA-MARCA-02.png\" alt=\"AKNA SRL\"></div><div class=\"auth-box\"><h3>Gustu</h3><h3 data-ng-bind-html=\"switchText(\'Iniciar sesión\', \'Login\')\"></h3><form class=\"\" data-ng-submit=\"loginNew()\"><div class=\"form-group\"><input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{switchText(\'Correo electrónico\', \'Email\')}}\" data-ng-model=\"auth.email\" data-ng-required=\"true\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" placeholder=\"{{switchText(\'Contraseña\', \'Password\')}}\" data-ng-model=\"auth.password\" data-ng-required=\"true\"></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"forgot\" data-ng-bind-html=\"switchText(\'¿Olvidaste tu contraseña?\', \'Forgot your password?\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/footer.html","<div class=\"container-fluid\"><div class=\"view-footer\"><div class=\"col-xs-12\"><span class=\"copyright\">©akna</span> <span class=\"mail\">aknabolivia@gmail.com</span></div></div></div>");
$templateCache.put("app/views/header.html","<div class=\"container-fluid menu-header\"><div class=\"header row\"><div class=\"navbar navbar-default\" role=\"navigation\"><div class=\"navbar-header\"><button type=\"button\" class=\"navbar-toggle collapsed\" data-ng-init=\"navCollapsed = true\" data-ng-click=\"navCollapsed = !navCollapsed\" data-toggle=\"collapse\" data-target=\"#js-navbar-collapse\"><span class=\"icon-arrow-down\"></span> <span class=\"icon-arrow-up\"></span></button> <a class=\"navbar-brand logo\" ui-sref=\"home({lan: language})\" href=\"\" data-ng-if=\"currentState!=\'auth\'\"></a></div><div class=\"collapse navbar-collapse\" id=\"js-navbar-collapse\" collapse=\"navCollapsed\"><ul class=\"nav navbar-nav\" data-ng-if=\"currentState!=\'auth\'\"><li class=\"button-burger\"><a href=\"\" data-ng-click=\"showSideBarG()\"><img style=\"max-height: 18px;\" src=\"../assets/images/iconos/menu-akna1.svg\" alt=\"\"></a></li></ul><ul class=\"nav navbar-nav\" data-ng-class=\"group.ngClass\" data-ng-repeat=\"group in menu | orderBy : \'order\'\"><li data-ng-repeat=\"item in group.items\" data-ng-if=\"actS || item.showAlways\"><a href=\"\" data-ng-class=\"item.ngClass\" data-ng-style=\"item.ngStyle\" data-ng-if=\"!item.render\" ui-sref=\"{{item.stateGo}}({lan:language})\" data-ng-bind-html=\"item.label()\"></a> <span class=\"navbar-text\" data-ng-class=\"item.ngClass\" data-ng-if=\"item.render\" render-html=\"item.template\"></span></li></ul></div></div></div></div>");
$templateCache.put("app/views/home.html","<ng-include src=\"\'app/views/notifications.html\'\"></ng-include><ng-include src=\"\'app/views/sidebar.html\'\"></ng-include><div class=\"view-breadcrumb\"><ui-breadcrumbs displayname-property=\"data.displayName\"></ui-breadcrumbs></div><div class=\"view-body\" customheight=\"\" minus=\"140\"><div class=\"view-body-wrapper\" ui-view=\"\"><h3 class=\"body-title\">Hola, bienvenido al sistema de administración</h3><p class=\"body-instructions\">A continuación le presentamos las secciones a las cuales puede acceder. Haga clic en alguna de ellas para realizar una acción.</p><div class=\"button-box\"><div class=\"button-sys\" ui-sref=\"contents\"><h5>{{switchText(\'Contenidos\',\'Contents\')}}</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde, voluptatibus?</p><a href=\"\" class=\"buton-sys-bottom\">{{switchText(\'Ingresar\',\'Go to\')}} <span class=\"glyphicon glyphicon-chevron-right\"></span></a></div></div><div class=\"button-box\"><div class=\"button-sys\"><h5>{{switchText(\'Configuracion\',\'Configuration\')}}</h5><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Unde, voluptatibus?</p><a href=\"\" class=\"buton-sys-bottom\">{{switchText(\'Ingresar\',\'Go to\')}} <span class=\"glyphicon glyphicon-chevron-right\"></span></a></div></div></div></div>");
$templateCache.put("app/views/notifications.html","<div class=\"site-not\" data-ng-show=\"showNotsGlobal\"><div class=\"site-not-title\"><p data-ng-bind-html=\"switchText(\'Notificaciones\', \'Notifications\')\"></p><a href=\"\" data-ng-click=\"showNotsGlobal = !showNotsGlobal\" class=\"btn btn-close glyphicon glyphicon-remove\"></a></div></div>");
$templateCache.put("app/views/sidebar.html","<div class=\"navbar-default sidebar\" role=\"navigation\"><div class=\"sidebar-nav navbar-collapse\" data-ng-show=\"showSideBar\"><ul class=\"nav in\" id=\"side-menu\"><li class=\"sidebar-header active\"><h2>Menu <span data-ng-click=\"showSideBarG()\" class=\"glyphicon glyphicon-remove\"></span></h2></li><li class=\"profile active\"><a ui-sref=\"profile\"><div class=\"sidebar-profile\"></div><div class=\"user\"><span class=\"sidebar-user\" style=\"overflow: hidden\">{{currentUser.email}}</span> <small class=\"online\"><i class=\"fa dot fa-circle\" aria-hidden=\"true\"></i> online</small></div></a></li><li ui-sref-active=\"active\" class=\"nav-first-level\"><a ui-sref=\"inicio.home\"><span class=\"glyphicon glyphicon-home\"></span> Inicio</a></li><li ng-class=\"{active: collapseVar == 7}\" class=\"nav-first-level\"><a href=\"\" ng-click=\"check(7)\" ui-sref=\"contents\"><span class=\"glyphicon glyphicon-pencil\"></span> {{switchText(\'Contenidos\', \'Contents\')}}</a></li><li ng-class=\"{active: collapseVar == 99}\" class=\"nav-first-level\" restricted=\"\" blocked-for=\"configuracion\"><a href=\"\" ng-click=\"check(99)\" ui-sref=\"configuracion\"><span class=\"glyphicon glyphicon-cog\"></span> Configuración<span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" collapse=\"collapseVar!=99\"><li ng-init=\"third = !third\" ng-class=\"{active: multiCollapseVar == 13}\" restricted=\"\" blocked-for=\"users-home\"><a href=\"\" ui-sref=\"users-home\" ng-click=\"multiCheck(13)\">Usuarios y Roles <span class=\"fa arrow\"></span></a><ul class=\"nav nav-third-level\" collapse=\"multiCollapseVar!=13\"><li><a ui-sref=\"usuarios\">Administración de usuarios</a></li><li><a ui-sref=\"roles\">Administración de roles</a></li></ul></li><li ng-init=\"third = !third\" ng-class=\"{active: multiCollapseVar == 21}\" restricted=\"\" blocked-for=\"sessionlogs\"><a href=\"\" ui-sref=\"sessionlogs\">Historial de actividad de usuarios</a></li></ul></li><li ng-class=\"{active: collapseVar == 6}\" class=\"nav-first-level\"><a href=\"\" data-ng-click=\"logout()\"><span class=\"glyphicon glyphicon-log-out\"></span> Salir</a></li><li ng-class=\"{active: collapseVar == 99}\" class=\"hidden-lg hidden-md hidden-sm\"><a href=\"\" ng-click=\"check(99)\"><i class=\"fa fa-bell\" aria-hidden=\"true\"></i> Notificaciones <span class=\"notification\">{{notificationsTotal}}</span> <span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" collapse=\"collapseVar!=99\" data-ng-if=\"activeSession\"><li data-ng-repeat=\"notifications in notificationsPendings\" data-ng-if=\"notifications.pendings > 0\"><a><i class=\"fa fa-arrow-circle-right\" aria-hidden=\"true\"></i> {({{notifications.type + \' - \'+ notifications.name}})</a></li></ul></li><li ng-class=\"{active: collapseVar == 100}\" class=\"hidden-lg hidden-md hidden-sm nav-first-level\"><a href=\"\" ng-click=\"check(100)\"><i class=\"fa fa-user fa-fw\"></i>{{currentUser.email}}<span class=\"fa arrow\"></span></a><ul class=\"nav nav-second-level\" collapse=\"collapseVar!=100\" data-ng-if=\"!activeSession\"><li><a ui-sref=\"auth\"><i class=\"fa fa-sign-in fa-fw\"></i> Iniciar Sesión</a></li></ul><ul class=\"nav nav-second-level\" collapse=\"collapseVar!=100\" data-ng-if=\"activeSession\"><li><a data-ng-click=\"logout()\"><i class=\"fa fa-sign-out fa-fw\"></i> Cerrar sesión</a></li></ul></li></ul></div></div>");
$templateCache.put("app/wcms/main.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{\'Contenidos web\'}}</h1></div><div class=\"col-xs-12 no-padding\"><ul class=\"tree-new\"><li class=\"root\" equalheight=\"\" classitem=\"root\" data-ng-repeat=\"level in appMenuItems[currentModule] track by $index\"><a class=\"root-label\" data-ng-click=\"(level.items)?\'\':stateGo(level.state, level.stateParams)\">{{level.label}}</a><ul data-ng-if=\"level.items\"><li data-ng-repeat=\"subitem in level.items\"><a class=\"branch-label {{$root.currentModule}}\" data-ng-click=\"stateGo(subitem.state, subitem.stateParams)\">{{subitem.label}}<i class=\"far fa-edit\"></i></a></li></ul></li></ul></div></div></div>");
$templateCache.put("app/wcms/test.html","<p><b>Programación y ahorro energético​</b></p><p>Orientada a una gestión eficiente de los dispositivos electrónicos, con soluciones como:</p><ul><li>Control de enchufes para dispositivos electrónicos: programación y zonificación, pudiéndose encender o apagar mediante acceso convencional a internet (telefonía móvil,WiFi oEthernet)</li><li>Control de toldos y eléctricas, realizando algunas funciones repetitivas automáticamente o bien por el usuario manualmente mediante un mando a distancia, o gestión vía internet como en el caso anterior.</li><li>Programación de horarios de encendido o apagado de enchufes, persianas.</li><li>Temporizador de tiempo en funcionamiento de enchufes inteligentes.</li></ul><p><b>Confort</b></p><p>Orientado a mejorar la comodidad en una vivienda; con soluciones como:</p><ul><li>Iluminación.</li><ul><li>Apagado general de todas las luces de la vivienda</li><li>Automatización del apagado/encendido en cada punto de luz.</li><li>Regulación de la iluminación según el nivel de luminosidad ambiente.</li></ul><li>Automatización de todos los distintos sistemas/instalaciones/dotándolos de control eficiente y de fácil manejo.</li><li>Integración del portero al teléfono, o del videoportero al televisor, a través de \"cerraduras inteligentes\" que permiten el control de acceso del portero o videoportero a través de aplicaciones móviles​</li><li>Control vía Internet.</li><li>Programación de horarios de encendido o apagado de luces.</li><li>Temporizador de tiempo en funcionamiento de luces.</li><li>Control inteligente de los aparatos domésticos que funcionan mediante infrarrojo (televisión, radio, aire acondicionado, etc.).</li><li>Integración de la solución de intrusión y la solución de iluminación (sensor de movimiento e interruptor inteligente), para que se enciendan las luces cuando se detecte movimiento en la habitación.</li></ul><p><b>Seguridad</b></p><p>Orientada a proteger tanto los bienes patrimoniales, como la seguridad personal y la vida.</p><ul><li>Alarmas de intrusión (antiintrusión)</li><ul><li>Detección intrusos.</li><li>Cierre de persianas automatizado.</li><li>Simulación de presencia</li></ul><li>Sensores y alarmas de detección de incendios inalámbricos</li><ul><li>Sensores de humo</li><li>Sensores de movimiento</li><li>Sensores de temperatura</li><li>Sensores de gas (fugas de gas, para cocinas no eléctrica)</li><li>Sensores de fuga de agua</li><li>Sensores SOS</li><li>Sensores de contacto magnético</li></ul><li>Cámaras de seguridad con monitoreo a distancia vía Internet y con sensor de movimiento</li><ul><li>Almacenamiento local y/o en la nube.</li><li>Las cámaras funcionan como intercomunicadores (cuentan con parlante y micrófono).</li></ul><li>Armar el sistema de seguridad desde la aplicación móvil.</li><ul><li>Se puede zonificar el armado del sistema de seguridad.</li></ul></ul><p><b>Accesibilidad e integración de sistemas</b></p><p>Aplicaciones o instalaciones de control remoto del entorno que favorecen la autonomía personal de personas con limitaciones funcionales, o discapacidad.</p><ul><li>Ubicuidad en el control tanto externo como interno, control remoto desde Internet, PC, mandos inalámbricos (p.ej. PDA con Wi-Fi).</li><li>Gestión unificada de los sistemas de: seguridad, confort y programación y ahorro energético.</li><li>Se pueden automatizar distintos tipos de situaciones mediante la aplicación y mediante un interruptor inteligente. Ej. Al apretar un botón, bajar persianas, encender luces, encender tv, encender aire acondicionado. O cualquier situación que se desee.</li></ul>");
$templateCache.put("app/wcms/test2.html","<p><b>Programación y ahorro energético​</b></p><p>Orientada a una estión eficiente de los dispositivos electrónicos, con soluciones como:</p><ul><li>Control de enchufes para dispositivos electrónicos: programación y zonificación, pudiéndose encender o apagar mediante acceso convencional a internet (telefonía móvil,WiFi oEthernet)</li><li>Control de toldos y eléctricas, realizando algunas funciones repetitivas automáticamente o bien por el usuario manualmente mediante un mando a distancia, o gestión vía internet como en el caso anterior.</li><li>Programación de horarios de encendido o apagado de enchufes, persianas.</li><li>Temporizador de tiempo en funcionamiento de enchufes inteligentes.</li></ul><p><b>Confort</b></p><p>Orientado a mejorar la comodidad en una vivienda; con soluciones como:</p><ul><li>Iluminación.</li><ul><li>Apagado general de todas las luces de la vivienda</li><li>Automatización del apagado/encendido en cada punto de luz.</li><li>Regulación de la iluminación según el nivel de luminosidad ambiente.</li></ul><li>Automatización de todos los distintos sistemas/instalaciones/dotándolos de control eficiente y de fácil manejo.</li><li>Integración del portero al teléfono, o del videoportero al televisor, a través de \"cerraduras inteligentes\" que permiten el control de acceso del portero o videoportero a través de aplicaciones móviles​</li><li>Control vía Internet.</li><li>Programación de horarios de encendido o apagado de luces.</li><li>Temporizador de tiempo en funcionamiento de luces.</li><li>Control inteligente de los aparatos domésticos que funcionan mediante infrarrojo (televisión, radio, aire acondicionado, etc.).</li><li>Integración de la solución de intrusión y la solución de iluminación (sensor de movimiento e interruptor inteligente), para que se enciendan las luces cuando se detecte movimiento en la habitación.</li></ul><p><b>Seguridad</b></p><p>Orientada a proteger tanto los bienes patrimoniales, como la seguridad personal y la vida.</p><ul><li>Alarmas de intrusión (antiintrusión)</li><ul><li>Detección intrusos.</li><li>Cierre de persianas automatizado.</li><li>Simulación de presencia</li></ul><li>Sensores y alarmas de detección de incendios inalámbricos</li><ul><li>Sensores de humo</li><li>Sensores de movimiento</li><li>Sensores de temperatura</li><li>Sensores de gas (fugas de gas, para cocinas no eléctrica)</li><li>Sensores de fuga de agua</li><li>Sensores SOS</li><li>Sensores de contacto magnético</li></ul><li>Cámaras de seguridad con monitoreo a distancia vía Internet y con sensor de movimiento</li><ul><li>Almacenamiento local y/o en la nube.</li><li>Las cámaras funcionan como intercomunicadores (cuentan con parlante y micrófono).</li></ul><li>Armar el sistema de seguridad desde la aplicación móvil.</li><ul><li>Se puede zonificar el armado del sistema de seguridad.</li></ul></ul><p><b>Accesibilidad e integración de sistemas</b></p><p>Aplicaciones o instalaciones de control remoto del entorno que favorecen la autonomía personal de personas con limitaciones funcionales, o discapacidad.</p><ul><li>Ubicuidad en el control tanto externo como interno, control remoto desde Internet, PC, mandos inalámbricos (p.ej. PDA con Wi-Fi).</li><li>Gestión unificada de los sistemas de: seguridad, confort y programación y ahorro energético.</li><li>Se pueden automatizar distintos tipos de situaciones mediante la aplicación y mediante un interruptor inteligente. Ej. Al apretar un botón, bajar persianas, encender luces, encender tv, encender aire acondicionado. O cualquier situación que se desee.</li></ul>");
$templateCache.put("app/inventory/admin/product.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestión de productos\" ui-first-level=\"pro.productconfig\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productcombo.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de combos de productos\" ui-first-level=\"pro.comboconfig\"></uibuilder></div>");
$templateCache.put("app/components/navbar/navbar.html","<nav class=\"navbar navbar-static-top navbar-inverse\"><div class=\"container-fluid\"><div class=\"navbar-header\"><a class=\"navbar-brand\" href=\"https://github.com/Swiip/generator-gulp-angular\"><span class=\"glyphicon glyphicon-home\"></span> Gulp Angular</a></div><div class=\"collapse navbar-collapse\" id=\"bs-example-navbar-collapse-6\"><ul class=\"nav navbar-nav\"><li class=\"active\"><a ng-href=\"#\">Home</a></li><li><a ng-href=\"#\">About</a></li><li><a ng-href=\"#\">Contact</a></li></ul><ul class=\"nav navbar-nav navbar-right acme-navbar-text\"><li>Application was created {{ vm.relativeDate }}.</li></ul></div></div></nav>");
$templateCache.put("app/views/auth/activate.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/brand.png\" alt=\"AKNA\"></div><div class=\"auth-box\"><h3 data-ng-bind-html=\"switchText(\'Activa tu cuenta\', \'Active account\')\"></h3><form class=\"\" data-ng-submit=\"$root.loginNew(auth.email,auth.email)\"><div class=\"form-group\"><input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{switchText(\'Correo electrónico\', \'Email\')}}\" data-ng-model=\"auth.email\" data-ng-required=\"true\"></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"forgot\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'¿Olvidaste tu contraseña?\', \'Forgot your password?\')\" class=\"fhelp pull-left\"></a> <a ui-sref=\"auth\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Inicia sesión\', \'Login\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/auth/forgot.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/brand.png\" alt=\"AKNA\"></div><div class=\"auth-box\"><h3 data-ng-bind-html=\"switchText(\'Restaurar contraseña\', \'Restore password\')\"></h3><form class=\"\" data-ng-submit=\"us.forgotPassword()\"><div class=\"form-group\"><input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{switchText(\'Correo electrónico\', \'Email\')}}\" data-ng-model=\"us.reset.email\" data-ng-required=\"true\"></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"auth\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Iniciar sesión\', \'Login\')\" class=\"fhelp pull-left\"></a> <a ui-sref=\"activate\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Activa tu cuenta\', \'Active account\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/auth/login.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/brand.png\" alt=\"AKNA\"></div><div class=\"auth-box\"><h3 data-ng-bind-html=\"switchText(\'Iniciar sesión\', \'Login\')\"></h3><form class=\"\" data-ng-submit=\"loginNew(auth.email,auth.password)\"><div class=\"form-group\"><input id=\"email\" type=\"email\" class=\"form-control\" placeholder=\"{{switchText(\'Correo electrónico\', \'Email\')}}\" data-ng-model=\"auth.email\" data-ng-required=\"true\"></div><div class=\"form-group\"><input type=\"password\" class=\"form-control\" placeholder=\"{{switchText(\'Contraseña\', \'Password\')}}\" data-ng-model=\"auth.password\" data-ng-required=\"true\"></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"forgot\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'¿Olvidaste tu contraseña?\', \'Forgot your password?\')\" class=\"fhelp pull-left\"></a> <a ui-sref=\"activate\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Activa tu cuenta\', \'Active account\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/auth/newpassword.html","<div class=\"container-fluid crud-form-body\" style=\"position: relative;\"><div class=\"grid-title\"><h3 style=\"text-transform: uppercase;\">Registre una contraseña</h3><div class=\"alert alert-success\" role=\"alert\"><h4 class=\"alert-heading\">Hola {{$root.currentUser.firstname}}!</h4><p>Este es el último paso, para completar la activación necesitamos que registres una nueva contraseña.</p></div></div><form class=\"crud-form\" data-ng-init=\"us.usercp.currentpass = $root.currentUser.email\" data-ng-submit=\"us.changePassword(true)\"><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Nueva contraseña\',\'New password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.newpass\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Repita la contraseña\',\'Confirm password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.newpass2\"></div></div><div class=\"forms\"><button type=\"submit\" class=\"btn btn-action success pull-right\">{{switchText(\'Guardar\',\'Save\')}}</button> <button type=\"button\" data-ng-click=\"us.restore()\" class=\"btn btn-action info pull-right\">{{switchText(\'Cancelar\',\'Cancel\')}}</button></div></form></div>");
$templateCache.put("app/views/auth/password.html","<div class=\"container-fluid crud-form-body\" style=\"position: relative;\"><div class=\"grid-title\"><ul class=\"header-tab\"><li><a class=\"{{currentModule}}\" href=\"\" ui-sref=\"profile({lan:$root.language})\" data-ng-class=\"{\'active\': $root.currentState == \'profile\'}\">{{$root.switchText(\'Perfil\',\'Profile\')}}</a></li><li><a class=\"{{currentModule}}\" href=\"\" ui-sref=\"password({lan:$root.language})\" data-ng-class=\"{\'active\': $root.currentState == \'password\'}\">{{$root.switchText(\'Contraseña\',\'Password\')}}</a></li></ul></div><form class=\"crud-form\" data-ng-submit=\"us.changePassword(true)\"><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Contraseña actual\',\'Current Password\')}}</span></div><div class=\"box-input\"><input type=\"text\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.currentpass\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Nueva contraseña\',\'New password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.newpass\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{switchText(\'Repita la contraseña\',\'Confirm password\')}}</span></div><div class=\"box-input\"><input type=\"password\" class=\"form-control\" required=\"\" data-ng-model=\"us.usercp.newpass2\"></div></div><div class=\"forms\"><button type=\"submit\" style=\"margin-left: 10px\" class=\"btn btn-theme pull-right\">{{switchText(\'Guardar\',\'Save\')}}</button> <button type=\"button\" data-ng-click=\"us.restore()\" class=\"btn btn-theme pull-right\">{{switchText(\'Cancelar\',\'Cancel\')}}</button></div></form></div>");
$templateCache.put("app/views/auth/profile.html","<div class=\"container-fluid crud-form-body\" style=\"position: relative;\"><div class=\"grid-title\"><ul class=\"header-tab\"><li><a class=\"{{currentModule}}\" href=\"\" ui-sref=\"profile({lan:$root.language})\" data-ng-class=\"{\'active\': $root.currentState == \'profile\'}\">{{$root.switchText(\'Perfil\',\'Profile\')}}</a></li><li><a class=\"{{currentModule}}\" href=\"\" ui-sref=\"password({lan:$root.language})\" data-ng-class=\"{\'active\': $root.currentState == \'password\'}\">{{$root.switchText(\'Contraseña\',\'Password\')}}</a></li></ul></div><form class=\"crud-form\" data-ng-init=\"us.restore()\" data-ng-submit=\"us.saveUserData()\"><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'nombres\',\'firtname\')}}</span></div><div class=\"box-input\"><input class=\"form-control\" data-ng-model=\"us.profile.firstname\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'apeliidos\',\'lastname\')}}</span></div><div class=\"box-input\"><input class=\"form-control\" data-ng-model=\"us.profile.lastname\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'correo electrónico\',\'email\')}}</span></div><div class=\"box-input\"><input type=\"text\" class=\"form-control\" data-ng-model=\"us.profile.email\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'telefono\',\'phone\')}}</span></div><div class=\"box-input\"><input type=\"text\" class=\"form-control\" data-ng-model=\"us.profile.phone\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'imagen\',\'photo\')}}</span></div><div class=\"box-input\"><input type=\"text\" class=\"form-control\" data-ng-model=\"us.profile.photo\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'género\',\'gender\')}}</span></div><div class=\"box-input\"><input class=\"form-control\" data-ng-model=\"us.profile.gender\"></div></div><div class=\"forms\"><div class=\"box-label\"><span class=\"filter-label\">{{$root.switchText(\'fecha de nacimiento\',\'birthday\')}}</span></div><div class=\"box-input\"><input class=\"form-control\" data-ng-model=\"us.profile.birthday\"></div></div><div class=\"forms\"><button type=\"submit\" class=\"btn btn-theme2 pull-right\">{{switchText(\'Guardar\',\'Save\')}}</button> <button type=\"button\" data-ng-click=\"us.restore()\" class=\"btn btn-theme2 pull-right\">{{switchText(\'Cancelar\',\'Cancel\')}}</button></div></form></div>");
$templateCache.put("app/views/auth/reset.html","<div class=\"container-fluid\"><div class=\"auth-view\" windowheight=\"\"><div class=\"auth-title\"><img src=\"../assets/images/brand.png\" alt=\"AKNA\"></div><div class=\"auth-box\"><img class=\"client-brand\" src=\"../assets/images/client-brand.svg\" alt=\"AKNA\"><h3 data-ng-bind-html=\"switchText(\'Nueva contraseña\', \'New password\')\"></h3><form class=\"\" data-ng-submit=\"us.resetForgottenPassword()\"><div class=\"form-group\"><input type=\"password\" id=\"newpass\" placeholder=\"{{switchText(\'Nueva contraseña\', \'New password\')}}\" required=\"\" data-ng-model=\"us.reset.newpass\" class=\"form-control\"></div><div class=\"form-group\"><input type=\"password\" placeholder=\"{{$root.switchText(\'Confirmar contraseña\', \'Confirm password\')}}\" required=\"\" data-ng-model=\"us.reset.newpass2\" class=\"form-control\"></div><button type=\"submit\" class=\"btn-theme\" data-ng-bind-html=\"switchText(\'Ingresar\', \'Confirm\')\" data-ng-disabled=\"auth.email.lenght < 6\"></button> <a ui-sref=\"forgot\" style=\"margin-bottom: 10px;\" data-ng-bind-html=\"switchText(\'Iniciar sesión\', \'Login\')\" class=\"fhelp pull-left\"></a></form></div></div></div>");
$templateCache.put("app/views/default/defaultcrud.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{$root.currentTitle}}\" ui-first-level=\"{component:\'grid\',model:$root.currentState}\"></uibuilder></div>");
$templateCache.put("app/views/default/main.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{$root.currentTitle}}</h1></div></div><ul class=\"tree-new\"><li class=\"root\" data-ng-repeat=\"level in appMenuItems[currentModule] track by $index\"><a class=\"branch {{$root.currentModule}}\" style=\"text-transform: capitalize\" data-ng-click=\"(level.items)?\'\':stateGo(level.state, level.stateParams)\">{{level.label}}</a><ul data-ng-if=\"level.items\"><li data-ng-repeat=\"subitem in level.items\"><a class=\"branch {{$root.currentModule}}\" style=\"text-transform: capitalize\" data-ng-click=\"stateGo(subitem.state, subitem.stateParams)\">{{subitem.label}}</a><ul data-ng-if=\"subitem.items\"><li data-ng-repeat=\"subitem2 in subitem.items\"><a class=\"{{$root.currentModule}}\" style=\"text-transform: capitalize\" data-ng-click=\"stateGo(subitem2.state, subitem2.stateParams)\">{{subitem2.label}}</a></li></ul></li></ul></li></ul></div>");
$templateCache.put("app/views/default/user-info.html","");
$templateCache.put("app/views/glossary/glosario.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"titulo\">Glosario <button type=\"button\" tooltip=\"Ayuda\" tooltip-placement=\"bottom\" data-ng-click=\"openModal(\'helpmodal\')\" class=\"btn btn-default pull-right\" title=\"Ayuda\"><i class=\"fa fa-question\"></i></button></h1></div></div><div ui-view=\"\"></div><crud state=\"terminos\" rules=\"rules\" table-name=\"terminos\" table-label=\"Terminos\" title-field=\"termino\"></crud></div>");
$templateCache.put("app/views/glossary/home2.html","<form class=\"modal-theme\" data-ng-submit=\"insertRelation($root.tagData)\"><div class=\"modal-header center\"><a type=\"button\" class=\"close cancel\" data-ng-click=\"$dismiss()\" style=\"color: white;\">&times;</a><h4>Agregar etiquetas</h4></div><div class=\"modal-body\"><div class=\"form-group\"><div class=\"row formtags\"><div class=\"col-xs-12\"><label class=\"label-form\">Agregar etiqueta?</label><p>{{$root.tagData}}</p></div></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn-default btn pull-left\" data-ng-click=\"$dismiss()\">Cancelar</button> <button class=\"btn btn-theme pull-right\" type=\"submit\">Insertar</button></div></form>");
$templateCache.put("app/views/glossary/modal-glossary.html","<div class=\"modal-theme\"><div class=\"modal-header\"><a type=\"button\" class=\"close cancel\" data-ng-click=\"$dismiss()\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\" style=\"text-transform: uppercase\"><i class=\"fas fa-tag\"></i> Termino adjunto</h4></div><div class=\"modal-body row\"><div class=\"col-xs-12\"><p>{{title}}</p></div></div></div>");
$templateCache.put("app/views/crudgenerator/crudgenerator_home.html","<div class=\"container-fluid\" style=\"background:white;\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"page-header\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generador de cruds</h1></div></div><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle\">Crear Crud</h4></div><div class=\"col-xs-12 mB20\"><div class=\"col-xs-12 col-md-3\"><a class=\"btn btn-lg\" data-ng-class=\"{\'btn-primary\':crudStep==1 ,\'btn-default\':crudStep!=1}\" data-ng-click=\"changeValue(1)\" style=\"border-radius: inherit;width: 100%;font-size: 14px;\">1. Nombre</a></div><div class=\"col-xs-12 col-md-3\"><a class=\"btn btn-lg\" data-ng-class=\"{\'btn-primary\':crudStep==2 ,\'btn-default\':crudStep!=2}\" data-ng-click=\"changeValue(2)\" style=\"border-radius: inherit;width: 100%;font-size: 14px;\">2. Campos</a></div></div></div><ng-include src=\"\'app/views/crudgenerator/includes/step1.html\'\" data-ng-if=\"crudStep==1\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/step2.html\'\" data-ng-if=\"crudStep==2\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/step3.html\'\" data-ng-if=\"crudStep==3\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/step4.html\'\" data-ng-if=\"crudStep==4\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/addPermission.html\'\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/addSection.html\'\"></ng-include><div class=\"row\"><div class=\"col-xs-12\"><a href=\"\" class=\"btn btn-success\" data-ng-click=\"print(\'data\')\">Imprimir datos de modelo</a></div></div></div>");
$templateCache.put("app/views/crudgenerator/newModel.html","<form action=\"\" name=\"myForm\" data-ng-submit=\"generateCrud()\"><div class=\"row form-group admin-form\"><div class=\"box-options\"><a href=\"\" class=\"btn btn-primary pull-right btn-op\" data-ng-click=\"addField()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar columna</a></div></div><ng-include src=\"\'app/views/crudgenerator/includes/form.html\'\" data-ng-repeat=\"field in data.dataEstructure\"></ng-include><div class=\"row form-group admin-form\"><div class=\"box-options\"><button type=\"submit\" href=\"\" class=\"btn btn-primary pull-right btn-op\" data-ng-disabled=\"data.dataEstructure.length ==0\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generar Crud</button></div></div><ng-include src=\"\'app/views/crudgenerator/includes/addPermission.html\'\"></ng-include><ng-include src=\"\'app/views/crudgenerator/includes/addSection.html\'\"></ng-include></form>lalala");
$templateCache.put("app/views/crudgenerator/test16.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"col-xs-12\"><h1 class=\"page-header\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generador de cruds</h1></div></div><crud state=\"test16\" table-name=\"test16\" table-label=\"test16\" title-field=\"title1\" rules=\"rules\" relations=\"relations\" grid-options=\"gridOptions\" file-upload=\"multiFileUpload\" file-route=\"archivos/imagenes/productos\"></crud></div>");
$templateCache.put("app/views/inventory/invmain.html","<div class=\"container-fluid\" ui-view=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h1>{{currentModule}}</h1></div></div><ul class=\"tree\"><li class=\"root\" data-ng-repeat=\"level in appMenuItems[currentModule] track by $index\"><a style=\"text-transform: capitalize\" data-ng-click=\"(level.items)?\'\':stateGo(level.state, level.stateParams)\">{{level.label}}</a><ul data-ng-if=\"level.items\"><li data-ng-repeat=\"subitem in level.items\"><a style=\"text-transform: capitalize\" data-ng-click=\"stateGo(subitem.state, subitem.stateParams)\">{{subitem.label}}</a><ul data-ng-if=\"subitem.items\"><li data-ng-repeat=\"subitem2 in subitem.items\"><a style=\"text-transform: capitalize\" data-ng-click=\"stateGo(subitem2.state, subitem2.stateParams)\">{{subitem2.label}}</a></li></ul></li></ul></li></ul></div>");
$templateCache.put("app/views/main/home.html","<div class=\"app-main\" customheight=\"\" minus=\"70\"><div class=\"main-button-box\"><div class=\"col-xs-12 main-title\"><h2>Hola, bienvenido a AKNA SUITE</h2><p>Seleccione el módulo al cual desee acceder</p></div><div class=\"main-button\" ui-sref=\"wcms\" data-ng-if=\"$root.appMenuItems.wcms\"><img src=\"../assets/images/icons/icon-web.svg\" alt=\"\"><p>Contenidos web</p></div><div class=\"main-button\" ui-sref=\"crm\" data-ng-if=\"$root.appMenuItems.crm\"><img src=\"../assets/images/icons/icon-crm.svg\" alt=\"\"><p>CRM</p></div><div class=\"main-button\" ui-sref=\"dashboard\" data-ng-if=\"$root.appMenuItems.dashboard\"><img src=\"../assets/images/icons/icon-dashboard-a.svg\" alt=\"\"><p>Dashboard</p></div><div class=\"main-button\" ui-sref=\"inventory\" data-ng-if=\"$root.appMenuItems.inventory\"><img src=\"../assets/images/icons/icon-inventario-a.svg\" alt=\"\"><p>Inventario</p></div><div class=\"main-button\" ui-sref=\"purchases\" data-ng-if=\"$root.appMenuItems.purchases\"><img src=\"../assets/images/icons/icon-compra-a.svg\" alt=\"\"><p>Compras</p></div><div class=\"main-button\" ui-sref=\"sales\" data-ng-if=\"$root.appMenuItems.sales\"><img src=\"../assets/images/icons/icon-venta-a.svg\" alt=\"\"><p>Ventas</p></div><div class=\"main-button\" ui-sref=\"accounting\" data-ng-if=\"$root.appMenuItems.accounting\"><img src=\"../assets/images/icons/icon-contabilidad-a.svg\" alt=\"\"><p>Contabilidad</p></div><div class=\"main-button\" ui-sref=\"admin\" data-ng-if=\"$root.appMenuItems.admin\"><img src=\"../assets/images/icons/icon-admin-a.svg\" alt=\"\"><p>Administración</p></div><div class=\"main-button\" ui-sref=\"ecommerce\" data-ng-if=\"$root.appMenuItems.ecommerce\"><img src=\"../assets/images/icons/icon-vecommerce-a.svg\" alt=\"\"><p>E-Commerce</p></div></div></div>");
$templateCache.put("app/wcms/appxcare/usercitizen.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Usuarios civiles\" ui-first-level=\"wc.usercitizen\"></uibuilder></div>");
$templateCache.put("app/wcms/appxcare/usergovernment.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Usuarios gubernamentales\" ui-first-level=\"wc.usergovernment\"></uibuilder></div>");
$templateCache.put("app/wcms/appxcare/usermedic.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Usuarios medicos\" ui-first-level=\"wc.usermedic\"></uibuilder></div>");
$templateCache.put("app/views/user/changepass.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"view-menu\"><div class=\"view-menu-items\"><ul class=\"submenu\"><li><a href=\"\" ui-sref=\"profile\"><img src=\"../assets/images/iconos/vista-mosaico.svg\" alt=\"\"> {{switchText(\'Perfil\', \'Profile\')}}</a></li><li><a href=\"\" ui-sref=\"changepass\" class=\"active\"><img src=\"../assets/images/iconos/vista-mosaico.svg\" alt=\"\"> {{switchText(\'Cambiar contraseña\', \'Change Password\')}}</a></li></ul></div><div class=\"view-menu-options\"></div></div><div class=\"view-not\" data-ng-show=\"showNots\"><div class=\"context-box\"><div class=\"context-icon\"><img src=\"../assets/images/iconos/icon-project1.svg\" alt=\"\"></div><div class=\"context-title\"><p>Medio ambiente</p></div><a href=\"\" data-ng-click=\"showNots = !showNots\" class=\"btn btn-close glyphicon glyphicon-remove\"></a></div><div class=\"options-box\"><div class=\"option\" data-ng-click=\"notDisplay = 1\" data-ng-class=\"{\'active\':notDisplay === 1}\"><p data-ng-bind-html=\"switchText(\'Detalles\', \'Details\')\"></p></div><div class=\"option\" data-ng-click=\"notDisplay = 2\" data-ng-class=\"{\'active\':notDisplay == 2}\"><p data-ng-bind-html=\"switchText(\'Comentarios\', \'Comments\')\"></p></div></div><div contextheight=\"\" data-ng-if=\"notDisplay === 1\" class=\"context-content\"><div class=\"data-box\"><div class=\"data-label\"><p>Titulo:</p></div><div class=\"data-cont\"><p>Informe del estudio realizado</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Descripcion:</p></div><div class=\"data-cont\"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia.</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Proyecto:</p></div><div class=\"data-cont\"><p>Medio ambiente</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Creado:</p></div><div class=\"data-cont\"><p>1 de junio de 2018</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Actualizado:</p></div><div class=\"data-cont\"><p>1 de junio de 2019</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Autor:</p></div><div class=\"data-cont\"><p>Fernando López</p></div></div></div><div contextheight=\"\" data-ng-if=\"notDisplay == 2\" class=\"context-content\"><div class=\"comment-form\"><form data-ng-submit=\"addComment(newComment)\"><input type=\"text\" data-ng-model=\"newComment\" placeholder=\"{{switchText(\'Añadir un comentario\', \'Add comment\')}}\" class=\"form-control\"> <button type=\"submit\" class=\"btn btn-comment\"><img src=\"../assets/images/iconos/icon-next.svg\" alt=\"\"></button></form></div><div class=\"comment-box\" data-ng-repeat=\"item in comments\" data-ng-class=\"{\'active\':doc[$index]}\" data-ng-show=\"item.active\" data-ng-init=\"doc[$index] = false\"><div class=\"not-date\"><span>{{item.created_at}}, {{item.autor}}</span></div><div class=\"not-icon\"><img src=\"../assets/images/brand.svg\" alt=\"\"></div><div class=\"not-body\" data-ng-click=\"doc[$index] = !doc[$index]\"><p data-ng-class=\"{\'show\':doc[$index]}\" data-ng-bind-html=\"item.comment\"></p><span data-ng-click=\"doc[$index] = !doc[$index]\" data-ng-show=\"!doc[$index] && item.comment.length > 90\" data-ng-bind-html=\"switchText(\'Más...\', \'More...\')\"></span></div><a href=\"\" data-ng-click=\"item.active=false\" class=\"btn btn-close-not glyphicon glyphicon-remove\"></a></div></div></div></div></div><div class=\"container-fluid view-content\"><div class=\"row\"><div class=\"content-title\"><h3 data-ng-bind-html=\"switchText(\'Cambiar contraseña\', \'Change password\')\"></h3></div></div></div><div class=\"container-fluid view-content\"><div class=\"view-user\"><div class=\"forms\"><span class=\"filter-label\">Actual:</span> <input class=\"form-control\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Nueva:</span> <input class=\"form-control\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Verifique:</span> <input class=\"form-control\" name=\"\" id=\"\"></div><div class=\"forms\"><button class=\"btn btn-theme2 pull-right\">Save</button> <button class=\"btn btn-theme2 pull-right\">Cancel</button> <button class=\"btn btn-theme2 pull-right\">Generate</button></div></div></div>");
$templateCache.put("app/views/user/profile.html","<div class=\"container-fluid\"><div class=\"row\"><div class=\"view-menu\"><div class=\"view-menu-items\"><ul class=\"submenu\"><li><a href=\"\" ui-sref=\"profile\" class=\"active\"><img src=\"../assets/images/iconos/vista-mosaico.svg\" alt=\"\"> {{switchText(\'Perfil\', \'Profile\')}}</a></li><li><a href=\"\" ui-sref=\"changepass\"><img src=\"../assets/images/iconos/vista-mosaico.svg\" alt=\"\"> {{switchText(\'Cambiar contraseña\', \'Change Password\')}}</a></li></ul></div><div class=\"view-menu-options\"></div></div><div class=\"view-not\" data-ng-show=\"showNots\"><div class=\"context-box\"><div class=\"context-icon\"><img src=\"../assets/images/iconos/icon-project1.svg\" alt=\"\"></div><div class=\"context-title\"><p>Medio ambiente</p></div><a href=\"\" data-ng-click=\"showNots = !showNots\" class=\"btn btn-close glyphicon glyphicon-remove\"></a></div><div class=\"options-box\"><div class=\"option\" data-ng-click=\"notDisplay = 1\" data-ng-class=\"{\'active\':notDisplay === 1}\"><p data-ng-bind-html=\"switchText(\'Detalles\', \'Details\')\"></p></div><div class=\"option\" data-ng-click=\"notDisplay = 2\" data-ng-class=\"{\'active\':notDisplay == 2}\"><p data-ng-bind-html=\"switchText(\'Comentarios\', \'Comments\')\"></p></div></div><div contextheight=\"\" data-ng-if=\"notDisplay === 1\" class=\"context-content\"><div class=\"data-box\"><div class=\"data-label\"><p>Titulo:</p></div><div class=\"data-cont\"><p>Informe del estudio realizado</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Descripcion:</p></div><div class=\"data-cont\"><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Officia.</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Proyecto:</p></div><div class=\"data-cont\"><p>Medio ambiente</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Creado:</p></div><div class=\"data-cont\"><p>1 de junio de 2018</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Actualizado:</p></div><div class=\"data-cont\"><p>1 de junio de 2019</p></div></div><div class=\"data-box\"><div class=\"data-label\"><p>Autor:</p></div><div class=\"data-cont\"><p>Fernando López</p></div></div></div><div contextheight=\"\" data-ng-if=\"notDisplay == 2\" class=\"context-content\"><div class=\"comment-form\"><form data-ng-submit=\"addComment(newComment)\"><input type=\"text\" data-ng-model=\"newComment\" placeholder=\"{{switchText(\'Añadir un comentario\', \'Add comment\')}}\" class=\"form-control\"> <button type=\"submit\" class=\"btn btn-comment\"><img src=\"../assets/images/iconos/icon-next.svg\" alt=\"\"></button></form></div><div class=\"comment-box\" data-ng-repeat=\"item in comments\" data-ng-class=\"{\'active\':doc[$index]}\" data-ng-show=\"item.active\" data-ng-init=\"doc[$index] = false\"><div class=\"not-date\"><span>{{item.created_at}}, {{item.autor}}</span></div><div class=\"not-icon\"><img src=\"../assets/images/brand.svg\" alt=\"\"></div><div class=\"not-body\" data-ng-click=\"doc[$index] = !doc[$index]\"><p data-ng-class=\"{\'show\':doc[$index]}\" data-ng-bind-html=\"item.comment\"></p><span data-ng-click=\"doc[$index] = !doc[$index]\" data-ng-show=\"!doc[$index] && item.comment.length > 90\" data-ng-bind-html=\"switchText(\'Más...\', \'More...\')\"></span></div><a href=\"\" data-ng-click=\"item.active=false\" class=\"btn btn-close-not glyphicon glyphicon-remove\"></a></div></div></div></div></div><div class=\"container-fluid view-content\"><div class=\"row\"><div class=\"content-title\"><h3 data-ng-bind-html=\"switchText(\'Perfil\', \'Profile\')\"></h3></div></div></div><div class=\"container-fluid view-content\"><div class=\"view-user\"><div class=\"forms\"><span class=\"filter-label\">Nombre:</span> <input class=\"form-control\" data-ng-model=\"currentUser.nombres\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Apellidos:</span> <input class=\"form-control\" data-ng-model=\"currentUser.apellidos\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Email:</span> <input class=\"form-control\" data-ng-model=\"currentUser.email\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Cargo:</span> <input class=\"form-control\" value=\"BI Engineer\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Area:</span> <input class=\"form-control\" value=\"BI\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Profesión:</span> <input class=\"form-control\" value=\"BI Engineer\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Edad:</span> <input class=\"form-control\" value=\"29\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Punto focal:</span> <input class=\"form-control\" value=\"Si\" name=\"\" id=\"\"></div><div class=\"forms\"><span class=\"filter-label\">Toma desiciones:</span> <input class=\"form-control\" value=\"Si\" name=\"\" id=\"\"></div><div class=\"forms\"><button class=\"btn btn-theme2 pull-right\">Save</button> <button class=\"btn btn-theme2 pull-right\">Cancel</button></div></div></div>");
$templateCache.put("app/wcms/config/mailinginnerreceiver.html","<div class=\"container-fluid\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"Receptores de correo\" ui-first-level=\"{component:\'grid\', model:\'mailinginnerreceiver\'}\"></uibuilder></div></div>");
$templateCache.put("app/wcms/config/webconfig.html","<div class=\"container-fluid\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"Configuraciones\" ui-first-level=\"{component:\'grid\', model:\'webconfig\'}\"></uibuilder></div></div>");
$templateCache.put("app/wcms/tatasapp/marker.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Marcadores\" ui-first-level=\"wc.marker\"></uibuilder></div>");
$templateCache.put("app/wcms/tatasapp/markercategory.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Categorización de marcadores\" ui-first-level=\"wc.markercategory\"></uibuilder></div>");
$templateCache.put("app/wcms/tatasapp/markeruser.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Registro de actividad\" ui-first-level=\"wc.markeruser\"></uibuilder></div>");
$templateCache.put("app/wcms/contents/contents.html","<div class=\"container-fluid\" data-ng-if=\"wc.crudReady && wc.type==\'dinamicGustu\'\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{\'Secciones - \'+wc.model}}\" ui-first-level=\"wc.webgsection\"></uibuilder></div></div><div class=\"container-fluid\" data-ng-if=\"wc.crudReady && wc.type==\'dinamic\'\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{wc.model}}\" ui-first-level=\"{component:\'grid\',model:wc.model}\"></uibuilder></div></div><div class=\"container-fluid\" data-ng-if=\"wc.crudReady && wc.type==\'fixed\'\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{\'Contenidos fijos generales\'}}\" ui-first-level=\"wc.contenidoRules\"></uibuilder></div></div>");
$templateCache.put("app/wcms/contents/dinamicdefault.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{$root.currentState}}\" ui-first-level=\"{component:\'grid\':model:$root.currentState}}\"></uibuilder></div><div ui-view=\"\"></div>");
$templateCache.put("app/wcms/contents/fixedcontent.html","<!DOCTYPE html><html lang=\"en\"><head><meta charset=\"UTF-8\"><title></title></head><body></body></html>");
$templateCache.put("app/wcms/contents/webadversiting-cinema.html","<div class=\"container-fluid\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"Publicidad Sitio Web\" ui-first-level=\"wc.adversitingCinema\"></uibuilder></div></div>");
$templateCache.put("app/wcms/contents/webadversiting-online.html","<div class=\"container-fluid\"><div class=\"container-fluid\"><uibuilder ui-crud-title=\"Publicidad online\" ui-first-level=\"wc.adversitingOnline\"></uibuilder></div></div>");
$templateCache.put("app/wcms/contents/webadversiting.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Publicidad\" ui-first-level=\"wc.webadversiting\"></uibuilder></div>");
$templateCache.put("app/wcms/contents/webcollection.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Secciones\" ui-first-level=\"wc.webcollection\"></uibuilder></div>");
$templateCache.put("app/wcms/contents/webcontext.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Plantillas\" ui-first-level=\"wc.webcontext\"></uibuilder></div>");
$templateCache.put("app/wcms/contents/webroute.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Manuales\" ui-first-level=\"wc.webroute\"></uibuilder></div>");
$templateCache.put("app/wcms/contents/websection.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"{{wc.webrouteParam}}\" ui-first-level=\"wc.websection\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productbrand/productbrand.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de marcas de productos\" ui-first-level=\"{component:\'grid\',model:\'productbrand\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productbatch/productbatch.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de lotes de productos\" ui-first-level=\"{component:\'grid\',model:\'productbatch\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productcategory/productcategory.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de categorias productos\" ui-first-level=\"{component:\'grid\',model:\'productcategory\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productitem/productitem.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de productos\" ui-first-level=\"{component:\'grid\',model:\'product\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productgroup/productgroup.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de grupos productos\" ui-first-level=\"{component:\'grid\',model:\'productgroup\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productmeasure/productmeasure.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de medidas productos\" ui-first-level=\"{component:\'grid\',model:\'productmeasure\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/productline/productline.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de lineas productos\" ui-first-level=\"{component:\'grid\',model:\'productline\'}\"></uibuilder></div>");
$templateCache.put("app/inventory/admin/warehouse/warehouse.html","<div class=\"container-fluid\"><uibuilder ui-crud-title=\"Gestion de almacenes\" ui-first-level=\"{component:\'grid\',model:\'warehouse\'}\"></uibuilder></div>");
$templateCache.put("app/scripts/directives/appcontextmenu/appcontextmenu.html","<div><a href=\"\" class=\"info-btn-close {{$parent.currentModule}}\" tooltip-placement=\"{{\'left\'}}\" uib-tooltip=\"Detalle\" data-ng-class=\"{\'hide\': $parent.infoMenu}\" data-ng-click=\"$parent.showInfoMenu()\"><i class=\"fas fa-info-circle\"></i></a><div data-ng-class=\"{ \'active\': $parent.infoMenu }\" class=\"app-info-menu {{$parent.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$parent.infoMenu}\" data-ng-click=\"$parent.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a></div></div>");
$templateCache.put("app/scripts/directives/datepicker/datepicker.html","<p class=\"input-group\">{{placeholder}} <input type=\"text\" style=\"width: 100%;\" class=\"form-control\" datepicker-popup=\"{{format}}\" ng-model=\"ngModel\" ng-change=\"ngChange\" ng-required=\"ngRequired\" is-open=\"opened\" datepicker-options=\"dateOptions\" date-disabled=\"disabled(date, mode)\" close-text=\"Close\"> <span class=\"input-group-btn\"><button class=\"btn form-control\" style=\"min-width: 35px;border-left: 0;\" ng-click=\"open($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p>");
$templateCache.put("app/scripts/directives/appmenu/appmenu.html","<div><script type=\"text/ng-template\" id=\"userPopover.html\"><ul class=\"menu-items\"> <li><a href=\"\" style=\"font-weight: bold;text-transform: uppercase;\"> {{$root.currentUser.firstname+\' \'+$root.currentUser.lastname}}</a></li> <li><a ui-sref=\"profile\">Ver perfil</a></li> <li><a data-ng-click=\"logout()\">Cerrar sesión</a></li> </ul></script><script type=\"text/ng-template\" id=\"appPopover.html\"><div class=\"app-popover\"> <div class=\"main-button\" ui-sref=\"wcms\" data-ng-if=\"$root.appMenuItems.wcms\"> <img src=\"../assets/images/icons/icon-web.svg\" alt=\"\"> <p>Contenidos web</p> </div> <div class=\"main-button\" ui-sref=\"crm\" data-ng-if=\"$root.appMenuItems.crm\"> <img src=\"../assets/images/icons/icon-crm.svg\" alt=\"\"> <p>CRM</p> </div> <div class=\"main-button\" ui-sref=\"dashboard\" data-ng-if=\"$root.appMenuItems.dashboard\"> <img src=\"../assets/images/icons/icon-dashboard-a.svg\" alt=\"\"> <p>Dashboard</p> </div> <div class=\"main-button\" ui-sref=\"inventory\" data-ng-if=\"$root.appMenuItems.inventory\"> <img src=\"../assets/images/icons/icon-inventario-a.svg\" alt=\"\"> <p>Inventario</p> </div> <div class=\"main-button\" ui-sref=\"purchases\" data-ng-if=\"$root.appMenuItems.purchases\"> <img src=\"../assets/images/icons/icon-compra-a.svg\" alt=\"\"> <p>Compras</p> </div> <div class=\"main-button\" ui-sref=\"sales\" data-ng-if=\"$root.appMenuItems.sales\"> <img src=\"../assets/images/icons/icon-venta-a.svg\" alt=\"\"> <p>Ventas</p> </div> <div class=\"main-button\" ui-sref=\"accounting\" data-ng-if=\"$root.appMenuItems.accounting\"> <img src=\"../assets/images/icons/icon-contabilidad-a.svg\" alt=\"\"> <p>Contabilidad</p> </div> <div class=\"main-button\" ui-sref=\"admin\" data-ng-if=\"$root.appMenuItems.admin\"> <img src=\"../assets/images/icons/icon-admin-a.svg\" alt=\"\"> <p>Administración</p> </div> </div></script><div class=\"app-menu {{menuClass}}\"><a href=\"\" class=\"menu-btn burger\" data-ng-if=\"currentState != \'home\'\" data-ng-click=\"showAppMenu()\"><i data-ng-if=\"!appMenu\" class=\"fas fa-bars\"></i> <i data-ng-if=\"appMenu\" class=\"fas fa-arrow-left\"></i></a> <a href=\"\" class=\"menu-btn profile\" popover-placement=\"{{\'right\'}}\" uib-popover-template=\"userPopover.templateUrl\"><i class=\"fas fa-user-circle\"></i></a><a href=\"\" class=\"menu-btn help\"><i class=\"fas fa-question-circle\"></i></a> <a href=\"\" class=\"menu-btn apps\" popover-placement=\"{{\'right-bottom\'}}\" uib-popover-template=\"appPopover.templateUrl\"><i class=\"fas fa-th\"></i></a></div><div class=\"menu-box {{menuClass}}\" data-ng-class=\"{\'showmenu\': appMenu}\"><a href=\"\" class=\"menu-btn burger\" data-ng-if=\"currentState != \'home\'\" data-ng-click=\"showAppMenu()\"><i data-ng-if=\"appMenu\" class=\"fas fa-arrow-left\"></i></a><div class=\"menu-header {{menuClass}}\"><h5 style=\"text-transform: uppercase\">{{menuTitle}}</h5><div class=\"col-xs-12\" style=\"padding: 0\"><div class=\"input-group\"><input type=\"text\" class=\"form-control\" placeholder=\"Search for...\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" style=\"padding: 0 5px;\" type=\"button\"><i class=\"fas fa-search\"></i></button></span></div></div></div><div class=\"menu-level {{menuClass}}\" data-ng-show=\"$index<=currentLevel\" data-ng-repeat=\"level in menuLevels track by $index\"><a class=\"menu-back\" data-ng-click=\"showParent()\" data-ng-show=\"currentLevel>0 && $index>0\"><i class=\"fas fa-long-arrow-alt-left\"></i></a><ul class=\"menu-items {{menuClass}}\"><li data-ng-repeat=\"item in level\"><hr data-ng-if=\"item.hr\" style=\"margin: 5px 0;\"><a href=\"\" data-ng-click=\"(item.items)?selectItems(item, $parent.$index ):stateGo(item.state, item.stateParams)\">{{item.label}} <i data-ng-show=\"item.items && $parent.$index ==currentLevel\" class=\"fas fa-caret-right\"></i></a></li></ul></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/uibuilder.html","<div class=\"container-fluid\"><a href=\"\" class=\"info-btn-close {{$root.currentModule}}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"fas fa-info-circle\"></i></a><uicontextualmenu data-ng-if=\"$root.infoMenu\" model-name=\"{{$root.uiConf.level[0].model}}\"></uicontextualmenu><div class=\"crud-grid-header\"><div class=\"grid-title\"><h3 style=\"text-transform: uppercase\">{{uiCrudTitle}}</h3></div></div><div data-ng-repeat=\"view in $root.uiConf.level\"><uicrudgrid data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'grid\'\" model-name=\"{{view.model}}\"></uicrudgrid><uidefaultform data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uidefaultform\'\" level=\"$index\" model-name=\"{{view.model}}\"></uidefaultform><uipiker data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uipiker\'\" level=\"$index\" custom-params=\"$index\" model-name=\"{{view.model}}\"></uipiker><uipayment data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uipayment\'\" level=\"$index\" model-name=\"{{view.model}}\"></uipayment><uiinvoice data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiinvoice\'\" level=\"$index\" model-name=\"{{view.model}}\"></uiinvoice><uiexcel data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiexcel\'\" level=\"$index\" model-name=\"{{view.model}}\"></uiexcel><uiticket data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uiticket\'\" level=\"$index\" model-name=\"{{view.model}}\"></uiticket><uireport data-ng-if=\"$root.uiConf.currentLevel >= $index && view.component == \'uireport\'\" level=\"$index\" model-name=\"{{view.model}}\"></uireport></div></div>");
$templateCache.put("app/scripts/directives/uiBreadcrumbs/uiBreadcrumbs.tpl.html","<ol class=\"breadcrumb\"><li ng-repeat=\"crumb in breadcrumbs\" ng-class=\"{active: $last}\"><a ui-sref=\"{{ crumb.route}}\" class=\"{{currentModule}}\" ui-sref-opts=\"{reload: true}\" style=\"text-transform: capitalize\" ng-if=\"!$last\" data-ng-bind-html=\"crumb.displayName\"></a> <span style=\"text-transform: capitalize\" ng-show=\"!$last\">&nbsp;</span></li></ol>");
$templateCache.put("app/views/directives/crud/crud.html","<div class=\"row mT10 mB30\"><div data-ng-if=\"true\" class=\"mB40\"><ng-include src=\"\'app/views/directives/crud/crudGrid.html\'\" data-ng-if=\"crudView==\'crudGrid\'\"></ng-include><ng-include src=\"\'app/views/directives/crud/crudForm.html\'\" data-ng-if=\"crudView==\'crudForm\'\"></ng-include><ng-include src=\"\'app/views/directives/crud/crudView.html\'\" data-ng-if=\"crudView==\'crudView\'\"></ng-include><ng-include src=\"\'app/views/directives/crud/crudPassword.html\'\" data-ng-if=\"crudView==\'crudPassword\'\"></ng-include><ng-include src=\"\'app/views/directives/crud/crudDelete.html\'\"></ng-include></div></div>");
$templateCache.put("app/views/directives/crud/crudDelete.html","<div class=\"modal fade modal-delete\" id=\"crudDeleteModal\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\">Eliminar {{crudTitle}}</h4></div><div class=\"modal-body\"><p>¿Esta seguro de eliminar este registro y su contenido relacionado?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button> <button type=\"button\" class=\"btn btn-delete\" data-ng-click=\"updateRegister(tabla,selected,actionType);$dismiss()\">Confirmar</button></div></div></div></div>");
$templateCache.put("app/views/directives/crud/crudDownloadFields.html","<form action=\"\" data-ng-submit=\"reloadData()\"><div class=\"col-xs-12 col-md-4 menureport\" style=\"justify-content: flex-start\"><p class=\"text-info reportlabel\" style=\"width: 58px;text-align: left\">Desde</p><mydatepicker ng-model=\"filters.dateFrom\" ng-required=\"true\" date-options=\"dateOptions\" opened=\"opened1\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12 col-md-4 menureport\" style=\"justify-content: flex-start\"><p class=\"text-info reportlabel\" style=\"width: 58px;text-align: left\">Hasta</p><mydatepicker ng-model=\"filters.dateTo\" ng-required=\"true\" date-options=\"dateOptions\" opened=\"opened2\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12 col-md-4 menureport\"><button class=\"btn btn-primary pull-left\" type=\"submit\" data-ng-if=\"!csvReady\" style=\"width: 140px;\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Filtrar por fecha</button></div><div class=\"col-xs-12 mB20\"><hr style=\"margin: 0px 0px 10px 0px;\"><a href=\"\" class=\"btn btn-primary pull-right\" data-ng-click=\"reloadData(true)\" style=\"width: 140px;\"><i class=\"fa fa-cloud-download\" aria-hidden=\"true\"></i> Generar csv</a> <a href=\"{{dataset.downloadLink}}\" class=\"pull-right\" target=\"_blank\" data-ng-if=\"dataset.downloadLink !=\'\' && downloadReady\" style=\"margin: 8px 15px;\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Documento generado</a> <img src=\"images/loader_blue.gif\" data-ng-if=\"(dataset.downloadLink.length > 0 && !downloadReady)\" class=\"mR20 pull-right\" alt=\"\" style=\"width: 34px;\"></div></form>");
$templateCache.put("app/views/directives/crud/crudForm.html","<div class=\"row\"><div class=\"pL30 pR30\"><form action=\"\" name=\"myForm\" data-ng-submit=\"updateRegister(tabla,selected,actionType)\"><div class=\"row\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle\" data-ng-if=\"actionType==\'edit\'\">{{crudTitle}}</h4><h4 class=\"header-subtitle\" data-ng-if=\"actionType==\'new\'\">Agregar registro</h4><h4 class=\"header-subtitle\" data-ng-if=\"actionType==\'password\'\">Modificar contraseña</h4></div></div><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties | orderBy:\'order\'\" data-ng-if=\"actionType!=\'password\' && ( (dato.active && dato.activeForCreate==null && dato.activeForEdit == null) || (dato.active && !dato.activeForCreate && dato.activeForEdit && actionType==\'edit\') || (dato.active && dato.activeForCreate && !dato.activeForEdit && actionType==\'new\'))\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle-2\" data-ng-show=\"dato.subtitle\" render-html=\"dato.subtitle\"></h4><hr data-ng-if=\"dato.hr\" style=\"margin: 10px 0 20px 0;\"></div><div class=\"row\" data-ng-show=\"!dato.groupedBy || (dato.groupedBy == lan)\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind-html=\"dato.invalid+dato.label\" class=\"label-form\" data-ng-class=\"{\'text-danger\':dato.invalid}\"></label> <small class=\"text-info\" data-ng-if=\"dato.helpText\" style=\"width: 100%;float: left;text-align: right; padding-right: 40px;\" data-ng-bind-html=\"dato.helpText\"></small></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><input class=\"form-control\" type=\"text\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'text\'\" name=\"{{dato.name}}\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, selected[dato.name] ,dato.name)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'email\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'number\'\" data-ng-disabled=\"dato.disabled\"><div data-ng-if=\"dato.type==\'date\'\"><mydatepicker ng-model=\"selected[dato.name]\" date-options=\"dateOptions\" opened=\"opened\" data-ng-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div data-ng-if=\"dato.type==\'password\'\" data-ng-init=\"cloneField(selected[dato.name])\"><input class=\"form-control\" type=\"password\" ng-change=\"validatePassword(dato.name+1,dato.name+2)\" id=\"{{dato.name+1}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"password\" ng-change=\"validatePassword(dato.name+1,dato.name+2)\" id=\"{{dato.name+2}}\" data-ng-required=\"dato.required\" data-ng-model=\"copyField\" data-ng-if=\"dato.type==\'password\'\" data-ng-disabled=\"dato.disabled\"></div><textarea class=\"form-control\" data-ng-model=\"selected[dato.name]\" data-ng-required=\"dato.required\" style=\"min-height: 34px\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\n            </textarea><text-angular data-ng-model=\"selected[dato.name]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"dato.toolbar\" data-ng-disabled=\"dato.disabled\"></text-angular><div class=\"flex\" style=\"justify-content: flex-start;align-items: flex-start;\" data-ng-if=\"dato.type==\'Allfiles\'\"><button style=\"max-height: 34px\" class=\"btn btn-theme\" data-ng-if=\"!dato.disabled\" ngf-select=\"\" ng-model=\"selected.file\" id=\"file\" name=\"file2\" ngf-max-size=\"4096MB\"><i class=\"fa fa-cloud-upload mR5\" aria-hidden=\"true\"></i> Cargar archivo</button><div data-ng-if=\"selected.tipo == 1\"><a data-ng-if=\"actionType==\'edit\' && selected.file.name==null\" class=\"mL20\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><img data-ng-src=\"{{selected[dato.name]}}\" style=\"max-height: 100px\"></a> <img data-ng-if=\"selected.file.name!=null\" ngf-thumbnail=\"selected.file || \'/thumb.jpg\'\" style=\"margin-left:10px;height: 100px;\"></div><div data-ng-if=\"selected.tipo == 2\"><a data-ng-if=\"actionType==\'edit\' && selected.file.name==null\" class=\"mL20\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><p style=\"max-height: 100px\">Abrir documento</p></a></div><div data-ng-if=\"selected.tipo == 3\"><video controls=\"\" ngf-src=\"selected.file\" style=\"max-height: 200px; margin-left: 10px;\"></video><video heigth=\"400\" controls=\"\" data-ng-if=\"actionType==\'edit\' && selected.file.name==null\" data-ng-src=\"{{selected[dato.name]}}\" style=\"height: 200px\"></video></div><span class=\"text-info flex mL10 mT10\" style=\"overflow: hidden; text-align: left; justify-content: flex-start\" data-ng-if=\"actionType==\'new\' || selected.file.name!=null\"><i class=\"fa fa-check mR5\" aria-hidden=\"true\" data-ng-if=\"actionType==\'new\' && selected.file!=null\"></i>{{selected.file.name}}</span></div><div class=\"flex\" style=\"justify-content: flex-start;align-items: flex-start;\" data-ng-if=\"dato.type==\'file\'\"><button style=\"max-height: 34px\" class=\"btn btn-theme\" data-ng-if=\"dato.type==\'file\'\" data-ng-change=\"print(selected)\" ngf-select=\"\" ng-model=\"selected[(fileUpload===\'true\')?\'file\':dato.name]\" id=\"{{[(fileUpload===\'true\')?\'file\':dato.name]}}\" name=\"{{dato.name}}\" ngf-pattern=\"\'.jpg,.jpeg,.png,.gif,.svg\'\" ngf-accept=\"\'image/jpg,image/jpeg,image/png,image/gif,image/svg + xml\'\" ngf-max-size=\"4096MB\"><i class=\"fa fa-cloud-upload mR5\" aria-hidden=\"true\"></i> Cargar imagen</button> <a data-ng-if=\"actionType==\'edit\' && selected[(fileUpload===\'true\')?\'file\':dato.name].name==null\" class=\"mL20\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><img data-ng-src=\"{{selected[dato.name]}}\" style=\"max-height: 100px\"></a> <img data-ng-if=\"selected[(fileUpload===\'true\')?\'file\':dato.name].name!=null\" ngf-thumbnail=\"selected[(fileUpload===\'true\')?\'file\':dato.name] || \'/thumb.jpg\'\" style=\"margin-left:10px;height: 100px;\"> <span class=\"text-info flex mL10 mT10\" style=\"overflow: hidden; text-align: left; justify-content: flex-start\" data-ng-if=\"actionType==\'new\' || selected[(fileUpload===\'true\')?\'file\':dato.name].name!=null\"><i class=\"fa fa-check mR5\" aria-hidden=\"true\" data-ng-if=\"actionType==\'new\' && selected[(fileUpload===\'true\')?\'file\':dato.name]!=null\"></i> {{selected[(fileUpload===\'true\')?\'file\':dato.name].name}}</span></div><div class=\"flex\" style=\"justify-content: flex-start;align-items: flex-start;\" data-ng-if=\"dato.type==\'pdf\'\"><button style=\"max-height: 34px\" class=\"btn btn-theme\" data-ng-if=\"dato.type==\'pdf\'\" ngf-select=\"\" ng-model=\"selected[(fileUpload===\'true\')?\'file\':dato.name]\" id=\"file\" ngf-pattern=\"\'.pdf,.csv,.xls,.xlsx\'\" ngf-accept=\"\'application/pdf,application/vnd.ms-excel,application/csv\'\" ngf-max-size=\"4096MB\"><i class=\"fa fa-cloud-upload mR5\" aria-hidden=\"true\"></i> Cargar documento</button> <a data-ng-if=\"actionType==\'edit\' && selected[(fileUpload===\'true\')?\'file\':dato.name].name==null\" class=\"mL20\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><p style=\"max-height: 100px\">Abrir documento</p></a> <span class=\"text-info flex mL10 mT10\" style=\"overflow: hidden; text-align: left; justify-content: flex-start\" data-ng-if=\"actionType==\'new\' || selected[(fileUpload===\'true\')?\'file\':dato.name].name!=null\"><i class=\"fa fa-check mR5\" aria-hidden=\"true\" data-ng-if=\"actionType==\'new\' && selected[(fileUpload===\'true\')?\'file\':dato.name]!=null\"></i> {{selected[(fileUpload===\'true\')?\'file\':dato.name].name}}</span></div><div class=\"flex\" style=\"justify-content: flex-start;align-items: flex-start;\" data-ng-if=\"dato.type==\'video\'\"><button style=\"max-height: 34px\" class=\"btn btn-theme\" data-ng-if=\"!dato.disabled\" ngf-select=\"\" ng-model=\"selected.file\" id=\"file\" ngf-pattern=\"\'video/*\'\" ngf-accept=\"\'video/*\'\" ngf-max-size=\"4096MB\"><i class=\"fa fa-cloud-upload mR5\" aria-hidden=\"true\"></i> Cargar video</button><video controls=\"\" ngf-src=\"selected.file\" style=\"max-height: 200px; margin-left: 10px;\"></video><video heigth=\"400\" controls=\"\" data-ng-if=\"actionType==\'edit\' && selected.file.name==null\" data-ng-src=\"{{selected[dato.name]}}\" style=\"height: 200px\"></video><span class=\"text-info flex mL10 mT10\" style=\"overflow: hidden; text-align: left; justify-content: flex-start\" data-ng-if=\"actionType==\'new\' || selected.file.name!=null\"><i class=\"fa fa-check mR5\" aria-hidden=\"true\" data-ng-if=\"actionType==\'new\' && selected.file!=null\"></i>{{selected.file.name}}</span></div><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-init=\"(dato.default)?selected[dato.name]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange(dataset,selected)\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'select\'\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'selectMultiple\'\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><div class=\"flex mT5\" style=\"justify-content: flex-start\"><input type=\"checkbox\" ng-model=\"selected[dato.name]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.type==\'checkbox\'\" style=\"width: 20px;height: 20px;margin: 0;\" ng-checked=\"selected[dato.name]==1\" ng-true-value=\"1\" ng-false-value=\"0\"> <span class=\"text-info mL10\" data-ng-if=\"dato.type==\'checkbox\' && selected[dato.name]==1\">{{dato.labelChecked}}</span> <span class=\"text-info mL10\" data-ng-if=\"dato.type==\'checkbox\' && selected[dato.name]==0\">{{dato.labelUnchecked}}</span></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type==\'mapLon\' && actionType==\'edit\'\" class=\"mT20\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><ng-map center=\"-16.495859,-68.133529\" data-ng-if=\"dato.type==\'mapLon\' && actionType==\'new\'\" class=\"mT20\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><switch-customized-crud id=\"selected[dato.name]\" name=\"selected[dato.name]\" ng-model=\"selected[dato.name]\" data-ng-change=\"dato.ngChange(selected,dato, dataset)\" data-ng-init=\"dato.ngInit(selected,dato, dataset)\" required=\"dato.required\" disabled=\"dato.disabled\" class=\"green\" on=\"{{dato.on}}\" off=\"{{dato.off}}\" data-ng-if=\"dato.type==\'switchCustom\'\"></switch-customized-crud><switch id=\"selected[dato.name]\" name=\"selected[dato.name]\" ng-model=\"selected[dato.name]\" data-ng-change=\"dato.ngChange(selected,dato)\" required=\"dato.required\" disabled=\"dato.disabled\" class=\"green\" data-ng-if=\"dato.type==\'switch\'\" on=\"{{dato.on}}\" off=\"{{dato.off}}\"></switch></div></div></div><div class=\"form-group\" data-ng-if=\"tableName==\'usuarios\' && actionType==\'new\'\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label class=\"label-form\">Contraseña</label> <small data-ng-class=\"{\'text-info\': (selected.password || selected.password.length > 10),\'text-warning\': (!selected.password || selected.password.length < 10) }\" style=\"width: 100%;float: left;text-align: right; padding-right: 40px;\">*Se requieren al menos 8 caracteres</small></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><div data-ng-init=\"cloneField(selected.password)\"><input class=\"form-control\" type=\"password\" placeholder=\"Ingrese su contraseña\" ng-change=\"validatePassword(\'password1\',\'password2\')\" id=\"{{\'password1\'}}\" data-ng-required=\"true\" maxlength=\"20\" data-ng-model=\"selected.password\"> <input class=\"form-control mT5\" type=\"password\" placeholder=\"Repita su contraseña\" ng-change=\"validatePassword(\'password1\',\'password2\')\" maxlength=\"20\" id=\"{{\'password2\'}}\" data-ng-required=\"true\" data-ng-model=\"copyField\"></div></div></div><div class=\"row mT10\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label class=\"label-form\">Generar contraseña automática</label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><p class=\"form-control\" data-ng-if=\"passGeneratorReady\">{{selected.password}}</p><a href=\"\" class=\"btn btn-primary\" data-ng-click=\"passGenerator(8)\">Generar Contraseña</a></div></div></div><div class=\"form-group\" data-ng-if=\"tableName==\'usuarios\' && actionType==\'password\'\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label class=\"label-form\">Contraseña</label> <small data-ng-class=\"{\'text-info\': (selected.password || selected.password.length > 10),\'text-warning\': (!selected.password || selected.password.length < 10) }\" style=\"width: 100%;float: left;text-align: right; padding-right: 40px;\">*Se requieren al menos 8 caracteres</small></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><div data-ng-init=\"cloneField(selected.password)\"><input class=\"form-control\" type=\"password\" placeholder=\"Ingrese una nueva contraseña\" ng-change=\"validatePassword(\'password1\',\'password2\')\" id=\"{{\'password1\'}}\" data-ng-required=\"true\" maxlength=\"20\" data-ng-model=\"selected.password\"> <input class=\"form-control mT5\" type=\"password\" placeholder=\"Repita una nueva contraseña\" ng-change=\"validatePassword(\'password1\',\'password2\')\" id=\"{{\'password2\'}}\" data-ng-required=\"true\" maxlength=\"20\" data-ng-model=\"copyField\"></div></div></div><div class=\"row mT10\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label class=\"label-form\">Generar contraseña automática</label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><p class=\"form-control\" data-ng-if=\"passGeneratorReady\">{{selected.password}}</p><a href=\"\" class=\"btn btn-primary\" data-ng-click=\"passGenerator(8)\">Generar Contraseña</a></div></div></div><div><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"resetRegisterAndGoBack();\">Cancelar</button> <button type=\"submit\" class=\"btn btn-primary pull-right\" data-ng-if=\"actionType!=\'password\'\" data-ng-disabled=\"actionType==\'new\' && tableName ==\'usuarios\' && selected.password.length < 8\">Guardar</button> <button type=\"submit\" class=\"btn btn-primary pull-right\" data-ng-if=\"actionType==\'password\'\">Modificar contraseña.</button><button type=\"button\" class=\"btn btn-default pull-right mR10\" data-ng-click=\"resetRegister()\">Revertir</button></div></form></div></div>");
$templateCache.put("app/views/directives/crud/crudGrid.html","<div data-ng-if=\"!hideHeader\"><div class=\"col-xs-12 col-sm-12 col-md-4\" data-ng-if=\"dataset.options.create && fieldsLoaded\"><a class=\"btn btn-primary\" ui-sref=\"{{state}}.new\" data-ng-click=\"showGrid(1);chooseRegister(\'\',\'new\')\" title=\"Editar\"><i class=\"fa fa-plus\"></i> Agregar Registro</a></div><div class=\"col-xs-12 col-sm-6 flex\" data-ng-class=\"{\'col-md-4\':dataset.options.create,\'col-md-8\':!dataset.options.create}\" data-ng-if=\"fieldsLoaded\" style=\"display:flex;justify-content: flex-start; align-items: center\"><p class=\"text-info\" style=\"margin-bottom:0;margin-right: 15px;font-size: 12px;\">Mostrando</p><select data-ng-model=\"filters.per_page\" data-ng-change=\"changePerPage()\" class=\"form-control\" style=\"max-width: 75px;\"><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div><div class=\"col-xs-12 col-sm-6 col-md-4\" data-ng-if=\"fieldsLoaded\"><div class=\"form-group input-group\"><input class=\"form-control\" type=\"search\" placeholder=\"Buscar por {{(titleFieldLabel)?titleFieldLabel:titleField}}\" data-ng-model=\"filters.comparaciones[0].dato\" data-ng-change=\"search()\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-click=\"search()\" type=\"button\"><i class=\"fa fa-search\"></i></button></span></div></div><ng-include src=\"\'views/directives/crud/crudDownloadFields.html\'\" data-ng-if=\"downloadData && fieldsLoaded\"></ng-include></div><div><div class=\"col-xs-12\" style=\"overflow-x: scroll;\"><table class=\"table table-hover table-striped\" style=\"margin: 0;margin-bottom: 40px;\"><thead><tr><th style=\"max-width: 130px; width: 100px\" data-ng-hide=\"dataset.options.hideTools\">OPCIONES</th><th data-ng-repeat=\"modelProperties in dataset.modelProperties\" data-ng-click=\"sortBy(modelProperties.name)\" data-ng-class=\"{active: propertyName == modelProperties.name}\" data-ng-if=\"modelProperties.activeGrid && modelProperties.name !=\'password\'\" style=\"text-transform: uppercase\"><div class=\"flex\" style=\"justify-content: space-between\"><div><p data-ng-bind-html=\"modelProperties.label\" style=\"margin: 0; padding: 0;\"></p></div><div class=\"pull-right\"><i data-ng-show=\"propertyName == \'\' || propertyName != modelProperties.name\" class=\"fa fa-sort mL5\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == modelProperties.name && !reverse\" class=\"fa fa-sort-desc mL5\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == modelProperties.name && reverse\" class=\"fa fa-sort-asc mL5\" aria-hidden=\"true\"></i></div></div></th></tr></thead><tbody><tr ng-repeat=\"register in dataset.resultado.data\" data-ng-if=\"fieldsLoaded\"><td class=\"center\" data-ng-hide=\"dataset.options.hideTools\"><div class=\"btn-group flex\" style=\"justify-content: center\"><button type=\"button\" data-ng-if=\"dataset.relations && dataset.options.relationsLinks && dataset.relations.hasMany.length>0\" class=\"dropdown-toggle btn btn-default\" tooltip=\"Más\" tooltip-placement=\"right\" data-toggle=\"dropdown\" style=\"padding-left: 12px; padding-right: 12px;\"><i class=\"fa fa-ellipsis-h\" aria-hidden=\"true\"></i></button><ul class=\"dropdown-menu dropdown-user\"><li data-ng-repeat=\"relations in dataset.relations.hasMany\"><a ui-sref=\"{{relations.table}}\" data-ng-if=\"relations.redirectToSection!=null&&relations.redirectToSection\" data-ng-click=\"getSubtitile(register.nombre); setFilter(relations.table,register.id,register[titleField], titleField);\"><i class=\"fa fa-plus\"></i> Administrar {{relations.tableLabel==null?relations.table:relations.tableLabel}}</a></li></ul><div data-ng-if=\"dataset.options.customButton\" render-html=\"dataset.options.customButton\"></div><button type=\"button\" class=\"btn btn-default\" ui-sref=\"{{state}}.select({id:register.id})\" data-ng-click=\"chooseRegister(register,\'edit\')\" data-ng-if=\"dataset.options.update\" tooltip=\"Editar\" tooltip-placement=\"bottom\"><i class=\"fa fa-pencil\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-default\" ui-sref=\"{{state}}.view({id:register.id})\" data-ng-click=\"showGrid(3);chooseRegister(register,\'edit\')\" data-ng-if=\"dataset.options.read\" tooltip=\"Ver\" tooltip-placement=\"bottom\"><i class=\"fa fa-eye\"></i></button> <button type=\"button\" class=\"btn btn-default\" data-toggle=\"modal\" data-target=\"#crudDeleteModal\" data-ng-click=\"chooseRegister(register,\'delete\')\" data-ng-if=\"dataset.options.delete\" data-ng-disabled=\"register.email==currentUser.email && tableName==\'usuarios\'\" tooltip=\"Eliminar\" tooltip-placement=\"bottom\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i></button> <button type=\"button\" class=\"btn btn-default\" ui-sref=\"{{state}}.select({id:register.id})\" data-ng-click=\"showGrid(1);chooseRegister(register,\'password\')\" data-ng-if=\"tableName == \'usuarios\'\" tooltip=\"Cambiar contraseña\" tooltip-placement=\"bottom\"><i class=\"fa fa-unlock-alt\" aria-hidden=\"true\"></i></button></div></td><td data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"dato.activeGrid && dato.name !=\'password\'\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[dato.name])\"></p><div data-ng-if=\"dato.render == false\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'pdf\' && dato.type!=\'video\' && dato.type!=\'Allfiles\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[dato.name]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[dato.name])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[dato.name]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><img data-ng-if=\"dato.type==\'file\'\" data-ng-src=\"{{register[dato.name]}}\" alt=\"\" style=\"max-height: 100px;\"></a> <a data-ng-if=\"dato.type==\'video\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><video heigth=\"400\" controls=\"\" data-ng-if=\"dato.type==\'video\'\" data-ng-src=\"{{register[dato.name]}}\" style=\"height: 200px\"></video></a> <a data-ng-if=\"dato.type==\'pdf\' || dato.type==\'Allfiles\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><p>{{(register[dato.name])?\'Abrir documento\':\'Sin documento\'}}</p></a></div></td></tr><tr data-ng-if=\"results.length == 0 || resultEmpty\" style=\"text-align: center\"><td colspan=\"{{dataset.modelProperties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr><tr data-ng-if=\"!fieldsLoaded\"><td colspan=\"{{dataset.modelProperties.length+1}}\" style=\"text-align: center\"><strong>Cargando...</strong></td></tr></tbody></table></div><div class=\"col-sm-12 col-md-6 flex mT20\" style=\"justify-content: flex-start;height: 34px\" data-ng-if=\"!hideHeader\"><b class=\"text-info\" style=\"margin-bottom: 0;\">Total de registros obtenidos {{dataset.resultado.total}}</b></div><div class=\"col-sm-12 col-md-6 mT20\" data-ng-if=\"!hideHeader\"><div class=\"pagination\"><button data-ng-click=\"changePage(1)\" data-ng-disabled=\"(filters.page)<=1\" class=\"btn btn-primary\"><i class=\"fa fa-angle-double-left\" aria-hidden=\"true\"></i> Inicio</button> <button data-ng-click=\"changePage(\'decrease\')\" data-ng-disabled=\"(filters.page)<=1\" class=\"btn btn-primary\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>Página <b>{{filters.page}}</b> de <b>{{pagesTotal}}</b></span> <button data-ng-click=\"changePage(\'increase\')\" data-ng-disabled=\"(filters.page)>=pagesTotal\" class=\"btn btn-primary\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"changePage(pagesTotal)\" data-ng-disabled=\"(filters.page)>=pagesTotal\" class=\"btn btn-primary\">Último <i class=\"fa fa-angle-double-right\" aria-hidden=\"true\"></i></button></div></div></div>");
$templateCache.put("app/views/directives/crud/crudPassword.html","<div class=\"row\" data-ng-if=\"formView == true\"><div class=\"pL30 pR30\"><form action=\"\" data-ng-submit=\"updateRegister(tabla, selected, actionType)\"><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"dato.active == true\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'Email\' && actionType!=\'password\'\"></label> <label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'password\' && actionType==\'password\'\"></label> <label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'password\' && actionType==\'new\'\"></label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><input class=\"form-control\" type=\"text\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'text\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'email\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'number\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"><div data-ng-if=\"(dato.type == \'password\' && actionType==\'new\') || dato.type == \'password\' && actionType==\'password\'\" data-ng-init=\"cloneField(selected[dato.name])\"><input class=\"form-control\" type=\"password\" placeholder=\"Nueva contraseña\" ng-change=\"validatePassword(dato.name + 1, dato.name + 2)\" id=\"{{dato.name + 1}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control mT10\" type=\"password\" placeholder=\"Repita su contraseña\" ng-change=\"validatePassword(dato.name + 1, dato.name + 2)\" id=\"{{dato.name + 2}}\" data-ng-required=\"dato.required\" data-ng-model=\"copyField\" data-ng-if=\"dato.type == \'password\'\" data-ng-disabled=\"dato.disabled\"></div><text-angular data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'textarea\'\" data-ng-disabled=\"dato.disabled\"></text-angular><img data-ng-src=\"{{selected[dato.name]}}\" style=\"height: 50px;\" data-ng-if=\"dato.type == \'file\'\"> <input type=\"file\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'file\'\" data-ng-disabled=\"dato.disabled\"><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[value] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type == \'select\'\" data-ng-disabled=\"dato.disabled\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[value] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type == \'selectMultiple\'\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><input type=\"checkbox\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'checkbox\'\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"width: 34px;height: 34px;margin: 0;\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type == \'mapLon\'\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" title=\"Hello World!\"></marker></ng-map></div></div></div><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"resetRegisterAndGoBack();\">Cancelar</button><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"resetRegister()\">Revertir</button> <button type=\"submit\" class=\"btn btn-primary\">Guardar</button></div></form></div></div>");
$templateCache.put("app/views/directives/crud/crudView.html","<div class=\"row\"><div class=\"pL30 pR30\"><form action=\"\"><div class=\"row\" data-ng-if=\"(crudView==\'crudView\')\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle\">{{crudTitle}}</h4></div></div><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"( (dato.active && dato.activeForCreate==null && dato.activeForEdit == null) || (dato.active && !dato.activeForCreate && dato.activeForEdit && actionType==\'edit\') || (dato.active && dato.activeForCreate && !dato.activeForEdit && actionType==\'new\'))\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\"></label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><p data-ng-bind-html=\"selected[dato.name]\" class=\"form-control\" style=\"height: auto\" data-ng-if=\"dato.type==\'text\'||dato.type==\'email\'||dato.type==\'number\'||dato.type==\'password\'||dato.type==\'textarea\'||dato.type==\'textareaSimple\'\"></p><p data-ng-bind-html=\"dateToSpanishFormat(selected[dato.name])\" data-ng-if=\"dato.type==\'date\'\" class=\"form-control\"></p><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><img data-ng-src=\"{{selected[dato.name]}}\" style=\"max-height: 100px\" data-ng-if=\"dato.type==\'file\'\"></a> <a data-ng-if=\"dato.type==\'pdf\' || dato.type==\'Allfiles\'\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><p>Abrir documento</p></a><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'select\'\" data-ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'selectMultiple\'\" data-ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><input type=\"checkbox\" id=\"{{dato.name}}\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'checkbox\'\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"width: 34px;height: 34px;margin: 0;\"> <input class=\"form-control\" type=\"text\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLat\'\"> <input class=\"form-control\" type=\"text\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLon\'\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type==\'mapLon\'\" class=\"mT20\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" title=\"Hello World!\"></marker></ng-map></div></div></div><div class=\"\"><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"showGrid(2);resetRegisterAndGoBack();\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary pull-right\" data-ng-disabled=\"!dataset.options.update\" ui-sref=\"{{tabla}}.select({id:selected.id})\" data-ng-click=\"showGrid(1);chooseRegister(selected,\'edit\')\">Editar</button></div></form></div></div>");
$templateCache.put("app/views/directives/crud/modalRestart.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"text-align: center; background: #337ab7;\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" data-ng-click=\"$dismiss()\" aria-hidden=\"true\" style=\"color:white; opacity: 1;\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\" style=\"text-align: center; color:white\">Modificación de permisos</h4></div><div class=\"modal-body\"><div class=\"row\" style=\"text-align: center;\"><span style=\"padding: 0px 30px;\">Para aplicar los cambios es necesario reiniciar su sesión, ¿Desea continuar?</span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn-default btn pull-left\" data-ng-click=\"$dismiss()\">Cancelar</button> <button type=\"submit\" class=\"btn-primary btn pull-right\" data-ng-click=\"logout()\">Cerrar sesión</button></div></div>");
$templateCache.put("app/views/directives/crudform/crud.html","<div class=\"container-fluid\"><ng-include src=\"\'app/views/directives/crudform/crudContextMenu.html\'\"></ng-include><div class=\"crud-container\" customheight=\"\" minus=\"50\"><div class=\"crud-grid-header\"><div class=\"grid-title\"><h3>{{crudTitle}} {{(crud.crudView!=\'grid\')?crudTitleSecond:\'\'}}</h3><a class=\"btn btn-action\" data-ng-if=\"dataset.options.create && crud.crudView==\'grid\'\" data-ng-click=\"showCrudForm(true);chooseRegister(\'\',\'new\')\"><i class=\"fa fa-plus\"></i> {{switchText(\'Nuevo\', \'New\')}}</a></div></div><ng-include src=\"\'app/views/directives/crudform/crudGridFilters.html\'\" data-ng-if=\"!customFilters && crud.crudView==\'grid\'\"></ng-include><ng-include src=\"customFilters\" data-ng-if=\"customFilters && crud.crudView==\'custom\' || customFilters && crud.crudView==\'grid\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudPagination.html\'\" data-ng-if=\"crud.crudView==\'grid\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudGrid.html\'\" data-ng-if=\"crud.crudView==\'grid\'\"></ng-include><ng-include src=\"customTemplates\" data-ng-if=\"crud.crudView==\'custom\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudPagination.html\'\" data-ng-if=\"crud.crudView==\'grid\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudForm.html\'\"></ng-include><ng-include src=\"\'app/views/directives/crudform/crudInnerCrud.html\'\"></ng-include><ng-include src=\"\'app/views/directives/customModal/customModal2.html\'\"></ng-include><script type=\"text/ng-template\" id=\"deleteModal.html\"><div class=\"modal-header warning\"> <h3 class=\"modal-title\" id=\"modal-title\">Eliminando {{$parent.selected[titleField]}}</h3> </div> <div class=\"modal-body\" id=\"modal-body\"> <p>¿Esta seguro de eliminar este registro y su contenido relacionado?{{$parent.titleField}}</p> <span class=\"text-danger\"> <i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno </span> </div> <div class=\"modal-footer\"> <button class=\"btn btn-action danger pull-rigth\" type=\"button\" ng-click=\"updateRegister(tabla,selected,actionType);\">OK </button> <button class=\"btn btn-action success pull-left\" type=\"button\" ng-click=\"$dismiss(true)\">Cancel</button> </div></script></div></div>");
$templateCache.put("app/views/directives/crudform/crudContextMenu.html","<div><a href=\"\" class=\"info-btn-close {{$root.currentModule}}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"fas fa-info-circle\"></i></a><div data-ng-class=\"{ \'active\': $root.infoMenu }\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5 data-ng-class=\"{\'hide\': !$root.infoMenu}\">{{selected[titleField]}}</h5></div></div><div class=\"info-menu-body\" ui-heigth=\"\"><div class=\"row\"><div class=\"col-xs-12\"><h5><strong>Detalles</strong></h5></div></div><div class=\"data-box\" data-ng-if=\"selected\" data-ng-repeat=\"dato in dataset.modelProperties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><ng-include ng-init=\"context=\'detail\'\" src=\"\'app/views/directives/crudform/form/formwidget/\'+dato.type+\'.html\'\"></ng-include><p data-ng-if=\"!selected[dato.name] || selected[dato.name]==\'\'\">Sin datos</p></div></div><div class=\"row\"><div class=\"col-xs-12\"><button style=\"margin: auto;\" data-ng-if=\"selected\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"showCrudForm(true);\">{{switchText(\'Editar\', \'Edit\')}}</button></div></div></div></div></div>");
$templateCache.put("app/views/directives/crudform/crudDelete.html","<div class=\"cmodal-content small\"><div class=\"cmodal-header\"><h4 class=\"modal-title\" id=\"myModalLabel\">Eliminar \"{{crudTitle}}\"</h4></div><div class=\"cmodal-body\"><p>¿Esta seguro de eliminar este registro y su contenido relacionado?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span></div><div class=\"cmodal-footer\"><button type=\"button\" class=\"btn btn-theme pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"button\" class=\"btn btn-theme red pull-right\" data-ng-click=\"updateRegister(tabla,selected,actionType);\">Confirmar</button></div></div>");
$templateCache.put("app/views/directives/crudform/crudDownloadFields.html","<form action=\"\" data-ng-submit=\"reloadData()\"><div class=\"col-xs-12 col-md-4 menureport\" style=\"justify-content: flex-start\"><p class=\"text-info reportlabel\" style=\"width: 58px;text-align: left\">Desde</p><mydatepicker ng-model=\"filters.dateFrom\" ng-required=\"true\" date-options=\"dateOptions\" opened=\"opened1\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12 col-md-4 menureport\" style=\"justify-content: flex-start\"><p class=\"text-info reportlabel\" style=\"width: 58px;text-align: left\">Hasta</p><mydatepicker ng-model=\"filters.dateTo\" ng-required=\"true\" date-options=\"dateOptions\" opened=\"opened2\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12 col-md-4 menureport\"><button class=\"btn btn-primary pull-left\" type=\"submit\" data-ng-if=\"!csvReady\" style=\"width: 140px;\"><i class=\"fa fa-search\" aria-hidden=\"true\"></i> Filtrar por fecha</button></div><div class=\"col-xs-12 mB20\"><hr style=\"margin: 0px 0px 10px 0px;\"><a href=\"\" class=\"btn btn-primary pull-right\" data-ng-click=\"reloadData(true)\" style=\"width: 140px;\"><i class=\"fa fa-cloud-download\" aria-hidden=\"true\"></i> Generar csv</a> <a href=\"{{dataset.downloadLink}}\" class=\"pull-right\" target=\"_blank\" data-ng-if=\"dataset.downloadLink !=\'\' && downloadReady\" style=\"margin: 8px 15px;\"><i class=\"fa fa-check\" aria-hidden=\"true\"></i> Documento generado</a> <img src=\"images/loader_blue.gif\" data-ng-if=\"(dataset.downloadLink.length > 0 && !downloadReady)\" class=\"mR20 pull-right\" alt=\"\" style=\"width: 34px;\"></div></form>");
$templateCache.put("app/views/directives/crudform/crudForm.html","<div class=\"crud-form-body level1 wow slideInLeft\" data-ng-if=\"crudForm\"><form class=\"crud-form level1\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister(tabla,selected,actionType)\"><div class=\"forms\"><div class=\"form-header sub\"><h3>Nuevo {{crudTitleSecond}}</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"showCrudForm(false)\"><i class=\"far fa-times-circle\"></i></a></div></div><div class=\"forms\" data-ng-if=\"dato.active\" data-ng-repeat=\"dato in dataset.modelProperties | orderBy:\'order\'\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle-2\" data-ng-show=\"dato.subtitle\" render-html=\"dato.subtitle\"></h4><hr data-ng-if=\"dato.hr\" style=\"margin: 10px 0 20px 0;\"></div><div class=\"box-label\"><span class=\"filter-label\" data-ng-bind-html=\"dato.invalid+dato.label\" data-ng-class=\"{\'text-danger\':dato.invalid}\"></span></div><div class=\"box-input\"><ng-include ng-init=\"context=\'form\'\" src=\"\'app/views/directives/crudform/form/formwidget/\'+dato.type+\'.html\'\"></ng-include></div></div><div class=\"forms\"><button type=\"submit\" class=\"btn btn-action success pull-right\">Save</button> <button data-ng-click=\"resetRegister()\" class=\"btn btn-action info pull-right\">Revert</button> <button class=\"btn btn-action danger pull-left\" data-ng-click=\"showCrudForm(false);resetRegisterAndGoBack();\">Cancel</button></div></form></div>");
$templateCache.put("app/views/directives/crudform/crudGrid.html","<div class=\"crud-grid-body wow fadeInUp\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th data-ng-hide=\"dataset.options.hideTools\" class=\"column-title grid-options\"><strong>Opciones</strong></th><th data-ng-repeat=\"modelProperties in dataset.modelProperties\" data-ng-click=\"sortBy(modelProperties.name)\" data-ng-class=\"{active: propertyName == modelProperties.name}\" data-ng-if=\"modelProperties.activeGrid && modelProperties.name !=\'password\'\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"modelProperties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName == modelProperties.name && !reverse\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == modelProperties.name && reverse\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th></tr></thead><tbody><tr ng-repeat=\"register in dataset.result.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':(selected.id == register.id && $root.infoMenu)}\"><td class=\"grid-options\" data-ng-hide=\"dataset.options.hideTools\"><div data-ng-if=\"dataset.options.customButton\" render-html=\"dataset.options.customButton\"></div><button type=\"button\" class=\"btn btn-grid {{$root.currentModule}}\" ui-sref=\"{{childrenState}}({id:register.id})\" data-ng-if=\"childrenState\" tooltip=\"{{switchText(\'Ingresar\', \'Get into\')}}\"><i class=\"fas fa-sign-in-alt\"></i></button> <button type=\"button\" class=\"btn btn-grid {{$root.currentModule}}\" data-ng-click=\"$root.showInfoMenu();chooseRegister(register,\'edit\')\" data-ng-if=\"dataset.options.read\" tooltip=\"{{switchText(\'Detalles\', \'Details\')}}\"><i class=\"fas fa-info\"></i></button> <button type=\"button\" class=\"btn btn-grid edit {{$root.currentModule}}\" data-ng-click=\"showCrudForm(true);chooseRegister(register,\'edit\')\" data-ng-if=\"dataset.options.update\" tooltip=\"{{switchText(\'Editar\', \'Edit\')}}\"><i class=\"fas fa-edit\"></i></button> <button type=\"button\" class=\"btn btn-grid delete {{$root.currentModule}}\" data-ng-click=\"chooseRegister(register,\'delete\');updateRegister(tabla,selected,actionType);openModal(\'deleteModal.html\')\" data-ng-if=\"dataset.options.delete\" data-ng-disabled=\"register.email==$root.currentUser.email && tableName==\'usuarios\'\" tooltip=\"{{switchText(\'Eliminar\', \'Delete\')}}\"><i class=\"fas fa-times\"></i></button> <button type=\"button\" class=\"btn btn-grid\" ui-sref=\"{{state}}.select({id:register.id})\" data-ng-click=\"showGrid(1);chooseRegister(register,\'password\')\" data-ng-if=\"tableName == \'usuarios\'\" tooltip=\"Cambiar contraseña\"><i class=\"fas fa-times\"></i></button></td><td data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"dato.activeGrid && dato.name !=\'password\'\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[dato.name])\"></p><div data-ng-if=\"dato.render == false\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'pdf\' && dato.type!=\'video\' && dato.type!=\'Allfiles\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[dato.name]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[dato.name])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[dato.name]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><img data-ng-if=\"dato.type==\'file\'\" data-ng-src=\"{{register[dato.name]}}\" alt=\"\" style=\"max-height: 100px;\"></a> <a data-ng-if=\"dato.type==\'video\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><video heigth=\"400\" controls=\"\" data-ng-if=\"dato.type==\'video\'\" data-ng-src=\"{{register[dato.name]}}\" style=\"height: 200px\"></video></a> <a data-ng-if=\"dato.type==\'pdf\' || dato.type==\'Allfiles\'\" target=\"_blank\" href=\"{{register[dato.name]}}\"><p>{{(register[dato.name])?\'Abrir documento\':\'Sin documento\'}}</p></a></div></td></tr><tr data-ng-if=\"dataset.result.data.length==0\" style=\"text-align: center\"><td colspan=\"{{dataset.modelProperties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr></tbody></table></div></div>");
$templateCache.put("app/views/directives/crudform/crudGridFilters.html","<div class=\"crud-grid-filters\"><div class=\"filters-header\"><a class=\"btn btn-action\" data-ng-click=\"showGridFilters()\"><i data-ng-class=\"{\'open\':gridFilters}\" class=\"fa fa-plus\"></i> {{switchText(\'Filtros\', \'Filters\')}}</a></div><div data-ng-show=\"gridFilters\" class=\"filters-box\"><div class=\"form-group flex\" data-ng-repeat=\"cfilter in customFiltersSet\"><span class=\"filter-label\">{{cfilter.label}}:</span><select class=\"form-control\" data-ng-change=\"reload2(cfilter.field)\" data-ng-model=\"filterCustomFields[cfilter.field]\"><option value=\"\">Todos</option><option value=\"{{y.id}}\" data-ng-repeat=\"y in cfilter.options\">{{y.label}}</option></select></div><div class=\"form-group flex\"><span class=\"filter-label\">Mostrar:</span><select data-ng-model=\"filters.per_page\" data-ng-class=\"$root.currentModule\" data-ng-change=\"changePerPage()\" class=\"form-control\"><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div><div class=\"form-group input-group\"><input type=\"text\" placeholder=\"Search\" data-ng-model=\"filters.comparaciones[0].dato\" data-ng-change=\"search()\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"button\"><i class=\"fas fa-search\"></i></button></span></div></div></div>");
$templateCache.put("app/views/directives/crudform/crudInnerCrud.html","<div class=\"crud-form-body level2 wow slideInLeft\" data-ng-if=\"innerCrud\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"saveInnerCrud()\"><div class=\"forms\"><div class=\"form-header sub\"><h3>{{(innerCruds[innerTable].actionType==\'insert\')?\'Agregar \' :\'\'}} {{(innerCruds[innerTable].actionType==\'update\')?\'Editar \' :\'\'}} {{(innerCruds[innerTable].actionType==\'delete\')?\'Eliminar \':\'\'}}</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"showCrudInnercrud(false)\"><i class=\"far fa-times-circle\"></i></a></div></div><form data-ng-submit=\"saveInnerCrud()\"><div class=\"cmodal-body\" data-ng-if=\"innerCruds[innerTable].actionType == \'delete\'\"><p>¿Esta seguro de eliminar este registro y su contenido relacionado?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span></div><div class=\"forms\" data-ng-if=\"innerCruds[innerTable].actionType != \'delete\'\"><div class=\"forms\" data-ng-repeat=\"dato in innerCrudModel track by $index\"><div class=\"col-xs-12\" data-ng-show=\"dato.subtitle\"><h4 class=\"header-subtitle-2\">{{dato.subtitle}}</h4><hr></div><div class=\"box-label\"><div class=\"filter-label\"><p>{{dato.label}}</p></div></div><div class=\"box-input\"><input class=\"form-control\" type=\"text\" data-ng-required=\"true\" data-ng-model=\"innerCruds[innerTable][dato.name]\" data-ng-if=\"dato.type==\'text\'\" data-ng-disabled=\"dato.disabled\"><select data-ng-model=\"innerCruds[innerTable][dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" data-ng-options=\"item.id as item[dato.itemsLabel] for item in dato.items\" data-ng-if=\"dato.type==\'select\'\"></select><select data-ng-model=\"innerCruds[innerTable][dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" data-ng-init=\"innerCruds[innerTable][dato.name+\'list\']=[]\" data-ng-change=\"(tableName==\'mailing\')?addToList(innerCruds[innerTable][dato.name],dato.name+\'list\'):0\" data-ng-options=\"item.id as item[dato.itemsLabel] for item in dato.items\" data-ng-if=\"dato.type==\'list\'\"></select><div data-ng-if=\"dato.type==\'list\'\" data-ng-repeat=\"it in innerCruds[innerTable][dato.name+\'list\']\"><span data-ng-repeat=\"i in dato.items track by $index\" style=\"display: block;float: left;padding-right: 10px;font-size: 12px;\" data-ng-show=\"it == i.id\">{{i[dato.itemsLabel]}} <span style=\"font-size: 12px;cursor:pointer\" data-ng-click=\"removeFromList(i.$index,dato.name+\'list\')\" class=\"glyphicon glyphicon-remove\"></span></span></div><div data-ng-if=\"dato.type==\'date\'\"><mydatepicker ng-model=\"innerCruds[innerTable][dato.name]\" date-options=\"dateOptions\" opened=\"opened\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><textarea class=\"form-control\" data-ng-model=\"innerCruds[innerTable][dato.name]\" data-ng-required=\"dato.required\" style=\"min-height: 50px\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\n          </textarea></div></div></div><div class=\"forms\"><button type=\"button\" class=\"btn btn-action danger pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"submit\" data-ng-if=\"tableName!=\'mailing\'\" class=\"btn btn-action success pull-right\">Confirmar</button></div></form></form></div>");
$templateCache.put("app/views/directives/crudform/crudPagination.html","<div class=\"crud-grid-pagination\" data-ng-if=\"crud.crudView==\'grid\'\"><div class=\"pagination-nav-options\" data-ng-class=\"$root.currentModule\"><button data-ng-click=\"changePage(1)\" data-ng-disabled=\"(filters.page)<=1\" data-ng-class=\"$root.currentModule\" class=\"btn btn-grid\">{{switchText(\'Inicio\', \'First\')}}</button> <button data-ng-click=\"changePage(\'decrease\')\" data-ng-disabled=\"(filters.page)<=1\" data-ng-class=\"$root.currentModule\" class=\"btn btn-grid\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>{{filters.page}} {{switchText(\'de\', \'from\')}} {{pagesTotal}}</span> <button data-ng-click=\"changePage(\'increase\')\" data-ng-disabled=\"(filters.page)>=pagesTotal\" data-ng-class=\"$root.currentModule\" class=\"btn btn-grid\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"changePage(pagesTotal)\" data-ng-disabled=\"(filters.page)>=pagesTotal\" data-ng-class=\"$root.currentModule\" class=\"btn btn-grid\">{{switchText(\'Último\', \'Last\')}}</button></div><div class=\"pagination-records\" data-ng-class=\"$root.currentModule\"><div class=\"form-group flex\"><span class=\"filter-label\">Mostrar:</span><select data-ng-model=\"filters.per_page\" data-ng-class=\"$root.currentModule\" data-ng-change=\"changePerPage()\" class=\"form-control\"><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div></div><div class=\"pagination-total\" data-ng-class=\"$root.currentModule\"><span class=\"result\">{{switchText(\'Registros\', \'Records\')}}: {{dataset.resultado.total}}</span></div></div>");
$templateCache.put("app/views/directives/crudform/crudPassword.html","<div class=\"row\" data-ng-if=\"formView == true\"><div class=\"pL30 pR30\"><form action=\"\" data-ng-submit=\"updateRegister(tabla, selected, actionType)\"><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"dato.active == true\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'Email\' && actionType!=\'password\'\"></label> <label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'password\' && actionType==\'password\'\"></label> <label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\" data-ng-if=\"dato.label == \'password\' && actionType==\'new\'\"></label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><input class=\"form-control\" type=\"text\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'text\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'email\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'number\' && actionType!=\'password\'\" data-ng-disabled=\"dato.disabled\"><div data-ng-if=\"(dato.type == \'password\' && actionType==\'new\') || dato.type == \'password\' && actionType==\'password\'\" data-ng-init=\"cloneField(selected[dato.name])\"><input class=\"form-control\" type=\"password\" placeholder=\"Nueva contraseña\" ng-change=\"validatePassword(dato.name + 1, dato.name + 2)\" id=\"{{dato.name + 1}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'password\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control mT10\" type=\"password\" placeholder=\"Repita su contraseña\" ng-change=\"validatePassword(dato.name + 1, dato.name + 2)\" id=\"{{dato.name + 2}}\" data-ng-required=\"dato.required\" data-ng-model=\"copyField\" data-ng-if=\"dato.type == \'password\'\" data-ng-disabled=\"dato.disabled\"></div><text-angular data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'textarea\'\" data-ng-disabled=\"dato.disabled\"></text-angular><img data-ng-src=\"{{selected[dato.name]}}\" style=\"height: 50px;\" data-ng-if=\"dato.type == \'file\'\"> <input type=\"file\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'file\'\" data-ng-disabled=\"dato.disabled\"><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[value] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type == \'select\'\" data-ng-disabled=\"dato.disabled\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[value] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type == \'selectMultiple\'\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><input type=\"checkbox\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'checkbox\'\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"width: 34px;height: 34px;margin: 0;\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type == \'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type == \'mapLon\'\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" title=\"Hello World!\"></marker></ng-map></div></div></div><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"resetRegisterAndGoBack();\">Cancelar</button><div class=\"pull-right\"><button type=\"button\" class=\"btn btn-default\" data-ng-click=\"resetRegister()\">Revertir</button> <button type=\"submit\" class=\"btn btn-primary\">Guardar</button></div></form></div></div>");
$templateCache.put("app/views/directives/crudform/crudView.html","<div class=\"row\"><div class=\"pL30 pR30\"><form action=\"\"><div class=\"row\" data-ng-if=\"(crudView==\'crudView\')\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle\">{{crudTitle}}</h4></div></div><div class=\"form-group\" data-ng-repeat=\"dato in dataset.modelProperties\" data-ng-if=\"( (dato.active && dato.activeForCreate==null && dato.activeForEdit == null) || (dato.active && !dato.activeForCreate && dato.activeForEdit && actionType==\'edit\') || (dato.active && dato.activeForCreate && !dato.activeForEdit && actionType==\'new\'))\"><div class=\"row\"><div class=\"col-xs-12 col-sm-4 col-md-4 box-izq\"><label data-ng-bind=\"dato.label\" class=\"label-form <!--arrow_box-->\"></label></div><div class=\"col-xs-12 col-sm-8 col-md-8 box-der\"><p data-ng-bind-html=\"selected[dato.name]\" class=\"form-control\" style=\"height: auto\" data-ng-if=\"dato.type==\'text\'||dato.type==\'email\'||dato.type==\'number\'||dato.type==\'password\'||dato.type==\'textarea\'||dato.type==\'textareaSimple\'\"></p><p data-ng-bind-html=\"dateToSpanishFormat(selected[dato.name])\" data-ng-if=\"dato.type==\'date\'\" class=\"form-control\"></p><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><img data-ng-src=\"{{selected[dato.name]}}\" style=\"max-height: 100px\" data-ng-if=\"dato.type==\'file\'\"></a> <a data-ng-if=\"dato.type==\'pdf\' || dato.type==\'Allfiles\'\" target=\"_blank\" href=\"{{selected[dato.name]}}\"><p>Abrir documento</p></a><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'select\'\" data-ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><select ng-model=\"selected[dato.name]\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-required=\"dato.required\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"dato.type==\'selectMultiple\'\" data-ng-disabled=\"true\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><input type=\"checkbox\" id=\"{{dato.name}}\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'checkbox\'\" ng-true-value=\"1\" ng-false-value=\"0\" style=\"width: 34px;height: 34px;margin: 0;\"> <input class=\"form-control\" type=\"text\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLat\'\"> <input class=\"form-control\" type=\"text\" data-ng-disabled=\"true\" data-ng-required=\"dato.required\" id=\"{{dato.name}}\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"dato.type==\'mapLon\'\"><ng-map center=\"{{selected.latitud}},{{selected.longitud}}\" data-ng-if=\"dato.type==\'mapLon\'\" class=\"mT20\"><marker position=\"{{selected.latitud}},{{selected.longitud}}\" title=\"Hello World!\"></marker></ng-map></div></div></div><div class=\"\"><button type=\"button\" class=\"btn btn-default pull-left\" data-ng-click=\"showGrid(2);resetRegisterAndGoBack();\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary pull-right\" data-ng-disabled=\"!dataset.options.update\" ui-sref=\"{{tabla}}.select({id:selected.id})\" data-ng-click=\"showGrid(1);chooseRegister(selected,\'edit\')\">Editar</button></div></form></div></div>");
$templateCache.put("app/views/directives/crudform/modalRestart.html","<div class=\"modal-content\"><div class=\"modal-header\" style=\"text-align: center; background: #337ab7;\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" data-ng-click=\"$dismiss()\" aria-hidden=\"true\" style=\"color:white; opacity: 1;\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\" style=\"text-align: center; color:white\">Modificación de permisos</h4></div><div class=\"modal-body\"><div class=\"row\" style=\"text-align: center;\"><span style=\"padding: 0px 30px;\">Para aplicar los cambios es necesario reiniciar su sesión, ¿Desea continuar?</span></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn-default btn pull-left\" data-ng-click=\"$dismiss()\">Cancelar</button> <button type=\"submit\" class=\"btn-primary btn pull-right\" data-ng-click=\"logout()\">Cerrar sesión</button></div></div>");
$templateCache.put("app/views/directives/customModal/customModal.html","<div class=\"wow fadeIn container-fluid custom-modal\" data-ng-if=\"customModal.visible\" modalheight=\"\"><a data-ng-click=\"closeCustomModal()\" class=\"btn btn-close-modal\"><i class=\"fas fa-times\"></i></a><div class=\"cmodal-body\"><ng-include src=\"customModal.ngTemplate\" data-ng-if=\"customModal.ngTemplate\"></ng-include></div></div>");
$templateCache.put("app/views/directives/customModal/customModal2.html","<div class=\"wow fadeIn container-fluid custom-modal\" data-ng-if=\"customModal2.visible\" modalheight=\"\"><a data-ng-click=\"closeCustomModal2()\" class=\"btn btn-close-modal\"><i class=\"fas fa-times\"></i></a><div class=\"cmodal-body\"><ng-include src=\"customModal2.ngTemplate\" data-ng-if=\"customModal2.ngTemplate\"></ng-include></div></div>");
$templateCache.put("app/views/crudgenerator/includes/addPermission.html","<div class=\"modal fade modal-add\" id=\"crudAddPermission\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\">CREAR NUEVO PERMISO</h4></div><div class=\"modal-body\"><p>¿Esta seguro de agregar este nuevo permiso?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Nombre</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newPermission.nombre\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Permiso</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newPermission.permiso\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Descripción</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newPermission.descripcion\" class=\"form-control\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"createPermission(newPermission,temp);closeModal(\'crudAddPermission\')\">Confirmar</button></div></div></div></div>");
$templateCache.put("app/views/crudgenerator/includes/addSection.html","<div class=\"modal fade modal-add\" id=\"crudAddSection\" tabindex=\"-1\" role=\"dialog\" aria-labelledby=\"myModalLabel\" aria-hidden=\"true\"><div class=\"modal-dialog\"><div class=\"modal-content\"><div class=\"modal-header\"><a type=\"button\" class=\"close cancel\" data-dismiss=\"modal\" aria-hidden=\"true\">&times;</a><h4 class=\"modal-title\" id=\"myModalLabel\">CREAR NUEVA SECCIÓN</h4></div><div class=\"modal-body\"><p>¿Esta seguro de agregar esta nueva sección?</p><span class=\"text-danger\"><i class=\"fa fa-exclamation-triangle mR5\" aria-hidden=\"true\"></i> Advertencia esta acción no tiene retorno</span><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Vista</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newView.nombre\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">State</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newView.state\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Url</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newView.url\" class=\"form-control\"></div></div><div class=\"row form-group admin-form mT20\"><div class=\"box-left\"><label class=\"label-form\">Padre</label></div><div class=\"box-rigth\"><input type=\"text\" data-ng-model=\"newView.parent\" class=\"form-control\"></div></div></div><div class=\"modal-footer\"><button type=\"button\" class=\"btn btn-default\" data-dismiss=\"modal\">Cancelar</button> <button type=\"button\" class=\"btn btn-primary\" data-ng-click=\"createView(newView);closeModal(\'crudAddSection\')\">Confirmar</button></div></div></div></div>");
$templateCache.put("app/views/crudgenerator/includes/form.html","<div class=\"field-box\"><div class=\"admin-form\"><a href=\"\" class=\"btn btn-danger\" data-ng-click=\"deleteField(field, $index)\"><i class=\"fa fa-times\" aria-hidden=\"true\"></i> Eliminar</a></div><div class=\"form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Nombre</label> <small class=\"text-info\">No incluir espacios o caracteres especiales</small></div><div class=\"box-rigth\"><input class=\"form-control\" data-ng-required=\"true\" type=\"text\" data-ng-model=\"field.dbField\"></div></div><div class=\"admin-form\"><div class=\"col-xs-12 subdivision\"><h4 class=\"\" data-ng-click=\"changeFormDetail(field,\'showDB\')\">Base de datos <i class=\"fa fa-caret-down\" aria-hidden=\"true\" data-ng-if=\"field.showDB\"></i> <i class=\"fa fa-caret-left\" aria-hidden=\"true\" data-ng-if=\"!field.showDB\"></i></h4></div></div><ng-include src=\"\'app/views/crudgenerator/includes/form_db_fields.html\'\" data-ng-if=\"field.showDB\"></ng-include><div class=\"admin-form\"><div class=\"col-xs-12 subdivision\"><h4 class=\"\" data-ng-click=\"changeFormDetail(field, \'showMV\')\">Validaciones de formulario <i class=\"fa fa-caret-down\" aria-hidden=\"true\" data-ng-if=\"field.showMV\"></i> <i class=\"fa fa-caret-left\" aria-hidden=\"true\" data-ng-if=\"!field.showMV\"></i></h4></div></div><ng-include src=\"\'app/views/crudgenerator/includes/form_validation_fields.html\'\" data-ng-if=\"field.showMV\"></ng-include></div>");
$templateCache.put("app/views/crudgenerator/includes/form_db_fields.html","<div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Tipo de campo</label></div><div class=\"box-rigth\"><select class=\"form-control\" data-ng-model=\"field.dbType\"><option value=\"INT\">INT</option><option value=\"BIGINT\">BIGINT</option><option value=\"MEDIUMINT\">MEDIUMINT</option><option value=\"SMALLINT\">SMALLINT</option><option value=\"TINYINT\">TINYINT</option><option value=\"DECIMAL\">DECIMAL</option><option value=\"DOUBLE\">DOUBLE</option><option value=\"FLOAT\">FLOAT</option><option value=\"BLOB\">BLOB</option><option value=\"CHAR\">CHAR</option><option value=\"LONGTEXT\">LONGTEXT</option><option value=\"MEDIUMTEXT\">MEDIUMTEXT</option><option value=\"TEXT\">TEXT</option><option value=\"VARCHAR\">VARCHAR</option><option value=\"DATE\">DATE</option><option value=\"DATETIME\">DATETIME</option><option value=\"TIME\">TIME</option><option value=\"TIMESTAMP\">TIMESTAMP</option><option value=\"DATE\">DATE</option><option value=\"IP\">IP</option><option value=\"JSON\">JSON</option><option value=\"JSONB\">JSONB</option><option value=\"MAC\">MAC</option><option value=\"ENUM\">ENUM</option><option value=\"UUID\">UUID</option></select></div></div><div class=\"row form-group admin-form\" data-ng-if=\"field.dbType == \'VARCHAR\' || field.dbType == \'CHAR\'\"><div class=\"box-left\"><label class=\"label-form\">Tamaño</label></div><div class=\"box-rigth\"><input type=\"TEXT\" class=\"form-control\" data-ng-model=\"field.dbSize\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Valor por defecto</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\" data-ng-model=\"field.dbDefault\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Habilitar campo con traducción</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"field.dbAutoTraduction\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Traducciones</label></div><div class=\"box-rigth\"><select name=\"\" id=\"dbLanguages\" multiple=\"\" ng-multiple=\"true\" class=\"form-control\" data-ng-model=\"field.dbLanguages\"><option selected=\"\" value=\"\">-- No --</option><option value=\"es\">Español</option><option value=\"en\">Ingles</option><option value=\"fr\">Frances</option><option value=\"pt\">Portugues</option><option value=\"de\">Aleman</option><option value=\"it\">Italiano</option></select></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permitir valores nulos</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"field.dbNull\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Indices</label></div><div class=\"box-rigth\"><select name=\"\" id=\"dbIndex\" class=\"form-control\" data-ng-model=\"field.dbIndex\"><option selected=\"\" value=\"\">-- No --</option><option value=\"PK\">(PK) Llave primaria</option><option value=\"FK\">(FK) Llave foranea</option><option value=\"UNIQUE\">UNIQUE</option><option value=\"INDEX\">INDEX</option></select></div></div><div class=\"row form-group admin-form\" data-ng-if=\"field.dbIndex == \'FK\'\"><div class=\"box-left\"><label class=\"label-form\">Tabla de referencia</label></div><div class=\"box-rigth\"><select ng-options=\"item.table as item.table for item in migrations\" name=\"\" id=\"dbFkTable\" data-ng-change=\"getTableColumns(field.dbFkTable)\" class=\"form-control\" data-ng-model=\"field.dbFkTable\"></select></div></div><div class=\"row form-group admin-form\" data-ng-if=\"field.dbIndex == \'FK\'\"><div class=\"box-left\"><label class=\"label-form\">Campo de referencia</label></div><div class=\"box-rigth\"><select ng-options=\"o as o for o in migrationsColunns\" id=\"\" class=\"form-control\" data-ng-model=\"field.dbFkField\"></select></div></div><div class=\"row form-group admin-form\" data-ng-if=\"field.dbIndex == \'FK\'\"><div class=\"box-left\"><label class=\"label-form\">Eliminación en cascada</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"field.dbFkCascadeDelete\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Comentarios</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\" data-ng-model=\"field.dbComment\"></div></div>");
$templateCache.put("app/views/crudgenerator/includes/form_validation_fields.html","<div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Tipo de campo</label></div><div class=\"box-rigth\"><select class=\"form-control\"></select></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Etiqueta</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Requerido</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Desabilitado</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Personalizado</label></div><div class=\"box-rigth\"><textarea class=\"form-control\"></textarea></div></div>");
$templateCache.put("app/views/crudgenerator/includes/step1.html","<form action=\"\" data-ng-submit=\"changeValue(2)\"><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\" data-ng-class=\"{\'text-danger\':!modelvalid && data.model.length>0}\">{{(!modelvalid && data.model.length>0)?\'* \':\'\'}}Nombre de la tabla</label></div><div class=\"box-rigth\"><input class=\"form-control\" data-ng-change=\"verifyModelName()\" type=\"text\" data-ng-model=\"data.model\" data-ng-required=\"true\"></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Origen de datos</label></div><div class=\"box-rigth\"><input type=\"file\" class=\"form-control\" onchange=\"angular.element(this).scope().onFileChange(this)\"></div></div><div class=\"col-xs-12 mT20\" style=\"margin-top: 50px\"><button data-ng-disabled=\"crudStep == 1\" data-ng-click=\"changeValue(crudStep-1)\" class=\"btn btn-primary pull-left\">Anterior</button> <button type=\"submit\" data-ng-disabled=\"!modelvalid\" class=\"btn btn-primary pull-left mL20\">Siguiente</button></div></form>");
$templateCache.put("app/views/crudgenerator/includes/step2.html","<div class=\"row admin-form\"><div class=\"box-options\"><a href=\"\" class=\"btn btn-primary pull-right btn-op\" data-ng-click=\"addField()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar columna</a></div></div><ng-include src=\"\'app/views/crudgenerator/includes/form.html\'\" data-ng-repeat=\"field in data.dataEstructure\"></ng-include><div class=\"row admin-form\" data-ng-if=\"data.dataEstructure.length>0\"><div class=\"box-options\"><a href=\"\" class=\"btn btn-primary pull-right btn-op\" data-ng-click=\"addField()\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Agregar columna</a></div></div><div class=\"col-xs-12 mT20\"><button data-ng-click=\"generateCrud()\" class=\"btn btn-primary pull-right btn-op\" data-ng-disabled=\"data.dataEstructure.length ==0\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generar Crud</button><button data-ng-disabled=\"crudStep == 1\" data-ng-click=\"changeValue(crudStep-1)\" class=\"btn btn-primary pull-left\">Anterior</button></div>");
$templateCache.put("app/views/crudgenerator/includes/step3.html","<form action=\"\" name=\"myForm3\" data-ng-submit=\"changeValue(4)\"><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permisos para creación</label></div><div class=\"box-rigth\"><select ng-options=\"item.id as item.nombre for item in permissions\" name=\"\" id=\"insert\" class=\"form-control\" data-ng-model=\"data.permissions.insert\" required=\"\"></select><a class=\"btn btn-primary btn-op mT10\" data-ng-click=\"setTempValue(\'insert\')\" data-toggle=\"modal\" data-target=\"#crudAddPermission\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo permiso.</a></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permisos para actualización</label></div><div class=\"box-rigth\"><select ng-options=\"item.id as item.nombre for item in permissions\" name=\"\" id=\"update\" class=\"form-control\" data-ng-model=\"data.permissions.update\" required=\"\"></select><a class=\"btn btn-primary btn-op mT10\" data-ng-click=\"setTempValue(\'update\')\" data-toggle=\"modal\" data-target=\"#crudAddPermission\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo permiso.</a></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permisos para eliminación</label></div><div class=\"box-rigth\"><select ng-options=\"item.id as item.nombre for item in permissions\" name=\"\" id=\"delete\" class=\"form-control\" data-ng-model=\"data.permissions.delete\" required=\"\"></select><a class=\"btn btn-primary btn-op mT10\" data-ng-click=\"setTempValue(\'delete\')\" data-toggle=\"modal\" data-target=\"#crudAddPermission\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo permiso.</a></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Habilitar edición con revisiones</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"data.permissions.reviewEnable\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Permisos para aprobar o rechazar</label></div><div class=\"box-rigth\"><select data-ng-disabled=\"!data.permissions.reviewEnable\" ng-options=\"item.id as item.nombre for item in permissions\" name=\"\" id=\"review\" class=\"form-control\" data-ng-model=\"data.permissions.review\" required=\"\"></select><button class=\"btn btn-primary btn-op mT10\" data-ng-disabled=\"!data.permissions.reviewEnable\" data-ng-click=\"setTempValue(\'review\')\" data-toggle=\"modal\" data-target=\"#crudAddPermission\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo permiso.</button></div></div><div class=\"col-xs-12 mT20\"><button type=\"submit\" data-ng-disabled=\"!permission.review||!permission.insert||!permission.update||!permission.delete\" class=\"btn btn-primary pull-right mL20\">Siguiente</button> <button data-ng-disabled=\"crudStep == 1\" data-ng-click=\"changeValue(crudStep-1)\" class=\"btn btn-primary pull-right\">Anterior</button></div></form>");
$templateCache.put("app/views/crudgenerator/includes/step4.html","<div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Habilitar interfaz de adminstración</label></div><div class=\"box-rigth\"><label class=\"switch\"><input type=\"checkbox\" data-ng-model=\"data.administration.enable\"> <span class=\"slider round\"></span></label></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Seccion de administracion</label></div><div class=\"box-rigth\"><select name=\"\" id=\"\" class=\"form-control\" data-ng-click=\"setTempValue(\'section\')\" data-ng-disabled=\"!data.administration.enable\" ng-options=\"item.id as item.nombre for item in pages\" data-ng-model=\"data.administration.section\"></select><button class=\"btn btn-primary btn-op mT10\" data-ng-disabled=\"!data.administration.enable\" data-toggle=\"modal\" data-target=\"#crudAddSection\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nueva sección</button></div></div><div class=\"row form-group admin-form\"><div class=\"box-left\"><label class=\"label-form\">Agrupar por</label></div><div class=\"box-rigth\"><input type=\"text\" class=\"form-control\" data-ng-disabled=\"!data.administration.enable\" data-ng-model=\"data.administration.group\"> <button class=\"btn btn-primary btn-op mT10\" data-ng-disabled=\"!data.administration.enable\"><i class=\"fa fa-plus\" aria-hidden=\"true\"></i> Nuevo grupo</button></div></div><div class=\"col-xs-12 mT20\"><button type=\"submit\" data-ng-click=\"generateCrud()\" class=\"btn btn-primary pull-right btn-op\" data-ng-disabled=\"data.dataEstructure.length ==0\"><i class=\"fa fa-magic\" aria-hidden=\"true\"></i> Generar Crud</button> <button data-ng-disabled=\"crudStep == 1\" data-ng-click=\"changeValue(crudStep-1)\" style=\"margin-right: 20px;\" class=\"btn btn-primary pull-right\">Anterior</button></div>");
$templateCache.put("app/views/directives/datepicker/datepicker.html","<p class=\"input-group\"><input type=\"text\" style=\"width: 100%;\" class=\"form-control\" datepicker-popup=\"{{format}}\" ng-model=\"ngModel\" ng-change=\"ngChange\" is-open=\"opened\" min=\"minDate\" max=\"\'2015-06-22\'\" datepicker-options=\"dateOptions\" date-disabled=\"disabled(date, mode)\" ng-required=\"true\" close-text=\"Close\"> <span class=\"input-group-btn\"><button class=\"btn form-control\" style=\"min-width: 35px;border-left: 0;\" ng-click=\"open($event)\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></p>");
$templateCache.put("app/views/directives/crudform/customModals/addEvent.html","<div class=\"cmodal-content medium\"><div class=\"cmodal-header\"><h4 class=\"modal-title\">{{switchText(\'Agregar evento\', \'Add event\')}}</h4></div><div class=\"cmodal-body\"><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Nombre\', \'Name\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Tipo\', \'Type\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Fecha\', \'Date\')}}</p></div><div class=\"data-cont\"><mydatepicker ng-model=\"selected[dato.name]\" date-options=\"dateOptions\" opened=\"opened\" data-ng-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Tipo\', \'Type\')}}</p></div><div class=\"data-cont\"><textarea name=\"\" style=\"min-height: 50px\" class=\"form-control\"></textarea></div></div></div><div class=\"cmodal-footer\"><button type=\"button\" class=\"btn btn-theme pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"button\" class=\"btn btn-theme red pull-right\" data-ng-click=\"\">Confirmar</button></div></div>");
$templateCache.put("app/views/directives/crudform/customModals/addProjectStage.html","<div class=\"cmodal-content medium\"><div class=\"cmodal-header\"><h4 class=\"modal-title\">{{switchText(\'Agregar etapa\', \'Add project stage\')}}</h4></div><div class=\"cmodal-body\"><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Nombre\', \'Name\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Orden\', \'Order\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Fecha inicio\', \'Start Date\')}}</p></div><div class=\"data-cont\"><mydatepicker ng-model=\"selected[dato.name]\" date-options=\"dateOptions\" opened=\"opened\" data-ng-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Fecha cierre\', \'Closing date\')}}</p></div><div class=\"data-cont\"><mydatepicker ng-model=\"selected[dato.name]\" date-options=\"dateOptions\" opened=\"opened\" data-ng-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div></div><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Descripción\', \'Description\')}}</p></div><div class=\"data-cont\"><textarea name=\"\" style=\"min-height: 50px\" class=\"form-control\"></textarea></div></div></div><div class=\"cmodal-footer\"><button type=\"button\" class=\"btn btn-theme pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"button\" class=\"btn btn-theme red pull-right\" data-ng-click=\"\">Confirmar</button></div></div>");
$templateCache.put("app/views/directives/crudform/customModals/addUser.html","<div class=\"cmodal-content medium\"><div class=\"cmodal-header\"><h4 class=\"modal-title\">{{switchText(\'Agregar usuario\', \'Add user\')}}</h4></div><div class=\"cmodal-body\"><div class=\"data-box\"><div class=\"data-label\"><p>{{switchText(\'Correo electrónico\', \'Email\')}}</p></div><div class=\"data-cont\"><input type=\"text\" data-ng-model=\"newComment\" class=\"form-control\"></div></div></div><div class=\"cmodal-footer\"><button type=\"button\" class=\"btn btn-theme pull-left\" data-ng-click=\"closeCustomModal2()\">Cancelar</button> <button type=\"button\" class=\"btn btn-theme red pull-right\" data-ng-click=\"\">Confirmar</button></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/uicontextualmenu.html","<div><ng-include src=\"currentTemplate\"></ng-include></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiexcel/uiexcel.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\"><div class=\"form-header sub {{$root.currentModule}}\"><h3>Cargar entradas desde un archivo Excel</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms\"><h5><strong>Paso 1: Cargue un archivo y a continuación seleccione \"leer archivo\"</strong></h5></div><div class=\"forms\" data-ng-if=\"!dato.hide\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle-2\" data-ng-show=\"dato.subtitle\" render-html=\"dato.subtitle\"></h4><hr data-ng-if=\"dato.hr\" style=\"margin: 10px 0 20px 0;\"></div><div class=\"box-label\"><span class=\"filter-label\" data-ng-bind-html=\"dato.invalid+dato.label\" data-ng-class=\"{\'text-danger\':dato.invalid}\"></span> <small data-ng-bind-html=\"dato.helpText\"></small></div><div class=\"box-input webcontent\" style=\"padding: 0\"><ng-include data-ng-if=\"dato.type==\'innerCrud\'\" src=\"\'app/scripts/directives/uibuilder/components/uiformwidgets/innercrud.html\'\"></ng-include><div data-ng-if=\"dato.type==\'log\'\"><p data-ng-init=\"toJson($root[modelName].selected[key])\"></p><p data-ng-bind-html=\"$root[modelName].selected.logrender\"></p></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'text\'\" name=\"{{key}}\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, $root[modelName].selected[key] ,key)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'number\'\" name=\"{{key}}\" min=\"0\" step=\"0.01\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, $root[modelName].selected[key] ,key)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'email\'\" data-ng-disabled=\"dato.disabled\"><select class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange($root[modelName])\" data-ng-options=\"item.id as item[dato.itemsLabel] for item in $root[modelName].properties[key].items\" data-ng-if=\"dato.type==\'select\' && $root[modelName].properties[key].items\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && $root[modelName].actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && $root[modelName].actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><button data-ng-if=\"dato.type==\'select\' && dato.onclick==true && !$root[modelName].properties[key].items\" data-ng-click=\"$root.loadItemList($root[modelName].properties[key], dato.itemsSource)\" type=\"button\" class=\"btn btn-primary\">Cargar elementos</button><select class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange($root[modelName])\" data-ng-options=\"item.id as item[dato.itemsLabel].es for item in $root[modelName].properties[key].items\" data-ng-if=\"dato.type==\'selectArray\'\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && $root[modelName].actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && $root[modelName].actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><color-picker data-ng-if=\"dato.type==\'color\'\" ng-model=\"$root[modelName].selected[key]\" options=\"$root.colorOptions\"></color-picker><div class=\"col-xs-12\" data-ng-if=\"dato.type==\'laundry\'\"><p>Seleccionado : {{$root[modelName].selected[key]}}</p><div class=\"icon-care i{{$index+1}}\" data-ng-click=\"$root[modelName].selected[key]=$index+1\" data-ng-class=\"{\'active\': ($index+1) === $root[modelName].selected[key]}\" data-ng-repeat=\"item in [1,1,1,1,1,1,1,1,1,1,1,1,1,1,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1] track by $index\">{{$index+1}}</div></div><div data-ng-if=\"dato.type==\'switch\'\"><label class=\"switch\"><input type=\"checkbox\" ng-model=\"$root[modelName].selected[key]\"> <span class=\"slider\"></span></label></div><div data-ng-if=\"dato.type==\'date\'\"><mydatepicker ng-model=\"$root[modelName].selected[key]\" date-options=\"dateOptions\" opened=\"opened\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><textarea class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-required=\"dato.required\" style=\"min-height: 70px\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\"></textarea><text-angular data-ng-model=\"$root[modelName].selected[key]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"loadToolBar(dato.toolbar)\" data-ng-disabled=\"dato.disabled\"></text-angular><div data-ng-if=\"dato.type==\'file\'\" class=\"upload-box\"><div class=\"upload-preview\" data-ng-if=\"!selected[key+\'_file\'].name\"><img data-ng-if=\"dato.fileType == \'image\'\" ng-src=\"{{$root.api+$root[modelName].selected[key]}}\" alt=\"\"> <button class=\"upload-btn\" data-ngf-select=\"\" data-ng-model=\"$root[modelName].selected[key+\'_file\']\" data-ngf-max-size=\"4096MB\"><i class=\"fas fa-cloud-upload-alt\"></i></button> <a class=\"upload-btn\" style=\"padding-left: 9px;\" data-ng-click=\"$root[modelName].selected[key]=\'\'\"><i class=\"fas fa-times\"></i></a> <a target=\"_blank\" style=\"display: block;width: calc(100% - 80px);margin-top: 5px\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><i class=\"fas fa-link\" data-ng-if=\"$root[modelName].selected[key]!=\'\'\"></i> {{$root[modelName].selected[key]}}</a></div><div data-ng-if=\"$root[modelName].selected[key+\'_file\'].name\" class=\"upload-preview\"><span data-ng-if=\"dato.fileType != \'image\'\">{{selected[key]}}</span> <a style=\"display: block;width: calc(100% - 50px); float: left;\">{{ $root[modelName].selected[key+\'_file\'].name }}</a> <img data-ng-if=\"$root[modelName].selected[key+\'_file\'].name!=null\" ngf-thumbnail=\"$root[modelName].selected[key+\'_file\'] || \'/thumb.jpg\'\"> <a class=\"upload-btn\" style=\"opacity: 0.5\" href=\"\"><i class=\"fas fa-check\" style=\"color: green;\"></i></a></div></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected.lat\" data-ng-if=\"dato.type==\'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected.lng\" data-ng-if=\"dato.type==\'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\" data-ng-if=\"dato.type==\'mapLon\' && $root[modelName].actionType==\'edit\'\"><marker position=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><ng-map center=\"-16.495859,-68.133529\" data-ng-if=\"dato.type==\'mapLon\' && $root[modelName].actionType==\'store\'\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><img style=\"max-width: 50%; display: block; border: 2px solid #000000; padding: 10px; margin-top: 15px; margin-bottom: 15px; margin-left: auto; margin-right: auto; opacity: 0.8;\" data-ng-if=\"dato.widget == \'preview\'\" data-ng-src=\"/assets/images/widgets/widget_{{$root[modelName].selected.type}}.png\" alt=\"\"><div data-ng-if=\"dato.type==\'json\'\" class=\"webcontent\"><div data-ng-repeat=\"(k, v) in $root[modelName].selected[key]\" style=\"position: relative; display: flex;\"><input data-ng-if=\"dato.jsonType==\'text\'\" type=\"text\" class=\"form-control lan\" data-ng-model=\"$root[modelName].selected[key][k]\"> <textarea class=\"form-control lan\" data-ng-model=\"$root[modelName].selected[key][k]\" data-ng-required=\"dato.required\" style=\"min-height: 70px\" data-ng-if=\"dato.jsonType==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\r\n            </textarea><div><text-angular data-ng-model=\"$root[modelName].selected[key][k]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.jsonType==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"loadToolBar(dato.toolbar)\" data-ng-disabled=\"dato.disabled\"></text-angular></div><button class=\"btn btn-default btn-flag\"><span class=\"lan-flag {{k}}\"><i class=\"fas fa-map-marker-alt\" data-ng-if=\"k == \'lat\' || k == \'lon\'\"></i></span></button></div></div></div></div><div class=\"forms\"><button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button> <button type=\"button\" data-ng-disabled=\"!$root.backupTickets.file\" data-ng-click=\"saveTickets();\" class=\"btn btn-action success pull-right\">Almacenar entradas</button> <button type=\"button\" style=\"margin-right: 10px;\" data-ng-click=\"uploadExcel();\" class=\"btn btn-action grey pull-right\">Leer archivo</button><h3 ng-if=\"backupTickets.diff.length==0\">No existen diferencias con esta versión de la base de datos</h3></div><div class=\"forms\" data-ng-if=\"$root.backupTickets.file\"><h5><strong>Paso 2: Verifique los datos ingresados, para guardar seleccione \"Almacenar tickets\"</strong></h5><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código de la entrada</strong></th><th class=\"column-title\"><strong>Validez</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\"><tr class=\"test {{$root.currentModule}}\" data-ng-repeat=\"item in $root.backupTickets.file\"><td></td><td>{{item.id}}</td><td>{{item.code}}</td><td data-ng-class=\"{\'success\': true }\">Si</td></tr></tbody></table></div></div><div class=\"forms\" data-ng-if=\"$root.backupTickets.file\"><button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button> <button type=\"button\" data-ng-disabled=\"!$root.backupTickets.file\" data-ng-click=\"saveTickets();\" class=\"btn btn-action success pull-right\">Almacenar entradas</button> <button type=\"button\" style=\"margin-right: 10px;\" data-ng-click=\"uploadExcel();\" class=\"btn btn-action grey pull-right\">Leer archivo</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uidefaultform/uidefaultform.html","<div class=\"crud-form-body\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3,\'level4\':level==4,\'level5\':level==5}\"><form class=\"crud-form wow slideInLeft\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3 data-ng-if=\"$root[modelName].actionType==\'store\'\"><i class=\"fa fa-plus\"></i> Nuevo {{ modelName }}</h3><h3 data-ng-if=\"$root[modelName].actionType==\'update\'\"><i class=\"fas fa-edit\"></i> Editar {{ $root[modelName].selected[referenceField]?modelName:$root[modelName].selected[referenceField] }}</h3><h3 data-ng-if=\"$root[modelName].actionType==\'delete\'\"><i class=\"fas fa-exclamation-triangle\" style=\"color: #d94a4a;\"></i> Eliminar {{ $root[modelName].selected[referenceField]?modelName:$root[modelName].selected[referenceField] }}</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms\" data-ng-if=\"!dato.hide\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle-2\" data-ng-show=\"dato.subtitle\" render-html=\"dato.subtitle\"></h4><hr data-ng-if=\"dato.hr\" style=\"margin: 10px 0 20px 0;\"></div><div class=\"box-label\"><span class=\"filter-label\" data-ng-bind-html=\"dato.invalid+dato.label+(dato.required==true?\' *\':\'\')\" data-ng-class=\"{\'text-danger\':dato.invalid}\"></span> <small data-ng-bind-html=\"dato.helpText\"></small></div><div class=\"box-input webcontent\" style=\"padding: 0\"><ng-include data-ng-if=\"dato.type==\'innerCrud\'\" src=\"\'app/scripts/directives/uibuilder/components/uiformwidgets/innercrud.html\'\"></ng-include><div data-ng-if=\"dato.type==\'log\'\"><p data-ng-init=\"toJson($root[modelName].selected[key])\"></p><p data-ng-bind-html=\"$root[modelName].selected.logrender\"></p></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'text\'\" name=\"{{key}}\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, $root[modelName].selected[key] ,key)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'number\'\" name=\"{{key}}\" min=\"0\" step=\"0.01\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, $root[modelName].selected[key] ,key)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'email\'\" data-ng-disabled=\"dato.disabled\"><select class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange($root[modelName])\" data-ng-options=\"item.id as item[dato.itemsLabel] for item in $root[modelName].properties[key].items\" data-ng-if=\"dato.type==\'select\' && $root[modelName].properties[key].items\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && $root[modelName].actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && $root[modelName].actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><button data-ng-if=\"dato.type==\'select\' && dato.onclick==true && !$root[modelName].properties[key].items\" data-ng-click=\"$root.loadItemList($root[modelName].properties[key], dato.itemsSource)\" type=\"button\" class=\"btn btn-primary\">Cargar elementos</button><select class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange($root[modelName])\" data-ng-options=\"item.id as item[dato.itemsLabel].es for item in $root[modelName].properties[key].items\" data-ng-if=\"dato.type==\'selectArray\'\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && $root[modelName].actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && $root[modelName].actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><color-picker data-ng-if=\"dato.type==\'color\'\" ng-model=\"$root[modelName].selected[key]\" options=\"$root.colorOptions\"></color-picker><div class=\"col-xs-12\" data-ng-if=\"dato.type==\'laundry\'\"><p>Seleccionado : {{$root[modelName].selected[key]}}</p><div class=\"icon-care i{{$index+1}}\" data-ng-click=\"$root[modelName].selected[key]=$index+1\" data-ng-class=\"{\'active\': ($index+1) === $root[modelName].selected[key]}\" data-ng-repeat=\"item in [1,1,1,1,1,1,1,1,1,1,1,1,1,1,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1] track by $index\">{{$index+1}}</div></div><div data-ng-if=\"dato.type==\'switch\'\"><label class=\"switch\"><input type=\"checkbox\" ng-model=\"$root[modelName].selected[key]\"> <span class=\"slider\"></span></label></div><div data-ng-if=\"dato.type==\'date\'\"><mydatepicker ng-model=\"$root[modelName].selected[key]\" date-options=\"dateOptions\" opened=\"opened\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><textarea class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-required=\"dato.required\" style=\"min-height: 70px\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\r\n       </textarea><text-angular data-ng-model=\"$root[modelName].selected[key]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"loadToolBar(dato.toolbar)\" data-ng-disabled=\"dato.disabled\"></text-angular><div data-ng-if=\"dato.type==\'file\'\" class=\"upload-box\"><div class=\"upload-preview\" data-ng-if=\"!selected[key+\'_file\'].name\"><img data-ng-if=\"dato.fileType == \'image\'\" ng-src=\"{{$root.api+$root[modelName].selected[key]}}\" alt=\"\"> <button class=\"upload-btn\" data-ngf-select=\"\" data-ng-model=\"$root[modelName].selected[key+\'_file\']\" data-ngf-max-size=\"4096MB\"><i class=\"fas fa-cloud-upload-alt\"></i></button> <a class=\"upload-btn\" style=\"padding-left: 9px;\" data-ng-click=\"$root[modelName].selected[key]=\'\'\"><i class=\"fas fa-times\"></i></a> <a target=\"_blank\" style=\"display: block;width: calc(100% - 80px);margin-top: 5px\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><i class=\"fas fa-link\" data-ng-if=\"$root[modelName].selected[key]!=\'\'\"></i> {{$root[modelName].selected[key]}}</a></div><div data-ng-if=\"$root[modelName].selected[key+\'_file\'].name\" class=\"upload-preview\"><span data-ng-if=\"dato.fileType != \'image\'\">{{selected[key]}}</span> <a style=\"display: block;width: calc(100% - 50px); float: left;\">{{ $root[modelName].selected[key+\'_file\'].name }}</a> <img data-ng-if=\"$root[modelName].selected[key+\'_file\'].name!=null\" ngf-thumbnail=\"$root[modelName].selected[key+\'_file\'] || \'/thumb.jpg\'\"> <a class=\"upload-btn\" style=\"opacity: 0.5\" href=\"\"><i class=\"fas fa-check\" style=\"color: green;\"></i></a></div></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected.lat\" data-ng-if=\"dato.type==\'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected.lng\" data-ng-if=\"dato.type==\'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\" data-ng-if=\"dato.type==\'mapLon\' && $root[modelName].actionType==\'edit\'\"><marker position=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><ng-map center=\"-16.495859,-68.133529\" data-ng-if=\"dato.type==\'mapLon\' && $root[modelName].actionType==\'store\'\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><img style=\"max-width: 50%; display: block; border: 2px solid #000000; padding: 10px; margin-top: 15px; margin-bottom: 15px; margin-left: auto; margin-right: auto; opacity: 0.8;\" data-ng-if=\"dato.widget == \'preview\'\" data-ng-src=\"/assets/images/widgets/widget_{{$root[modelName].selected.type}}.png\" alt=\"\"><div data-ng-if=\"dato.type==\'json\'\" class=\"webcontent\"><div data-ng-repeat=\"(k, v) in $root[modelName].selected[key]\" style=\"position: relative; display: flex;\"><input data-ng-if=\"dato.jsonType==\'text\'\" type=\"text\" class=\"form-control lan\" data-ng-model=\"$root[modelName].selected[key][k]\"> <textarea class=\"form-control lan\" data-ng-model=\"$root[modelName].selected[key][k]\" data-ng-required=\"dato.required\" style=\"min-height: 70px\" data-ng-if=\"dato.jsonType==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\r\n            </textarea><div><text-angular data-ng-model=\"$root[modelName].selected[key][k]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.jsonType==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"loadToolBar(dato.toolbar)\" data-ng-disabled=\"dato.disabled\"></text-angular></div><button class=\"btn btn-default btn-flag\"><span class=\"lan-flag {{k}}\"><i class=\"fas fa-map-marker-alt\" data-ng-if=\"k == \'lat\' || k == \'lon\'\"></i></span></button></div></div></div></div><div class=\"forms buttons\"><button type=\"submit\" class=\"btn btn-action success pull-right\">Guardar</button> <button data-ng-click=\"$root[modelName].resetRegister()\" type=\"button\" data-ng-disabled=\"$root[modelName].$root[modelName].actionType == \'store\'\" class=\"btn btn-action info pull-right\">Revertir</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root[modelName].resetRegister(true);\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicrudgrid/crudgrid.html","<div class=\"crud-grid-body wow fadeInUp\"><div class=\"row\"><div class=\"col-xs-12\"><a class=\"btn btn-action\" data-ng-if=\"$root[modelName].operations.create\" data-ng-click=\"$root.chooseRegister(modelName, {}, \'store\');\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Nuevo\', \'New\')}}</a> <a class=\"btn btn-action\" data-ng-if=\"$root[modelName].operations.createinventory\" data-ng-click=\"$root.chooseRegister(modelName, {}, \'store\', false, \'uiinventoryform\');\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Nuevo\', \'New\')}}</a> <a class=\"btn btn-action\" data-ng-if=\"modelName == \'movieticket\' || modelName == \'movieticketbatch\'\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component:\'uiexcel\', model:\'movieticketbatch\'},true)\"><i class=\"fa fa-upload\"></i> {{$root.switchText(\'Cargar desde archivo\', \'Load from file\')}}</a> <a class=\"btn btn-action\" data-ng-if=\"modelName == \'mpromo\'\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component:\'uiticket\', model:\'mpromo\'},false)\"><i class=\"fa fa-magic\"></i> {{$root.switchText(\'Generar varios\', \'Load from file\')}}</a> <a class=\"btn btn-action\" data-ng-if=\"modelName == \'voucher\'\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component:\'uireport\', model:\'voucher\'},false)\"><i class=\"fa fa-magic\"></i> {{$root.switchText(\'Reporte de venta\', \'Sales report\')}}</a> <a class=\"btn btn-action\" data-ng-if=\"$root[modelName].operations.download == true\" data-ng-click=\"$root.downloadexcel(modelName,{})\"><i class=\"fa fa-download\" aria-hidden=\"true\"></i> Descargar</a> <a href=\"{{$root.excelPath}}\" data-ng-if=\"$root[modelName].operations.download == true\" target=\"_blank\">Link al archivo</a></div></div><uifilters data-ng-if=\"$root[modelName].ready\" model-name=\"{{modelName}}\"></uifilters><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th data-ng-repeat=\"(key, properties) in $root[modelName].properties\" data-ng-if=\"!properties.hideGrid\" data-ng-click=\"sortBy(key)\" data-ng-class=\"{active: propertyName == key}\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName != key\" class=\"fa fa-sort\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == key && dir==\'desc\'\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == key && dir==\'asc\'\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\"><td style=\"cursor: pointer\" data-ng-click=\"$root.chooseRegister(modelName, register,\'read\')\" data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" data-ng-if=\"!dato.hideGrid\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\" style=\"max-height: 100px;overflow: hidden;\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\' && dato.type!=\'json\' && dato.type!=\'switch\'\" data-ng-bind-html=\"register[key]\"></p><p data-ng-if=\"dato.type==\'switch\'\">{{ register[key] == \'1\'? \'si\':\'no\' }}</p><p data-ng-if=\"dato.type==\'date\'\">{{ $root.dateToSpanishFormat(register[key]) }}</p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><div data-ng-if=\"dato.type==\'json\'\"><p>{{register[key].es}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{$root.api+register[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+register[key]}}\"></a></div></td></tr><tr data-ng-if=\"dataset.result.data.length==0\" style=\"text-align: center\"><td colspan=\"{{dataset.properties.length+1}}\"><strong><i class=\"fa fa-search\"></i> No se encontraron resultados...</strong></td></tr></tbody></table></div><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html","<div class=\"container-fluid\"><div class=\"crud-grid-pagination\"><div class=\"pagination-nav-options\" data-ng-class=\"$root.currentModule\"><button data-ng-click=\"changePage(1)\" data-ng-disabled=\"(filters.page)<=1\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\">{{$root.switchText(\'Inicio\', \'First\')}}</button> <button data-ng-click=\"changePage(\'decrease\')\" data-ng-disabled=\"(filters.page)<=1\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\"><i class=\"fa fa-angle-left\" aria-hidden=\"true\"></i></button> <span>{{$root[modelName].dataset.current_page}} {{$root.switchText(\'de\', \'from\')}} {{$root[modelName].dataset.last_page}}</span> <button data-ng-click=\"changePage(\'increase\')\" data-ng-disabled=\"(filters.page)>=$root[modelName].dataset.last_page\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\"><i class=\"fa fa-angle-right\" aria-hidden=\"true\"></i></button> <button data-ng-click=\"changePage($root[modelName].dataset.last_page)\" data-ng-disabled=\"(filters.page)>=$root[modelName].dataset.last_page\" data-ng-class=\"$root.currentModule\" type=\"button\" class=\"btn btn-grid\">{{$root.switchText(\'Último\', \'Last\')}}</button></div><div class=\"pagination-records\" data-ng-class=\"$root.currentModule\"><div class=\"form-group flex\"><span class=\"filter-label\">Mostrar:</span><select data-ng-model=\"filters.per_page\" data-ng-class=\"$root.currentModule\" data-ng-change=\"changePerPage(filters.per_page)\" class=\"form-control\"><option value=\"10\">10</option><option value=\"10\">10</option><option value=\"20\">20</option><option value=\"50\">50</option><option value=\"100\">100</option></select></div></div><div class=\"pagination-total\" data-ng-class=\"$root.currentModule\"><span class=\"result\">{{$root.switchText(\'Registros\', \'Records\')}}: {{$root[modelName].dataset.total}}</span></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uifilters/uifilters.html","<div><ng-include src=\"currentTemplate\"></ng-include></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiformwidgets/customcontent.html","<div class=\"manual-wrapper\"><div class=\"content\"><div class=\"content-box\" data-ng-if=\"subitem.type==0\" data-ng-bind-html=\"$root.transl(subitem.content)\"></div><a class=\"content-box img\" data-ng-if=\"subitem.type==1\" target=\"_blank\" href=\"{{ $root.api+subitem.image }}\"><img class=\"image-view\" ng-src=\"{{ $root.api+subitem.image }}\" alt=\"{{subitem.name}}\" style=\"max-height: 150px;\"></a><div class=\"content-box video\" data-ng-if=\"subitem.type==2\" style=\"margin-bottom: 20px\"><div class=\"video\" my-youtube=\"\" code=\"subitem.link\"></div></div><div class=\"content-box slider\" data-ng-if=\"subitem.type==3\"><ng-owl-carousel class=\"owl-theme gallery-wrapper\" owl-items=\"subitem.websectiondataitem\" owl-properties=\"$root.defaultOwlConf\" owl-ready=\"$root.ready($api)\"><div class=\"gallery-item\" data-ng-repeat=\"item in subitem.websectiondataitem\"><img ng-src=\"{{ $root.api+item.image }}\" alt=\"{{item.name}}\" style=\"max-height: 150px;margin-bottom: 10px;\"></div></ng-owl-carousel></div><div class=\"content-box accordion\" data-ng-if=\"subitem.type==4\"><accordion close-others=\"oneAtATime\"><div accordion-group=\"\" data-ng-repeat=\"subitem2 in subitem.websectiondataitem\" class=\"panel-default panel-bid\" is-open=\"faq.status[$index].open\"><accordion-heading><img ng-src=\"{{$root.api+subitem2.image}}\" alt=\"\"> {{$root.transl(subitem2.title)}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-chevron-down\': faq.status[$index].open, \'glyphicon-chevron-right\': !faq.status[$index].open}\"></i></accordion-heading><p data-ng-bind-html=\"$root.transl(subitem2.content)\"></p></div></accordion></div><a class=\"content-box btn-cta\" data-ng-if=\"subitem.type==5\" target=\"_blank\" href=\"{{subitem.link}}\"><div class=\"content-box-icon\" data-ng-if=\"subitem.image!=\'\'\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\" data-ng-bind-html=\"subitem.title\"></h3><div class=\"content-box-icon-2\"><img src=\"assets/images/icon/icon-link.png\" alt=\"\"></div></a> <a class=\"content-box btn-cta\" data-ng-if=\"subitem.type==17\" target=\"_blank\" href=\"{{subitem.link}}\"><div class=\"content-box-icon\" data-ng-if=\"subitem.image!=\'\'\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\" data-ng-bind-html=\"subitem.title\"></h3><div class=\"content-box-icon-2\"><img src=\"assets/images/icon/icon-descarga.png\" alt=\"\"></div></a> <a class=\"content-box btn-cta\" data-ng-if=\"subitem.type==18\" target=\"_blank\" href=\"{{subitem.link}}\"><div class=\"content-box-icon\" data-ng-if=\"subitem.image!=\'\'\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\" data-ng-bind-html=\"subitem.title\"></h3><div class=\"content-box-icon-2\"><img src=\"assets/images/icon/icon-pdf.png\" alt=\"\"></div></a> <a class=\"content-box btn-cta\" data-ng-if=\"subitem.type==19\" target=\"_blank\" href=\"{{subitem.link}}\"><div class=\"content-box-icon\" data-ng-if=\"subitem.image!=\'\'\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\" data-ng-bind-html=\"subitem.title\"></h3><div class=\"content-box-icon-2\"><img src=\"assets/images/icon/icon-video.png\" alt=\"\"></div></a> <a class=\"content-box btn-cta\" data-ng-if=\"subitem.type==20\" target=\"_blank\" href=\"{{subitem.link}}\"><div class=\"content-box-icon\" data-ng-if=\"subitem.image!=\'\'\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\" data-ng-bind-html=\"subitem.title\"></h3><div class=\"content-box-icon-2\"></div></a><div class=\"content-box list-cta\" data-ng-if=\"subitem.type==6\"><div class=\"list-cta-item\" data-ng-repeat=\"item in subitem.websectiondataitem\"><div class=\"content-box-icon\"><p>{{$index+1}}</p></div><h3 class=\"content-box-title\">{{item.title.es}}</h3><a class=\"content-box-icon-2\" href=\"{{item.link}}\" target=\"_blank\"><i class=\"fas fa-arrow-down\"></i></a></div></div><div class=\"content-box informative type-1\" data-ng-if=\"subitem.type==7\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"content-box informative type-2\" data-ng-if=\"subitem.type==8\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"content-box informative type-3\" data-ng-if=\"subitem.type==9\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"content-box informative type-4\" data-ng-if=\"subitem.type==10\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"content-box informative type-5\" data-ng-if=\"subitem.type==11\"><div class=\"content-box-header\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3></div><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"content-box filled color-primary type-1\" data-ng-if=\"subitem.type==12\"><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div><div class=\"btn-small secondary\" data-ng-if=\"subitem.link!=\'\'\">Boton de descarga</div></div><div class=\"content-box filled color-primary type-2\" data-ng-if=\"subitem.type==13\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"content-box filled color-secondary type-1\" data-ng-if=\"subitem.type==14\"><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div><div class=\"btn-small primary\" data-ng-if=\"subitem.link!=\'\'\">Boton de descarga</div></div><div class=\"content-box filled color-secondary type-2\" data-ng-if=\"subitem.type==15\"><div class=\"content-box-icon\"><img ng-src=\"{{ $root.api+subitem.image }}\" alt=\"\"></div><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"content-box fill-mixed\" data-ng-if=\"subitem.type==16\"><div class=\"inner-box top\"><h3 class=\"content-box-title\">{{subitem.title}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.content.es\"></div></div><div class=\"inner-box bottom\"><h3 class=\"content-box-title\">{{subitem.title2}}</h3><div class=\"content-box-text\" data-ng-bind-html=\"subitem.link\"></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiformwidgets/innercrud.html","<div class=\"innercrud-box\" style=\"width: 100%\" data-ng-if=\"dato.type==\'innerCrud\'\"><input style=\"cursor: not-allowed;\" type=\"text\" disabled=\"\" placeholder=\"Almacene el registro, para habilitar este campo\" class=\"form-control\" data-ng-if=\"$root[modelName].actionType==\'store\'\"> <button class=\"btn btn-action\" data-ng-if=\"dato.saveMany && $root[modelName].actionType==\'update\'\" type=\"button\" style=\"margin-bottom: 5px;float: left; margin-right: 5px\" data-ng-disabled=\"dato.disabled\" data-ng-click=\"$root.openPicker(dato.model, dato.modelAs, key)\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Agregar varios\', \'Add New\')}}</button><div class=\"grid-table-box {{$root.currentModule}}\" data-ng-if=\"$root[modelName].actionType!=\'store\' && dato.presentation.type==\'article\' && dato.items.length > 0\"><table class=\"table table-hover small\"><thead><tr><th>#</th><th class=\"\"><strong>Artículo</strong></th><th class=\"\"><strong>Fecha</strong></th><th class=\"\"><strong>Portada</strong></th><th class=\"\"><strong><i class=\"fas fa-wrench\"></i></strong></th></tr></thead><tbody><tr data-ng-repeat=\"subitem in dato.items\" class=\"{{$root.currentModule}}\"><td>{{$index+1}}</td><td>{{subitem.name}}</td><td>{{subitem.created_at}}</td><td><a href=\"\"><img ng-src=\"{{$root.api+subitem.image}}\" style=\"width: 80px; margin-right: 5px\" alt=\"\"></a></td><td><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" style=\"margin-right: 5px\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></td></tr></tbody></table></div><div class=\"grid-table-box {{$root.currentModule}}\" data-ng-if=\"$root[modelName].actionType!=\'store\' && dato.presentation.type==\'render2\' && dato.items.length > 0\"><table class=\"table table-hover small\"><thead><tr><th class=\"\" style=\"width: 55px\"><strong>Orden</strong></th><th class=\"\"><strong>Contenido</strong></th><th style=\"width: 55px\"><strong><i class=\"fas fa-wrench\"></i></strong></th></tr></thead><tbody><tr data-ng-repeat=\"subitem in dato.items | orderBy:\'order\'\" class=\"{{$root.currentModule}}\"><td><i data-ng-click=\"reOrder(modelName, key, dato, subitem, dato.items[$index+1] )\" data-ng-if=\"$index < dato.items.length-1\" class=\"fas fa-arrow-down\" style=\"margin-right: 5px\"></i> <i data-ng-click=\"reOrder(modelName, key, dato, subitem, dato.items[$index-1] )\" data-ng-if=\"$index > 0\" class=\"fas fa-arrow-up\" style=\"margin-right: 5px\"></i></td><td><div class=\"manual-wrapper\"><div class=\"content\"><a data-ng-if=\"$root.websectiondata.selected.type==3\" class=\"content-box img\" target=\"_blank\" href=\"{{ $root.api+subitem.link }}\"><img class=\"image-view\" ng-src=\"{{ $root.api+subitem.image }}\" alt=\"{{subitem.name}}\" style=\"max-height: 150px;\"></a><div data-ng-if=\"$root.websectiondata.selected.type==4\" class=\"content-box accordion\"><accordion close-others=\"oneAtATime\"><div accordion-group=\"\" class=\"panel-default panel-bid\" is-open=\"faq.status[$index].open\"><accordion-heading>{{$root.transl(subitem.title)}} <i class=\"pull-right glyphicon\" ng-class=\"{\'glyphicon-minus\': faq.status[$index].open, \'glyphicon-plus\': !faq.status[$index].open}\"></i></accordion-heading><p data-ng-bind-html=\"$root.transl(subitem.content)\"></p></div></accordion></div></div></div></td><td><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" style=\"margin-right: 5px\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></td></tr></tbody></table></div><div class=\"grid-table-box {{$root.currentModule}}\" data-ng-if=\"$root[modelName].actionType!=\'store\' && dato.presentation.type==\'render\' && dato.items.length > 0\"><table class=\"table table-hover small\"><thead><tr><th class=\"\" style=\"width: 55px\"><strong>Orden</strong></th><th class=\"\"><strong>Contenido</strong></th><th style=\"width: 55px\"><strong><i class=\"fas fa-wrench\"></i></strong></th></tr></thead><tbody><tr data-ng-repeat=\"subitem in dato.items | orderBy:\'order\'\" class=\"{{$root.currentModule}}\"><td><i data-ng-click=\"reOrder(modelName, key, dato, subitem, dato.items[$index+1] )\" data-ng-if=\"$index < dato.items.length-1\" class=\"fas fa-arrow-down\" style=\"margin-right: 5px\"></i> <i data-ng-click=\"reOrder(modelName, key, dato, subitem, dato.items[$index-1] )\" data-ng-if=\"$index > 0\" class=\"fas fa-arrow-up\" style=\"margin-right: 5px\"></i></td><td><ng-include src=\"\'app/scripts/directives/uibuilder/components/uiformwidgets/customcontent.html\'\"></ng-include></td><td><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" style=\"margin-right: 5px\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></td></tr></tbody></table></div><div class=\"grid-table-box {{$root.currentModule}}\" data-ng-if=\"$root[modelName].actionType!=\'store\' && dato.presentation.type==\'laundry\' && dato.items.length > 0\"><table class=\"table table-hover small\"><thead><tr><th class=\"\" style=\"width: 55px\"><strong>Icono</strong></th><th class=\"\"><strong>Texto</strong></th><th style=\"width: 55px\"><strong><i class=\"fas fa-wrench\"></i></strong></th></tr></thead><tbody><tr data-ng-repeat=\"subitem in dato.items | orderBy:\'order\'\" class=\"{{$root.currentModule}}\"><td><div class=\"icon-care i{{subitem.icon}}\"></div></td><td>{{subitem.label}}</td><td><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" style=\"margin-right: 5px\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></td></tr></tbody></table></div><div class=\"grid-table-box {{$root.currentModule}}\" data-ng-if=\"$root[modelName].actionType!=\'store\' && dato.presentation.type==\'gallery\' && dato.items.length > 0\"><table class=\"table table-hover small\"><thead><tr><th class=\"\" style=\"width: 55px\"><strong>Foto</strong></th><th class=\"\"><strong>Nombre</strong></th><th style=\"width: 55px\"><strong><i class=\"fas fa-wrench\"></i></strong></th></tr></thead><tbody><tr data-ng-repeat=\"subitem in dato.items | orderBy:\'order\'\" class=\"{{$root.currentModule}}\"><td><a href=\"\" style=\"margin: auto 20px;display: block;\"><img ng-src=\"{{$root.api+subitem.image}}\" style=\"max-width: 80px;max-height: 80px;\" alt=\"\"></a></td><td>{{subitem.name}}</td><td><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" style=\"margin-right: 5px\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></td></tr></tbody></table></div><div class=\"grid-table-box {{$root.currentModule}}\" data-ng-if=\"$root[modelName].actionType!=\'store\' && dato.presentation.type==\'thumb\' && dato.items.length > 0\"><table class=\"table table-hover small\"><thead><tr><th class=\"\" style=\"width: 55px\"><strong>Portada</strong></th><th class=\"\" style=\"width: 55px\"><strong>Color</strong></th><th class=\"\"><strong>Nombre</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Estado</strong></th><th style=\"width: 55px\"><strong><i class=\"fas fa-wrench\"></i></strong></th></tr></thead><tbody><tr data-ng-repeat=\"subitem in dato.items | orderBy:\'order\'\" class=\"{{$root.currentModule}}\"><td><a href=\"\"><img ng-src=\"{{$root.api+subitem.portrait}}\" style=\"max-height: 80px; height:80px; margin-right: 5px\" alt=\"\"></a></td><td><a href=\"\" data-ng-if=\"subitem.showas==\'1\'\"><img ng-src=\"{{$root.api+subitem.image}}\" style=\"width: 40px; height:40px; margin-right: 5px\" alt=\"\"></a> <a href=\"\" data-ng-if=\"subitem.showas==\'0\'\"><div style=\"background-color: {{\'#\'+subitem.color}}; border:1px solid black; width:40px; height:40px;margin-right: 5px;\"></div></a></td><td>{{subitem.name}}</td><td>{{subitem.showas == \'1\' ? \'foto\': \'color\'}}</td><td>{{subitem.isactive == \'1\' ? \'Visible\': \'Oculto\'}}</td><td><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" style=\"margin-right: 5px\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></td></tr></tbody></table></div><div class=\"grid-table-box {{$root.currentModule}}\" data-ng-if=\"$root[modelName].actionType!=\'store\' && dato.presentation.type==\'product\' && dato.items.length > 0\"><table class=\"table table-hover small\"><thead><tr><th class=\"\" style=\"width: 55px\"><strong>Medida</strong></th><th class=\"\"><strong>Código</strong></th><th class=\"\"><strong>Tope de venta</strong></th><th style=\"width: 55px\"><strong><i class=\"fas fa-wrench\"></i></strong></th></tr></thead><tbody><tr data-ng-repeat=\"subitem in dato.items | orderBy:\'order\'\" class=\"{{$root.currentModule}}\"><td>{{subitem.size}}</td><td>{{subitem.code}}</td><td>{{subitem.max}}</td><td><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" style=\"margin-right: 5px\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></td></tr></tbody></table></div><button class=\"btn btn-action\" data-ng-if=\"$root[modelName].actionType==\'update\'\" type=\"button\" style=\"margin-bottom: 5px;float: left;\" data-ng-disabled=\"dato.disabled\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'store\', modelName, dato);\"><i class=\"fa fa-plus\"></i> {{$root.switchText(\'Agregar nuevo\', \'Add New\')}}</button><div class=\"innercrud-item\" data-ng-if=\"$root[modelName].actionType!=\'store\' && dato.presentation==\'thumb\'\" data-ng-repeat=\"subitem in dato.items\"><a href=\"\" data-ng-if=\"subitem.showas==\'1\'\"><img ng-src=\"{{$root.api+subitem.image}}\" style=\"width: 40px; height:40px; margin-right: 5px\" alt=\"\"></a> <a href=\"\" data-ng-if=\"subitem.showas==\'0\'\"><div style=\"background-color: {{\'#\'+subitem.color}}; width:40px; height:40px;margin-right: 5px;\"></div></a><p data-ng-if=\"dato.subType!=\'file\'\" style=\"margin-bottom: 0;\" class=\"item-text {{$root.currentModule}}\">{{subitem.referenceField}}</p><i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></div><div class=\"innercrud-item\" data-ng-if=\"$root[modelName].actionType!=\'store\' && !dato.presentation\" data-ng-repeat=\"subitem in dato.items\"><a href=\"\"><img ng-src=\"{{$root.api+subitem.image}}\" style=\"max-width: 80px;max-height: 80px; margin-right: 5px\" alt=\"\"></a><p data-ng-if=\"dato.subType!=\'file\'\" style=\"margin-bottom: 0;\" class=\"item-text {{$root.currentModule}}\">{{subitem.referenceField}}</p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\"><span>Abrir</span></a> <a target=\"_blank\" data-ng-if=\"dato.subType==\'image\'\" href=\"{{$root.api+subitem.referenceField}}\"><img data-ng-src=\"{{$root.api+ subitem.referenceField }}\" style=\"max-height: 50px\"></a> <i class=\"fas fa-pencil-alt\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'update\', modelName, dato);\"></i> <i class=\"fas fa-times\" data-ng-if=\"$root[modelName].actionType==\'update\'\" data-ng-click=\"$root.setInnerCrud( key, subitem, \'delete\', modelName, dato);\"></i></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiinvoice/uiinvoice.html","<div class=\"crud-form-body level1\"><form class=\"crud-form wow slideInLeft\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister()\"><div data-ng-class=\"{\'danger\':$root.voucher.actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3>Impresión de comprobante</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div id=\"invoice\"><div class=\"forms expanded\"><h3 style=\"text-align: center; margin: 0 0 20px\">Comprobante de pago Nro. {{ $root.voucher.selected.vouchertypeLabel }} {{$root.voucher.selected.code}}</h3><img class=\"client-brand\" style=\"width: 200px; margin: 20px auto;\" src=\"../assets/images/client-brand.svg\" alt=\"AKNA\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.paymentDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Item</strong></th><th class=\"\"><strong>Cant.</strong></th><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Pre.</strong></th><th class=\"\"><strong>Desc.</strong></th><th class=\"\"><strong>Total</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td>#{{$index + 1}}</td><td>{{register.quantity}}</td><td>{{register.description}}</td><td>{{register.value}}</td><td>{{register.discount}}</td><td>{{register.sub}}</td></tr><tr data-ng-if=\"$root.currentModule == \'inventory\' || $root.currentModule == \'purchases\'\"><td colspan=\"5\" style=\"text-align: right\"><strong>Transporte</strong></td><td><strong>{{ $root.voucher.selected.transport_amount}}</strong></td></tr><tr data-ng-if=\"$root.currentModule == \'inventory\' || $root.currentModule == \'purchases\'\"><td colspan=\"5\" style=\"text-align: right\"><strong>Otros</strong></td><td><strong>{{ $root.voucher.selected.other_amount}}</strong></td></tr><tr><td colspan=\"5\" style=\"text-align: right\"><strong>Descuento</strong></td><td><strong>{{ $root.voucher.selected.discount>0? $root.voucher.selected.discount: 0}}%</strong></td></tr><tr><td colspan=\"5\" style=\"text-align: right\"><strong>Total Bs.</strong></td><td><strong>{{ $root.voucher.selected.total>0? $root.voucher.selected.total: 0 }}</strong></td></tr></tbody></table></div></div></div><div class=\"forms expanded\"><button type=\"button\" data-ng-click=\"$root.printDiv(\'invoice\');\" class=\"btn btn-action success pull-right\">Imprimir</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipayment/uipayment.html","<div class=\"crud-form-body level1\"><form class=\"crud-form wow slideInLeft\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"$root.saveVoucher()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3><i class=\"fa fa-plus\"></i> Registrar transaccion</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.paymentDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\"><div class=\"pay-box none-border-bottom\"><div class=\"pay-header\"><h5 style=\"float: left;margin-right: 20px;margin-top: 5px;margin-bottom: 20px;\">{{$root.paymentTitle}}</h5><a data-ng-if=\"$root.currentModule==\'sales\'\" data-ng-click=\"$root.newPay(\'cash\',\'\',false, \'efectivo\')\" class=\"btn-action\">Efectivo Bs.</a> <a data-ng-if=\"$root.currentModule==\'sales\'\" data-ng-click=\"$root.newPay(\'cash\',\'USD\',false, \'efectivo\')\" class=\"btn-action\">Efectivo USD</a> <a data-ng-if=\"$root.currentModule==\'sales\'\" data-ng-click=\"$root.newPay(\'card\',\'\',false, \'tarjeta\')\" class=\"btn-action\">Tarjeta</a> <a data-ng-if=\"$root.currentModule==\'sales\'\" data-ng-click=\"$root.newPay(\'other\',\'\',true, \'Transfer\')\" class=\"btn-action\">Transfer</a> <a data-ng-if=\"$root.currentModule==\'purchases\'\" data-ng-click=\"$root.newPay(\'other\',\'\',true, \'Transfer\')\" class=\"btn-action\">Transfer</a></div></div></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"pay-method\"><div class=\"pay-item-box\" data-ng-repeat=\"tr in $root.voucher.selected.vouchertransaction track by $index | orderBy:\'payment_type\'\"><div class=\"pay-icon\"><svg data-ng-if=\"tr.payment_type==\'cash\'\" class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-efectivo\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-05\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M18.5895126,7.98669683 L18.5895126,6.83822798 C18.5895126,5.66070525 17.7934915,4.67647488 16.7398607,4.45268794 L16.7398607,2.74307091 C16.7398607,2.47798423 16.5361376,2.26284141 16.2851215,2.26284141 L15.0525508,2.26284141 C14.9290891,1.04305848 13.949126,0.089562802 12.7618019,0.089562802 L2.45445502,0.089562802 C1.1839136,0.089562802 0.150063948,1.18112446 0.150063948,2.52288568 L0.150063948,13.4541097 C0.150063948,14.7958709 1.18368623,15.8874326 2.45445502,15.8874326 L16.2851215,15.8874326 C17.5556629,15.8874326 18.5895126,14.7958709 18.5895126,13.4541097 L18.5895126,12.395924 C19.3075458,11.9831667 19.7959358,11.1795027 19.7959358,10.2572219 L19.7959358,10.1258791 C19.7959358,9.20359839 19.3075458,8.39921398 18.5895126,7.98669683 Z M15.8303823,4.40466499 L3.57629672,4.40466499 C3.26798352,4.40466499 3.01696746,4.1395783 3.01696746,3.81422281 C3.01696746,3.4883871 3.26798352,3.22354053 3.57629672,3.22354053 L14.6112264,3.22354053 L15.8301549,3.22354053 L15.8301549,4.40466499 L15.8303823,4.40466499 Z M17.6800341,13.4541097 C17.6800341,14.2661778 17.0543129,14.9269736 16.2851215,14.9269736 L2.45445502,14.9269736 C1.68526361,14.9269736 1.05954242,14.2661778 1.05954242,13.4541097 L1.05954242,2.52288568 C1.05954242,1.7108176 1.68526361,1.0500218 2.45445502,1.0500218 L12.7618019,1.0500218 C13.4468666,1.0500218 14.0182464,1.57443242 14.134887,2.26284141 L3.57629672,2.26284141 C2.76640614,2.26284141 2.10748899,2.95869396 2.10748899,3.8139827 C2.10748899,4.66927144 2.76640614,5.36488387 3.57629672,5.36488387 L16.2851215,5.36488387 C17.0543129,5.36488387 17.6800341,6.02567967 17.6800341,6.83798787 L17.6800341,7.70240097 C17.6177348,7.69711845 17.5552082,7.69231615 17.4917721,7.69231615 L13.7087964,7.69231615 C12.4382549,7.69231615 11.4046327,8.78411792 11.4046327,10.1258791 L11.4046327,10.2572219 C11.4046327,11.598743 12.4382549,12.6903047 13.7087964,12.6903047 L17.4915447,12.6903047 C17.5549808,12.6903047 17.6175075,12.6855024 17.6798067,12.6802199 L17.6798067,13.4541097 L17.6800341,13.4541097 Z M18.8864573,10.2572219 C18.8864573,11.06929 18.2607361,11.7298457 17.4917721,11.7298457 L13.7087964,11.7298457 C12.9398323,11.7298457 12.3141111,11.06929 12.3141111,10.2572219 L12.3141111,10.1258791 C12.3141111,9.31357095 12.9396049,8.65277515 13.7087964,8.65277515 L17.4915447,8.65277515 C18.2605087,8.65277515 18.8862299,9.31357095 18.8862299,10.1258791 L18.8862299,10.2572219 L18.8864573,10.2572219 Z\" id=\"Shape\"></path><ellipse id=\"Oval\" cx=\"13.7708683\" cy=\"10.1911904\" rx=\"0.710075316\" ry=\"0.749878366\"></ellipse></g></g></g></svg><svg data-ng-if=\"tr.payment_type==\'card\'\" class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-tarjeta\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-19\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M17.9217986,4.68226115 L17.2439313,4.68226115 L16.1861765,1.53034885 C15.845177,0.514070674 14.8056509,-0.0126540474 13.868206,0.358267716 L1.39024761,5.28411928 C0.936229683,5.46338495 0.573841714,5.82376167 0.369679477,6.29855207 C0.165517241,6.7736061 0.144128817,7.30613059 0.309403008,7.79832031 L2.84052863,15.3414507 C2.88136108,15.4637731 2.96181072,15.5552513 3.05830169,15.6148308 C3.36624639,16.2211706 3.96099043,16.6326907 4.64298952,16.6326907 L17.9220416,16.6326907 C18.91952,16.6326907 19.7305788,15.7527072 19.7305788,14.6710498 L19.7305788,6.64390211 C19.7305788,5.56224469 18.9192769,4.68226115 17.9217986,4.68226115 Z M3.80641045,7.582147 L18.7583776,7.582147 L18.7583776,8.63665095 L3.80641045,8.63665095 L3.80641045,7.582147 Z M18.7474404,6.52764305 L3.81734771,6.52764305 C3.87057573,6.08264239 4.21838068,5.73676509 4.64274647,5.73676509 L17.9217986,5.73676509 C18.3461644,5.73676509 18.6942124,6.08264239 18.7474404,6.52764305 Z M14.2009418,1.34871055 C14.6338144,1.17761728 15.115297,1.42094407 15.2727936,1.8909892 L16.2095093,4.68226115 L5.75737506,4.68226115 L14.2009418,1.34871055 Z M1.25073675,6.74407999 C1.34504026,6.52447954 1.5125019,6.35786792 1.72225429,6.27508936 L3.03108005,5.75838243 C2.90590916,6.0249083 2.83396628,6.3251783 2.83396628,6.64390211 L2.83396628,12.2404182 L1.22254291,7.43767996 C1.14646818,7.21017073 1.15643324,6.96394406 1.25073675,6.74407999 Z M17.9217986,15.5784504 L4.64298952,15.5784504 C4.18192314,15.5784504 3.8066535,15.1714119 3.8066535,14.6713134 L3.8066535,9.69115489 L18.7586207,9.69115489 L18.7586207,14.6713134 C18.7583776,15.1714119 18.383108,15.5784504 17.9217986,15.5784504 Z\" id=\"Shape\"></path><path d=\"M7.76594258,10.7564675 L5.26471214,10.7564675 C4.99638463,10.7564675 4.77861158,10.9926764 4.77861158,11.2837195 L4.77861158,13.9966945 C4.77861158,14.2877376 4.99638463,14.5239465 5.26471214,14.5239465 L7.76594258,14.5239465 C8.03427009,14.5239465 8.25204314,14.2877376 8.25204314,13.9966945 L8.25204314,11.2837195 C8.25204314,10.9924128 8.03451314,10.7564675 7.76594258,10.7564675 Z M7.27984202,13.4694425 L5.7508127,13.4694425 L5.7508127,11.8109715 L7.27984202,11.8109715 L7.27984202,13.4694425 Z\" id=\"Shape\"></path></g></g></g></svg><svg data-ng-if=\"tr.payment_type==\'other\'\" class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-deposito\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-27\" transform=\"translate(0.000000, 2.000000)\"><path d=\"M19.2563877,5.59601502 L14.3193073,0.381418141 C14.1800395,0.234343717 13.9715024,0.190452396 13.7894577,0.270021457 C13.6078991,0.349590517 13.4895336,0.536706147 13.4895336,0.744355727 L13.4895336,3.19020598 L9.72225429,3.19020598 C9.45392678,3.19020598 9.23615373,3.42018623 9.23615373,3.70355475 C9.23615373,3.98692328 9.45392678,4.21690353 9.72225429,4.21690353 L13.9756342,4.21690353 C14.2439617,4.21690353 14.4617348,3.98692328 14.4617348,3.70355475 L14.4617348,1.98383635 L18.2251253,5.95869593 L14.4617348,9.93329884 L14.4617348,8.21332376 C14.4617348,7.92995524 14.2439617,7.69997498 13.9756342,7.69997498 L5.95157223,7.69997498 C5.95497494,7.45356757 5.95497494,7.13837142 5.95497494,6.73333924 L5.95497494,5.25361139 C5.95497494,5.04596181 5.83660945,4.85884618 5.65505089,4.77927712 C5.47276318,4.69945138 5.26446909,4.7433427 5.12520128,4.8906738 L0.188120918,10.1045007 C-0.00170135197,10.3049634 -0.00170135197,10.6299131 0.188120918,10.8303758 L5.12495823,16.044716 C5.21804648,16.1430223 5.34224518,16.1951272 5.46863132,16.1951272 C5.5313383,16.1951272 5.59453137,16.1822935 5.65480784,16.1561127 C5.8363664,16.0765437 5.95473189,15.889428 5.95473189,15.6817784 L5.95473189,13.2351582 L9.72225429,13.2351582 C9.9905818,13.2351582 10.2083549,13.0051779 10.2083549,12.7218094 C10.2083549,12.4384409 9.9905818,12.2084606 9.72225429,12.2084606 L5.46838827,12.2084606 C5.20006076,12.2084606 4.98228771,12.4384409 4.98228771,12.7218094 L4.98228771,12.7279696 C4.98253076,12.7857213 4.98277381,13.6596976 4.98277381,14.4422978 L1.21938326,10.4674382 L4.98277381,6.49309201 C4.98277381,7.26029176 4.98253076,8.11578749 4.98228771,8.20280011 C4.98155856,8.23924787 4.98471821,8.27595231 4.99152362,8.31265675 C5.03648792,8.55341732 5.23627525,8.72667254 5.46838827,8.72667254 L13.4895336,8.72667254 L13.4895336,11.1725228 C13.4895336,11.3801724 13.6078991,11.567288 13.7894577,11.6468571 C13.9715024,11.7261694 14.1797964,11.6825348 14.3193073,11.5354604 L19.2563877,6.32189019 C19.4462099,6.12142749 19.4462099,5.79647772 19.2563877,5.59601502 Z\" id=\"Shape\"></path></g></g></g></svg><svg data-ng-if=\"tr.payment_type==\'credit\'\" class=\"pay-icon-svg {{$root.currentModule}}\" width=\"20px\" height=\"20px\" viewbox=\"0 0 20 20\" version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\"><g id=\"Symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\"><g id=\"icon-cheque\" fill-rule=\"nonzero\" fill=\"#EDB129\"><g id=\"business-collection-outlines-02\" transform=\"translate(0.000000, 1.000000)\"><path d=\"M19.1969457,0.119841272 L4.98349486,0.119841272 C4.7241116,0.119841272 4.51359765,0.342155516 4.51359765,0.616078423 L4.51359765,11.7563544 L0.551894273,11.7563544 C0.292511013,11.7563544 0.0819970631,11.9786686 0.0819970631,12.2525915 L0.0819970631,14.806476 C0.0819970631,16.3763222 1.29127753,17.6533885 2.77756241,17.6533885 L16.9708076,17.6533885 L16.9755066,17.6533885 C16.9771512,17.6533885 16.9785609,17.6528923 16.9802056,17.6528923 C18.4624963,17.6474337 19.6668429,16.3728486 19.6668429,14.806476 L19.6668429,0.616078423 C19.6668429,0.341907397 19.4563289,0.119841272 19.1969457,0.119841272 Z M2.77756241,16.6609142 C1.80933921,16.6609142 1.02179148,15.8289727 1.02179148,14.806476 L1.02179148,12.7488287 L14.2750073,12.7488287 L14.2750073,14.806476 C14.2750073,15.5141102 14.5207636,16.162444 14.9269897,16.6609142 L2.77756241,16.6609142 L2.77756241,16.6609142 Z M18.7270485,14.806476 C18.7270485,15.8289727 17.9392658,16.6609142 16.9708076,16.6609142 C16.0025844,16.6609142 15.2148018,15.8289727 15.2148018,14.806476 L15.2148018,12.2525915 C15.2148018,11.9786686 15.0042878,11.7563544 14.7449046,11.7563544 L5.45339207,11.7563544 L5.45339207,1.11231557 L18.7268135,1.11231557 L18.7268135,14.806476 L18.7270485,14.806476 Z\" id=\"Shape\"></path><path d=\"M7.94408223,4.40683402 L15.9922467,4.40683402 C16.25163,4.40683402 16.4621439,4.18451978 16.4621439,3.91059687 C16.4621439,3.63667396 16.25163,3.41435972 15.9922467,3.41435972 L7.94408223,3.41435972 C7.68469897,3.41435972 7.47418502,3.63667396 7.47418502,3.91059687 C7.47418502,4.18451978 7.68446402,4.40683402 7.94408223,4.40683402 Z\" id=\"Shape\"></path><path d=\"M7.94408223,6.82499766 L15.9922467,6.82499766 C16.25163,6.82499766 16.4621439,6.60268342 16.4621439,6.32876051 C16.4621439,6.0548376 16.25163,5.83252336 15.9922467,5.83252336 L7.94408223,5.83252336 C7.68469897,5.83252336 7.47418502,6.0548376 7.47418502,6.32876051 C7.47418502,6.60268342 7.68446402,6.82499766 7.94408223,6.82499766 Z\" id=\"Shape\"></path><path d=\"M7.94408223,9.24291318 L13.2682526,9.24291318 C13.5276358,9.24291318 13.7381498,9.02059894 13.7381498,8.74667603 C13.7381498,8.47275312 13.5276358,8.25043888 13.2682526,8.25043888 L7.94408223,8.25043888 C7.68469897,8.25043888 7.47418502,8.47275312 7.47418502,8.74667603 C7.47418502,9.02059894 7.68446402,9.24291318 7.94408223,9.24291318 Z\" id=\"Shape\"></path></g></g></g></svg></div><div class=\"pay-block\"><div class=\"pay-label\"><p>{{tr.payment_label}} Bs.:</p></div><div class=\"pay-item\"><input class=\"form-control\" type=\"number\" data-ng-disabled=\"tr.currency != $root.globalParams.currency || $root.voucher.selected.balance==0\" data-ng-change=\"$root.calculateBalance(tr.amount)\" data-ng-model=\"tr.amount\"></div><div class=\"clearfix\"></div><div class=\"pay-label\" data-ng-if=\"tr.currency != $root.globalParams.currency\"><p data-ng-if=\"tr.currency != $root.globalParams.currency\">{{tr.currency}}:</p></div><div class=\"pay-item\" data-ng-if=\"tr.currency != $root.globalParams.currency\"><input class=\"form-control\" type=\"number\" data-ng-disabled=\"$root.voucher.selected.balance==0\" data-ng-change=\"$root.exchange(tr, tr.amounthOther)\" data-ng-model=\"tr.amounthOther\"></div><div class=\"clearfix\"></div><div class=\"pay-label\" data-ng-if=\"tr.verification\"><p>Nro. cuenta:</p></div><div class=\"pay-item\" data-ng-if=\"tr.verification\"><input class=\"form-control\" type=\"text\" data-ng-model=\"tr.account\"></div><div class=\"clearfix\"></div><div class=\"pay-label\" data-ng-if=\"tr.verification\"><p>Nro. orden:</p></div><div class=\"pay-item\" data-ng-if=\"tr.verification\"><input class=\"form-control\" type=\"text\" data-ng-model=\"tr.code\"></div></div></div></div><div class=\"pay-resume\"><div class=\"pay-result\"><div class=\"result-label\"><p>Total a pagar:</p></div><div class=\"result-amount\"><p>{{ $root.voucher.selected.total | number : \'1.1\'}}</p></div></div><div class=\"pay-result\"><div class=\"result-label\"><p>Total cancelado:</p></div><div class=\"result-amount\"><p>{{ $root.voucher.selected.totalAmount | number : \'1.1\'}}</p></div></div><div class=\"pay-result\"><div class=\"result-label\"><p>Deuda:</p></div><div class=\"result-amount\" data-ng-class=\"{\'danger\': $root.voucher.selected.balance > 0 , \'success\': $root.voucher.selected.balance == 0 }\"><p>{{ $root.voucher.selected.balance | number : \'1.1\'}}</p></div><button data-ng-click=\"$root.newPay(\'credit\',\'\',false, \'Crédito\')\" type=\"button\" data-ng-if=\"$root.voucher.selected.balance > 0 && $root.voucher.actionType == \'store\' && $root.currentModule == \'purchases\'\" class=\"btn btn-action info pull-right\"><i class=\"fa fa-plus\"></i> CRÉDITO</button> <button data-ng-click=\"$root.newPay(\'credit\',\'\',false, \'Crédito\')\" type=\"button\" data-ng-disabled=\"$root.voucher.selected.partner.partnercategory.topcredit < $root.voucher.selected.balance\" data-ng-if=\"$root.voucher.selected.balance > 0 && $root.voucher.actionType == \'store\' && $root.currentModule == \'sales\'\" class=\"btn btn-action info pull-right\"><i class=\"fa fa-plus\"></i> CRÉDITO</button></div><div class=\"pay-result\" data-ng-if=\"$root.newCreditIndex != \'unsigned\'\"><div class=\"result-label\"><p>Nuevo crédito:</p></div><div class=\"result-amount info\"><p>{{ $root.voucher.selected.vouchertransaction[$root.newCreditIndex].amount | number : \'1.1\'}}</p></div><button data-ng-click=\"remove($root.newCreditIndex)\" type=\"button\" class=\"btn btn-action danger pull-right\"><i class=\"fa fa-times\"></i> Cancelar</button></div><div class=\"pay-result\"><div class=\"result-label\"><p>Cambio:</p></div><div class=\"result-amount\" data-ng-class=\"{\'info\': $root.voucher.selected.positiveBalance >0 }\"><p>{{ $root.voucher.selected.positiveBalance | number : \'1.1\'}}</p></div></div></div></div></div><div class=\"forms expanded\"><button type=\"submit\" data-ng-disabled=\"$root.blockPay\" class=\"btn btn-action success pull-right\">Guardar</button> <button data-ng-click=\"resetPay()\" type=\"button\" class=\"btn btn-action info pull-right\">Revertir</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipiker/uipiker.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"saveSelection();\"><div class=\"form-header sub {{$root.currentModule}}\"><h3>Selección de items</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms\" style=\"margin-bottom: 0\"><uifilters data-ng-if=\"$root[modelName].ready\" model-name=\"{{modelName}}\"></uifilters></div><div class=\"forms\"><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include></div><ng-include data-ng-if=\"!$root[modelName].childModel\" src=\"\'app/scripts/directives/uibuilder/components/uipiker/templates/default.html\'\"></ng-include><ng-include data-ng-if=\"$root[modelName].childModel\" src=\"\'app/scripts/directives/uibuilder/components/uipiker/templates/\'+$root[modelName].childModel+\'.html\'\"></ng-include><div class=\"forms\"><ng-include src=\"\'app/scripts/directives/uibuilder/components/uicrudgrid/crudPagination.html\'\"></ng-include></div><div class=\"forms\"><button type=\"submit\" class=\"btn btn-action success pull-right\">Save</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancel</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uireadvoucher/uireadvoucher.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\" data-ng-submit=\"updateRegister()\"><div data-ng-class=\"{\'danger\':$root[modelName].actionType==\'delete\'}\" class=\"form-header sub {{$root.currentModule}}\"><h3 data-ng-if=\"$root[modelName].actionType==\'store\'\"><i class=\"fa fa-plus\"></i> Comprobante</h3><h3 data-ng-if=\"$root[modelName].actionType==\'update\'\"><i class=\"fas fa-edit\"></i> Editar entrega de productos</h3><h3 data-ng-if=\"$root[modelName].actionType==\'delete\'\"><i class=\"fas fa-exclamation-triangle\" style=\"color: #d94a4a;\"></i> Anular entrega de productos</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"closeAndBack()\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"detail\" data-ng-repeat=\"i in $root.paymentDetail\"><p class=\"detail-label\">{{i.label}}:</p><p class=\"detail-item\" data-ng-class=\"{\'success\':i.success()}\">{{i.value}}</p></div></div></div><div class=\"forms expanded\"><div class=\"pay-box\"><div class=\"pay-header\"><h5>Detalle {{$root.memVoucher.code}}</h5></div></div></div><div class=\"forms expanded\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\" style=\"border-bottom: none\"><thead><tr><th></th><th><strong>No.</strong></th><th class=\"column-title\"><strong>Código</strong></th><th class=\"column-title\"><strong>Producto</strong></th><th class=\"column-title\"><strong>Estanteria</strong></th><th class=\"column-title\"><strong>Cantidad</strong></th><th class=\"column-title\"><strong>Precio</strong></th><th class=\"column-title\"><strong>Descuento</strong></th><th class=\"column-title\"><strong>Total</strong></th></tr></thead><tbody style=\"border-top: 1px solid #ddd;\" data-ng-repeat=\"register in $root.memVoucher.voucherline\"><tr class=\"test {{$root.currentModule}}\"><td></td><td>#{{$index + 1}}</td><td>{{register.product.code}} {{register.product.code_secondary}}</td><td>{{register.product.description}}</td><td>{{(register.product.stock.length==1)?register.product.stock[0].batchcode:\'\'}}</td><td>{{register.quantity}}</td><td>{{register.value}}</td><td>{{register.discount}} %</td><td>{{register.sub}}</td></tr><tr data-ng-if=\"register.product.stock.length>1\" style=\"background: #F8F8F8;\" data-ng-repeat=\"st in register.stockadjustment\"><td></td><td></td><td></td><td style=\"padding-left: 20px;\">Lote - {{st.batchcode}}</td><td>{{st.batchcode}}</td><td>{{st.quantity}}</td><td colspan=\"3\"></td></tr></tbody><tbody><tr><td rowspan=\"3\" colspan=\"7\"><strong>Comentarios:</strong>{{$root.memVoucher.comments}}</td><td><strong>transporte:</strong></td><td><strong>{{ $root.memVoucher.transport_amount}}</strong></td></tr><tr><td><strong>Otros:</strong></td><td><strong>{{ $root.memVoucher.other_amount}}</strong></td></tr><tr><td><strong>Total:</strong></td><td><strong>{{ $root.memVoucher.total}}</strong></td></tr></tbody></table></div></div><div class=\"forms expanded\"><button type=\"button\" style=\"margin-right: 5px\" data-ng-click=\"$root.loadVoucher($root.memVoucher, \'store\');closeAndBack()\" class=\"btn btn-action success pull-right\">copiar</button> <button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"closeAndBack()\">Cancelar</button></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uireport/uireport.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" ui-heigth=\"\" name=\"myForm\"><div class=\"form-header sub {{$root.currentModule}}\"><h3>Cargar entradas desde un archivo Excel</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms\"><h5><strong>Filtros</strong></h5><div class=\"crud-grid-filters\"><div class=\"filters-box\"><div data-ng-repeat=\"(key, dato) in filters.filters | orderBy:\'order\'\"><div class=\"form-group input-group\" data-ng-if=\"filters.filters[key].type == \'selectlist\'\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-model=\"filters.filters[key].value\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\" style=\"width: calc(100% - 15px);padding: 5px;\"><li style=\"margin: 5px 0\" data-ng-click=\"pick(key, item);\" data-ng-repeat=\"item in filters.filters[key].items\">{{item.name}}</li></ul></div><div class=\"form-group input-group left-addon\" data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\"><small class=\"form-group-left-addon\">Desde</small><mydatepicker ng-model=\"filters.filters[key].from\" date-options=\"dateOptions\" opened=\"opened\" ng-submit=\"\'search\'\" pl=\"Desde\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"form-group input-group left-addon\" data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\"><small class=\"form-group-left-addon\">Hasta</small><mydatepicker ng-model=\"filters.filters[key].to\" date-options=\"dateOptions\" opened=\"opened\" ng-submit=\"\'search\'\" pl=\"Hasta\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div></div><button class=\"btn btn-default\" ng-click=\"search()\"><i class=\"fas fa-search\"></i> <span>Buscar</span></button></div></div></div><div class=\"forms\" data-ng-if=\"data\"><button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button> <a type=\"button\" style=\"margin-right: 10px;\" data-ng-click=\"download();\" class=\"btn btn-action grey pull-right\">Generar Excel</a> <a type=\"button\" ng-if=\"data.excel\" style=\"margin-right: 10px;\" href=\"{{$root.api+ \'/\'+data.excel.file}}\" target=\"_blank\" class=\"btn btn-action success pull-right\">Descargar</a></div><div class=\"forms\" data-ng-if=\"data\"><div class=\"row\"><div class=\"col-sm-12 col-md-6 flex mT20\" style=\"justify-content: flex-start;height: 34px\" data-ng-if=\"!hideHeader\"><p><span class=\"text-info\" style=\"margin-bottom: 0;\">Total películas: {{data.result.length}}</span> | <span class=\"text-info\" style=\"margin-bottom: 0;\">Total tickets vendidos: {{data.total}}</span></p></div><div class=\"col-xs-12\" style=\"overflow-x: scroll;\"><table class=\"table table-hover table-striped\"><thead><tr><th>Película</th><th>Tickets vendidos</th><th>Total vendido Bs.</th><th>Participación porcentual</th></tr></thead><tbody><tr data-ng-repeat=\"item in data.result\"><td>{{item.description}}</td><td>{{item.quantity}}</td><td>{{item.subtotal}}</td><td>{{item.percentage}}</td></tr></tbody></table></div></div></div><div class=\"forms\" data-ng-if=\"data\"><button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button> <a type=\"button\" style=\"margin-right: 10px;\" data-ng-click=\"download();\" class=\"btn btn-action grey pull-right\">Generar Excel</a> <a type=\"button\" ng-if=\"data.excel\" style=\"margin-right: 10px;\" href=\"{{$root.api+ \'/\'+data.excel.file}}\" target=\"_blank\" class=\"btn btn-action success pull-right\">Descargar</a></div></form></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uiticket/uiticket.html","<div class=\"crud-form-body wow slideInLeft\" data-ng-class=\"{\'level1\':level==1,\'level2\':level==2,\'level3\':level==3}\"><form class=\"crud-form\" data-ng-submit=\"storepromo()\" ui-heigth=\"\" name=\"myForm\"><div class=\"form-header sub {{$root.currentModule}}\"><h3>Generar promociones</h3><a href=\"\" class=\"info-btn-close\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\"><i class=\"far fa-times-circle\"></i></a></div><div class=\"forms\"><h5><strong>Complete el formulario</strong></h5></div><div class=\"forms\" data-ng-if=\"!dato.hide\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"col-xs-12\"><h4 class=\"header-subtitle-2\" data-ng-show=\"dato.subtitle\" render-html=\"dato.subtitle\"></h4><hr data-ng-if=\"dato.hr\" style=\"margin: 10px 0 20px 0;\"></div><div class=\"box-label\"><span class=\"filter-label\" data-ng-bind-html=\"dato.invalid+dato.label+(dato.required==true?\' *\':\'\')\" data-ng-class=\"{\'text-danger\':dato.invalid}\"></span> <small data-ng-bind-html=\"dato.helpText\"></small></div><div class=\"box-input webcontent\" style=\"padding: 0\"><ng-include data-ng-if=\"dato.type==\'innerCrud\'\" src=\"\'app/scripts/directives/uibuilder/components/uiformwidgets/innercrud.html\'\"></ng-include><div data-ng-if=\"dato.type==\'log\'\"><p data-ng-init=\"toJson($root[modelName].selected[key])\"></p><p data-ng-bind-html=\"$root[modelName].selected.logrender\"></p></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'text\'\" name=\"{{key}}\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, $root[modelName].selected[key] ,key)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"number\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'number\'\" name=\"{{key}}\" min=\"0\" step=\"0.01\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, $root[modelName].selected[key] ,key)\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"email\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-if=\"dato.type==\'email\'\" data-ng-disabled=\"dato.disabled\"><select class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange($root[modelName])\" data-ng-options=\"item.id as item[dato.itemsLabel] for item in $root[modelName].properties[key].items\" data-ng-if=\"dato.type==\'select\' && $root[modelName].properties[key].items\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && $root[modelName].actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && $root[modelName].actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><button data-ng-if=\"dato.type==\'select\' && dato.onclick==true && !$root[modelName].properties[key].items\" data-ng-click=\"$root.loadItemList($root[modelName].properties[key], dato.itemsSource)\" type=\"button\" class=\"btn btn-primary\">Cargar elementos</button><select class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-init=\"(dato.default)?$root[modelName].selected[key]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange($root[modelName])\" data-ng-options=\"item.id as item[dato.itemsLabel].es for item in $root[modelName].properties[key].items\" data-ng-if=\"dato.type==\'selectArray\'\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && $root[modelName].actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && $root[modelName].actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><color-picker data-ng-if=\"dato.type==\'color\'\" ng-model=\"$root[modelName].selected[key]\" options=\"$root.colorOptions\"></color-picker><div class=\"col-xs-12\" data-ng-if=\"dato.type==\'laundry\'\"><p>Seleccionado : {{$root[modelName].selected[key]}}</p><div class=\"icon-care i{{$index+1}}\" data-ng-click=\"$root[modelName].selected[key]=$index+1\" data-ng-class=\"{\'active\': ($index+1) === $root[modelName].selected[key]}\" data-ng-repeat=\"item in [1,1,1,1,1,1,1,1,1,1,1,1,1,1,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,11,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1] track by $index\">{{$index+1}}</div></div><div data-ng-if=\"dato.type==\'switch\'\"><label class=\"switch\"><input type=\"checkbox\" ng-model=\"$root[modelName].selected[key]\"> <span class=\"slider\"></span></label></div><div data-ng-if=\"dato.type==\'date\'\"><mydatepicker ng-model=\"$root[modelName].selected[key]\" date-options=\"dateOptions\" opened=\"opened\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><textarea class=\"form-control\" data-ng-model=\"$root[modelName].selected[key]\" data-ng-required=\"dato.required\" style=\"min-height: 70px\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\"></textarea><text-angular data-ng-model=\"$root[modelName].selected[key]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.type==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"loadToolBar(dato.toolbar)\" data-ng-disabled=\"dato.disabled\"></text-angular><div data-ng-if=\"dato.type==\'file\'\" class=\"upload-box\"><div class=\"upload-preview\" data-ng-if=\"!selected[key+\'_file\'].name\"><img data-ng-if=\"dato.fileType == \'image\'\" ng-src=\"{{$root.api+$root[modelName].selected[key]}}\" alt=\"\"> <button class=\"upload-btn\" data-ngf-select=\"\" data-ng-model=\"$root[modelName].selected[key+\'_file\']\" data-ngf-max-size=\"4096MB\"><i class=\"fas fa-cloud-upload-alt\"></i></button> <a class=\"upload-btn\" style=\"padding-left: 9px;\" data-ng-click=\"$root[modelName].selected[key]=\'\'\"><i class=\"fas fa-times\"></i></a> <a target=\"_blank\" style=\"display: block;width: calc(100% - 80px);margin-top: 5px\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><i class=\"fas fa-link\" data-ng-if=\"$root[modelName].selected[key]!=\'\'\"></i> {{$root[modelName].selected[key]}}</a></div><div data-ng-if=\"$root[modelName].selected[key+\'_file\'].name\" class=\"upload-preview\"><span data-ng-if=\"dato.fileType != \'image\'\">{{selected[key]}}</span> <a style=\"display: block;width: calc(100% - 50px); float: left;\">{{ $root[modelName].selected[key+\'_file\'].name }}</a> <img data-ng-if=\"$root[modelName].selected[key+\'_file\'].name!=null\" ngf-thumbnail=\"$root[modelName].selected[key+\'_file\'] || \'/thumb.jpg\'\"> <a class=\"upload-btn\" style=\"opacity: 0.5\" href=\"\"><i class=\"fas fa-check\" style=\"color: green;\"></i></a></div></div><input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected.lat\" data-ng-if=\"dato.type==\'mapLat\'\" data-ng-disabled=\"dato.disabled\"> <input class=\"form-control\" type=\"text\" data-ng-required=\"dato.required\" data-ng-model=\"$root[modelName].selected.lng\" data-ng-if=\"dato.type==\'mapLon\'\" data-ng-disabled=\"dato.disabled\"><ng-map center=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\" data-ng-if=\"dato.type==\'mapLon\' && $root[modelName].actionType==\'edit\'\"><marker position=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><ng-map center=\"-16.495859,-68.133529\" data-ng-if=\"dato.type==\'mapLon\' && $root[modelName].actionType==\'store\'\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map><img style=\"max-width: 50%; display: block; border: 2px solid #000000; padding: 10px; margin-top: 15px; margin-bottom: 15px; margin-left: auto; margin-right: auto; opacity: 0.8;\" data-ng-if=\"dato.widget == \'preview\'\" data-ng-src=\"/assets/images/widgets/widget_{{$root[modelName].selected.type}}.png\" alt=\"\"><div data-ng-if=\"dato.type==\'json\'\" class=\"webcontent\"><div data-ng-repeat=\"(k, v) in $root[modelName].selected[key]\" style=\"position: relative; display: flex;\"><input data-ng-if=\"dato.jsonType==\'text\'\" type=\"text\" class=\"form-control lan\" data-ng-model=\"$root[modelName].selected[key][k]\"> <textarea class=\"form-control lan\" data-ng-model=\"$root[modelName].selected[key][k]\" data-ng-required=\"dato.required\" style=\"min-height: 70px\" data-ng-if=\"dato.jsonType==\'textarea\' && dato.toolbar==null\" data-ng-disabled=\"dato.disabled\">\r\n          </textarea><div><text-angular data-ng-model=\"$root[modelName].selected[key][k]\" data-ng-required=\"dato.required\" data-ng-if=\"dato.jsonType==\'textarea\' && dato.toolbar!=null\" ta-toolbar=\"loadToolBar(dato.toolbar)\" data-ng-disabled=\"dato.disabled\"></text-angular></div><button class=\"btn btn-default btn-flag\"><span class=\"lan-flag {{k}}\"><i class=\"fas fa-map-marker-alt\" data-ng-if=\"k == \'lat\' || k == \'lon\'\"></i></span></button></div></div></div></div><div class=\"forms\"><button class=\"btn btn-action danger pull-left\" type=\"button\" data-ng-click=\"$root.uiConf.switchView(\'prev\')\">Cancelar</button> <button type=\"submit\" class=\"btn btn-action success pull-right\">Almacenar tickets</button></div></form></div>");
$templateCache.put("app/views/directives/crudform/form/formwidget/innercrud.html","<div><div data-ng-if=\"context == \'form\'\" class=\"flex\" style=\"align-items: flex-start; justify-content: flex-start\"><button class=\"btn btn-action disabled\" data-ng-if=\"actionType==\'new\'\" type=\"button\" data-ng-click=\"trigguerMessage(\'info\',\'Almacene el registro primero\',\'\')\"><i class=\"fa fa-plus\"></i> {{switchText(\'Nuevo\', \'New\')}}</button> <button class=\"btn btn-action\" data-ng-if=\"actionType!=\'new\'\" type=\"button\" data-ng-disabled=\"dato.disabled\" data-ng-click=\"setInnerCrud(\'insert\', selected.id, dato.default, dato);showCrudInnercrud(true);\"><i class=\"fa fa-plus\"></i> {{switchText(\'Nuevo.\', \'New\')}}</button><div class=\"pull-left\" style=\"width: 300px;\"><small style=\"background: #eee; padding: 5px; margin-left: 5px;margin-bottom: 5px; display: block; float: left; height: 25px;\" data-ng-repeat=\"st in selected[dato.name]\">{{st[dato.titleField]}} <i class=\"fas fa-pencil-alt\" style=\"margin-left: 5px\" data-ng-if=\"!dato.disabled\" data-ng-click=\"setInnerCrud(\'update\', selected.id, st, dato);showCrudInnercrud(true);\"></i> <i class=\"fas fa-times\" style=\"margin-left: 5px\" data-ng-if=\"!dato.disabled\" data-ng-click=\"setInnerCrud(\'delete\', selected.id, st, dato);showCrudInnercrud(true);\"></i></small></div></div><div data-ng-if=\"context == \'default\'\"><p data-ng-repeat=\"st in selected[dato.name] track by $index\">{{st[dato.titleField]}}</p></div><div data-ng-if=\"context == \'custom\'\" render-html=\"widget.customTemplate\"></div></div>");
$templateCache.put("app/views/directives/crudform/form/formwidget/select.html","<div><select ng-model=\"selected[dato.name]\" class=\"form-control\" data-ng-init=\"(dato.default)?selected[dato.name]=dato.default:\'\'\" data-ng-required=\"dato.required\" data-ng-change=\"dato.ngChange(dataset,selected)\" ng-options=\"item.id as item[dato.itemsLabel] for item in dataset.modelProperties[dato.id].items\" data-ng-if=\"context==\'form\'\" data-ng-disabled=\"dato.disabled || (dato.disabledForCreate && !dato.disabledForEdit && actionType==\'new\') || (!dato.disabledForCreate && dato.disabledForEdit && actionType==\'edit\')\"><option value=\"\" disabled=\"\" selected=\"\">Selecione una opción</option></select><div data-ng-if=\"context==\'detail\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == selected[dato.name]\">{{itemselect[dato.itemsLabel]}}</p></div></div>");
$templateCache.put("app/views/directives/crudform/form/formwidget/text.html","<div><input class=\"form-control\" type=\"text\" id=\"{{dato.name}}\" data-ng-required=\"dato.required\" data-ng-model=\"selected[dato.name]\" data-ng-if=\"context==\'form\'\" name=\"{{dato.name}}\" data-ng-init=\"(dato.default)?selected[dato.name]=dato.default:0\" data-ng-pattern=\"{{(dato.pattern)?dato.pattern:\'\'}}\" data-ng-change=\"validateInput(dato, selected[dato.name] ,dato.name)\" data-ng-disabled=\"dato.disabled\"><p data-ng-if=\"context==\'detail\'\" data-ng-bind=\"selected[dato.name]\"></p></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/default.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>{{$root[modelName].selected[$root[modelName].referenceField]}}</h5><ul class=\"info-menu-tabs\"><li><a href=\"\" class=\"{{$root.currentModule}} active\">Detalles</a> <a href=\"\" class=\"{{$root.currentModule}}\"></a> <a href=\"\" class=\"{{$root.currentModule}}\"></a></li></ul></div></div><div class=\"info-menu-body\" data-ng-if=\"!$root[modelName].selected || ( $root[modelName].selected && $root[modelName].actionType==\'store\' )\" ui-heigth=\"\"><div class=\"col-xs-12\"><p>Seleccione un elemento</p></div></div><div class=\"info-menu-body\" data-ng-if=\"$root[modelName].selected\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide || dato.hideRead\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"$root[modelName].selected[key]===\'\'\">Sin datos.</p><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root[modelName].selected[key])\"></p><p data-ng-if=\"dato.type==\'number\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'text\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'textarea\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'date\'\">{{ $root.dateToSpanishFormat($root[modelName].selected[key]) }}</p><p data-ng-if=\"dato.type==\'json\'\" data-ng-bind-html=\"$root[modelName].selected[key].es\"></p><p data-ng-if=\"dato.type==\'switch\'\">{{($root[modelName].selected[key]==true)?\'Si\':\'No\'}}</p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root[modelName].selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root[modelName].selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root[modelName].selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div><p data-ng-if=\"dato.type==\'mapLat\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'mapLon\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'mapLon\'\">mapa {{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}</p></div><ng-map style=\"clear: both; margin-bottom: 20px;\" data-ng-if=\"dato.type==\'mapLon\'\" center=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\"><marker position=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\"></marker></ng-map></div><ng-include data-ng-if=\"modelName==\'purchase\'\" src=\"\'app/scripts/directives/uibuilder/components/uicontextualmenu/templates/purchase.html\'\"></ng-include><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.update\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\');\">{{$root.switchText(\'Editar\', \'Edit\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.delete\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'delete\');\">{{$root.switchText(\'Eliminar\', \'Delete\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"modelName === \'productgroup\'\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\');\"><a data-ng-if=\"modelName === \'productgroup\'\" target=\"_blank\" href=\"http://burbank.bo/producto/{{$root[modelName].selected.id}}\">{{$root.switchText(\'Ver en web\', \'Edit\')}}</a></button></div><div class=\"col-xs-12\" style=\"height: 100px\"></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/movieticketbatch.html","");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/salepoint.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root[modelName].selected[$root[modelName].referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a style=\"width: 50%;\" href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Por conciliar</a> <a style=\"width: 50%;\" href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">Conciliado</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root[modelName].selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root[modelName].selected[key]!=\'\'\" data-ng-bind-html=\"$root[modelName].selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root[modelName].selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root[modelName].selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root[modelName].selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Fecha</strong></th><th class=\"\"><strong>Caja</strong></th><th class=\"\"><strong>Esperado Bs.</strong></th><th class=\"\"><strong>Conciliado Bs.</strong></th></tr></thead><tbody ng-repeat=\"register in $root[modelName].selected.salepointverification\"><tr class=\"{{$root.currentModule}}\"><td>Caja 1</td><td>{{register.created_at}}</td><td>{{register.cash_initial_amount}}</td><td>{{register.cash_ending_amount}}</td></tr><tr><td colspan=\"4\">{{register.comment}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/salepointverification.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root[modelName].selected[$root[modelName].referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">{{$root[modelName].properties.partner_id.label}}</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Stock</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root[modelName].selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root[modelName].selected[key]!=\'\'\" data-ng-bind-html=\"$root[modelName].selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root[modelName].selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root[modelName].selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root[modelName].selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th><th class=\"\"><strong>Costo</strong></th><th class=\"\"><strong>Sub</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].selected.voucherline\" class=\"{{$root.currentModule}}\"><td><div style=\"max-height: 35px; overflow: hidden\">{{register.product.description}}</div></td><td>{{register.quantity}}</td><td>{{register.value}}</td><td>{{register.value * register.quantity}}</td></tr><tr><td colspan=\"5\" style=\"text-align: right\"><strong>Total: {{ $root[modelName].selected.total}}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\" data-ng-if=\"$root.currentState == \'debts\'\"><a href=\"\" class=\"btn-action\" data-ng-click=\"$root.setDebt(); $root.openPayment();\">Cancelar</a></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root[modelName].selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root[modelName].selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root[modelName].selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root[modelName].selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root[modelName].selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root[modelName].properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root[modelName].properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\" data-ng-if=\"(p.product.id == $root.voucher.picked) || !$root.voucher.picked\" data-ng-repeat=\"p in $root[modelName].selected.voucherline\"><div class=\"col-xs-12\" style=\"padding: 0 5px\"><p style=\"font-family: Roboto-Regular;font-size: 16px;line-height: 24px;\">{{p.product.description}}</p></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Almacen</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Stock</strong></th><th class=\"\"><strong>Disp.</strong></th><th class=\"\"><strong>Reserv.</strong></th><th class=\"\"><strong>Fecha Ent.</strong></th></tr></thead><tbody><tr ng-repeat=\"st in p.product.stock | orderBy:\'warehouse_id\'\" class=\"{{$root.currentModule}}\"><td>{{st.warehouse.name}}</td><td>{{st.batchcode}}</td><td>{{st.current_stock}}</td><td>{{st.current_stock}}</td><td>{{st.reserved_stock}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/selleragenda.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle</h5><ul class=\"info-menu-tabs\"></ul></div></div><div class=\"info-menu-body\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root.selleragenda.selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.selleragenda.selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.selleragenda.selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.selleragenda.selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root.selleragenda.selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root.selleragenda.properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root.selleragenda.properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/stocklog.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root.voucher.selected[$root.voucher.referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Detalle</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">Stock Excel</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Stock Actual</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide || dato.hideRead\" data-ng-repeat=\"(key, dato) in $root[modelName].properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"$root[modelName].selected[key]===\'\'\">Sin datos.</p><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root[modelName].selected[key])\"></p><p data-ng-if=\"dato.type==\'number\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'text\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'textarea\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'date\'\">{{ $root.dateToSpanishFormat($root[modelName].selected[key]) }}</p><p data-ng-if=\"dato.type==\'json\'\" data-ng-bind-html=\"$root[modelName].selected[key].es\"></p><p data-ng-if=\"dato.type==\'switch\'\">{{($root[modelName].selected[key]==true)?\'Si\':\'No\'}}</p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root[modelName].selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root[modelName].selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root[modelName].selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root[modelName].selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div><p data-ng-if=\"dato.type==\'mapLat\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'mapLon\'\" data-ng-bind-html=\"$root[modelName].selected[key]\"></p><p data-ng-if=\"dato.type==\'mapLon\'\">mapa {{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}</p></div><ng-map style=\"clear: both; margin-bottom: 20px;\" data-ng-if=\"dato.type==\'mapLon\'\" center=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\"><marker position=\"{{$root[modelName].selected.lat}},{{$root[modelName].selected.lng}}\"></marker></ng-map></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.update\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\');\">{{$root.switchText(\'Editar\', \'Edit\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root[modelName].operations.delete\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'delete\');\">{{$root.switchText(\'Eliminar\', \'Delete\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option danger\" data-ng-if=\"modelName==\'stocklog\'\" data-ng-click=\"$root.updateStock($root[modelName].selected.id);\">Actualizar Stock</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"modelName === \'productgroup\'\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\');\"><a data-ng-if=\"modelName === \'productgroup\'\" target=\"_blank\" href=\"http://burbank.bo/producto/{{$root[modelName].selected.id}}\">{{$root.switchText(\'Ver en web\', \'Edit\')}}</a></button></div><div class=\"col-xs-12\" style=\"height: 100px\"></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Stock</strong></th><th class=\"\"><strong>Código</strong></th><th class=\"\"><strong>Talla</strong></th><th class=\"\"><strong>Color</strong></th><th class=\"\"><strong>Producto</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.stocklog.selected.fileRows | orderBy:\'codigo\'\" class=\"{{$root.currentModule}}\"><td>{{register.cantidad}}</td><td>{{register.codigo}}</td><td>{{register.talla}}</td><td>{{register.color}}</td><td>{{register.descripcion}}</td></tr><tr><td colspan=\"5\" style=\"text-align: right\"><strong>Total coincidencias: {{ $root.stocklog.selected.fileRegisters}}</strong></td></tr></tbody></table></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\" style=\"height: 100px\"></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Stock actual</strong></th><th class=\"\"><strong>Stock nuevo</strong></th><th class=\"\"><strong>Código</strong></th><th class=\"\"><strong>Talla</strong></th><th class=\"\"><strong>Color</strong></th><th class=\"\"><strong>Producto</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.stocklog.selected.fileMatches | orderBy:\'code\'\" class=\"{{$root.currentModule}}\"><td>{{register.max}}</td><td>{{$root.retrieveNewStock(register.code)}}</td><td>{{register.code}}</td><td>{{register.size}}</td><td>{{register.productsubtype?register.productsubtype.name:\'\'}}</td><td>{{register.productsubtype?register.productsubtype.productgroup.name:\'\'}}</td></tr><tr><td colspan=\"5\" style=\"text-align: right\"><strong>Total coincidencias: {{ $root.stocklog.selected.fileMatches.length}}</strong></td></tr></tbody></table></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\" style=\"height: 100px\"></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-creation.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root.voucher.selected[$root.voucher.referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">Cliente</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root.voucher.properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root.voucher.selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root.voucher.selected[key]!=\'\'\" data-ng-bind-html=\"($root.voucher.selected[key]?$root.voucher.selected[key]:\'Sin Datos\')+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root.voucher.selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><p data-ng-if=\"dato.type==\'switch\'\">{{($root[modelName].selected[key]==true)?\'Si\':\'No\'}}</p><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root.voucher.selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root.voucher.selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root.voucher.selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Foto</strong></th><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cant</strong></th><th class=\"\"><strong>Prec</strong></th><th class=\"\"><strong>Desc</strong></th><th class=\"\"><strong>Sub..</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td><img src=\"{{$root.api+register.product.productsubtype.portrait}}\" style=\"max-width: 25px;\"></td><td>{{register.description}}</td><td>{{register.quantity}}</td><td>{{register.value}}</td><td>{{register.discount}}</td><td>{{register.sub}}</td></tr><tr><td colspan=\"6\" style=\"text-align: right\"><strong>Descuento: {{ $root.voucher.selected.discount > 0?$root.voucher.selected.discount:0}}%</strong></td></tr><tr><td colspan=\"6\" style=\"text-align: right\"><strong>Total: Bs. {{ $root.voucher.selected.total }}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 100px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root[modelName].operations.update\" data-ng-click=\"$root.chooseRegister(modelName,$root[modelName].selected,\'update\');\">{{$root.switchText(\'Editar\', \'Edit\')}}</button> <button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-click=\"$root.uiConf.switchView(\'next\', {actionType:\'store\',component:\'uiinvoice\', model:\'voucher\'}, false)\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir</button> <button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\"><a href=\"{{$root.sendLinkWhastapp($root.voucher.selected.user.phone, $root.voucher.selected)}}\" target=\"_blank\"><i class=\"fab fa-whatsapp\"></i> Notificar estado del pedido</a></button> <button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\"><a href=\"{{$root.opemWhastapp($root.voucher.selected.user.phone)}}\" target=\"_blank\"><i class=\"fab fa-whatsapp\"></i> Chatear con el cliente</a></button></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.voucher.operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.user.firstname}} {{$root.voucher.selected.user.lastname}}</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.user.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Razón social:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.user.docextend}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.user.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.user.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.user.address}}:</p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root.voucher.properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root.voucher.properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\" data-ng-if=\"$root.voucher.selected.vouchertype_id == 10 && ((p.product.id == $root.voucher.picked) || !$root.voucher.picked)\" data-ng-repeat=\"p in $root.voucher.selected.voucherlineTemp\"><div class=\"col-xs-12\" style=\"padding: 0 5px\"><p style=\"font-family: Roboto-Regular;font-size: 16px;line-height: 24px;\">{{p.product.description}}</p></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Almacen</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Stock</strong></th><th class=\"\"><strong>Disp.</strong></th><th class=\"\"><strong>Reserv.</strong></th><th class=\"\"><strong>Fecha Ent.</strong></th></tr></thead><tbody><tr ng-repeat=\"st in p.product.stock | orderBy:\'warehouse_id\'\" class=\"{{$root.currentModule}}\"><td>{{st.warehouse.name}}</td><td>{{st.batchcode}}</td><td>{{st.current_stock}}</td><td>{{st.current_stock}}</td><td>{{st.reserved_stock}}</td></tr></tbody></table></div></div><div class=\"row\" data-ng-if=\"$root.voucher.selected.vouchertype_id!= 10\" style=\"padding: 0 10px\" data-ng-repeat=\"p in $root.voucher.selected.voucherline\"><div class=\"col-xs-12\" style=\"padding: 0 5px\"><p style=\"font-family: Roboto-Regular;font-size: 16px;line-height: 24px;\">{{p.product.description}}</p></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Almacen</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Stock</strong></th><th class=\"\"><strong>Disp.</strong></th><th class=\"\"><strong>Reserv.</strong></th><th class=\"\"><strong>Fecha Ent.</strong></th></tr></thead><tbody><tr ng-repeat=\"st in p.product.stock | orderBy:\'warehouse_id\'\" class=\"{{$root.currentModule}}\"><td>{{st.warehouse.name}}</td><td>{{st.batchcode}}</td><td>{{st.current_stock}}</td><td>{{st.current_stock}}</td><td>{{st.reserved_stock}}</td></tr></tbody></table></div></div></div></div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 2\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"switchClevel(\'prev\');\"><i class=\"fas fa-arrow-left\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Historial</h5><ul class=\"info-menu-tabs\"><li><a data-ng-click=\"$root.tabl2 = 1\" data-ng-class=\"{\'active\':$root.tabl2==1}\" style=\"width: 50%; text-transform: capitalize;\" class=\"{{$root.currentModule}}\">{{voucherLabel}}</a> <a data-ng-click=\"$root.tabl2 = 2\" data-ng-class=\"{\'active\':$root.tabl2==2}\" style=\"width: 50%; text-transform: capitalize;\" class=\"{{$root.currentModule}}\">Productos</a></li></ul></div></div><div ui-heigth=\"\" class=\"info-menu-body\" data-ng-if=\"$root.tabl2 == 1\"><div style=\"margin-bottom: 60px\" class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\" style=\"width: 90px;\"><strong>Fecha</strong></th><th class=\"\"><strong>Comprobante</strong></th><th class=\"\"><strong>Total</strong></th></tr></thead><tbody><tr data-ng-if=\"!checkItems()\"><td colspan=\"3\">No se encontrarón resultados</td></tr><tr ng-repeat=\"v in $root.voucher.selected.partner.voucher\" data-ng-if=\"v.vouchertype_id == voucherFilter\" data-ng-click=\"$root.readTempVoucher(v)\" class=\"{{$root.currentModule}}\"><td>{{v.created_at}}</td><td>{{v.code}}</td><td>{{v.total}}</td></tr></tbody></table></div></div><div ui-heigth=\"\" class=\"info-menu-body\" data-ng-init=\"$root.createProductIndex($root.voucher.selected.partner.voucher, voucherFilter)\" data-ng-if=\"$root.tabl2 == 2\"><div style=\"margin-bottom: 60px\" class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th></tr></thead><tbody><tr data-ng-repeat=\"i in $root.productIndex\"><td>{{i.description}}</td><td>{{i.total}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-stockorder.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root.voucher.selected[$root.voucher.referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">{{$root.voucher.properties.partner_id.label}}</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Entregas</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root.voucher.properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root.voucher.selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root.voucher.selected[key]!=\'\'\" data-ng-bind-html=\"$root.voucher.selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root.voucher.selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root.voucher.selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root.voucher.selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root.voucher.selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th><th class=\"\"><strong>Costo</strong></th><th class=\"\"><strong>Desc</strong></th><th class=\"\"><strong>Sub..</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td><div style=\"max-height: 35px; overflow: hidden\">{{register.product.description}}</div></td><td>{{register.quantity}}</td><td>{{register.value}}</td><td>{{register.discount}}</td><td>{{register.sub}}</td></tr><tr><td colspan=\"5\" style=\"text-align: right\"><strong>Total: {{ $root.voucher.selected.total}}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-click=\"$root.uiConf.switchView(\'next\', {actionType:\'store\',component:\'uiinvoice\', model:\'voucher\'}, false)\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir</button> <button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.voucher.selected.vouchertype_id!=10\" data-ng-click=\"$root.openStockview()\" class=\"info-btn-option {{$root.currentModule}}\">Devolución / Entrega</button> <button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.voucher.selected.vouchertype_id==10\" data-ng-click=\"$root.openComboview()\" class=\"info-btn-option {{$root.currentModule}}\">Devolución / Entrega (C)</button></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.voucher.operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root.voucher.selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root.voucher.selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root.voucher.properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root.voucher.properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Codigo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root.voucher.selected.stockorder\" class=\"{{$root.currentModule}}\"><td data-ng-click=\"$root.setStockorder(vt); $root.uiConf.switchView(\'next\', {actionType:\'store\',component:\'uiinvoicestock\', model:\'voucher\'}, false)\">{{vt.id}}</td><td>{{vt.created_at}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-temp.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">Cliente</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root.payrequest.properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root.payrequest.selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root.payrequest.selected[key]!=\'\'\" data-ng-bind-html=\"($root.payrequest.selected[key]?$root.payrequest.selected[key]:\'Sin Datos\')+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root.payrequest.selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><p data-ng-if=\"dato.type==\'switch\'\">{{($root[modelName].selected[key]==true)?\'Si\':\'No\'}}</p><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root.payrequest.selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root.payrequest.selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root.payrequest.selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Foto</strong></th><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cant</strong></th><th class=\"\"><strong>Prec</strong></th><th class=\"\"><strong>Desc</strong></th><th class=\"\"><strong>Sub..</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.payrequest.selected.parsedata.items\" class=\"{{$root.currentModule}}\"><td><img src=\"{{$root.api+register.product.productsubtype.portrait}}\" style=\"max-width: 25px;\"></td><td>{{register.description}}</td><td>{{register.quantity}}</td><td>{{register.value}}</td><td>{{register.discount}}</td><td>{{register.sub}}</td></tr><tr><td colspan=\"6\" style=\"text-align: right\"><strong>Descento: {{ $root.payrequest.selected.parsedata.discount > 0?$root.payrequest.selected.parsedata.discount:0}}%</strong></td></tr><tr><td colspan=\"6\" style=\"text-align: right\"><strong>Total: {{ $root.payrequest.selected.parsedata.discount > 0? $root.payrequest.selected.parsedata.total- ($root.payrequest.selected.parsedata.total * ($root.payrequest.selected.parsedata.discount /100)): $root.payrequest.selected.parsedata.total }}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 100px\"><div class=\"col-xs-12\"><button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"modelName==\'payrequest\'\" class=\"info-btn-option\" data-ng-click=\"$root.storeparsedata($root.payrequest.selected.parsedata)\">Registrar pago y enviar notificación por email</button></div><div class=\"col-xs-12\"></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.payrequest.selected.client.firstname}} {{$root.payrequest.selected.client.lastname}}</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.payrequest.selected.client.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Razón social:</p></div><div class=\"data-cont\"><p>{{$root.payrequest.selected.client.docextend}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.payrequest.selected.client.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.payrequest.selected.client.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.payrequest.selected.client.address}}:</p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root.voucher.properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root.voucher.properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\" data-ng-if=\"$root.voucher.selected.vouchertype_id == 10 && ((p.product.id == $root.voucher.picked) || !$root.voucher.picked)\" data-ng-repeat=\"p in $root.voucher.selected.voucherlineTemp\"><div class=\"col-xs-12\" style=\"padding: 0 5px\"><p style=\"font-family: Roboto-Regular;font-size: 16px;line-height: 24px;\">{{p.product.description}}</p></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Almacen</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Stock</strong></th><th class=\"\"><strong>Disp.</strong></th><th class=\"\"><strong>Reserv.</strong></th><th class=\"\"><strong>Fecha Ent.</strong></th></tr></thead><tbody><tr ng-repeat=\"st in p.product.stock | orderBy:\'warehouse_id\'\" class=\"{{$root.currentModule}}\"><td>{{st.warehouse.name}}</td><td>{{st.batchcode}}</td><td>{{st.current_stock}}</td><td>{{st.current_stock}}</td><td>{{st.reserved_stock}}</td></tr></tbody></table></div></div><div class=\"row\" data-ng-if=\"$root.voucher.selected.vouchertype_id!= 10\" style=\"padding: 0 10px\" data-ng-repeat=\"p in $root.voucher.selected.voucherline\"><div class=\"col-xs-12\" style=\"padding: 0 5px\"><p style=\"font-family: Roboto-Regular;font-size: 16px;line-height: 24px;\">{{p.product.description}}</p></div><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Almacen</strong></th><th class=\"\"><strong>Lote</strong></th><th class=\"\"><strong>Stock</strong></th><th class=\"\"><strong>Disp.</strong></th><th class=\"\"><strong>Reserv.</strong></th><th class=\"\"><strong>Fecha Ent.</strong></th></tr></thead><tbody><tr ng-repeat=\"st in p.product.stock | orderBy:\'warehouse_id\'\" class=\"{{$root.currentModule}}\"><td>{{st.warehouse.name}}</td><td>{{st.batchcode}}</td><td>{{st.current_stock}}</td><td>{{st.current_stock}}</td><td>{{st.reserved_stock}}</td></tr></tbody></table></div></div></div></div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 2\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"switchClevel(\'prev\');\"><i class=\"fas fa-arrow-left\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Historial</h5><ul class=\"info-menu-tabs\"><li><a data-ng-click=\"$root.tabl2 = 1\" data-ng-class=\"{\'active\':$root.tabl2==1}\" style=\"width: 50%; text-transform: capitalize;\" class=\"{{$root.currentModule}}\">{{voucherLabel}}</a> <a data-ng-click=\"$root.tabl2 = 2\" data-ng-class=\"{\'active\':$root.tabl2==2}\" style=\"width: 50%; text-transform: capitalize;\" class=\"{{$root.currentModule}}\">Productos</a></li></ul></div></div><div ui-heigth=\"\" class=\"info-menu-body\" data-ng-if=\"$root.tabl2 == 1\"><div style=\"margin-bottom: 60px\" class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\" style=\"width: 90px;\"><strong>Fecha</strong></th><th class=\"\"><strong>Comprobante</strong></th><th class=\"\"><strong>Total</strong></th></tr></thead><tbody><tr data-ng-if=\"!checkItems()\"><td colspan=\"3\">No se encontrarón resultados</td></tr><tr ng-repeat=\"v in $root.voucher.selected.partner.voucher\" data-ng-if=\"v.vouchertype_id == voucherFilter\" data-ng-click=\"$root.readTempVoucher(v)\" class=\"{{$root.currentModule}}\"><td>{{v.created_at}}</td><td>{{v.code}}</td><td>{{v.total}}</td></tr></tbody></table></div></div><div ui-heigth=\"\" class=\"info-menu-body\" data-ng-init=\"$root.createProductIndex($root.voucher.selected.partner.voucher, voucherFilter)\" data-ng-if=\"$root.tabl2 == 2\"><div style=\"margin-bottom: 60px\" class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th></tr></thead><tbody><tr data-ng-repeat=\"i in $root.productIndex\"><td>{{i.description}}</td><td>{{i.total}}</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uicontextualmenu/templates/voucher-transaction.html","<div><div data-ng-class=\"{ \'active\': $root.infoMenu }\" data-ng-if=\"clevel == 1\" class=\"app-info-menu {{$root.currentModule}}\" windowheight=\"\"><a href=\"\" class=\"info-btn-close\" data-ng-class=\"{\'hide\': !$root.infoMenu}\" data-ng-click=\"$root.showInfoMenu()\"><i class=\"far fa-times-circle\"></i></a><div class=\"info-menu-header {{$root.currentModule}}\"><div class=\"col-xs-12\"><h5>Detalle {{$root.voucher.selected[$root.voucher.referenceField]}}</h5><ul class=\"info-menu-tabs\"><li data-ng-init=\"tab = 1\"><a href=\"\" data-ng-click=\"$root.tab=1;\" data-ng-class=\"{\'active\':$root.tab==1}\" class=\"{{$root.currentModule}}\">Ticket</a> <a href=\"\" data-ng-click=\"$root.tab=2;\" data-ng-class=\"{\'active\':$root.tab==2}\" class=\"{{$root.currentModule}}\">{{$root.voucher.properties.partner_id.label}}</a> <a href=\"\" data-ng-click=\"$root.tab=3;\" data-ng-class=\"{\'active\':$root.tab==3}\" class=\"{{$root.currentModule}}\">Pagos</a></li></ul></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==1\" ui-heigth=\"\"><div class=\"data-box\" data-ng-hide=\"dato.hide\" data-ng-repeat=\"(key, dato) in $root.voucher.properties | orderBy:\'order\'\"><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">{{dato.label}}:</p></div><div class=\"data-cont\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction($root.voucher.selected[key])\"></p><p data-ng-if=\"dato.type==\'text\' && $root.voucher.selected[key]!=\'\'\" data-ng-bind-html=\"$root.voucher.selected[key]+\' \'+dato.currency\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == $root.voucher.selected[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" style=\"margin-bottom: 10px; display: block\" href=\"{{$root.api+$root.voucher.selected[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\">{{$root.voucher.selected[key]}} <i class=\"fas fa-external-link-alt\"></i></span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+$root.voucher.selected[key]}}\"></a><div class=\"innercrud t2\" data-ng-if=\"dato.type==\'innerCrud\'\"><div data-ng-repeat=\"subitem in dato.items\"><p data-ng-if=\"dato.subType!=\'file\'\" class=\"innercrud-item {{$root.currentModule}}\" style=\"margin-bottom: 5px;\"><span>{{subitem.referenceField}}</span></p><a target=\"_blank\" data-ng-if=\"dato.subType==\'file\'\" href=\"{{$root.api+subitem.referenceField}}\">Abrir <img data-ng-src=\"{{$root.api+subitem.referenceField}}\" style=\"max-height: 50px\"></a></div></div></div></div><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Producto</strong></th><th class=\"\"><strong>Cantidad</strong></th><th class=\"\"><strong>Costo</strong></th><th class=\"\"><strong>Desc</strong></th><th class=\"\"><strong>Sub</strong></th></tr></thead><tbody><tr ng-repeat=\"register in $root.voucher.selected.voucherline\" class=\"{{$root.currentModule}}\"><td><div style=\"max-height: 35px; overflow: hidden\">{{register.product.description}}</div></td><td>{{register.quantity}}</td><td>{{register.value}}</td><td>{{register.discount}}</td><td>{{register.sub}}..</td></tr><tr><td colspan=\"5\" style=\"text-align: right\"><strong>Descento: {{ $root.voucher.selected.discount > 0?$root.voucher.selected.discount:0}}</strong></td><td colspan=\"5\" style=\"text-align: right\"><strong>Total: {{ $root.voucher.selected.discount > 0? $root.voucher.selected.discount- ($root.voucher.selected.total * ($root.voucher.selected.discount /100)): $root.voucher.selected.total }}</strong></td></tr></tbody></table></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"$root.setDebt(); $root.openPayment();\">Registrar pago</button> <button type=\"button\" style=\"margin: auto;margin-bottom: 15px\" data-ng-click=\"$root.uiConf.switchView(\'next\', {actionType:\'store\',component:\'uiinvoice\', model:\'voucher\'}, false)\" class=\"info-btn-option {{$root.currentModule}}\">Imprimir</button></div><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.readinventory\" data-ng-click=\"$root.uiConf.switchView(\'next\', {component: \'uiinventoryform\',model:modelName, actionType: \'read\'}, false);\">{{$root.switchText(\'Detalle\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-if=\"$root.voucher.operations.updateinventory\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'update\',false,\'uiinventoryform\');\">{{$root.switchText(\'Registrar ingreso\', \'Detail\')}}</button> <button style=\"margin: auto;margin-bottom: 15px\" data-ng-if=\"$root.voucher.operations.deleteinventory\" class=\"info-btn-option danger\" data-ng-click=\"$root.chooseRegister(modelName,$root.voucher.selected,\'delete\',false,\'uiinventoryform\');\">{{$root.switchText(\'anular\', \'cancel\')}}</button></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==2\" ui-heigth=\"\"><div class=\"data-box\"><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Categoría:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p>{{$root.voucher.selected.partner.partnercategory.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Nombre:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.name}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">CI/NIT:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.docid}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Teléfono:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.phone}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Email:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.email}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\">Dirección:</p></div><div class=\"data-cont\"><p>{{$root.voucher.selected.partner.address}}:</p></div><div class=\"data-label\"><p class=\"{{$root.currentModule}}\" data-ng-if=\"$root.currentModule != \'inventory\'\">Website:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.website}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p class=\"{{$root.currentModule}}\">Country:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule != \'inventory\'\"><p>{{$root.voucher.selected.partner.country}}:</p></div><div class=\"data-label\" data-ng-if=\"$root.currentModule == \'sales\'\"><p class=\"{{$root.currentModule}}\">Descuentos:</p></div><div class=\"data-cont\" data-ng-if=\"$root.currentModule == \'sales\'\"><p><span data-ng-repeat=\"dis in $root.voucher.selected.partner.clientdiscount\">{{dis.product.description}} - {{dis.discount}} %</span></p></div></div><div class=\"row\" style=\"margin-bottom: 60px\"><div class=\"col-xs-12\"><button style=\"margin: auto;margin-bottom: 15px\" type=\"button\" data-ng-if=\"item.label2\" data-ng-repeat=\"item in $root.voucher.properties.vouchertype_id.items\" class=\"info-btn-option {{$root.currentModule}}\" data-ng-click=\"switchClevel(\'next\'); setVoucherFilter(item, $root.voucher.properties.vouchertype_id)\">{{item.label2}}</button></div></div><div class=\"data-box\" data-ng-if=\"$root.currentModule != \'inventory\'\"><div class=\"col-xs-12\" style=\"margin-bottom: 150px;overflow: hidden;max-height: 200px\"><ng-map center=\"-16.495859,-68.133529\"><marker position=\"-16.495859,-68.133529\" draggable=\"true\" on-dragend=\"pos()\"></marker></ng-map></div></div></div><div class=\"info-menu-body\" data-ng-show=\"$root.tab==3\" minus=\"100\" ui-heigth=\"\"><div class=\"row\" style=\"padding: 0 10px\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover small\"><thead><tr><th class=\"\"><strong>Monto</strong></th><th class=\"\"><strong>Tipo</strong></th><th class=\"\"><strong>Fecha</strong></th></tr></thead><tbody><tr ng-repeat=\"vt in $root.voucher.selected.vouchertransaction\" class=\"{{$root.currentModule}}\"><td>{{vt.amount}}</td><td>{{vt.payment_type}}</td><td>{{vt.created_at}}</td></tr></tbody></table></div></div></div></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uifilters/templates/default.html","<div class=\"crud-grid-filters\"><div class=\"filters-box\"><div data-ng-repeat=\"(key, dato) in $root[modelName].filters.filters | orderBy:\'order\'\" data-ng-if=\"!$root[modelName].filters.filters[key].hide\"><form data-ng-submit=\"search()\"><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type==\'search\'\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-model=\"$root[modelName].filters.filters[key].value\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fas fa-search\"></i></button></span></div></form><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type==\'date\'\"><form data-ng-submit=\"search()\"><input type=\"date\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-model=\"$root[modelName].filters.filters[key].value\" data-ng-change=\"search()\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" type=\"submit\"><i class=\"fas fa-search\"></i></button></span></form></div><button data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\" class=\"btn btn-default\" ng-click=\"search()\"><i class=\"fas fa-search\"></i> <span>Actualizar fechas</span></button><div data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\" class=\"form-group input-group left-addon\"><small class=\"form-group-left-addon\">Desde</small><mydatepicker ng-model=\"$root[modelName].filters.filters[key].from\" date-options=\"dateOptions\" opened=\"opened\" ng-submit=\"\'search\'\" pl=\"Desde\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\" class=\"form-group input-group left-addon\"><small class=\"form-group-left-addon\">Hasta</small><mydatepicker ng-model=\"$root[modelName].filters.filters[key].to\" date-options=\"dateOptions\" opened=\"opened\" ng-submit=\"\'search\'\" pl=\"Hasta\" date-required=\"dato.required\" format=\"{{\'yyyy/MM/dd\'}}\"></mydatepicker></div><div class=\"col-xs-12\" data-ng-if=\"$root[modelName].filters.filters[key].type==\'dateRange\'\"></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'autocomplete\'\"><input type=\"text\" data-ng-init=\"$root[modelName].filters.filters[key][key+\'_open\'] = false\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-click=\"$root[modelName].filters.filters[key][key+\'_open\'] = true\" data-ng-model=\"$root[modelName].filters.filters[key].value\" data-ng-change=\"loadAcItems(modelName,key,dato.operator,dato.value)\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-click=\"pickItem(key, \'\');\" type=\"button\"><i data-ng-show=\"$root[modelName].filters.filters[key].value==\'\'\" class=\"fas fa-filter\"></i> <i data-ng-show=\"$root[modelName].filters.filters[key].value!=\'\'\" class=\"fas fa-times\"></i></button></span><ul class=\"form-ac\" data-ng-show=\"$root[modelName].filters.filters[key][key+\'_open\']\"><li data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pickItem(key, item[key]);\"><a href=\"\">{{item[key]}}</a></li></ul></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'select\'\"><input type=\"text\" data-ng-init=\"$root[modelName].filters.filters[key][key+\'_open\'] = false\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-click=\"$root[modelName].filters.filters[key][key+\'_open\'] = true\" data-ng-model=\"$root[modelName].filters.filters[key].value\" class=\"form-control search\"> <span class=\"input-group-btn\"><button class=\"btn btn-default\" data-ng-click=\"pickItem(key, \'\');\" type=\"button\"><i data-ng-show=\"$root[modelName].filters.filters[key].value==\'\'\" class=\"fas fa-filter\"></i> <i data-ng-show=\"$root[modelName].filters.filters[key].value!=\'\'\" class=\"fas fa-times\"></i></button></span><ul class=\"form-ac\" data-ng-show=\"$root[modelName].filters.filters[key][key+\'_open\']\"><ul data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pick(key, item,dato);\"><li style=\"width: 200px !important;\">{{item.title}}</li></ul></ul></div><div class=\"form-group input-group\" data-ng-if=\"($root[modelName].filters.filters[key].type == \'partner\' && $root.currentModule != \'inventory\') || ($root[modelName].filters.filters[key].type == \'partner\' && key == \'partner_related\')\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-model=\"$root[modelName].filters.filters[key].value2\" class=\"form-control search\"> <span class=\"input-group-btn\"><button data-ng-click=\"loadItems(key, dato.table, dato.field, dato.operator, dato.value2, dato.other)\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i> NIT/CI</li><li><i class=\"fas fa-search\"></i> Nombre</li><li>Teléfono</li></ul><ul data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pick(key, item, dato);\"><li>{{item.docid}}</li><li>{{item.name}}</li><li>{{item.phone}}</li></ul></li></ul></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'product\'\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" data-ng-model=\"$root[modelName].filters.filters[key].value2\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" data-ng-click=\"loadFilterList(key, dato.table, dato.field, dato.operator, dato.value2, dato.searchIn)\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i>Código</li><li><i class=\"fas fa-search\"></i>Código 2</li><li>Descripcion</li></ul><ul data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pick(key, item, dato);\"><li>{{item.code}}</li><li>{{item.code_secondary}}</li><li>{{item.description}}</li></ul></li></ul></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'list\'\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" data-ng-model=\"$root[modelName].filters.filters[key].value2\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" data-ng-if=\"!$root[modelName].filters.filters[key].value2 || $root[modelName].filters.filters[key].value2 == \'\'\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" data-ng-click=\"loadFilterList(key, dato.table, dato.field, dato.operator, dato.value2, dato.field)\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button> <button id=\"single-button\" data-ng-if=\"$root[modelName].filters.filters[key].value2 && $root[modelName].filters.filters[key].value2 != \'\'\" data-ng-click=\"$root[modelName].filters.filters[key].value2 = \'\'\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-times\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i>Nombre</li></ul><ul data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\" data-ng-click=\"pick(key, item,dato);\"><li style=\"width: 200px !important;\">{{item.name}}</li></ul></li><p data-ng-if=\"$root[modelName].filters.filters[key].page < $root[modelName].filters.filters[key].lastPage\" style=\"text-align: center;padding: 30px; cursor: not-allowed;\" ng-mouseover=\"loadFilterList(key, dato.table, dato.field, dato.operator, dato.value2, \'next\', dato.field)\">Mostrar más <i class=\"fa fa-plus\"></i></p></ul></div><div class=\"form-group input-group\" data-ng-if=\"$root[modelName].filters.filters[key].type == \'selectlist\'\" uib-dropdown=\"\" is-open=\"status.isopen\"><input type=\"text\" placeholder=\"{{dato.label?dato.label:key}}\" data-ng-disabled=\"$root[modelName].filters.filters[key].disabled\" data-ng-model=\"$root[modelName].filters.filters[key].value2\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\" ng-disabled=\"disabled\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\" style=\"width: calc(100% - 15px);padding: 5px;\"><li style=\"margin: 5px 0\" data-ng-click=\"pick(key, item,dato);\" data-ng-repeat=\"item in $root[modelName].filters.filters[key].items\">{{item.name}}</li></ul></div><div data-ng-if=\"$root[modelName].filters.filters[key].type == \'group\'\"><div class=\"form-group input-group\" data-ng-repeat=\"sf in dato.subitems track by $index\" uib-dropdown=\"\" is-open=\"sf.isopen\"><input type=\"text\" placeholder=\"{{sf.label}}\" data-ng-model=\"sf.search\" data-ng-change=\"resetLoadData(sf)\" class=\"form-control search\"> <span class=\"input-group-btn\"><button id=\"single-button\" data-ng-click=\"loadData(sf)\" type=\"button\" class=\"btn btn-default\" uib-dropdown-toggle=\"\"><i class=\"fas fa-filter\"></i></button></span><ul class=\"dropdown-menu grid-selector-options small {{$root.currentModule}}\" uib-dropdown-menu=\"\" role=\"menu\" aria-labelledby=\"single-button\"><li><ul><li><i class=\"fas fa-search\"></i>Name</li></ul><ul data-ng-repeat=\"item in sf.data track by $index\" data-ng-click=\"setFilter(sf, item, dato, key);\"><li style=\"width: 200px !important;\">{{item[sf.searchIn]}}</li></ul></li><p data-ng-if=\"sf.page < sf.lastPage\" style=\"text-align: center;padding: 30px; cursor: not-allowed;\" ng-mouseover=\"loadData(sf)\">Mostrar más <i class=\"fa fa-plus\"></i></p></ul></div></div></div><a style=\"float: left;margin-right: 15px;\" target=\"_blank\" data-ng-if=\"modelName==\'stock\'\" ng-href=\"{{$root.api+\'/print/stockreport\'+ $root.stockReport() }}\" tooltip=\"{{$root.switchText(\'Imprimir\', \'Print\')}}\" class=\"btn btn-default\" type=\"button\"><i class=\"fas fa-print\"></i></a><button data-ng-click=\"resetFilters()\" data-ng-if=\"countItems($root[modelName].filters.filters)>0\" tooltip=\"{{$root.switchText(\'Resetear\', \'Reset\')}}\" class=\"btn btn-default\" type=\"button\"><i class=\"fas fa-retweet\"></i> <span>Reiniciar filtros</span></button></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipiker/templates/default.html","<div class=\"forms\" data-ng-if=\"$root[modelName].ready\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th></th><th data-ng-repeat=\"properties in $root[modelName].properties\" data-ng-if=\"!properties.hideGrid\" data-ng-click=\"sortBy(properties.name)\" data-ng-class=\"{active: propertyName == properties.name}\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName == properties && !reverse\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == properties.name && reverse\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th><th>Stock</th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-click=\"($root.calculateStock(register.stock)>0)?$root.addToList(itemsList , register, \'id\', true):\'\'\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\"><td class=\"\"><button type=\"button\" style=\"font-size: 8px;width: 15px;height: 15px;padding: 0;min-width: inherit !important;min-height: inherit !important;\" class=\"btn btn-grid {{$root.currentModule}}\"><i data-ng-show=\"!$root.verifyInList(itemsList , register, \'id\')\" style=\"color:#1DA587\" class=\"fas fa-check\"></i></button></td><td data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" data-ng-if=\"!dato.hideGrid\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[key]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[key])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{$root.api+register[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+register[key]}}\"></a></div></td><td>{{$root.calculateStock(register.stock)}}</td></tr></tbody></table></div></div>");
$templateCache.put("app/scripts/directives/uibuilder/components/uipiker/templates/productcomboitem.html","<div class=\"forms\" data-ng-if=\"$root[modelName].ready\"><div class=\"grid-table-box {{$root.currentModule}}\"><table class=\"table table-hover\"><thead><tr><th></th><th data-ng-repeat=\"properties in $root[modelName].properties\" data-ng-if=\"!properties.hideGrid\" data-ng-click=\"sortBy(properties.name)\" data-ng-class=\"{active: propertyName == properties.name}\" class=\"column-title\"><div class=\"flex\"><strong data-ng-bind-html=\"properties.label\"></strong><div class=\"pull-right\"><i data-ng-show=\"propertyName == properties && !reverse\" class=\"fa fa-sort-down\" aria-hidden=\"true\"></i> <i data-ng-show=\"propertyName == properties.name && reverse\" class=\"fa fa-sort-up\" aria-hidden=\"true\"></i></div></div></th><th data-ng-if=\"$root[modelName].childModel\">min</th><th data-ng-if=\"$root[modelName].childModel\">max</th></tr></thead><tbody><tr ng-repeat=\"register in $root[modelName].dataset.data\" class=\"test {{$root.currentModule}}\" data-ng-class=\"{\'picked\':($root[modelName].selected.id == register.id )}\"><td class=\"\"><button type=\"button\" style=\"font-size: 8px;width: 15px;height: 15px;padding: 0;min-width: inherit !important;min-height: inherit !important;\" data-ng-click=\"$root.addToList(itemsList , register, \'id\', true)\" class=\"btn btn-grid {{$root.currentModule}}\"><i data-ng-show=\"!$root.verifyInList(itemsList , register, \'id\')\" style=\"color:#1DA587\" class=\"fas fa-check\"></i></button></td><td data-ng-repeat=\"(key, dato) in $root[modelName].properties track by $index\" data-ng-if=\"!dato.hideGrid\"><p data-ng-if=\"dato.render\" render-html=\"dato.renderFunction(register[key])\"></p><div data-ng-if=\"!dato.render\"><p data-ng-if=\"dato.type!=\'select\' && dato.type!=\'file\' && dato.type!=\'date\'\" data-ng-bind-html=\"register[key]\"></p><p data-ng-bind-html=\"dateToSpanishFormat(register[key])\" data-ng-if=\"dato.type==\'date\'\"></p><div data-ng-if=\"dato.type==\'select\'\" data-ng-repeat=\"itemselect in dato.items\"><p data-ng-if=\"itemselect.id == register[key]\">{{itemselect[dato.itemsLabel]}}</p></div><a data-ng-if=\"dato.type==\'file\'\" target=\"_blank\" href=\"{{$root.api+register[key]}}\"><span data-ng-if=\"dato.fileType != \'image\'\"><i class=\"fas fa-external-link-alt\"></i> Abrir</span> <img data-ng-if=\"dato.fileType == \'image\'\" style=\"width: 100px;\" data-ng-src=\"{{$root.api+register[key]}}\"></a></div></td><th data-ng-if=\"$root[modelName].childModel\"><input data-ng-required=\"!$root.verifyInList(itemsList , register, \'id\')\" data-ng-disabled=\"$root.verifyInList(itemsList , register, \'id\')\" data-ng-model=\"register.min\" type=\"number\" class=\"form-control\"></th><th data-ng-if=\"$root[modelName].childModel\"><input data-ng-required=\"!$root.verifyInList(itemsList , register, \'id\')\" data-ng-disabled=\"$root.verifyInList(itemsList , register, \'id\')\" data-ng-model=\"register.max\" type=\"number\" class=\"form-control\"></th></tr></tbody></table></div></div>");}]);